var We = "top", st = "bottom", it = "right", qe = "left", Qs = "auto", rn = [We, st, it, qe], Or = "start", Kr = "end", Su = "clippingParents", da = "viewport", Fr = "popper", Ou = "reference", Co = /* @__PURE__ */ rn.reduce(function(e, t) {
  return e.concat([t + "-" + Or, t + "-" + Kr]);
}, []), fa = /* @__PURE__ */ [].concat(rn, [Qs]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Or, t + "-" + Kr]);
}, []), Au = "beforeRead", Nu = "read", Cu = "afterRead", Du = "beforeMain", Iu = "main", Mu = "afterMain", Ru = "beforeWrite", Lu = "write", xu = "afterWrite", ku = [Au, Nu, Cu, Du, Iu, Mu, Ru, Lu, xu];
function Ft(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ot(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Ar(e) {
  var t = ot(e).Element;
  return e instanceof t || e instanceof Element;
}
function ct(e) {
  var t = ot(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function pa(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = ot(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Dp(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, s = t.attributes[r] || {}, i = t.elements[r];
    !ct(i) || !Ft(i) || (Object.assign(i.style, n), Object.keys(s).forEach(function(o) {
      var a = s[o];
      a === !1 ? i.removeAttribute(o) : i.setAttribute(o, a === !0 ? "" : a);
    }));
  });
}
function Ip(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var s = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), a = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !ct(s) || !Ft(s) || (Object.assign(s.style, a), Object.keys(i).forEach(function(l) {
        s.removeAttribute(l);
      }));
    });
  };
}
const ha = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Dp,
  effect: Ip,
  requires: ["computeStyles"]
};
function Pt(e) {
  return e.split("-")[0];
}
var Er = Math.max, xs = Math.min, zr = Math.round;
function Do() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Pu() {
  return !/^((?!chrome|android).)*safari/i.test(Do());
}
function Jr(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), s = 1, i = 1;
  t && ct(e) && (s = e.offsetWidth > 0 && zr(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && zr(n.height) / e.offsetHeight || 1);
  var o = Ar(e) ? ot(e) : window, a = o.visualViewport, l = !Pu() && r, u = (n.left + (l && a ? a.offsetLeft : 0)) / s, c = (n.top + (l && a ? a.offsetTop : 0)) / i, d = n.width / s, f = n.height / i;
  return {
    width: d,
    height: f,
    top: c,
    right: u + d,
    bottom: c + f,
    left: u,
    x: u,
    y: c
  };
}
function ga(e) {
  var t = Jr(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function $u(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && pa(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function qt(e) {
  return ot(e).getComputedStyle(e);
}
function Mp(e) {
  return ["table", "td", "th"].indexOf(Ft(e)) >= 0;
}
function cr(e) {
  return ((Ar(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Zs(e) {
  return Ft(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (pa(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    cr(e)
  );
}
function dl(e) {
  return !ct(e) || // https://github.com/popperjs/popper-core/issues/837
  qt(e).position === "fixed" ? null : e.offsetParent;
}
function Rp(e) {
  var t = /firefox/i.test(Do()), r = /Trident/i.test(Do());
  if (r && ct(e)) {
    var n = qt(e);
    if (n.position === "fixed")
      return null;
  }
  var s = Zs(e);
  for (pa(s) && (s = s.host); ct(s) && ["html", "body"].indexOf(Ft(s)) < 0; ) {
    var i = qt(s);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function Bn(e) {
  for (var t = ot(e), r = dl(e); r && Mp(r) && qt(r).position === "static"; )
    r = dl(r);
  return r && (Ft(r) === "html" || Ft(r) === "body" && qt(r).position === "static") ? t : r || Rp(e) || t;
}
function _a(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Cn(e, t, r) {
  return Er(e, xs(t, r));
}
function Lp(e, t, r) {
  var n = Cn(e, t, r);
  return n > r ? r : n;
}
function Fu() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Vu(e) {
  return Object.assign({}, Fu(), e);
}
function Bu(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var xp = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Vu(typeof t != "number" ? t : Bu(t, rn));
};
function kp(e) {
  var t, r = e.state, n = e.name, s = e.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, a = Pt(r.placement), l = _a(a), u = [qe, it].indexOf(a) >= 0, c = u ? "height" : "width";
  if (!(!i || !o)) {
    var d = xp(s.padding, r), f = ga(i), g = l === "y" ? We : qe, _ = l === "y" ? st : it, p = r.rects.reference[c] + r.rects.reference[l] - o[l] - r.rects.popper[c], y = o[l] - r.rects.reference[l], b = Bn(i), A = b ? l === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, v = p / 2 - y / 2, D = d[g], w = A - f[c] - d[_], j = A / 2 - f[c] / 2 + v, z = Cn(D, j, w), Z = l;
    r.modifiersData[n] = (t = {}, t[Z] = z, t.centerOffset = z - j, t);
  }
}
function Pp(e) {
  var t = e.state, r = e.options, n = r.element, s = n === void 0 ? "[data-popper-arrow]" : n;
  s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || $u(t.elements.popper, s) && (t.elements.arrow = s));
}
const Uu = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: kp,
  effect: Pp,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Xr(e) {
  return e.split("-")[1];
}
var $p = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Fp(e, t) {
  var r = e.x, n = e.y, s = t.devicePixelRatio || 1;
  return {
    x: zr(r * s) / s || 0,
    y: zr(n * s) / s || 0
  };
}
function fl(e) {
  var t, r = e.popper, n = e.popperRect, s = e.placement, i = e.variation, o = e.offsets, a = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, d = e.isFixed, f = o.x, g = f === void 0 ? 0 : f, _ = o.y, p = _ === void 0 ? 0 : _, y = typeof c == "function" ? c({
    x: g,
    y: p
  }) : {
    x: g,
    y: p
  };
  g = y.x, p = y.y;
  var b = o.hasOwnProperty("x"), A = o.hasOwnProperty("y"), v = qe, D = We, w = window;
  if (u) {
    var j = Bn(r), z = "clientHeight", Z = "clientWidth";
    if (j === ot(r) && (j = cr(r), qt(j).position !== "static" && a === "absolute" && (z = "scrollHeight", Z = "scrollWidth")), j = j, s === We || (s === qe || s === it) && i === Kr) {
      D = st;
      var Q = d && j === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        j[z]
      );
      p -= Q - n.height, p *= l ? 1 : -1;
    }
    if (s === qe || (s === We || s === st) && i === Kr) {
      v = it;
      var ee = d && j === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        j[Z]
      );
      g -= ee - n.width, g *= l ? 1 : -1;
    }
  }
  var X = Object.assign({
    position: a
  }, u && $p), fe = c === !0 ? Fp({
    x: g,
    y: p
  }, ot(r)) : {
    x: g,
    y: p
  };
  if (g = fe.x, p = fe.y, l) {
    var ce;
    return Object.assign({}, X, (ce = {}, ce[D] = A ? "0" : "", ce[v] = b ? "0" : "", ce.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + p + "px)" : "translate3d(" + g + "px, " + p + "px, 0)", ce));
  }
  return Object.assign({}, X, (t = {}, t[D] = A ? p + "px" : "", t[v] = b ? g + "px" : "", t.transform = "", t));
}
function Vp(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, s = n === void 0 ? !0 : n, i = r.adaptive, o = i === void 0 ? !0 : i, a = r.roundOffsets, l = a === void 0 ? !0 : a, u = {
    placement: Pt(t.placement),
    variation: Xr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, fl(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, fl(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ma = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Vp,
  data: {}
};
var Qn = {
  passive: !0
};
function Bp(e) {
  var t = e.state, r = e.instance, n = e.options, s = n.scroll, i = s === void 0 ? !0 : s, o = n.resize, a = o === void 0 ? !0 : o, l = ot(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(c) {
    c.addEventListener("scroll", r.update, Qn);
  }), a && l.addEventListener("resize", r.update, Qn), function() {
    i && u.forEach(function(c) {
      c.removeEventListener("scroll", r.update, Qn);
    }), a && l.removeEventListener("resize", r.update, Qn);
  };
}
const ya = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Bp,
  data: {}
};
var Up = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ds(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Up[t];
  });
}
var Hp = {
  start: "end",
  end: "start"
};
function pl(e) {
  return e.replace(/start|end/g, function(t) {
    return Hp[t];
  });
}
function Ea(e) {
  var t = ot(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function va(e) {
  return Jr(cr(e)).left + Ea(e).scrollLeft;
}
function jp(e, t) {
  var r = ot(e), n = cr(e), s = r.visualViewport, i = n.clientWidth, o = n.clientHeight, a = 0, l = 0;
  if (s) {
    i = s.width, o = s.height;
    var u = Pu();
    (u || !u && t === "fixed") && (a = s.offsetLeft, l = s.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: a + va(e),
    y: l
  };
}
function Yp(e) {
  var t, r = cr(e), n = Ea(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, i = Er(r.scrollWidth, r.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), o = Er(r.scrollHeight, r.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), a = -n.scrollLeft + va(e), l = -n.scrollTop;
  return qt(s || r).direction === "rtl" && (a += Er(r.clientWidth, s ? s.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: a,
    y: l
  };
}
function ba(e) {
  var t = qt(e), r = t.overflow, n = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + s + n);
}
function Hu(e) {
  return ["html", "body", "#document"].indexOf(Ft(e)) >= 0 ? e.ownerDocument.body : ct(e) && ba(e) ? e : Hu(Zs(e));
}
function Dn(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Hu(e), s = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = ot(n), o = s ? [i].concat(i.visualViewport || [], ba(n) ? n : []) : n, a = t.concat(o);
  return s ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(Dn(Zs(o)))
  );
}
function Io(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Gp(e, t) {
  var r = Jr(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function hl(e, t, r) {
  return t === da ? Io(jp(e, r)) : Ar(t) ? Gp(t, r) : Io(Yp(cr(e)));
}
function Wp(e) {
  var t = Dn(Zs(e)), r = ["absolute", "fixed"].indexOf(qt(e).position) >= 0, n = r && ct(e) ? Bn(e) : e;
  return Ar(n) ? t.filter(function(s) {
    return Ar(s) && $u(s, n) && Ft(s) !== "body";
  }) : [];
}
function qp(e, t, r, n) {
  var s = t === "clippingParents" ? Wp(e) : [].concat(t), i = [].concat(s, [r]), o = i[0], a = i.reduce(function(l, u) {
    var c = hl(e, u, n);
    return l.top = Er(c.top, l.top), l.right = xs(c.right, l.right), l.bottom = xs(c.bottom, l.bottom), l.left = Er(c.left, l.left), l;
  }, hl(e, o, n));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function ju(e) {
  var t = e.reference, r = e.element, n = e.placement, s = n ? Pt(n) : null, i = n ? Xr(n) : null, o = t.x + t.width / 2 - r.width / 2, a = t.y + t.height / 2 - r.height / 2, l;
  switch (s) {
    case We:
      l = {
        x: o,
        y: t.y - r.height
      };
      break;
    case st:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case it:
      l = {
        x: t.x + t.width,
        y: a
      };
      break;
    case qe:
      l = {
        x: t.x - r.width,
        y: a
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = s ? _a(s) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (i) {
      case Or:
        l[u] = l[u] - (t[c] / 2 - r[c] / 2);
        break;
      case Kr:
        l[u] = l[u] + (t[c] / 2 - r[c] / 2);
        break;
    }
  }
  return l;
}
function Qr(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, s = n === void 0 ? e.placement : n, i = r.strategy, o = i === void 0 ? e.strategy : i, a = r.boundary, l = a === void 0 ? Su : a, u = r.rootBoundary, c = u === void 0 ? da : u, d = r.elementContext, f = d === void 0 ? Fr : d, g = r.altBoundary, _ = g === void 0 ? !1 : g, p = r.padding, y = p === void 0 ? 0 : p, b = Vu(typeof y != "number" ? y : Bu(y, rn)), A = f === Fr ? Ou : Fr, v = e.rects.popper, D = e.elements[_ ? A : f], w = qp(Ar(D) ? D : D.contextElement || cr(e.elements.popper), l, c, o), j = Jr(e.elements.reference), z = ju({
    reference: j,
    element: v,
    placement: s
  }), Z = Io(Object.assign({}, v, z)), Q = f === Fr ? Z : j, ee = {
    top: w.top - Q.top + b.top,
    bottom: Q.bottom - w.bottom + b.bottom,
    left: w.left - Q.left + b.left,
    right: Q.right - w.right + b.right
  }, X = e.modifiersData.offset;
  if (f === Fr && X) {
    var fe = X[s];
    Object.keys(ee).forEach(function(ce) {
      var J = [it, st].indexOf(ce) >= 0 ? 1 : -1, B = [We, st].indexOf(ce) >= 0 ? "y" : "x";
      ee[ce] += fe[B] * J;
    });
  }
  return ee;
}
function Kp(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, s = r.boundary, i = r.rootBoundary, o = r.padding, a = r.flipVariations, l = r.allowedAutoPlacements, u = l === void 0 ? fa : l, c = Xr(n), d = c ? a ? Co : Co.filter(function(_) {
    return Xr(_) === c;
  }) : rn, f = d.filter(function(_) {
    return u.indexOf(_) >= 0;
  });
  f.length === 0 && (f = d);
  var g = f.reduce(function(_, p) {
    return _[p] = Qr(e, {
      placement: p,
      boundary: s,
      rootBoundary: i,
      padding: o
    })[Pt(p)], _;
  }, {});
  return Object.keys(g).sort(function(_, p) {
    return g[_] - g[p];
  });
}
function zp(e) {
  if (Pt(e) === Qs)
    return [];
  var t = ds(e);
  return [pl(e), t, pl(t)];
}
function Jp(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var s = r.mainAxis, i = s === void 0 ? !0 : s, o = r.altAxis, a = o === void 0 ? !0 : o, l = r.fallbackPlacements, u = r.padding, c = r.boundary, d = r.rootBoundary, f = r.altBoundary, g = r.flipVariations, _ = g === void 0 ? !0 : g, p = r.allowedAutoPlacements, y = t.options.placement, b = Pt(y), A = b === y, v = l || (A || !_ ? [ds(y)] : zp(y)), D = [y].concat(v).reduce(function(te, pe) {
      return te.concat(Pt(pe) === Qs ? Kp(t, {
        placement: pe,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: _,
        allowedAutoPlacements: p
      }) : pe);
    }, []), w = t.rects.reference, j = t.rects.popper, z = /* @__PURE__ */ new Map(), Z = !0, Q = D[0], ee = 0; ee < D.length; ee++) {
      var X = D[ee], fe = Pt(X), ce = Xr(X) === Or, J = [We, st].indexOf(fe) >= 0, B = J ? "width" : "height", R = Qr(t, {
        placement: X,
        boundary: c,
        rootBoundary: d,
        altBoundary: f,
        padding: u
      }), x = J ? ce ? it : qe : ce ? st : We;
      w[B] > j[B] && (x = ds(x));
      var M = ds(x), T = [];
      if (i && T.push(R[fe] <= 0), a && T.push(R[x] <= 0, R[M] <= 0), T.every(function(te) {
        return te;
      })) {
        Q = X, Z = !1;
        break;
      }
      z.set(X, T);
    }
    if (Z)
      for (var S = _ ? 3 : 1, I = function(pe) {
        var Se = D.find(function(ve) {
          var ye = z.get(ve);
          if (ye)
            return ye.slice(0, pe).every(function(ne) {
              return ne;
            });
        });
        if (Se)
          return Q = Se, "break";
      }, K = S; K > 0; K--) {
        var Y = I(K);
        if (Y === "break") break;
      }
    t.placement !== Q && (t.modifiersData[n]._skip = !0, t.placement = Q, t.reset = !0);
  }
}
const Yu = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Jp,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function gl(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function _l(e) {
  return [We, it, st, qe].some(function(t) {
    return e[t] >= 0;
  });
}
function Xp(e) {
  var t = e.state, r = e.name, n = t.rects.reference, s = t.rects.popper, i = t.modifiersData.preventOverflow, o = Qr(t, {
    elementContext: "reference"
  }), a = Qr(t, {
    altBoundary: !0
  }), l = gl(o, n), u = gl(a, s, i), c = _l(l), d = _l(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const Gu = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Xp
};
function Qp(e, t, r) {
  var n = Pt(e), s = [qe, We].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = i[0], a = i[1];
  return o = o || 0, a = (a || 0) * s, [qe, it].indexOf(n) >= 0 ? {
    x: a,
    y: o
  } : {
    x: o,
    y: a
  };
}
function Zp(e) {
  var t = e.state, r = e.options, n = e.name, s = r.offset, i = s === void 0 ? [0, 0] : s, o = fa.reduce(function(c, d) {
    return c[d] = Qp(d, t.rects, i), c;
  }, {}), a = o[t.placement], l = a.x, u = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = o;
}
const Wu = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Zp
};
function eh(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = ju({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const wa = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: eh,
  data: {}
};
function th(e) {
  return e === "x" ? "y" : "x";
}
function rh(e) {
  var t = e.state, r = e.options, n = e.name, s = r.mainAxis, i = s === void 0 ? !0 : s, o = r.altAxis, a = o === void 0 ? !1 : o, l = r.boundary, u = r.rootBoundary, c = r.altBoundary, d = r.padding, f = r.tether, g = f === void 0 ? !0 : f, _ = r.tetherOffset, p = _ === void 0 ? 0 : _, y = Qr(t, {
    boundary: l,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), b = Pt(t.placement), A = Xr(t.placement), v = !A, D = _a(b), w = th(D), j = t.modifiersData.popperOffsets, z = t.rects.reference, Z = t.rects.popper, Q = typeof p == "function" ? p(Object.assign({}, t.rects, {
    placement: t.placement
  })) : p, ee = typeof Q == "number" ? {
    mainAxis: Q,
    altAxis: Q
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Q), X = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, fe = {
    x: 0,
    y: 0
  };
  if (j) {
    if (i) {
      var ce, J = D === "y" ? We : qe, B = D === "y" ? st : it, R = D === "y" ? "height" : "width", x = j[D], M = x + y[J], T = x - y[B], S = g ? -Z[R] / 2 : 0, I = A === Or ? z[R] : Z[R], K = A === Or ? -Z[R] : -z[R], Y = t.elements.arrow, te = g && Y ? ga(Y) : {
        width: 0,
        height: 0
      }, pe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Fu(), Se = pe[J], ve = pe[B], ye = Cn(0, z[R], te[R]), ne = v ? z[R] / 2 - S - ye - Se - ee.mainAxis : I - ye - Se - ee.mainAxis, re = v ? -z[R] / 2 + S + ye + ve + ee.mainAxis : K + ye + ve + ee.mainAxis, ue = t.elements.arrow && Bn(t.elements.arrow), Ie = ue ? D === "y" ? ue.clientTop || 0 : ue.clientLeft || 0 : 0, h = (ce = X == null ? void 0 : X[D]) != null ? ce : 0, E = x + ne - h - Ie, N = x + re - h, k = Cn(g ? xs(M, E) : M, x, g ? Er(T, N) : T);
      j[D] = k, fe[D] = k - x;
    }
    if (a) {
      var L, P = D === "x" ? We : qe, G = D === "x" ? st : it, U = j[w], H = w === "y" ? "height" : "width", V = U + y[P], ie = U - y[G], W = [We, qe].indexOf(b) !== -1, se = (L = X == null ? void 0 : X[w]) != null ? L : 0, le = W ? V : U - z[H] - Z[H] - se + ee.altAxis, Ee = W ? U + z[H] + Z[H] - se - ee.altAxis : ie, Oe = g && W ? Lp(le, U, Ee) : Cn(g ? le : V, U, g ? Ee : ie);
      j[w] = Oe, fe[w] = Oe - U;
    }
    t.modifiersData[n] = fe;
  }
}
const qu = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: rh,
  requiresIfExists: ["offset"]
};
function nh(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function sh(e) {
  return e === ot(e) || !ct(e) ? Ea(e) : nh(e);
}
function ih(e) {
  var t = e.getBoundingClientRect(), r = zr(t.width) / e.offsetWidth || 1, n = zr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function oh(e, t, r) {
  r === void 0 && (r = !1);
  var n = ct(t), s = ct(t) && ih(t), i = cr(t), o = Jr(e, s, r), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Ft(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ba(i)) && (a = sh(t)), ct(t) ? (l = Jr(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = va(i))), {
    x: o.left + a.scrollLeft - l.x,
    y: o.top + a.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function ah(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function s(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(a) {
      if (!r.has(a)) {
        var l = t.get(a);
        l && s(l);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || s(i);
  }), n;
}
function lh(e) {
  var t = ah(e);
  return ku.reduce(function(r, n) {
    return r.concat(t.filter(function(s) {
      return s.phase === n;
    }));
  }, []);
}
function ch(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function uh(e) {
  var t = e.reduce(function(r, n) {
    var s = r[n.name];
    return r[n.name] = s ? Object.assign({}, s, n, {
      options: Object.assign({}, s.options, n.options),
      data: Object.assign({}, s.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var ml = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function yl() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function ei(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, s = t.defaultOptions, i = s === void 0 ? ml : s;
  return function(a, l, u) {
    u === void 0 && (u = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ml, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, g = {
      state: c,
      setOptions: function(b) {
        var A = typeof b == "function" ? b(c.options) : b;
        p(), c.options = Object.assign({}, i, c.options, A), c.scrollParents = {
          reference: Ar(a) ? Dn(a) : a.contextElement ? Dn(a.contextElement) : [],
          popper: Dn(l)
        };
        var v = lh(uh([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = v.filter(function(D) {
          return D.enabled;
        }), _(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var b = c.elements, A = b.reference, v = b.popper;
          if (yl(A, v)) {
            c.rects = {
              reference: oh(A, Bn(v), c.options.strategy === "fixed"),
              popper: ga(v)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(ee) {
              return c.modifiersData[ee.name] = Object.assign({}, ee.data);
            });
            for (var D = 0; D < c.orderedModifiers.length; D++) {
              if (c.reset === !0) {
                c.reset = !1, D = -1;
                continue;
              }
              var w = c.orderedModifiers[D], j = w.fn, z = w.options, Z = z === void 0 ? {} : z, Q = w.name;
              typeof j == "function" && (c = j({
                state: c,
                options: Z,
                name: Q,
                instance: g
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: ch(function() {
        return new Promise(function(y) {
          g.forceUpdate(), y(c);
        });
      }),
      destroy: function() {
        p(), f = !0;
      }
    };
    if (!yl(a, l))
      return g;
    g.setOptions(u).then(function(y) {
      !f && u.onFirstUpdate && u.onFirstUpdate(y);
    });
    function _() {
      c.orderedModifiers.forEach(function(y) {
        var b = y.name, A = y.options, v = A === void 0 ? {} : A, D = y.effect;
        if (typeof D == "function") {
          var w = D({
            state: c,
            name: b,
            instance: g,
            options: v
          }), j = function() {
          };
          d.push(w || j);
        }
      });
    }
    function p() {
      d.forEach(function(y) {
        return y();
      }), d = [];
    }
    return g;
  };
}
var dh = /* @__PURE__ */ ei(), fh = [ya, wa, ma, ha], ph = /* @__PURE__ */ ei({
  defaultModifiers: fh
}), hh = [ya, wa, ma, ha, Wu, Yu, qu, Uu, Gu], Ta = /* @__PURE__ */ ei({
  defaultModifiers: hh
});
const Ku = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  afterMain: Mu,
  afterRead: Cu,
  afterWrite: xu,
  applyStyles: ha,
  arrow: Uu,
  auto: Qs,
  basePlacements: rn,
  beforeMain: Du,
  beforeRead: Au,
  beforeWrite: Ru,
  bottom: st,
  clippingParents: Su,
  computeStyles: ma,
  createPopper: Ta,
  createPopperBase: dh,
  createPopperLite: ph,
  detectOverflow: Qr,
  end: Kr,
  eventListeners: ya,
  flip: Yu,
  hide: Gu,
  left: qe,
  main: Iu,
  modifierPhases: ku,
  offset: Wu,
  placements: fa,
  popper: Fr,
  popperGenerator: ei,
  popperOffsets: wa,
  preventOverflow: qu,
  read: Nu,
  reference: Ou,
  right: it,
  start: Or,
  top: We,
  variationPlacements: Co,
  viewport: da,
  write: Lu
}, Symbol.toStringTag, { value: "Module" }));
/*!
  * Bootstrap v5.3.6 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
const Jt = /* @__PURE__ */ new Map(), Ci = {
  set(e, t, r) {
    Jt.has(e) || Jt.set(e, /* @__PURE__ */ new Map());
    const n = Jt.get(e);
    if (!n.has(t) && n.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`);
      return;
    }
    n.set(t, r);
  },
  get(e, t) {
    return Jt.has(e) && Jt.get(e).get(t) || null;
  },
  remove(e, t) {
    if (!Jt.has(e))
      return;
    const r = Jt.get(e);
    r.delete(t), r.size === 0 && Jt.delete(e);
  }
}, gh = 1e6, _h = 1e3, Mo = "transitionend", zu = (e) => (e && window.CSS && window.CSS.escape && (e = e.replace(/#([^\s"#']+)/g, (t, r) => `#${CSS.escape(r)}`)), e), mh = (e) => e == null ? `${e}` : Object.prototype.toString.call(e).match(/\s([a-z]+)/i)[1].toLowerCase(), yh = (e) => {
  do
    e += Math.floor(Math.random() * gh);
  while (document.getElementById(e));
  return e;
}, Eh = (e) => {
  if (!e)
    return 0;
  let {
    transitionDuration: t,
    transitionDelay: r
  } = window.getComputedStyle(e);
  const n = Number.parseFloat(t), s = Number.parseFloat(r);
  return !n && !s ? 0 : (t = t.split(",")[0], r = r.split(",")[0], (Number.parseFloat(t) + Number.parseFloat(r)) * _h);
}, Ju = (e) => {
  e.dispatchEvent(new Event(Mo));
}, Gt = (e) => !e || typeof e != "object" ? !1 : (typeof e.jquery < "u" && (e = e[0]), typeof e.nodeType < "u"), sr = (e) => Gt(e) ? e.jquery ? e[0] : e : typeof e == "string" && e.length > 0 ? document.querySelector(zu(e)) : null, nn = (e) => {
  if (!Gt(e) || e.getClientRects().length === 0)
    return !1;
  const t = getComputedStyle(e).getPropertyValue("visibility") === "visible", r = e.closest("details:not([open])");
  if (!r)
    return t;
  if (r !== e) {
    const n = e.closest("summary");
    if (n && n.parentNode !== r || n === null)
      return !1;
  }
  return t;
}, ir = (e) => !e || e.nodeType !== Node.ELEMENT_NODE || e.classList.contains("disabled") ? !0 : typeof e.disabled < "u" ? e.disabled : e.hasAttribute("disabled") && e.getAttribute("disabled") !== "false", Xu = (e) => {
  if (!document.documentElement.attachShadow)
    return null;
  if (typeof e.getRootNode == "function") {
    const t = e.getRootNode();
    return t instanceof ShadowRoot ? t : null;
  }
  return e instanceof ShadowRoot ? e : e.parentNode ? Xu(e.parentNode) : null;
}, ks = () => {
}, Un = (e) => {
  e.offsetHeight;
}, Qu = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, Di = [], vh = (e) => {
  document.readyState === "loading" ? (Di.length || document.addEventListener("DOMContentLoaded", () => {
    for (const t of Di)
      t();
  }), Di.push(e)) : e();
}, ut = () => document.documentElement.dir === "rtl", ft = (e) => {
  vh(() => {
    const t = Qu();
    if (t) {
      const r = e.NAME, n = t.fn[r];
      t.fn[r] = e.jQueryInterface, t.fn[r].Constructor = e, t.fn[r].noConflict = () => (t.fn[r] = n, e.jQueryInterface);
    }
  });
}, Je = (e, t = [], r = e) => typeof e == "function" ? e.call(...t) : r, Zu = (e, t, r = !0) => {
  if (!r) {
    Je(e);
    return;
  }
  const s = Eh(t) + 5;
  let i = !1;
  const o = ({
    target: a
  }) => {
    a === t && (i = !0, t.removeEventListener(Mo, o), Je(e));
  };
  t.addEventListener(Mo, o), setTimeout(() => {
    i || Ju(t);
  }, s);
}, Sa = (e, t, r, n) => {
  const s = e.length;
  let i = e.indexOf(t);
  return i === -1 ? !r && n ? e[s - 1] : e[0] : (i += r ? 1 : -1, n && (i = (i + s) % s), e[Math.max(0, Math.min(i, s - 1))]);
}, bh = /[^.]*(?=\..*)\.|.*/, wh = /\..*/, Th = /::\d+$/, Ii = {};
let El = 1;
const ed = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
}, Sh = /* @__PURE__ */ new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);
function td(e, t) {
  return t && `${t}::${El++}` || e.uidEvent || El++;
}
function rd(e) {
  const t = td(e);
  return e.uidEvent = t, Ii[t] = Ii[t] || {}, Ii[t];
}
function Oh(e, t) {
  return function r(n) {
    return Oa(n, {
      delegateTarget: e
    }), r.oneOff && F.off(e, n.type, t), t.apply(e, [n]);
  };
}
function Ah(e, t, r) {
  return function n(s) {
    const i = e.querySelectorAll(t);
    for (let {
      target: o
    } = s; o && o !== this; o = o.parentNode)
      for (const a of i)
        if (a === o)
          return Oa(s, {
            delegateTarget: o
          }), n.oneOff && F.off(e, s.type, t, r), r.apply(o, [s]);
  };
}
function nd(e, t, r = null) {
  return Object.values(e).find((n) => n.callable === t && n.delegationSelector === r);
}
function sd(e, t, r) {
  const n = typeof t == "string", s = n ? r : t || r;
  let i = id(e);
  return Sh.has(i) || (i = e), [n, s, i];
}
function vl(e, t, r, n, s) {
  if (typeof t != "string" || !e)
    return;
  let [i, o, a] = sd(t, r, n);
  t in ed && (o = ((_) => function(p) {
    if (!p.relatedTarget || p.relatedTarget !== p.delegateTarget && !p.delegateTarget.contains(p.relatedTarget))
      return _.call(this, p);
  })(o));
  const l = rd(e), u = l[a] || (l[a] = {}), c = nd(u, o, i ? r : null);
  if (c) {
    c.oneOff = c.oneOff && s;
    return;
  }
  const d = td(o, t.replace(bh, "")), f = i ? Ah(e, r, o) : Oh(e, o);
  f.delegationSelector = i ? r : null, f.callable = o, f.oneOff = s, f.uidEvent = d, u[d] = f, e.addEventListener(a, f, i);
}
function Ro(e, t, r, n, s) {
  const i = nd(t[r], n, s);
  i && (e.removeEventListener(r, i, !!s), delete t[r][i.uidEvent]);
}
function Nh(e, t, r, n) {
  const s = t[r] || {};
  for (const [i, o] of Object.entries(s))
    i.includes(n) && Ro(e, t, r, o.callable, o.delegationSelector);
}
function id(e) {
  return e = e.replace(wh, ""), ed[e] || e;
}
const F = {
  on(e, t, r, n) {
    vl(e, t, r, n, !1);
  },
  one(e, t, r, n) {
    vl(e, t, r, n, !0);
  },
  off(e, t, r, n) {
    if (typeof t != "string" || !e)
      return;
    const [s, i, o] = sd(t, r, n), a = o !== t, l = rd(e), u = l[o] || {}, c = t.startsWith(".");
    if (typeof i < "u") {
      if (!Object.keys(u).length)
        return;
      Ro(e, l, o, i, s ? r : null);
      return;
    }
    if (c)
      for (const d of Object.keys(l))
        Nh(e, l, d, t.slice(1));
    for (const [d, f] of Object.entries(u)) {
      const g = d.replace(Th, "");
      (!a || t.includes(g)) && Ro(e, l, o, f.callable, f.delegationSelector);
    }
  },
  trigger(e, t, r) {
    if (typeof t != "string" || !e)
      return null;
    const n = Qu(), s = id(t), i = t !== s;
    let o = null, a = !0, l = !0, u = !1;
    i && n && (o = n.Event(t, r), n(e).trigger(o), a = !o.isPropagationStopped(), l = !o.isImmediatePropagationStopped(), u = o.isDefaultPrevented());
    const c = Oa(new Event(t, {
      bubbles: a,
      cancelable: !0
    }), r);
    return u && c.preventDefault(), l && e.dispatchEvent(c), c.defaultPrevented && o && o.preventDefault(), c;
  }
};
function Oa(e, t = {}) {
  for (const [r, n] of Object.entries(t))
    try {
      e[r] = n;
    } catch {
      Object.defineProperty(e, r, {
        configurable: !0,
        get() {
          return n;
        }
      });
    }
  return e;
}
function bl(e) {
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  if (e === Number(e).toString())
    return Number(e);
  if (e === "" || e === "null")
    return null;
  if (typeof e != "string")
    return e;
  try {
    return JSON.parse(decodeURIComponent(e));
  } catch {
    return e;
  }
}
function Mi(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
}
const Wt = {
  setDataAttribute(e, t, r) {
    e.setAttribute(`data-bs-${Mi(t)}`, r);
  },
  removeDataAttribute(e, t) {
    e.removeAttribute(`data-bs-${Mi(t)}`);
  },
  getDataAttributes(e) {
    if (!e)
      return {};
    const t = {}, r = Object.keys(e.dataset).filter((n) => n.startsWith("bs") && !n.startsWith("bsConfig"));
    for (const n of r) {
      let s = n.replace(/^bs/, "");
      s = s.charAt(0).toLowerCase() + s.slice(1), t[s] = bl(e.dataset[n]);
    }
    return t;
  },
  getDataAttribute(e, t) {
    return bl(e.getAttribute(`data-bs-${Mi(t)}`));
  }
};
class Hn {
  // Getters
  static get Default() {
    return {};
  }
  static get DefaultType() {
    return {};
  }
  static get NAME() {
    throw new Error('You have to implement the static method "NAME", for each component!');
  }
  _getConfig(t) {
    return t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  _configAfterMerge(t) {
    return t;
  }
  _mergeConfigObj(t, r) {
    const n = Gt(r) ? Wt.getDataAttribute(r, "config") : {};
    return {
      ...this.constructor.Default,
      ...typeof n == "object" ? n : {},
      ...Gt(r) ? Wt.getDataAttributes(r) : {},
      ...typeof t == "object" ? t : {}
    };
  }
  _typeCheckConfig(t, r = this.constructor.DefaultType) {
    for (const [n, s] of Object.entries(r)) {
      const i = t[n], o = Gt(i) ? "element" : mh(i);
      if (!new RegExp(s).test(o))
        throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${n}" provided type "${o}" but expected type "${s}".`);
    }
  }
}
const Ch = "5.3.6";
class Tt extends Hn {
  constructor(t, r) {
    super(), t = sr(t), t && (this._element = t, this._config = this._getConfig(r), Ci.set(this._element, this.constructor.DATA_KEY, this));
  }
  // Public
  dispose() {
    Ci.remove(this._element, this.constructor.DATA_KEY), F.off(this._element, this.constructor.EVENT_KEY);
    for (const t of Object.getOwnPropertyNames(this))
      this[t] = null;
  }
  // Private
  _queueCallback(t, r, n = !0) {
    Zu(t, r, n);
  }
  _getConfig(t) {
    return t = this._mergeConfigObj(t, this._element), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  // Static
  static getInstance(t) {
    return Ci.get(sr(t), this.DATA_KEY);
  }
  static getOrCreateInstance(t, r = {}) {
    return this.getInstance(t) || new this(t, typeof r == "object" ? r : null);
  }
  static get VERSION() {
    return Ch;
  }
  static get DATA_KEY() {
    return `bs.${this.NAME}`;
  }
  static get EVENT_KEY() {
    return `.${this.DATA_KEY}`;
  }
  static eventName(t) {
    return `${t}${this.EVENT_KEY}`;
  }
}
const Ri = (e) => {
  let t = e.getAttribute("data-bs-target");
  if (!t || t === "#") {
    let r = e.getAttribute("href");
    if (!r || !r.includes("#") && !r.startsWith("."))
      return null;
    r.includes("#") && !r.startsWith("#") && (r = `#${r.split("#")[1]}`), t = r && r !== "#" ? r.trim() : null;
  }
  return t ? t.split(",").map((r) => zu(r)).join(",") : null;
}, oe = {
  find(e, t = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(t, e));
  },
  findOne(e, t = document.documentElement) {
    return Element.prototype.querySelector.call(t, e);
  },
  children(e, t) {
    return [].concat(...e.children).filter((r) => r.matches(t));
  },
  parents(e, t) {
    const r = [];
    let n = e.parentNode.closest(t);
    for (; n; )
      r.push(n), n = n.parentNode.closest(t);
    return r;
  },
  prev(e, t) {
    let r = e.previousElementSibling;
    for (; r; ) {
      if (r.matches(t))
        return [r];
      r = r.previousElementSibling;
    }
    return [];
  },
  // TODO: this is now unused; remove later along with prev()
  next(e, t) {
    let r = e.nextElementSibling;
    for (; r; ) {
      if (r.matches(t))
        return [r];
      r = r.nextElementSibling;
    }
    return [];
  },
  focusableChildren(e) {
    const t = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((r) => `${r}:not([tabindex^="-"])`).join(",");
    return this.find(t, e).filter((r) => !ir(r) && nn(r));
  },
  getSelectorFromElement(e) {
    const t = Ri(e);
    return t && oe.findOne(t) ? t : null;
  },
  getElementFromSelector(e) {
    const t = Ri(e);
    return t ? oe.findOne(t) : null;
  },
  getMultipleElementsFromSelector(e) {
    const t = Ri(e);
    return t ? oe.find(t) : [];
  }
}, ti = (e, t = "hide") => {
  const r = `click.dismiss${e.EVENT_KEY}`, n = e.NAME;
  F.on(document, r, `[data-bs-dismiss="${n}"]`, function(s) {
    if (["A", "AREA"].includes(this.tagName) && s.preventDefault(), ir(this))
      return;
    const i = oe.getElementFromSelector(this) || this.closest(`.${n}`);
    e.getOrCreateInstance(i)[t]();
  });
}, Dh = "alert", Ih = "bs.alert", od = `.${Ih}`, Mh = `close${od}`, Rh = `closed${od}`, Lh = "fade", xh = "show";
class ri extends Tt {
  // Getters
  static get NAME() {
    return Dh;
  }
  // Public
  close() {
    if (F.trigger(this._element, Mh).defaultPrevented)
      return;
    this._element.classList.remove(xh);
    const r = this._element.classList.contains(Lh);
    this._queueCallback(() => this._destroyElement(), this._element, r);
  }
  // Private
  _destroyElement() {
    this._element.remove(), F.trigger(this._element, Rh), this.dispose();
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = ri.getOrCreateInstance(this);
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t](this);
      }
    });
  }
}
ti(ri, "close");
ft(ri);
const kh = "button", Ph = "bs.button", $h = `.${Ph}`, Fh = ".data-api", Vh = "active", wl = '[data-bs-toggle="button"]', Bh = `click${$h}${Fh}`;
class ni extends Tt {
  // Getters
  static get NAME() {
    return kh;
  }
  // Public
  toggle() {
    this._element.setAttribute("aria-pressed", this._element.classList.toggle(Vh));
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = ni.getOrCreateInstance(this);
      t === "toggle" && r[t]();
    });
  }
}
F.on(document, Bh, wl, (e) => {
  e.preventDefault();
  const t = e.target.closest(wl);
  ni.getOrCreateInstance(t).toggle();
});
ft(ni);
const Uh = "swipe", sn = ".bs.swipe", Hh = `touchstart${sn}`, jh = `touchmove${sn}`, Yh = `touchend${sn}`, Gh = `pointerdown${sn}`, Wh = `pointerup${sn}`, qh = "touch", Kh = "pen", zh = "pointer-event", Jh = 40, Xh = {
  endCallback: null,
  leftCallback: null,
  rightCallback: null
}, Qh = {
  endCallback: "(function|null)",
  leftCallback: "(function|null)",
  rightCallback: "(function|null)"
};
class Ps extends Hn {
  constructor(t, r) {
    super(), this._element = t, !(!t || !Ps.isSupported()) && (this._config = this._getConfig(r), this._deltaX = 0, this._supportPointerEvents = !!window.PointerEvent, this._initEvents());
  }
  // Getters
  static get Default() {
    return Xh;
  }
  static get DefaultType() {
    return Qh;
  }
  static get NAME() {
    return Uh;
  }
  // Public
  dispose() {
    F.off(this._element, sn);
  }
  // Private
  _start(t) {
    if (!this._supportPointerEvents) {
      this._deltaX = t.touches[0].clientX;
      return;
    }
    this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX);
  }
  _end(t) {
    this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX - this._deltaX), this._handleSwipe(), Je(this._config.endCallback);
  }
  _move(t) {
    this._deltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this._deltaX;
  }
  _handleSwipe() {
    const t = Math.abs(this._deltaX);
    if (t <= Jh)
      return;
    const r = t / this._deltaX;
    this._deltaX = 0, r && Je(r > 0 ? this._config.rightCallback : this._config.leftCallback);
  }
  _initEvents() {
    this._supportPointerEvents ? (F.on(this._element, Gh, (t) => this._start(t)), F.on(this._element, Wh, (t) => this._end(t)), this._element.classList.add(zh)) : (F.on(this._element, Hh, (t) => this._start(t)), F.on(this._element, jh, (t) => this._move(t)), F.on(this._element, Yh, (t) => this._end(t)));
  }
  _eventIsPointerPenTouch(t) {
    return this._supportPointerEvents && (t.pointerType === Kh || t.pointerType === qh);
  }
  // Static
  static isSupported() {
    return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
  }
}
const Zh = "carousel", eg = "bs.carousel", ur = `.${eg}`, ad = ".data-api", tg = "ArrowLeft", rg = "ArrowRight", ng = 500, _n = "next", Lr = "prev", Vr = "left", fs = "right", sg = `slide${ur}`, Li = `slid${ur}`, ig = `keydown${ur}`, og = `mouseenter${ur}`, ag = `mouseleave${ur}`, lg = `dragstart${ur}`, cg = `load${ur}${ad}`, ug = `click${ur}${ad}`, ld = "carousel", Zn = "active", dg = "slide", fg = "carousel-item-end", pg = "carousel-item-start", hg = "carousel-item-next", gg = "carousel-item-prev", cd = ".active", ud = ".carousel-item", _g = cd + ud, mg = ".carousel-item img", yg = ".carousel-indicators", Eg = "[data-bs-slide], [data-bs-slide-to]", vg = '[data-bs-ride="carousel"]', bg = {
  [tg]: fs,
  [rg]: Vr
}, wg = {
  interval: 5e3,
  keyboard: !0,
  pause: "hover",
  ride: !1,
  touch: !0,
  wrap: !0
}, Tg = {
  interval: "(number|boolean)",
  // TODO:v6 remove boolean support
  keyboard: "boolean",
  pause: "(string|boolean)",
  ride: "(boolean|string)",
  touch: "boolean",
  wrap: "boolean"
};
class jn extends Tt {
  constructor(t, r) {
    super(t, r), this._interval = null, this._activeElement = null, this._isSliding = !1, this.touchTimeout = null, this._swipeHelper = null, this._indicatorsElement = oe.findOne(yg, this._element), this._addEventListeners(), this._config.ride === ld && this.cycle();
  }
  // Getters
  static get Default() {
    return wg;
  }
  static get DefaultType() {
    return Tg;
  }
  static get NAME() {
    return Zh;
  }
  // Public
  next() {
    this._slide(_n);
  }
  nextWhenVisible() {
    !document.hidden && nn(this._element) && this.next();
  }
  prev() {
    this._slide(Lr);
  }
  pause() {
    this._isSliding && Ju(this._element), this._clearInterval();
  }
  cycle() {
    this._clearInterval(), this._updateInterval(), this._interval = setInterval(() => this.nextWhenVisible(), this._config.interval);
  }
  _maybeEnableCycle() {
    if (this._config.ride) {
      if (this._isSliding) {
        F.one(this._element, Li, () => this.cycle());
        return;
      }
      this.cycle();
    }
  }
  to(t) {
    const r = this._getItems();
    if (t > r.length - 1 || t < 0)
      return;
    if (this._isSliding) {
      F.one(this._element, Li, () => this.to(t));
      return;
    }
    const n = this._getItemIndex(this._getActive());
    if (n === t)
      return;
    const s = t > n ? _n : Lr;
    this._slide(s, r[t]);
  }
  dispose() {
    this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
  }
  // Private
  _configAfterMerge(t) {
    return t.defaultInterval = t.interval, t;
  }
  _addEventListeners() {
    this._config.keyboard && F.on(this._element, ig, (t) => this._keydown(t)), this._config.pause === "hover" && (F.on(this._element, og, () => this.pause()), F.on(this._element, ag, () => this._maybeEnableCycle())), this._config.touch && Ps.isSupported() && this._addTouchEventListeners();
  }
  _addTouchEventListeners() {
    for (const n of oe.find(mg, this._element))
      F.on(n, lg, (s) => s.preventDefault());
    const r = {
      leftCallback: () => this._slide(this._directionToOrder(Vr)),
      rightCallback: () => this._slide(this._directionToOrder(fs)),
      endCallback: () => {
        this._config.pause === "hover" && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout(() => this._maybeEnableCycle(), ng + this._config.interval));
      }
    };
    this._swipeHelper = new Ps(this._element, r);
  }
  _keydown(t) {
    if (/input|textarea/i.test(t.target.tagName))
      return;
    const r = bg[t.key];
    r && (t.preventDefault(), this._slide(this._directionToOrder(r)));
  }
  _getItemIndex(t) {
    return this._getItems().indexOf(t);
  }
  _setActiveIndicatorElement(t) {
    if (!this._indicatorsElement)
      return;
    const r = oe.findOne(cd, this._indicatorsElement);
    r.classList.remove(Zn), r.removeAttribute("aria-current");
    const n = oe.findOne(`[data-bs-slide-to="${t}"]`, this._indicatorsElement);
    n && (n.classList.add(Zn), n.setAttribute("aria-current", "true"));
  }
  _updateInterval() {
    const t = this._activeElement || this._getActive();
    if (!t)
      return;
    const r = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
    this._config.interval = r || this._config.defaultInterval;
  }
  _slide(t, r = null) {
    if (this._isSliding)
      return;
    const n = this._getActive(), s = t === _n, i = r || Sa(this._getItems(), n, s, this._config.wrap);
    if (i === n)
      return;
    const o = this._getItemIndex(i), a = (g) => F.trigger(this._element, g, {
      relatedTarget: i,
      direction: this._orderToDirection(t),
      from: this._getItemIndex(n),
      to: o
    });
    if (a(sg).defaultPrevented || !n || !i)
      return;
    const u = !!this._interval;
    this.pause(), this._isSliding = !0, this._setActiveIndicatorElement(o), this._activeElement = i;
    const c = s ? pg : fg, d = s ? hg : gg;
    i.classList.add(d), Un(i), n.classList.add(c), i.classList.add(c);
    const f = () => {
      i.classList.remove(c, d), i.classList.add(Zn), n.classList.remove(Zn, d, c), this._isSliding = !1, a(Li);
    };
    this._queueCallback(f, n, this._isAnimated()), u && this.cycle();
  }
  _isAnimated() {
    return this._element.classList.contains(dg);
  }
  _getActive() {
    return oe.findOne(_g, this._element);
  }
  _getItems() {
    return oe.find(ud, this._element);
  }
  _clearInterval() {
    this._interval && (clearInterval(this._interval), this._interval = null);
  }
  _directionToOrder(t) {
    return ut() ? t === Vr ? Lr : _n : t === Vr ? _n : Lr;
  }
  _orderToDirection(t) {
    return ut() ? t === Lr ? Vr : fs : t === Lr ? fs : Vr;
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = jn.getOrCreateInstance(this, t);
      if (typeof t == "number") {
        r.to(t);
        return;
      }
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
F.on(document, ug, Eg, function(e) {
  const t = oe.getElementFromSelector(this);
  if (!t || !t.classList.contains(ld))
    return;
  e.preventDefault();
  const r = jn.getOrCreateInstance(t), n = this.getAttribute("data-bs-slide-to");
  if (n) {
    r.to(n), r._maybeEnableCycle();
    return;
  }
  if (Wt.getDataAttribute(this, "slide") === "next") {
    r.next(), r._maybeEnableCycle();
    return;
  }
  r.prev(), r._maybeEnableCycle();
});
F.on(window, cg, () => {
  const e = oe.find(vg);
  for (const t of e)
    jn.getOrCreateInstance(t);
});
ft(jn);
const Sg = "collapse", Og = "bs.collapse", Yn = `.${Og}`, Ag = ".data-api", Ng = `show${Yn}`, Cg = `shown${Yn}`, Dg = `hide${Yn}`, Ig = `hidden${Yn}`, Mg = `click${Yn}${Ag}`, xi = "show", Hr = "collapse", es = "collapsing", Rg = "collapsed", Lg = `:scope .${Hr} .${Hr}`, xg = "collapse-horizontal", kg = "width", Pg = "height", $g = ".collapse.show, .collapse.collapsing", Lo = '[data-bs-toggle="collapse"]', Fg = {
  parent: null,
  toggle: !0
}, Vg = {
  parent: "(null|element)",
  toggle: "boolean"
};
class Zr extends Tt {
  constructor(t, r) {
    super(t, r), this._isTransitioning = !1, this._triggerArray = [];
    const n = oe.find(Lo);
    for (const s of n) {
      const i = oe.getSelectorFromElement(s), o = oe.find(i).filter((a) => a === this._element);
      i !== null && o.length && this._triggerArray.push(s);
    }
    this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
  }
  // Getters
  static get Default() {
    return Fg;
  }
  static get DefaultType() {
    return Vg;
  }
  static get NAME() {
    return Sg;
  }
  // Public
  toggle() {
    this._isShown() ? this.hide() : this.show();
  }
  show() {
    if (this._isTransitioning || this._isShown())
      return;
    let t = [];
    if (this._config.parent && (t = this._getFirstLevelChildren($g).filter((a) => a !== this._element).map((a) => Zr.getOrCreateInstance(a, {
      toggle: !1
    }))), t.length && t[0]._isTransitioning || F.trigger(this._element, Ng).defaultPrevented)
      return;
    for (const a of t)
      a.hide();
    const n = this._getDimension();
    this._element.classList.remove(Hr), this._element.classList.add(es), this._element.style[n] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
    const s = () => {
      this._isTransitioning = !1, this._element.classList.remove(es), this._element.classList.add(Hr, xi), this._element.style[n] = "", F.trigger(this._element, Cg);
    }, o = `scroll${n[0].toUpperCase() + n.slice(1)}`;
    this._queueCallback(s, this._element, !0), this._element.style[n] = `${this._element[o]}px`;
  }
  hide() {
    if (this._isTransitioning || !this._isShown() || F.trigger(this._element, Dg).defaultPrevented)
      return;
    const r = this._getDimension();
    this._element.style[r] = `${this._element.getBoundingClientRect()[r]}px`, Un(this._element), this._element.classList.add(es), this._element.classList.remove(Hr, xi);
    for (const s of this._triggerArray) {
      const i = oe.getElementFromSelector(s);
      i && !this._isShown(i) && this._addAriaAndCollapsedClass([s], !1);
    }
    this._isTransitioning = !0;
    const n = () => {
      this._isTransitioning = !1, this._element.classList.remove(es), this._element.classList.add(Hr), F.trigger(this._element, Ig);
    };
    this._element.style[r] = "", this._queueCallback(n, this._element, !0);
  }
  // Private
  _isShown(t = this._element) {
    return t.classList.contains(xi);
  }
  _configAfterMerge(t) {
    return t.toggle = !!t.toggle, t.parent = sr(t.parent), t;
  }
  _getDimension() {
    return this._element.classList.contains(xg) ? kg : Pg;
  }
  _initializeChildren() {
    if (!this._config.parent)
      return;
    const t = this._getFirstLevelChildren(Lo);
    for (const r of t) {
      const n = oe.getElementFromSelector(r);
      n && this._addAriaAndCollapsedClass([r], this._isShown(n));
    }
  }
  _getFirstLevelChildren(t) {
    const r = oe.find(Lg, this._config.parent);
    return oe.find(t, this._config.parent).filter((n) => !r.includes(n));
  }
  _addAriaAndCollapsedClass(t, r) {
    if (t.length)
      for (const n of t)
        n.classList.toggle(Rg, !r), n.setAttribute("aria-expanded", r);
  }
  // Static
  static jQueryInterface(t) {
    const r = {};
    return typeof t == "string" && /show|hide/.test(t) && (r.toggle = !1), this.each(function() {
      const n = Zr.getOrCreateInstance(this, r);
      if (typeof t == "string") {
        if (typeof n[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        n[t]();
      }
    });
  }
}
F.on(document, Mg, Lo, function(e) {
  (e.target.tagName === "A" || e.delegateTarget && e.delegateTarget.tagName === "A") && e.preventDefault();
  for (const t of oe.getMultipleElementsFromSelector(this))
    Zr.getOrCreateInstance(t, {
      toggle: !1
    }).toggle();
});
ft(Zr);
const Tl = "dropdown", Bg = "bs.dropdown", Dr = `.${Bg}`, Aa = ".data-api", Ug = "Escape", Sl = "Tab", Hg = "ArrowUp", Ol = "ArrowDown", jg = 2, Yg = `hide${Dr}`, Gg = `hidden${Dr}`, Wg = `show${Dr}`, qg = `shown${Dr}`, dd = `click${Dr}${Aa}`, fd = `keydown${Dr}${Aa}`, Kg = `keyup${Dr}${Aa}`, Br = "show", zg = "dropup", Jg = "dropend", Xg = "dropstart", Qg = "dropup-center", Zg = "dropdown-center", _r = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', e_ = `${_r}.${Br}`, ps = ".dropdown-menu", t_ = ".navbar", r_ = ".navbar-nav", n_ = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", s_ = ut() ? "top-end" : "top-start", i_ = ut() ? "top-start" : "top-end", o_ = ut() ? "bottom-end" : "bottom-start", a_ = ut() ? "bottom-start" : "bottom-end", l_ = ut() ? "left-start" : "right-start", c_ = ut() ? "right-start" : "left-start", u_ = "top", d_ = "bottom", f_ = {
  autoClose: !0,
  boundary: "clippingParents",
  display: "dynamic",
  offset: [0, 2],
  popperConfig: null,
  reference: "toggle"
}, p_ = {
  autoClose: "(boolean|string)",
  boundary: "(string|element)",
  display: "string",
  offset: "(array|string|function)",
  popperConfig: "(null|object|function)",
  reference: "(string|element|object)"
};
class mt extends Tt {
  constructor(t, r) {
    super(t, r), this._popper = null, this._parent = this._element.parentNode, this._menu = oe.next(this._element, ps)[0] || oe.prev(this._element, ps)[0] || oe.findOne(ps, this._parent), this._inNavbar = this._detectNavbar();
  }
  // Getters
  static get Default() {
    return f_;
  }
  static get DefaultType() {
    return p_;
  }
  static get NAME() {
    return Tl;
  }
  // Public
  toggle() {
    return this._isShown() ? this.hide() : this.show();
  }
  show() {
    if (ir(this._element) || this._isShown())
      return;
    const t = {
      relatedTarget: this._element
    };
    if (!F.trigger(this._element, Wg, t).defaultPrevented) {
      if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest(r_))
        for (const n of [].concat(...document.body.children))
          F.on(n, "mouseover", ks);
      this._element.focus(), this._element.setAttribute("aria-expanded", !0), this._menu.classList.add(Br), this._element.classList.add(Br), F.trigger(this._element, qg, t);
    }
  }
  hide() {
    if (ir(this._element) || !this._isShown())
      return;
    const t = {
      relatedTarget: this._element
    };
    this._completeHide(t);
  }
  dispose() {
    this._popper && this._popper.destroy(), super.dispose();
  }
  update() {
    this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
  }
  // Private
  _completeHide(t) {
    if (!F.trigger(this._element, Yg, t).defaultPrevented) {
      if ("ontouchstart" in document.documentElement)
        for (const n of [].concat(...document.body.children))
          F.off(n, "mouseover", ks);
      this._popper && this._popper.destroy(), this._menu.classList.remove(Br), this._element.classList.remove(Br), this._element.setAttribute("aria-expanded", "false"), Wt.removeDataAttribute(this._menu, "popper"), F.trigger(this._element, Gg, t), this._element.focus();
    }
  }
  _getConfig(t) {
    if (t = super._getConfig(t), typeof t.reference == "object" && !Gt(t.reference) && typeof t.reference.getBoundingClientRect != "function")
      throw new TypeError(`${Tl.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
    return t;
  }
  _createPopper() {
    if (typeof Ku > "u")
      throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org/docs/v2/)");
    let t = this._element;
    this._config.reference === "parent" ? t = this._parent : Gt(this._config.reference) ? t = sr(this._config.reference) : typeof this._config.reference == "object" && (t = this._config.reference);
    const r = this._getPopperConfig();
    this._popper = Ta(t, this._menu, r);
  }
  _isShown() {
    return this._menu.classList.contains(Br);
  }
  _getPlacement() {
    const t = this._parent;
    if (t.classList.contains(Jg))
      return l_;
    if (t.classList.contains(Xg))
      return c_;
    if (t.classList.contains(Qg))
      return u_;
    if (t.classList.contains(Zg))
      return d_;
    const r = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
    return t.classList.contains(zg) ? r ? i_ : s_ : r ? a_ : o_;
  }
  _detectNavbar() {
    return this._element.closest(t_) !== null;
  }
  _getOffset() {
    const {
      offset: t
    } = this._config;
    return typeof t == "string" ? t.split(",").map((r) => Number.parseInt(r, 10)) : typeof t == "function" ? (r) => t(r, this._element) : t;
  }
  _getPopperConfig() {
    const t = {
      placement: this._getPlacement(),
      modifiers: [{
        name: "preventOverflow",
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: "offset",
        options: {
          offset: this._getOffset()
        }
      }]
    };
    return (this._inNavbar || this._config.display === "static") && (Wt.setDataAttribute(this._menu, "popper", "static"), t.modifiers = [{
      name: "applyStyles",
      enabled: !1
    }]), {
      ...t,
      ...Je(this._config.popperConfig, [void 0, t])
    };
  }
  _selectMenuItem({
    key: t,
    target: r
  }) {
    const n = oe.find(n_, this._menu).filter((s) => nn(s));
    n.length && Sa(n, r, t === Ol, !n.includes(r)).focus();
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = mt.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof r[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
  static clearMenus(t) {
    if (t.button === jg || t.type === "keyup" && t.key !== Sl)
      return;
    const r = oe.find(e_);
    for (const n of r) {
      const s = mt.getInstance(n);
      if (!s || s._config.autoClose === !1)
        continue;
      const i = t.composedPath(), o = i.includes(s._menu);
      if (i.includes(s._element) || s._config.autoClose === "inside" && !o || s._config.autoClose === "outside" && o || s._menu.contains(t.target) && (t.type === "keyup" && t.key === Sl || /input|select|option|textarea|form/i.test(t.target.tagName)))
        continue;
      const a = {
        relatedTarget: s._element
      };
      t.type === "click" && (a.clickEvent = t), s._completeHide(a);
    }
  }
  static dataApiKeydownHandler(t) {
    const r = /input|textarea/i.test(t.target.tagName), n = t.key === Ug, s = [Hg, Ol].includes(t.key);
    if (!s && !n || r && !n)
      return;
    t.preventDefault();
    const i = this.matches(_r) ? this : oe.prev(this, _r)[0] || oe.next(this, _r)[0] || oe.findOne(_r, t.delegateTarget.parentNode), o = mt.getOrCreateInstance(i);
    if (s) {
      t.stopPropagation(), o.show(), o._selectMenuItem(t);
      return;
    }
    o._isShown() && (t.stopPropagation(), o.hide(), i.focus());
  }
}
F.on(document, fd, _r, mt.dataApiKeydownHandler);
F.on(document, fd, ps, mt.dataApiKeydownHandler);
F.on(document, dd, mt.clearMenus);
F.on(document, Kg, mt.clearMenus);
F.on(document, dd, _r, function(e) {
  e.preventDefault(), mt.getOrCreateInstance(this).toggle();
});
ft(mt);
const pd = "backdrop", h_ = "fade", Al = "show", Nl = `mousedown.bs.${pd}`, g_ = {
  className: "modal-backdrop",
  clickCallback: null,
  isAnimated: !1,
  isVisible: !0,
  // if false, we use the backdrop helper without adding any element to the dom
  rootElement: "body"
  // give the choice to place backdrop under different elements
}, __ = {
  className: "string",
  clickCallback: "(function|null)",
  isAnimated: "boolean",
  isVisible: "boolean",
  rootElement: "(element|string)"
};
class hd extends Hn {
  constructor(t) {
    super(), this._config = this._getConfig(t), this._isAppended = !1, this._element = null;
  }
  // Getters
  static get Default() {
    return g_;
  }
  static get DefaultType() {
    return __;
  }
  static get NAME() {
    return pd;
  }
  // Public
  show(t) {
    if (!this._config.isVisible) {
      Je(t);
      return;
    }
    this._append();
    const r = this._getElement();
    this._config.isAnimated && Un(r), r.classList.add(Al), this._emulateAnimation(() => {
      Je(t);
    });
  }
  hide(t) {
    if (!this._config.isVisible) {
      Je(t);
      return;
    }
    this._getElement().classList.remove(Al), this._emulateAnimation(() => {
      this.dispose(), Je(t);
    });
  }
  dispose() {
    this._isAppended && (F.off(this._element, Nl), this._element.remove(), this._isAppended = !1);
  }
  // Private
  _getElement() {
    if (!this._element) {
      const t = document.createElement("div");
      t.className = this._config.className, this._config.isAnimated && t.classList.add(h_), this._element = t;
    }
    return this._element;
  }
  _configAfterMerge(t) {
    return t.rootElement = sr(t.rootElement), t;
  }
  _append() {
    if (this._isAppended)
      return;
    const t = this._getElement();
    this._config.rootElement.append(t), F.on(t, Nl, () => {
      Je(this._config.clickCallback);
    }), this._isAppended = !0;
  }
  _emulateAnimation(t) {
    Zu(t, this._getElement(), this._config.isAnimated);
  }
}
const m_ = "focustrap", y_ = "bs.focustrap", $s = `.${y_}`, E_ = `focusin${$s}`, v_ = `keydown.tab${$s}`, b_ = "Tab", w_ = "forward", Cl = "backward", T_ = {
  autofocus: !0,
  trapElement: null
  // The element to trap focus inside of
}, S_ = {
  autofocus: "boolean",
  trapElement: "element"
};
class gd extends Hn {
  constructor(t) {
    super(), this._config = this._getConfig(t), this._isActive = !1, this._lastTabNavDirection = null;
  }
  // Getters
  static get Default() {
    return T_;
  }
  static get DefaultType() {
    return S_;
  }
  static get NAME() {
    return m_;
  }
  // Public
  activate() {
    this._isActive || (this._config.autofocus && this._config.trapElement.focus(), F.off(document, $s), F.on(document, E_, (t) => this._handleFocusin(t)), F.on(document, v_, (t) => this._handleKeydown(t)), this._isActive = !0);
  }
  deactivate() {
    this._isActive && (this._isActive = !1, F.off(document, $s));
  }
  // Private
  _handleFocusin(t) {
    const {
      trapElement: r
    } = this._config;
    if (t.target === document || t.target === r || r.contains(t.target))
      return;
    const n = oe.focusableChildren(r);
    n.length === 0 ? r.focus() : this._lastTabNavDirection === Cl ? n[n.length - 1].focus() : n[0].focus();
  }
  _handleKeydown(t) {
    t.key === b_ && (this._lastTabNavDirection = t.shiftKey ? Cl : w_);
  }
}
const Dl = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", Il = ".sticky-top", ts = "padding-right", Ml = "margin-right";
class xo {
  constructor() {
    this._element = document.body;
  }
  // Public
  getWidth() {
    const t = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - t);
  }
  hide() {
    const t = this.getWidth();
    this._disableOverFlow(), this._setElementAttributes(this._element, ts, (r) => r + t), this._setElementAttributes(Dl, ts, (r) => r + t), this._setElementAttributes(Il, Ml, (r) => r - t);
  }
  reset() {
    this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, ts), this._resetElementAttributes(Dl, ts), this._resetElementAttributes(Il, Ml);
  }
  isOverflowing() {
    return this.getWidth() > 0;
  }
  // Private
  _disableOverFlow() {
    this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
  }
  _setElementAttributes(t, r, n) {
    const s = this.getWidth(), i = (o) => {
      if (o !== this._element && window.innerWidth > o.clientWidth + s)
        return;
      this._saveInitialAttribute(o, r);
      const a = window.getComputedStyle(o).getPropertyValue(r);
      o.style.setProperty(r, `${n(Number.parseFloat(a))}px`);
    };
    this._applyManipulationCallback(t, i);
  }
  _saveInitialAttribute(t, r) {
    const n = t.style.getPropertyValue(r);
    n && Wt.setDataAttribute(t, r, n);
  }
  _resetElementAttributes(t, r) {
    const n = (s) => {
      const i = Wt.getDataAttribute(s, r);
      if (i === null) {
        s.style.removeProperty(r);
        return;
      }
      Wt.removeDataAttribute(s, r), s.style.setProperty(r, i);
    };
    this._applyManipulationCallback(t, n);
  }
  _applyManipulationCallback(t, r) {
    if (Gt(t)) {
      r(t);
      return;
    }
    for (const n of oe.find(t, this._element))
      r(n);
  }
}
const O_ = "modal", A_ = "bs.modal", dt = `.${A_}`, N_ = ".data-api", C_ = "Escape", D_ = `hide${dt}`, I_ = `hidePrevented${dt}`, _d = `hidden${dt}`, md = `show${dt}`, M_ = `shown${dt}`, R_ = `resize${dt}`, L_ = `click.dismiss${dt}`, x_ = `mousedown.dismiss${dt}`, k_ = `keydown.dismiss${dt}`, P_ = `click${dt}${N_}`, Rl = "modal-open", $_ = "fade", Ll = "show", ki = "modal-static", F_ = ".modal.show", V_ = ".modal-dialog", B_ = ".modal-body", U_ = '[data-bs-toggle="modal"]', H_ = {
  backdrop: !0,
  focus: !0,
  keyboard: !0
}, j_ = {
  backdrop: "(boolean|string)",
  focus: "boolean",
  keyboard: "boolean"
};
class $t extends Tt {
  constructor(t, r) {
    super(t, r), this._dialog = oe.findOne(V_, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new xo(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return H_;
  }
  static get DefaultType() {
    return j_;
  }
  static get NAME() {
    return O_;
  }
  // Public
  toggle(t) {
    return this._isShown ? this.hide() : this.show(t);
  }
  show(t) {
    this._isShown || this._isTransitioning || F.trigger(this._element, md, {
      relatedTarget: t
    }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(Rl), this._adjustDialog(), this._backdrop.show(() => this._showElement(t)));
  }
  hide() {
    !this._isShown || this._isTransitioning || F.trigger(this._element, D_).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(Ll), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
  }
  dispose() {
    F.off(window, dt), F.off(this._dialog, dt), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  handleUpdate() {
    this._adjustDialog();
  }
  // Private
  _initializeBackDrop() {
    return new hd({
      isVisible: !!this._config.backdrop,
      // 'static' option will be translated to true, and booleans will keep their value,
      isAnimated: this._isAnimated()
    });
  }
  _initializeFocusTrap() {
    return new gd({
      trapElement: this._element
    });
  }
  _showElement(t) {
    document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
    const r = oe.findOne(B_, this._dialog);
    r && (r.scrollTop = 0), Un(this._element), this._element.classList.add(Ll);
    const n = () => {
      this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, F.trigger(this._element, M_, {
        relatedTarget: t
      });
    };
    this._queueCallback(n, this._dialog, this._isAnimated());
  }
  _addEventListeners() {
    F.on(this._element, k_, (t) => {
      if (t.key === C_) {
        if (this._config.keyboard) {
          this.hide();
          return;
        }
        this._triggerBackdropTransition();
      }
    }), F.on(window, R_, () => {
      this._isShown && !this._isTransitioning && this._adjustDialog();
    }), F.on(this._element, x_, (t) => {
      F.one(this._element, L_, (r) => {
        if (!(this._element !== t.target || this._element !== r.target)) {
          if (this._config.backdrop === "static") {
            this._triggerBackdropTransition();
            return;
          }
          this._config.backdrop && this.hide();
        }
      });
    });
  }
  _hideModal() {
    this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(() => {
      document.body.classList.remove(Rl), this._resetAdjustments(), this._scrollBar.reset(), F.trigger(this._element, _d);
    });
  }
  _isAnimated() {
    return this._element.classList.contains($_);
  }
  _triggerBackdropTransition() {
    if (F.trigger(this._element, I_).defaultPrevented)
      return;
    const r = this._element.scrollHeight > document.documentElement.clientHeight, n = this._element.style.overflowY;
    n === "hidden" || this._element.classList.contains(ki) || (r || (this._element.style.overflowY = "hidden"), this._element.classList.add(ki), this._queueCallback(() => {
      this._element.classList.remove(ki), this._queueCallback(() => {
        this._element.style.overflowY = n;
      }, this._dialog);
    }, this._dialog), this._element.focus());
  }
  /**
   * The following methods are used to handle overflowing modals
   */
  _adjustDialog() {
    const t = this._element.scrollHeight > document.documentElement.clientHeight, r = this._scrollBar.getWidth(), n = r > 0;
    if (n && !t) {
      const s = ut() ? "paddingLeft" : "paddingRight";
      this._element.style[s] = `${r}px`;
    }
    if (!n && t) {
      const s = ut() ? "paddingRight" : "paddingLeft";
      this._element.style[s] = `${r}px`;
    }
  }
  _resetAdjustments() {
    this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
  }
  // Static
  static jQueryInterface(t, r) {
    return this.each(function() {
      const n = $t.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof n[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        n[t](r);
      }
    });
  }
}
F.on(document, P_, U_, function(e) {
  const t = oe.getElementFromSelector(this);
  ["A", "AREA"].includes(this.tagName) && e.preventDefault(), F.one(t, md, (s) => {
    s.defaultPrevented || F.one(t, _d, () => {
      nn(this) && this.focus();
    });
  });
  const r = oe.findOne(F_);
  r && $t.getInstance(r).hide(), $t.getOrCreateInstance(t).toggle(this);
});
ti($t);
ft($t);
const Y_ = "offcanvas", G_ = "bs.offcanvas", Kt = `.${G_}`, yd = ".data-api", W_ = `load${Kt}${yd}`, q_ = "Escape", xl = "show", kl = "showing", Pl = "hiding", K_ = "offcanvas-backdrop", Ed = ".offcanvas.show", z_ = `show${Kt}`, J_ = `shown${Kt}`, X_ = `hide${Kt}`, $l = `hidePrevented${Kt}`, vd = `hidden${Kt}`, Q_ = `resize${Kt}`, Z_ = `click${Kt}${yd}`, em = `keydown.dismiss${Kt}`, tm = '[data-bs-toggle="offcanvas"]', rm = {
  backdrop: !0,
  keyboard: !0,
  scroll: !1
}, nm = {
  backdrop: "(boolean|string)",
  keyboard: "boolean",
  scroll: "boolean"
};
class Vt extends Tt {
  constructor(t, r) {
    super(t, r), this._isShown = !1, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return rm;
  }
  static get DefaultType() {
    return nm;
  }
  static get NAME() {
    return Y_;
  }
  // Public
  toggle(t) {
    return this._isShown ? this.hide() : this.show(t);
  }
  show(t) {
    if (this._isShown || F.trigger(this._element, z_, {
      relatedTarget: t
    }).defaultPrevented)
      return;
    this._isShown = !0, this._backdrop.show(), this._config.scroll || new xo().hide(), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.classList.add(kl);
    const n = () => {
      (!this._config.scroll || this._config.backdrop) && this._focustrap.activate(), this._element.classList.add(xl), this._element.classList.remove(kl), F.trigger(this._element, J_, {
        relatedTarget: t
      });
    };
    this._queueCallback(n, this._element, !0);
  }
  hide() {
    if (!this._isShown || F.trigger(this._element, X_).defaultPrevented)
      return;
    this._focustrap.deactivate(), this._element.blur(), this._isShown = !1, this._element.classList.add(Pl), this._backdrop.hide();
    const r = () => {
      this._element.classList.remove(xl, Pl), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._config.scroll || new xo().reset(), F.trigger(this._element, vd);
    };
    this._queueCallback(r, this._element, !0);
  }
  dispose() {
    this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  // Private
  _initializeBackDrop() {
    const t = () => {
      if (this._config.backdrop === "static") {
        F.trigger(this._element, $l);
        return;
      }
      this.hide();
    }, r = !!this._config.backdrop;
    return new hd({
      className: K_,
      isVisible: r,
      isAnimated: !0,
      rootElement: this._element.parentNode,
      clickCallback: r ? t : null
    });
  }
  _initializeFocusTrap() {
    return new gd({
      trapElement: this._element
    });
  }
  _addEventListeners() {
    F.on(this._element, em, (t) => {
      if (t.key === q_) {
        if (this._config.keyboard) {
          this.hide();
          return;
        }
        F.trigger(this._element, $l);
      }
    });
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = Vt.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t](this);
      }
    });
  }
}
F.on(document, Z_, tm, function(e) {
  const t = oe.getElementFromSelector(this);
  if (["A", "AREA"].includes(this.tagName) && e.preventDefault(), ir(this))
    return;
  F.one(t, vd, () => {
    nn(this) && this.focus();
  });
  const r = oe.findOne(Ed);
  r && r !== t && Vt.getInstance(r).hide(), Vt.getOrCreateInstance(t).toggle(this);
});
F.on(window, W_, () => {
  for (const e of oe.find(Ed))
    Vt.getOrCreateInstance(e).show();
});
F.on(window, Q_, () => {
  for (const e of oe.find("[aria-modal][class*=show][class*=offcanvas-]"))
    getComputedStyle(e).position !== "fixed" && Vt.getOrCreateInstance(e).hide();
});
ti(Vt);
ft(Vt);
const sm = /^aria-[\w-]*$/i, bd = {
  // Global attributes allowed on any supplied element below.
  "*": ["class", "dir", "id", "lang", "role", sm],
  a: ["target", "href", "title", "rel"],
  area: [],
  b: [],
  br: [],
  col: [],
  code: [],
  dd: [],
  div: [],
  dl: [],
  dt: [],
  em: [],
  hr: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  i: [],
  img: ["src", "srcset", "alt", "title", "width", "height"],
  li: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  small: [],
  span: [],
  sub: [],
  sup: [],
  strong: [],
  u: [],
  ul: []
}, im = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), om = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, am = (e, t) => {
  const r = e.nodeName.toLowerCase();
  return t.includes(r) ? im.has(r) ? !!om.test(e.nodeValue) : !0 : t.filter((n) => n instanceof RegExp).some((n) => n.test(r));
};
function lm(e, t, r) {
  if (!e.length)
    return e;
  if (r && typeof r == "function")
    return r(e);
  const s = new window.DOMParser().parseFromString(e, "text/html"), i = [].concat(...s.body.querySelectorAll("*"));
  for (const o of i) {
    const a = o.nodeName.toLowerCase();
    if (!Object.keys(t).includes(a)) {
      o.remove();
      continue;
    }
    const l = [].concat(...o.attributes), u = [].concat(t["*"] || [], t[a] || []);
    for (const c of l)
      am(c, u) || o.removeAttribute(c.nodeName);
  }
  return s.body.innerHTML;
}
const cm = "TemplateFactory", um = {
  allowList: bd,
  content: {},
  // { selector : text ,  selector2 : text2 , }
  extraClass: "",
  html: !1,
  sanitize: !0,
  sanitizeFn: null,
  template: "<div></div>"
}, dm = {
  allowList: "object",
  content: "object",
  extraClass: "(string|function)",
  html: "boolean",
  sanitize: "boolean",
  sanitizeFn: "(null|function)",
  template: "string"
}, fm = {
  entry: "(string|element|function|null)",
  selector: "(string|element)"
};
class pm extends Hn {
  constructor(t) {
    super(), this._config = this._getConfig(t);
  }
  // Getters
  static get Default() {
    return um;
  }
  static get DefaultType() {
    return dm;
  }
  static get NAME() {
    return cm;
  }
  // Public
  getContent() {
    return Object.values(this._config.content).map((t) => this._resolvePossibleFunction(t)).filter(Boolean);
  }
  hasContent() {
    return this.getContent().length > 0;
  }
  changeContent(t) {
    return this._checkContent(t), this._config.content = {
      ...this._config.content,
      ...t
    }, this;
  }
  toHtml() {
    const t = document.createElement("div");
    t.innerHTML = this._maybeSanitize(this._config.template);
    for (const [s, i] of Object.entries(this._config.content))
      this._setContent(t, i, s);
    const r = t.children[0], n = this._resolvePossibleFunction(this._config.extraClass);
    return n && r.classList.add(...n.split(" ")), r;
  }
  // Private
  _typeCheckConfig(t) {
    super._typeCheckConfig(t), this._checkContent(t.content);
  }
  _checkContent(t) {
    for (const [r, n] of Object.entries(t))
      super._typeCheckConfig({
        selector: r,
        entry: n
      }, fm);
  }
  _setContent(t, r, n) {
    const s = oe.findOne(n, t);
    if (s) {
      if (r = this._resolvePossibleFunction(r), !r) {
        s.remove();
        return;
      }
      if (Gt(r)) {
        this._putElementInTemplate(sr(r), s);
        return;
      }
      if (this._config.html) {
        s.innerHTML = this._maybeSanitize(r);
        return;
      }
      s.textContent = r;
    }
  }
  _maybeSanitize(t) {
    return this._config.sanitize ? lm(t, this._config.allowList, this._config.sanitizeFn) : t;
  }
  _resolvePossibleFunction(t) {
    return Je(t, [void 0, this]);
  }
  _putElementInTemplate(t, r) {
    if (this._config.html) {
      r.innerHTML = "", r.append(t);
      return;
    }
    r.textContent = t.textContent;
  }
}
const hm = "tooltip", gm = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), Pi = "fade", _m = "modal", rs = "show", mm = ".tooltip-inner", Fl = `.${_m}`, Vl = "hide.bs.modal", mn = "hover", $i = "focus", ym = "click", Em = "manual", vm = "hide", bm = "hidden", wm = "show", Tm = "shown", Sm = "inserted", Om = "click", Am = "focusin", Nm = "focusout", Cm = "mouseenter", Dm = "mouseleave", Im = {
  AUTO: "auto",
  TOP: "top",
  RIGHT: ut() ? "left" : "right",
  BOTTOM: "bottom",
  LEFT: ut() ? "right" : "left"
}, Mm = {
  allowList: bd,
  animation: !0,
  boundary: "clippingParents",
  container: !1,
  customClass: "",
  delay: 0,
  fallbackPlacements: ["top", "right", "bottom", "left"],
  html: !1,
  offset: [0, 6],
  placement: "top",
  popperConfig: null,
  sanitize: !0,
  sanitizeFn: null,
  selector: !1,
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  title: "",
  trigger: "hover focus"
}, Rm = {
  allowList: "object",
  animation: "boolean",
  boundary: "(string|element)",
  container: "(string|element|boolean)",
  customClass: "(string|function)",
  delay: "(number|object)",
  fallbackPlacements: "array",
  html: "boolean",
  offset: "(array|string|function)",
  placement: "(string|function)",
  popperConfig: "(null|object|function)",
  sanitize: "boolean",
  sanitizeFn: "(null|function)",
  selector: "(string|boolean)",
  template: "string",
  title: "(string|element|function)",
  trigger: "string"
};
class on extends Tt {
  constructor(t, r) {
    if (typeof Ku > "u")
      throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org/docs/v2/)");
    super(t, r), this._isEnabled = !0, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
  }
  // Getters
  static get Default() {
    return Mm;
  }
  static get DefaultType() {
    return Rm;
  }
  static get NAME() {
    return hm;
  }
  // Public
  enable() {
    this._isEnabled = !0;
  }
  disable() {
    this._isEnabled = !1;
  }
  toggleEnabled() {
    this._isEnabled = !this._isEnabled;
  }
  toggle() {
    if (this._isEnabled) {
      if (this._isShown()) {
        this._leave();
        return;
      }
      this._enter();
    }
  }
  dispose() {
    clearTimeout(this._timeout), F.off(this._element.closest(Fl), Vl, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
  }
  show() {
    if (this._element.style.display === "none")
      throw new Error("Please use show on visible elements");
    if (!(this._isWithContent() && this._isEnabled))
      return;
    const t = F.trigger(this._element, this.constructor.eventName(wm)), n = (Xu(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
    if (t.defaultPrevented || !n)
      return;
    this._disposePopper();
    const s = this._getTipElement();
    this._element.setAttribute("aria-describedby", s.getAttribute("id"));
    const {
      container: i
    } = this._config;
    if (this._element.ownerDocument.documentElement.contains(this.tip) || (i.append(s), F.trigger(this._element, this.constructor.eventName(Sm))), this._popper = this._createPopper(s), s.classList.add(rs), "ontouchstart" in document.documentElement)
      for (const a of [].concat(...document.body.children))
        F.on(a, "mouseover", ks);
    const o = () => {
      F.trigger(this._element, this.constructor.eventName(Tm)), this._isHovered === !1 && this._leave(), this._isHovered = !1;
    };
    this._queueCallback(o, this.tip, this._isAnimated());
  }
  hide() {
    if (!this._isShown() || F.trigger(this._element, this.constructor.eventName(vm)).defaultPrevented)
      return;
    if (this._getTipElement().classList.remove(rs), "ontouchstart" in document.documentElement)
      for (const s of [].concat(...document.body.children))
        F.off(s, "mouseover", ks);
    this._activeTrigger[ym] = !1, this._activeTrigger[$i] = !1, this._activeTrigger[mn] = !1, this._isHovered = null;
    const n = () => {
      this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), F.trigger(this._element, this.constructor.eventName(bm)));
    };
    this._queueCallback(n, this.tip, this._isAnimated());
  }
  update() {
    this._popper && this._popper.update();
  }
  // Protected
  _isWithContent() {
    return !!this._getTitle();
  }
  _getTipElement() {
    return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
  }
  _createTipElement(t) {
    const r = this._getTemplateFactory(t).toHtml();
    if (!r)
      return null;
    r.classList.remove(Pi, rs), r.classList.add(`bs-${this.constructor.NAME}-auto`);
    const n = yh(this.constructor.NAME).toString();
    return r.setAttribute("id", n), this._isAnimated() && r.classList.add(Pi), r;
  }
  setContent(t) {
    this._newContent = t, this._isShown() && (this._disposePopper(), this.show());
  }
  _getTemplateFactory(t) {
    return this._templateFactory ? this._templateFactory.changeContent(t) : this._templateFactory = new pm({
      ...this._config,
      // the `content` var has to be after `this._config`
      // to override config.content in case of popover
      content: t,
      extraClass: this._resolvePossibleFunction(this._config.customClass)
    }), this._templateFactory;
  }
  _getContentForTemplate() {
    return {
      [mm]: this._getTitle()
    };
  }
  _getTitle() {
    return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
  }
  // Private
  _initializeOnDelegatedTarget(t) {
    return this.constructor.getOrCreateInstance(t.delegateTarget, this._getDelegateConfig());
  }
  _isAnimated() {
    return this._config.animation || this.tip && this.tip.classList.contains(Pi);
  }
  _isShown() {
    return this.tip && this.tip.classList.contains(rs);
  }
  _createPopper(t) {
    const r = Je(this._config.placement, [this, t, this._element]), n = Im[r.toUpperCase()];
    return Ta(this._element, t, this._getPopperConfig(n));
  }
  _getOffset() {
    const {
      offset: t
    } = this._config;
    return typeof t == "string" ? t.split(",").map((r) => Number.parseInt(r, 10)) : typeof t == "function" ? (r) => t(r, this._element) : t;
  }
  _resolvePossibleFunction(t) {
    return Je(t, [this._element, this._element]);
  }
  _getPopperConfig(t) {
    const r = {
      placement: t,
      modifiers: [{
        name: "flip",
        options: {
          fallbackPlacements: this._config.fallbackPlacements
        }
      }, {
        name: "offset",
        options: {
          offset: this._getOffset()
        }
      }, {
        name: "preventOverflow",
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: "arrow",
        options: {
          element: `.${this.constructor.NAME}-arrow`
        }
      }, {
        name: "preSetPlacement",
        enabled: !0,
        phase: "beforeMain",
        fn: (n) => {
          this._getTipElement().setAttribute("data-popper-placement", n.state.placement);
        }
      }]
    };
    return {
      ...r,
      ...Je(this._config.popperConfig, [void 0, r])
    };
  }
  _setListeners() {
    const t = this._config.trigger.split(" ");
    for (const r of t)
      if (r === "click")
        F.on(this._element, this.constructor.eventName(Om), this._config.selector, (n) => {
          this._initializeOnDelegatedTarget(n).toggle();
        });
      else if (r !== Em) {
        const n = r === mn ? this.constructor.eventName(Cm) : this.constructor.eventName(Am), s = r === mn ? this.constructor.eventName(Dm) : this.constructor.eventName(Nm);
        F.on(this._element, n, this._config.selector, (i) => {
          const o = this._initializeOnDelegatedTarget(i);
          o._activeTrigger[i.type === "focusin" ? $i : mn] = !0, o._enter();
        }), F.on(this._element, s, this._config.selector, (i) => {
          const o = this._initializeOnDelegatedTarget(i);
          o._activeTrigger[i.type === "focusout" ? $i : mn] = o._element.contains(i.relatedTarget), o._leave();
        });
      }
    this._hideModalHandler = () => {
      this._element && this.hide();
    }, F.on(this._element.closest(Fl), Vl, this._hideModalHandler);
  }
  _fixTitle() {
    const t = this._element.getAttribute("title");
    t && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", t), this._element.setAttribute("data-bs-original-title", t), this._element.removeAttribute("title"));
  }
  _enter() {
    if (this._isShown() || this._isHovered) {
      this._isHovered = !0;
      return;
    }
    this._isHovered = !0, this._setTimeout(() => {
      this._isHovered && this.show();
    }, this._config.delay.show);
  }
  _leave() {
    this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(() => {
      this._isHovered || this.hide();
    }, this._config.delay.hide));
  }
  _setTimeout(t, r) {
    clearTimeout(this._timeout), this._timeout = setTimeout(t, r);
  }
  _isWithActiveTrigger() {
    return Object.values(this._activeTrigger).includes(!0);
  }
  _getConfig(t) {
    const r = Wt.getDataAttributes(this._element);
    for (const n of Object.keys(r))
      gm.has(n) && delete r[n];
    return t = {
      ...r,
      ...typeof t == "object" && t ? t : {}
    }, t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  _configAfterMerge(t) {
    return t.container = t.container === !1 ? document.body : sr(t.container), typeof t.delay == "number" && (t.delay = {
      show: t.delay,
      hide: t.delay
    }), typeof t.title == "number" && (t.title = t.title.toString()), typeof t.content == "number" && (t.content = t.content.toString()), t;
  }
  _getDelegateConfig() {
    const t = {};
    for (const [r, n] of Object.entries(this._config))
      this.constructor.Default[r] !== n && (t[r] = n);
    return t.selector = !1, t.trigger = "manual", t;
  }
  _disposePopper() {
    this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = on.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof r[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
ft(on);
const Lm = "popover", xm = ".popover-header", km = ".popover-body", Pm = {
  ...on.Default,
  content: "",
  offset: [0, 8],
  placement: "right",
  template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
  trigger: "click"
}, $m = {
  ...on.DefaultType,
  content: "(null|string|element|function)"
};
class Na extends on {
  // Getters
  static get Default() {
    return Pm;
  }
  static get DefaultType() {
    return $m;
  }
  static get NAME() {
    return Lm;
  }
  // Overrides
  _isWithContent() {
    return this._getTitle() || this._getContent();
  }
  // Private
  _getContentForTemplate() {
    return {
      [xm]: this._getTitle(),
      [km]: this._getContent()
    };
  }
  _getContent() {
    return this._resolvePossibleFunction(this._config.content);
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = Na.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof r[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
ft(Na);
const Fm = "scrollspy", Vm = "bs.scrollspy", Ca = `.${Vm}`, Bm = ".data-api", Um = `activate${Ca}`, Bl = `click${Ca}`, Hm = `load${Ca}${Bm}`, jm = "dropdown-item", xr = "active", Ym = '[data-bs-spy="scroll"]', Fi = "[href]", Gm = ".nav, .list-group", Ul = ".nav-link", Wm = ".nav-item", qm = ".list-group-item", Km = `${Ul}, ${Wm} > ${Ul}, ${qm}`, zm = ".dropdown", Jm = ".dropdown-toggle", Xm = {
  offset: null,
  // TODO: v6 @deprecated, keep it for backwards compatibility reasons
  rootMargin: "0px 0px -25%",
  smoothScroll: !1,
  target: null,
  threshold: [0.1, 0.5, 1]
}, Qm = {
  offset: "(number|null)",
  // TODO v6 @deprecated, keep it for backwards compatibility reasons
  rootMargin: "string",
  smoothScroll: "boolean",
  target: "element",
  threshold: "array"
};
class si extends Tt {
  constructor(t, r) {
    super(t, r), this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map(), this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element, this._activeTarget = null, this._observer = null, this._previousScrollData = {
      visibleEntryTop: 0,
      parentScrollTop: 0
    }, this.refresh();
  }
  // Getters
  static get Default() {
    return Xm;
  }
  static get DefaultType() {
    return Qm;
  }
  static get NAME() {
    return Fm;
  }
  // Public
  refresh() {
    this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
    for (const t of this._observableSections.values())
      this._observer.observe(t);
  }
  dispose() {
    this._observer.disconnect(), super.dispose();
  }
  // Private
  _configAfterMerge(t) {
    return t.target = sr(t.target) || document.body, t.rootMargin = t.offset ? `${t.offset}px 0px -30%` : t.rootMargin, typeof t.threshold == "string" && (t.threshold = t.threshold.split(",").map((r) => Number.parseFloat(r))), t;
  }
  _maybeEnableSmoothScroll() {
    this._config.smoothScroll && (F.off(this._config.target, Bl), F.on(this._config.target, Bl, Fi, (t) => {
      const r = this._observableSections.get(t.target.hash);
      if (r) {
        t.preventDefault();
        const n = this._rootElement || window, s = r.offsetTop - this._element.offsetTop;
        if (n.scrollTo) {
          n.scrollTo({
            top: s,
            behavior: "smooth"
          });
          return;
        }
        n.scrollTop = s;
      }
    }));
  }
  _getNewObserver() {
    const t = {
      root: this._rootElement,
      threshold: this._config.threshold,
      rootMargin: this._config.rootMargin
    };
    return new IntersectionObserver((r) => this._observerCallback(r), t);
  }
  // The logic of selection
  _observerCallback(t) {
    const r = (o) => this._targetLinks.get(`#${o.target.id}`), n = (o) => {
      this._previousScrollData.visibleEntryTop = o.target.offsetTop, this._process(r(o));
    }, s = (this._rootElement || document.documentElement).scrollTop, i = s >= this._previousScrollData.parentScrollTop;
    this._previousScrollData.parentScrollTop = s;
    for (const o of t) {
      if (!o.isIntersecting) {
        this._activeTarget = null, this._clearActiveClass(r(o));
        continue;
      }
      const a = o.target.offsetTop >= this._previousScrollData.visibleEntryTop;
      if (i && a) {
        if (n(o), !s)
          return;
        continue;
      }
      !i && !a && n(o);
    }
  }
  _initializeTargetsAndObservables() {
    this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map();
    const t = oe.find(Fi, this._config.target);
    for (const r of t) {
      if (!r.hash || ir(r))
        continue;
      const n = oe.findOne(decodeURI(r.hash), this._element);
      nn(n) && (this._targetLinks.set(decodeURI(r.hash), r), this._observableSections.set(r.hash, n));
    }
  }
  _process(t) {
    this._activeTarget !== t && (this._clearActiveClass(this._config.target), this._activeTarget = t, t.classList.add(xr), this._activateParents(t), F.trigger(this._element, Um, {
      relatedTarget: t
    }));
  }
  _activateParents(t) {
    if (t.classList.contains(jm)) {
      oe.findOne(Jm, t.closest(zm)).classList.add(xr);
      return;
    }
    for (const r of oe.parents(t, Gm))
      for (const n of oe.prev(r, Km))
        n.classList.add(xr);
  }
  _clearActiveClass(t) {
    t.classList.remove(xr);
    const r = oe.find(`${Fi}.${xr}`, t);
    for (const n of r)
      n.classList.remove(xr);
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = si.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
F.on(window, Hm, () => {
  for (const e of oe.find(Ym))
    si.getOrCreateInstance(e);
});
ft(si);
const Zm = "tab", ey = "bs.tab", Ir = `.${ey}`, ty = `hide${Ir}`, ry = `hidden${Ir}`, ny = `show${Ir}`, sy = `shown${Ir}`, iy = `click${Ir}`, oy = `keydown${Ir}`, ay = `load${Ir}`, ly = "ArrowLeft", Hl = "ArrowRight", cy = "ArrowUp", jl = "ArrowDown", Vi = "Home", Yl = "End", mr = "active", Gl = "fade", Bi = "show", uy = "dropdown", wd = ".dropdown-toggle", dy = ".dropdown-menu", Ui = `:not(${wd})`, fy = '.list-group, .nav, [role="tablist"]', py = ".nav-item, .list-group-item", hy = `.nav-link${Ui}, .list-group-item${Ui}, [role="tab"]${Ui}`, Td = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', Hi = `${hy}, ${Td}`, gy = `.${mr}[data-bs-toggle="tab"], .${mr}[data-bs-toggle="pill"], .${mr}[data-bs-toggle="list"]`;
class en extends Tt {
  constructor(t) {
    super(t), this._parent = this._element.closest(fy), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), F.on(this._element, oy, (r) => this._keydown(r)));
  }
  // Getters
  static get NAME() {
    return Zm;
  }
  // Public
  show() {
    const t = this._element;
    if (this._elemIsActive(t))
      return;
    const r = this._getActiveElem(), n = r ? F.trigger(r, ty, {
      relatedTarget: t
    }) : null;
    F.trigger(t, ny, {
      relatedTarget: r
    }).defaultPrevented || n && n.defaultPrevented || (this._deactivate(r, t), this._activate(t, r));
  }
  // Private
  _activate(t, r) {
    if (!t)
      return;
    t.classList.add(mr), this._activate(oe.getElementFromSelector(t));
    const n = () => {
      if (t.getAttribute("role") !== "tab") {
        t.classList.add(Bi);
        return;
      }
      t.removeAttribute("tabindex"), t.setAttribute("aria-selected", !0), this._toggleDropDown(t, !0), F.trigger(t, sy, {
        relatedTarget: r
      });
    };
    this._queueCallback(n, t, t.classList.contains(Gl));
  }
  _deactivate(t, r) {
    if (!t)
      return;
    t.classList.remove(mr), t.blur(), this._deactivate(oe.getElementFromSelector(t));
    const n = () => {
      if (t.getAttribute("role") !== "tab") {
        t.classList.remove(Bi);
        return;
      }
      t.setAttribute("aria-selected", !1), t.setAttribute("tabindex", "-1"), this._toggleDropDown(t, !1), F.trigger(t, ry, {
        relatedTarget: r
      });
    };
    this._queueCallback(n, t, t.classList.contains(Gl));
  }
  _keydown(t) {
    if (![ly, Hl, cy, jl, Vi, Yl].includes(t.key))
      return;
    t.stopPropagation(), t.preventDefault();
    const r = this._getChildren().filter((s) => !ir(s));
    let n;
    if ([Vi, Yl].includes(t.key))
      n = r[t.key === Vi ? 0 : r.length - 1];
    else {
      const s = [Hl, jl].includes(t.key);
      n = Sa(r, t.target, s, !0);
    }
    n && (n.focus({
      preventScroll: !0
    }), en.getOrCreateInstance(n).show());
  }
  _getChildren() {
    return oe.find(Hi, this._parent);
  }
  _getActiveElem() {
    return this._getChildren().find((t) => this._elemIsActive(t)) || null;
  }
  _setInitialAttributes(t, r) {
    this._setAttributeIfNotExists(t, "role", "tablist");
    for (const n of r)
      this._setInitialAttributesOnChild(n);
  }
  _setInitialAttributesOnChild(t) {
    t = this._getInnerElement(t);
    const r = this._elemIsActive(t), n = this._getOuterElement(t);
    t.setAttribute("aria-selected", r), n !== t && this._setAttributeIfNotExists(n, "role", "presentation"), r || t.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(t, "role", "tab"), this._setInitialAttributesOnTargetPanel(t);
  }
  _setInitialAttributesOnTargetPanel(t) {
    const r = oe.getElementFromSelector(t);
    r && (this._setAttributeIfNotExists(r, "role", "tabpanel"), t.id && this._setAttributeIfNotExists(r, "aria-labelledby", `${t.id}`));
  }
  _toggleDropDown(t, r) {
    const n = this._getOuterElement(t);
    if (!n.classList.contains(uy))
      return;
    const s = (i, o) => {
      const a = oe.findOne(i, n);
      a && a.classList.toggle(o, r);
    };
    s(wd, mr), s(dy, Bi), n.setAttribute("aria-expanded", r);
  }
  _setAttributeIfNotExists(t, r, n) {
    t.hasAttribute(r) || t.setAttribute(r, n);
  }
  _elemIsActive(t) {
    return t.classList.contains(mr);
  }
  // Try to get the inner element (usually the .nav-link)
  _getInnerElement(t) {
    return t.matches(Hi) ? t : oe.findOne(Hi, t);
  }
  // Try to get the outer element (usually the .nav-item)
  _getOuterElement(t) {
    return t.closest(py) || t;
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = en.getOrCreateInstance(this);
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
F.on(document, iy, Td, function(e) {
  ["A", "AREA"].includes(this.tagName) && e.preventDefault(), !ir(this) && en.getOrCreateInstance(this).show();
});
F.on(window, ay, () => {
  for (const e of oe.find(gy))
    en.getOrCreateInstance(e);
});
ft(en);
const _y = "toast", my = "bs.toast", dr = `.${my}`, yy = `mouseover${dr}`, Ey = `mouseout${dr}`, vy = `focusin${dr}`, by = `focusout${dr}`, wy = `hide${dr}`, Ty = `hidden${dr}`, Sy = `show${dr}`, Oy = `shown${dr}`, Ay = "fade", Wl = "hide", ns = "show", ss = "showing", Ny = {
  animation: "boolean",
  autohide: "boolean",
  delay: "number"
}, Cy = {
  animation: !0,
  autohide: !0,
  delay: 5e3
};
class ii extends Tt {
  constructor(t, r) {
    super(t, r), this._timeout = null, this._hasMouseInteraction = !1, this._hasKeyboardInteraction = !1, this._setListeners();
  }
  // Getters
  static get Default() {
    return Cy;
  }
  static get DefaultType() {
    return Ny;
  }
  static get NAME() {
    return _y;
  }
  // Public
  show() {
    if (F.trigger(this._element, Sy).defaultPrevented)
      return;
    this._clearTimeout(), this._config.animation && this._element.classList.add(Ay);
    const r = () => {
      this._element.classList.remove(ss), F.trigger(this._element, Oy), this._maybeScheduleHide();
    };
    this._element.classList.remove(Wl), Un(this._element), this._element.classList.add(ns, ss), this._queueCallback(r, this._element, this._config.animation);
  }
  hide() {
    if (!this.isShown() || F.trigger(this._element, wy).defaultPrevented)
      return;
    const r = () => {
      this._element.classList.add(Wl), this._element.classList.remove(ss, ns), F.trigger(this._element, Ty);
    };
    this._element.classList.add(ss), this._queueCallback(r, this._element, this._config.animation);
  }
  dispose() {
    this._clearTimeout(), this.isShown() && this._element.classList.remove(ns), super.dispose();
  }
  isShown() {
    return this._element.classList.contains(ns);
  }
  // Private
  _maybeScheduleHide() {
    this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(() => {
      this.hide();
    }, this._config.delay)));
  }
  _onInteraction(t, r) {
    switch (t.type) {
      case "mouseover":
      case "mouseout": {
        this._hasMouseInteraction = r;
        break;
      }
      case "focusin":
      case "focusout": {
        this._hasKeyboardInteraction = r;
        break;
      }
    }
    if (r) {
      this._clearTimeout();
      return;
    }
    const n = t.relatedTarget;
    this._element === n || this._element.contains(n) || this._maybeScheduleHide();
  }
  _setListeners() {
    F.on(this._element, yy, (t) => this._onInteraction(t, !0)), F.on(this._element, Ey, (t) => this._onInteraction(t, !1)), F.on(this._element, vy, (t) => this._onInteraction(t, !0)), F.on(this._element, by, (t) => this._onInteraction(t, !1));
  }
  _clearTimeout() {
    clearTimeout(this._timeout), this._timeout = null;
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = ii.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof r[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        r[t](this);
      }
    });
  }
}
ti(ii);
ft(ii);
function Sd(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Dy } = Object.prototype, { getPrototypeOf: Da } = Object, { iterator: oi, toStringTag: Od } = Symbol, ai = /* @__PURE__ */ ((e) => (t) => {
  const r = Dy.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), St = (e) => (e = e.toLowerCase(), (t) => ai(t) === e), li = (e) => (t) => typeof t === e, { isArray: an } = Array, kn = li("undefined");
function Iy(e) {
  return e !== null && !kn(e) && e.constructor !== null && !kn(e.constructor) && Qe(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ad = St("ArrayBuffer");
function My(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Ad(e.buffer), t;
}
const Ry = li("string"), Qe = li("function"), Nd = li("number"), ci = (e) => e !== null && typeof e == "object", Ly = (e) => e === !0 || e === !1, hs = (e) => {
  if (ai(e) !== "object")
    return !1;
  const t = Da(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Od in e) && !(oi in e);
}, xy = St("Date"), ky = St("File"), Py = St("Blob"), $y = St("FileList"), Fy = (e) => ci(e) && Qe(e.pipe), Vy = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Qe(e.append) && ((t = ai(e)) === "formdata" || // detect form-data instance
  t === "object" && Qe(e.toString) && e.toString() === "[object FormData]"));
}, By = St("URLSearchParams"), [Uy, Hy, jy, Yy] = ["ReadableStream", "Request", "Response", "Headers"].map(St), Gy = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Gn(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), an(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let a;
    for (n = 0; n < o; n++)
      a = i[n], t.call(null, e[a], a, e);
  }
}
function Cd(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], t === s.toLowerCase())
      return s;
  return null;
}
const yr = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Dd = (e) => !kn(e) && e !== yr;
function ko() {
  const { caseless: e } = Dd(this) && this || {}, t = {}, r = (n, s) => {
    const i = e && Cd(t, s) || s;
    hs(t[i]) && hs(n) ? t[i] = ko(t[i], n) : hs(n) ? t[i] = ko({}, n) : an(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, s = arguments.length; n < s; n++)
    arguments[n] && Gn(arguments[n], r);
  return t;
}
const Wy = (e, t, r, { allOwnKeys: n } = {}) => (Gn(t, (s, i) => {
  r && Qe(s) ? e[i] = Sd(s, r) : e[i] = s;
}, { allOwnKeys: n }), e), qy = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Ky = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, zy = (e, t, r, n) => {
  let s, i, o;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      o = s[i], (!n || n(o, e, t)) && !a[o] && (t[o] = e[o], a[o] = !0);
    e = r !== !1 && Da(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Jy = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Xy = (e) => {
  if (!e) return null;
  if (an(e)) return e;
  let t = e.length;
  if (!Nd(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, Qy = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Da(Uint8Array)), Zy = (e, t) => {
  const n = (e && e[oi]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, eE = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, tE = St("HTMLFormElement"), rE = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), ql = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), nE = St("RegExp"), Id = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Gn(r, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (n[i] = o || s);
  }), Object.defineProperties(e, n);
}, sE = (e) => {
  Id(e, (t, r) => {
    if (Qe(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (Qe(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, iE = (e, t) => {
  const r = {}, n = (s) => {
    s.forEach((i) => {
      r[i] = !0;
    });
  };
  return an(e) ? n(e) : n(String(e).split(t)), r;
}, oE = () => {
}, aE = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function lE(e) {
  return !!(e && Qe(e.append) && e[Od] === "FormData" && e[oi]);
}
const cE = (e) => {
  const t = new Array(10), r = (n, s) => {
    if (ci(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[s] = n;
        const i = an(n) ? [] : {};
        return Gn(n, (o, a) => {
          const l = r(o, s + 1);
          !kn(l) && (i[a] = l);
        }), t[s] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, uE = St("AsyncFunction"), dE = (e) => e && (ci(e) || Qe(e)) && Qe(e.then) && Qe(e.catch), Md = ((e, t) => e ? setImmediate : t ? ((r, n) => (yr.addEventListener("message", ({ source: s, data: i }) => {
  s === yr && i === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), yr.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  Qe(yr.postMessage)
), fE = typeof queueMicrotask < "u" ? queueMicrotask.bind(yr) : typeof process < "u" && process.nextTick || Md, pE = (e) => e != null && Qe(e[oi]), C = {
  isArray: an,
  isArrayBuffer: Ad,
  isBuffer: Iy,
  isFormData: Vy,
  isArrayBufferView: My,
  isString: Ry,
  isNumber: Nd,
  isBoolean: Ly,
  isObject: ci,
  isPlainObject: hs,
  isReadableStream: Uy,
  isRequest: Hy,
  isResponse: jy,
  isHeaders: Yy,
  isUndefined: kn,
  isDate: xy,
  isFile: ky,
  isBlob: Py,
  isRegExp: nE,
  isFunction: Qe,
  isStream: Fy,
  isURLSearchParams: By,
  isTypedArray: Qy,
  isFileList: $y,
  forEach: Gn,
  merge: ko,
  extend: Wy,
  trim: Gy,
  stripBOM: qy,
  inherits: Ky,
  toFlatObject: zy,
  kindOf: ai,
  kindOfTest: St,
  endsWith: Jy,
  toArray: Xy,
  forEachEntry: Zy,
  matchAll: eE,
  isHTMLForm: tE,
  hasOwnProperty: ql,
  hasOwnProp: ql,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Id,
  freezeMethods: sE,
  toObjectSet: iE,
  toCamelCase: rE,
  noop: oE,
  toFiniteNumber: aE,
  findKey: Cd,
  global: yr,
  isContextDefined: Dd,
  isSpecCompliantForm: lE,
  toJSONObject: cE,
  isAsyncFn: uE,
  isThenable: dE,
  setImmediate: Md,
  asap: fE,
  isIterable: pE
};
function he(e, t, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), s && (this.response = s, this.status = s.status ? s.status : null);
}
C.inherits(he, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: C.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Rd = he.prototype, Ld = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Ld[e] = { value: e };
});
Object.defineProperties(he, Ld);
Object.defineProperty(Rd, "isAxiosError", { value: !0 });
he.from = (e, t, r, n, s, i) => {
  const o = Object.create(Rd);
  return C.toFlatObject(e, o, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), he.call(o, e.message, t, r, n, s), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const hE = null;
function Po(e) {
  return C.isPlainObject(e) || C.isArray(e);
}
function xd(e) {
  return C.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Kl(e, t, r) {
  return e ? e.concat(t).map(function(s, i) {
    return s = xd(s), !r && i ? "[" + s + "]" : s;
  }).join(r ? "." : "") : t;
}
function gE(e) {
  return C.isArray(e) && !e.some(Po);
}
const _E = C.toFlatObject(C, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ui(e, t, r) {
  if (!C.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = C.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, y) {
    return !C.isUndefined(y[p]);
  });
  const n = r.metaTokens, s = r.visitor || c, i = r.dots, o = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && C.isSpecCompliantForm(t);
  if (!C.isFunction(s))
    throw new TypeError("visitor must be a function");
  function u(_) {
    if (_ === null) return "";
    if (C.isDate(_))
      return _.toISOString();
    if (!l && C.isBlob(_))
      throw new he("Blob is not supported. Use a Buffer instead.");
    return C.isArrayBuffer(_) || C.isTypedArray(_) ? l && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function c(_, p, y) {
    let b = _;
    if (_ && !y && typeof _ == "object") {
      if (C.endsWith(p, "{}"))
        p = n ? p : p.slice(0, -2), _ = JSON.stringify(_);
      else if (C.isArray(_) && gE(_) || (C.isFileList(_) || C.endsWith(p, "[]")) && (b = C.toArray(_)))
        return p = xd(p), b.forEach(function(v, D) {
          !(C.isUndefined(v) || v === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Kl([p], D, i) : o === null ? p : p + "[]",
            u(v)
          );
        }), !1;
    }
    return Po(_) ? !0 : (t.append(Kl(y, p, i), u(_)), !1);
  }
  const d = [], f = Object.assign(_E, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: Po
  });
  function g(_, p) {
    if (!C.isUndefined(_)) {
      if (d.indexOf(_) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      d.push(_), C.forEach(_, function(b, A) {
        (!(C.isUndefined(b) || b === null) && s.call(
          t,
          b,
          C.isString(A) ? A.trim() : A,
          p,
          f
        )) === !0 && g(b, p ? p.concat(A) : [A]);
      }), d.pop();
    }
  }
  if (!C.isObject(e))
    throw new TypeError("data must be an object");
  return g(e), t;
}
function zl(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Ia(e, t) {
  this._pairs = [], e && ui(e, this, t);
}
const kd = Ia.prototype;
kd.append = function(t, r) {
  this._pairs.push([t, r]);
};
kd.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, zl);
  } : zl;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function mE(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Pd(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || mE;
  C.isFunction(r) && (r = {
    serialize: r
  });
  const s = r && r.serialize;
  let i;
  if (s ? i = s(t, r) : i = C.isURLSearchParams(t) ? t.toString() : new Ia(t, r).toString(n), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Jl {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    C.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const $d = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, yE = typeof URLSearchParams < "u" ? URLSearchParams : Ia, EE = typeof FormData < "u" ? FormData : null, vE = typeof Blob < "u" ? Blob : null, bE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: yE,
    FormData: EE,
    Blob: vE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ma = typeof window < "u" && typeof document < "u", $o = typeof navigator == "object" && navigator || void 0, wE = Ma && (!$o || ["ReactNative", "NativeScript", "NS"].indexOf($o.product) < 0), TE = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", SE = Ma && window.location.href || "http://localhost", OE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ma,
  hasStandardBrowserEnv: wE,
  hasStandardBrowserWebWorkerEnv: TE,
  navigator: $o,
  origin: SE
}, Symbol.toStringTag, { value: "Module" })), He = {
  ...OE,
  ...bE
};
function AE(e, t) {
  return ui(e, new He.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, s, i) {
      return He.isNode && C.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function NE(e) {
  return C.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function CE(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const s = r.length;
  let i;
  for (n = 0; n < s; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function Fd(e) {
  function t(r, n, s, i) {
    let o = r[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), l = i >= r.length;
    return o = !o && C.isArray(s) ? s.length : o, l ? (C.hasOwnProp(s, o) ? s[o] = [s[o], n] : s[o] = n, !a) : ((!s[o] || !C.isObject(s[o])) && (s[o] = []), t(r, n, s[o], i) && C.isArray(s[o]) && (s[o] = CE(s[o])), !a);
  }
  if (C.isFormData(e) && C.isFunction(e.entries)) {
    const r = {};
    return C.forEachEntry(e, (n, s) => {
      t(NE(n), s, r, 0);
    }), r;
  }
  return null;
}
function DE(e, t, r) {
  if (C.isString(e))
    try {
      return (t || JSON.parse)(e), C.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const Wn = {
  transitional: $d,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, i = C.isObject(t);
    if (i && C.isHTMLForm(t) && (t = new FormData(t)), C.isFormData(t))
      return s ? JSON.stringify(Fd(t)) : t;
    if (C.isArrayBuffer(t) || C.isBuffer(t) || C.isStream(t) || C.isFile(t) || C.isBlob(t) || C.isReadableStream(t))
      return t;
    if (C.isArrayBufferView(t))
      return t.buffer;
    if (C.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return AE(t, this.formSerializer).toString();
      if ((a = C.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return ui(
          a ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || s ? (r.setContentType("application/json", !1), DE(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Wn.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (C.isResponse(t) || C.isReadableStream(t))
      return t;
    if (t && C.isString(t) && (n && !this.responseType || s)) {
      const o = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? he.from(a, he.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: He.classes.FormData,
    Blob: He.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
C.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Wn.headers[e] = {};
});
const IE = C.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ME = (e) => {
  const t = {};
  let r, n, s;
  return e && e.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), r = o.substring(0, s).trim().toLowerCase(), n = o.substring(s + 1).trim(), !(!r || t[r] && IE[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Xl = Symbol("internals");
function yn(e) {
  return e && String(e).trim().toLowerCase();
}
function gs(e) {
  return e === !1 || e == null ? e : C.isArray(e) ? e.map(gs) : String(e);
}
function RE(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const LE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ji(e, t, r, n, s) {
  if (C.isFunction(n))
    return n.call(this, t, r);
  if (s && (t = r), !!C.isString(t)) {
    if (C.isString(n))
      return t.indexOf(n) !== -1;
    if (C.isRegExp(n))
      return n.test(t);
  }
}
function xE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function kE(e, t) {
  const r = C.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(s, i, o) {
        return this[n].call(this, t, s, i, o);
      },
      configurable: !0
    });
  });
}
let Ze = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const s = this;
    function i(a, l, u) {
      const c = yn(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const d = C.findKey(s, c);
      (!d || s[d] === void 0 || u === !0 || u === void 0 && s[d] !== !1) && (s[d || l] = gs(a));
    }
    const o = (a, l) => C.forEach(a, (u, c) => i(u, c, l));
    if (C.isPlainObject(t) || t instanceof this.constructor)
      o(t, r);
    else if (C.isString(t) && (t = t.trim()) && !LE(t))
      o(ME(t), r);
    else if (C.isObject(t) && C.isIterable(t)) {
      let a = {}, l, u;
      for (const c of t) {
        if (!C.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        a[u = c[0]] = (l = a[u]) ? C.isArray(l) ? [...l, c[1]] : [l, c[1]] : c[1];
      }
      o(a, r);
    } else
      t != null && i(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = yn(t), t) {
      const n = C.findKey(this, t);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return RE(s);
        if (C.isFunction(r))
          return r.call(this, s, n);
        if (C.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = yn(t), t) {
      const n = C.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || ji(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let s = !1;
    function i(o) {
      if (o = yn(o), o) {
        const a = C.findKey(n, o);
        a && (!r || ji(n, n[a], a, r)) && (delete n[a], s = !0);
      }
    }
    return C.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const i = r[n];
      (!t || ji(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const r = this, n = {};
    return C.forEach(this, (s, i) => {
      const o = C.findKey(n, i);
      if (o) {
        r[o] = gs(s), delete r[i];
        return;
      }
      const a = t ? xE(i) : String(i).trim();
      a !== i && delete r[i], r[a] = gs(s), n[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return C.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = t && C.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(t) {
    const n = (this[Xl] = this[Xl] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const a = yn(o);
      n[a] || (kE(s, o), n[a] = !0);
    }
    return C.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
Ze.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
C.reduceDescriptors(Ze.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
C.freezeMethods(Ze);
function Yi(e, t) {
  const r = this || Wn, n = t || r, s = Ze.from(n.headers);
  let i = n.data;
  return C.forEach(e, function(a) {
    i = a.call(r, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function Vd(e) {
  return !!(e && e.__CANCEL__);
}
function ln(e, t, r) {
  he.call(this, e ?? "canceled", he.ERR_CANCELED, t, r), this.name = "CanceledError";
}
C.inherits(ln, he, {
  __CANCEL__: !0
});
function Bd(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new he(
    "Request failed with status code " + r.status,
    [he.ERR_BAD_REQUEST, he.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function PE(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function $E(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let s = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const u = Date.now(), c = n[i];
    o || (o = u), r[s] = l, n[s] = u;
    let d = i, f = 0;
    for (; d !== s; )
      f += r[d++], d = d % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), u - o < t)
      return;
    const g = c && u - c;
    return g ? Math.round(f * 1e3 / g) : void 0;
  };
}
function FE(e, t) {
  let r = 0, n = 1e3 / t, s, i;
  const o = (u, c = Date.now()) => {
    r = c, s = null, i && (clearTimeout(i), i = null), e.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), d = c - r;
    d >= n ? o(u, c) : (s = u, i || (i = setTimeout(() => {
      i = null, o(s);
    }, n - d)));
  }, () => s && o(s)];
}
const Fs = (e, t, r = 3) => {
  let n = 0;
  const s = $E(50, 250);
  return FE((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, l = o - n, u = s(l), c = o <= a;
    n = o;
    const d = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && a && c ? (a - o) / u : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, r);
}, Ql = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, Zl = (e) => (...t) => C.asap(() => e(...t)), VE = He.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, He.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(He.origin),
  He.navigator && /(msie|trident)/i.test(He.navigator.userAgent)
) : () => !0, BE = He.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, s, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      C.isNumber(r) && o.push("expires=" + new Date(r).toGMTString()), C.isString(n) && o.push("path=" + n), C.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function UE(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function HE(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Ud(e, t, r) {
  let n = !UE(t);
  return e && (n || r == !1) ? HE(e, t) : t;
}
const ec = (e) => e instanceof Ze ? { ...e } : e;
function Nr(e, t) {
  t = t || {};
  const r = {};
  function n(u, c, d, f) {
    return C.isPlainObject(u) && C.isPlainObject(c) ? C.merge.call({ caseless: f }, u, c) : C.isPlainObject(c) ? C.merge({}, c) : C.isArray(c) ? c.slice() : c;
  }
  function s(u, c, d, f) {
    if (C.isUndefined(c)) {
      if (!C.isUndefined(u))
        return n(void 0, u, d, f);
    } else return n(u, c, d, f);
  }
  function i(u, c) {
    if (!C.isUndefined(c))
      return n(void 0, c);
  }
  function o(u, c) {
    if (C.isUndefined(c)) {
      if (!C.isUndefined(u))
        return n(void 0, u);
    } else return n(void 0, c);
  }
  function a(u, c, d) {
    if (d in t)
      return n(u, c);
    if (d in e)
      return n(void 0, u);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (u, c, d) => s(ec(u), ec(c), d, !0)
  };
  return C.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const d = l[c] || s, f = d(e[c], t[c], c);
    C.isUndefined(f) && d !== a || (r[c] = f);
  }), r;
}
const Hd = (e) => {
  const t = Nr({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = t;
  t.headers = o = Ze.from(o), t.url = Pd(Ud(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (C.isFormData(r)) {
    if (He.hasStandardBrowserEnv || He.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      o.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (He.hasStandardBrowserEnv && (n && C.isFunction(n) && (n = n(t)), n || n !== !1 && VE(t.url))) {
    const u = s && i && BE.read(i);
    u && o.set(s, u);
  }
  return t;
}, jE = typeof XMLHttpRequest < "u", YE = jE && function(e) {
  return new Promise(function(r, n) {
    const s = Hd(e);
    let i = s.data;
    const o = Ze.from(s.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: u } = s, c, d, f, g, _;
    function p() {
      g && g(), _ && _(), s.cancelToken && s.cancelToken.unsubscribe(c), s.signal && s.signal.removeEventListener("abort", c);
    }
    let y = new XMLHttpRequest();
    y.open(s.method.toUpperCase(), s.url, !0), y.timeout = s.timeout;
    function b() {
      if (!y)
        return;
      const v = Ze.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), w = {
        data: !a || a === "text" || a === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: v,
        config: e,
        request: y
      };
      Bd(function(z) {
        r(z), p();
      }, function(z) {
        n(z), p();
      }, w), y = null;
    }
    "onloadend" in y ? y.onloadend = b : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, y.onabort = function() {
      y && (n(new he("Request aborted", he.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function() {
      n(new he("Network Error", he.ERR_NETWORK, e, y)), y = null;
    }, y.ontimeout = function() {
      let D = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const w = s.transitional || $d;
      s.timeoutErrorMessage && (D = s.timeoutErrorMessage), n(new he(
        D,
        w.clarifyTimeoutError ? he.ETIMEDOUT : he.ECONNABORTED,
        e,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && C.forEach(o.toJSON(), function(D, w) {
      y.setRequestHeader(w, D);
    }), C.isUndefined(s.withCredentials) || (y.withCredentials = !!s.withCredentials), a && a !== "json" && (y.responseType = s.responseType), u && ([f, _] = Fs(u, !0), y.addEventListener("progress", f)), l && y.upload && ([d, g] = Fs(l), y.upload.addEventListener("progress", d), y.upload.addEventListener("loadend", g)), (s.cancelToken || s.signal) && (c = (v) => {
      y && (n(!v || v.type ? new ln(null, e, y) : v), y.abort(), y = null);
    }, s.cancelToken && s.cancelToken.subscribe(c), s.signal && (s.signal.aborted ? c() : s.signal.addEventListener("abort", c)));
    const A = PE(s.url);
    if (A && He.protocols.indexOf(A) === -1) {
      n(new he("Unsupported protocol " + A + ":", he.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(i || null);
  });
}, GE = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), s;
    const i = function(u) {
      if (!s) {
        s = !0, a();
        const c = u instanceof Error ? u : this.reason;
        n.abort(c instanceof he ? c : new ln(c instanceof Error ? c.message : c));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new he(`timeout ${t} of ms exceeded`, he.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", i));
    const { signal: l } = n;
    return l.unsubscribe = () => C.asap(a), l;
  }
}, WE = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + t, yield e.slice(n, s), n = s;
}, qE = async function* (e, t) {
  for await (const r of KE(e))
    yield* WE(r, t);
}, KE = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, tc = (e, t, r, n) => {
  const s = qE(e, t);
  let i = 0, o, a = (l) => {
    o || (o = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: c } = await s.next();
        if (u) {
          a(), l.close();
          return;
        }
        let d = c.byteLength;
        if (r) {
          let f = i += d;
          r(f);
        }
        l.enqueue(new Uint8Array(c));
      } catch (u) {
        throw a(u), u;
      }
    },
    cancel(l) {
      return a(l), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, di = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", jd = di && typeof ReadableStream == "function", zE = di && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Yd = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, JE = jd && Yd(() => {
  let e = !1;
  const t = new Request(He.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), rc = 64 * 1024, Fo = jd && Yd(() => C.isReadableStream(new Response("").body)), Vs = {
  stream: Fo && ((e) => e.body)
};
di && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Vs[t] && (Vs[t] = C.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new he(`Response type '${t}' is not supported`, he.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const XE = async (e) => {
  if (e == null)
    return 0;
  if (C.isBlob(e))
    return e.size;
  if (C.isSpecCompliantForm(e))
    return (await new Request(He.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (C.isArrayBufferView(e) || C.isArrayBuffer(e))
    return e.byteLength;
  if (C.isURLSearchParams(e) && (e = e + ""), C.isString(e))
    return (await zE(e)).byteLength;
}, QE = async (e, t) => {
  const r = C.toFiniteNumber(e.getContentLength());
  return r ?? XE(t);
}, ZE = di && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: s,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = Hd(e);
  u = u ? (u + "").toLowerCase() : "text";
  let g = GE([s, i && i.toAbortSignal()], o), _;
  const p = g && g.unsubscribe && (() => {
    g.unsubscribe();
  });
  let y;
  try {
    if (l && JE && r !== "get" && r !== "head" && (y = await QE(c, n)) !== 0) {
      let w = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), j;
      if (C.isFormData(n) && (j = w.headers.get("content-type")) && c.setContentType(j), w.body) {
        const [z, Z] = Ql(
          y,
          Fs(Zl(l))
        );
        n = tc(w.body, rc, z, Z);
      }
    }
    C.isString(d) || (d = d ? "include" : "omit");
    const b = "credentials" in Request.prototype;
    _ = new Request(t, {
      ...f,
      signal: g,
      method: r.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: b ? d : void 0
    });
    let A = await fetch(_);
    const v = Fo && (u === "stream" || u === "response");
    if (Fo && (a || v && p)) {
      const w = {};
      ["status", "statusText", "headers"].forEach((Q) => {
        w[Q] = A[Q];
      });
      const j = C.toFiniteNumber(A.headers.get("content-length")), [z, Z] = a && Ql(
        j,
        Fs(Zl(a), !0)
      ) || [];
      A = new Response(
        tc(A.body, rc, z, () => {
          Z && Z(), p && p();
        }),
        w
      );
    }
    u = u || "text";
    let D = await Vs[C.findKey(Vs, u) || "text"](A, e);
    return !v && p && p(), await new Promise((w, j) => {
      Bd(w, j, {
        data: D,
        headers: Ze.from(A.headers),
        status: A.status,
        statusText: A.statusText,
        config: e,
        request: _
      });
    });
  } catch (b) {
    throw p && p(), b && b.name === "TypeError" && /Load failed|fetch/i.test(b.message) ? Object.assign(
      new he("Network Error", he.ERR_NETWORK, e, _),
      {
        cause: b.cause || b
      }
    ) : he.from(b, b && b.code, e, _);
  }
}), Vo = {
  http: hE,
  xhr: YE,
  fetch: ZE
};
C.forEach(Vo, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const nc = (e) => `- ${e}`, ev = (e) => C.isFunction(e) || e === null || e === !1, Gd = {
  getAdapter: (e) => {
    e = C.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const s = {};
    for (let i = 0; i < t; i++) {
      r = e[i];
      let o;
      if (n = r, !ev(r) && (n = Vo[(o = String(r)).toLowerCase()], n === void 0))
        throw new he(`Unknown adapter '${o}'`);
      if (n)
        break;
      s[o || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(s).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? i.length > 1 ? `since :
` + i.map(nc).join(`
`) : " " + nc(i[0]) : "as no adapter specified";
      throw new he(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: Vo
};
function Gi(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ln(null, e);
}
function sc(e) {
  return Gi(e), e.headers = Ze.from(e.headers), e.data = Yi.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Gd.getAdapter(e.adapter || Wn.adapter)(e).then(function(n) {
    return Gi(e), n.data = Yi.call(
      e,
      e.transformResponse,
      n
    ), n.headers = Ze.from(n.headers), n;
  }, function(n) {
    return Vd(n) || (Gi(e), n && n.response && (n.response.data = Yi.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = Ze.from(n.response.headers))), Promise.reject(n);
  });
}
const Wd = "1.9.0", fi = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  fi[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ic = {};
fi.transitional = function(t, r, n) {
  function s(i, o) {
    return "[Axios v" + Wd + "] Transitional option '" + i + "'" + o + (n ? ". " + n : "");
  }
  return (i, o, a) => {
    if (t === !1)
      throw new he(
        s(o, " has been removed" + (r ? " in " + r : "")),
        he.ERR_DEPRECATED
      );
    return r && !ic[o] && (ic[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(i, o, a) : !0;
  };
};
fi.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function tv(e, t, r) {
  if (typeof e != "object")
    throw new he("options must be an object", he.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let s = n.length;
  for (; s-- > 0; ) {
    const i = n[s], o = t[i];
    if (o) {
      const a = e[i], l = a === void 0 || o(a, i, e);
      if (l !== !0)
        throw new he("option " + i + " must be " + l, he.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new he("Unknown option " + i, he.ERR_BAD_OPTION);
  }
}
const _s = {
  assertOptions: tv,
  validators: fi
}, Ct = _s.validators;
let vr = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Jl(),
      response: new Jl()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = Nr(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: i } = r;
    n !== void 0 && _s.assertOptions(n, {
      silentJSONParsing: Ct.transitional(Ct.boolean),
      forcedJSONParsing: Ct.transitional(Ct.boolean),
      clarifyTimeoutError: Ct.transitional(Ct.boolean)
    }, !1), s != null && (C.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : _s.assertOptions(s, {
      encode: Ct.function,
      serialize: Ct.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), _s.assertOptions(r, {
      baseUrl: Ct.spelling("baseURL"),
      withXsrfToken: Ct.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let o = i && C.merge(
      i.common,
      i[r.method]
    );
    i && C.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (_) => {
        delete i[_];
      }
    ), r.headers = Ze.concat(o, i);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(r) === !1 || (l = l && p.synchronous, a.unshift(p.fulfilled, p.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(p) {
      u.push(p.fulfilled, p.rejected);
    });
    let c, d = 0, f;
    if (!l) {
      const _ = [sc.bind(this), void 0];
      for (_.unshift.apply(_, a), _.push.apply(_, u), f = _.length, c = Promise.resolve(r); d < f; )
        c = c.then(_[d++], _[d++]);
      return c;
    }
    f = a.length;
    let g = r;
    for (d = 0; d < f; ) {
      const _ = a[d++], p = a[d++];
      try {
        g = _(g);
      } catch (y) {
        p.call(this, y);
        break;
      }
    }
    try {
      c = sc.call(this, g);
    } catch (_) {
      return Promise.reject(_);
    }
    for (d = 0, f = u.length; d < f; )
      c = c.then(u[d++], u[d++]);
    return c;
  }
  getUri(t) {
    t = Nr(this.defaults, t);
    const r = Ud(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Pd(r, t.params, t.paramsSerializer);
  }
};
C.forEach(["delete", "get", "head", "options"], function(t) {
  vr.prototype[t] = function(r, n) {
    return this.request(Nr(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
C.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(i, o, a) {
      return this.request(Nr(a || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  vr.prototype[t] = r(), vr.prototype[t + "Form"] = r(!0);
});
let rv = class qd {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        n.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        n.unsubscribe(i);
      }, o;
    }, t(function(i, o, a) {
      n.reason || (n.reason = new ln(i, o, a), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new qd(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function nv(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function sv(e) {
  return C.isObject(e) && e.isAxiosError === !0;
}
const Bo = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Bo).forEach(([e, t]) => {
  Bo[t] = e;
});
function Kd(e) {
  const t = new vr(e), r = Sd(vr.prototype.request, t);
  return C.extend(r, vr.prototype, t, { allOwnKeys: !0 }), C.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(s) {
    return Kd(Nr(e, s));
  }, r;
}
const Re = Kd(Wn);
Re.Axios = vr;
Re.CanceledError = ln;
Re.CancelToken = rv;
Re.isCancel = Vd;
Re.VERSION = Wd;
Re.toFormData = ui;
Re.AxiosError = he;
Re.Cancel = Re.CanceledError;
Re.all = function(t) {
  return Promise.all(t);
};
Re.spread = nv;
Re.isAxiosError = sv;
Re.mergeConfig = Nr;
Re.AxiosHeaders = Ze;
Re.formToJSON = (e) => Fd(C.isHTMLForm(e) ? new FormData(e) : e);
Re.getAdapter = Gd.getAdapter;
Re.HttpStatusCode = Bo;
Re.default = Re;
const {
  Axios: pO,
  AxiosError: hO,
  CanceledError: gO,
  isCancel: _O,
  CancelToken: mO,
  VERSION: yO,
  all: EO,
  Cancel: vO,
  isAxiosError: bO,
  spread: wO,
  toFormData: TO,
  AxiosHeaders: SO,
  HttpStatusCode: OO,
  formToJSON: AO,
  getAdapter: NO,
  mergeConfig: CO
} = Re, iv = 2e4, _e = (e) => {
  window.store.dispatch("showSuccessModal", e);
}, m = (e) => {
  window.store.dispatch("showErrorModal", e);
}, Le = {
  initOffCanvas(e) {
    const t = typeof e == "string" ? document.querySelector(e) : e;
    return Vt.getInstance(t) || new Vt(t);
  },
  initCollapse(e) {
    return new Zr(e);
  },
  initDropdown(e) {
    return new mt(e);
  },
  showLogin(e = "#loginModal") {
    new $t(e).show();
  },
  openModal(e) {
    setTimeout(() => {
      new $t(e).show();
    }, 100);
  },
  closeModal(e) {
    setTimeout(() => {
      let t = document.getElementById(e), r = $t.getInstance(t);
      r && r.hide();
    }, 100);
  },
  kFormatter(e) {
    return Math.abs(e) > 999 ? Math.sign(e) * (Math.abs(e) / 1e3).toFixed(1) + "k" : Math.sign(e) * Math.abs(e);
  },
  formatNumber(e) {
    return e !== null ? parseFloat(e).toFixed(2) : 0;
  },
  downloadExcel(e, t) {
    let r = require("xlsx");
    const n = r.utils.json_to_sheet(e), s = r.utils.book_new();
    r.utils.book_append_sheet(s, n, "Sheet1"), r.writeFile(s, t);
  },
  downloadPdf(e, t) {
    const { jsPDF: r } = require("jspdf"), n = require("jspdf-autotable").default, s = new r();
    n(s, {
      head: [Object.keys(e[0])],
      body: e.map((i) => Object.values(i))
    }), s.save(t);
  },
  notNull(e) {
    return e !== void 0;
  },
  compareLength: (e, t) => t.length == e,
  testRegex(e, t) {
    return e.test(t);
  },
  isMobile() {
    return window.innerWidth <= 991;
  },
  //----- sanitization helpers
  sanitizeDetails(e, t, r) {
    const n = {
      userId: /[^a-zA-Z0-9_.]/g,
      oldLoginUserId: /[\s]/g,
      password: /[\s]/g,
      oldLoginPassword: /[\s]/g,
      referCode: /[^0-9]/g,
      withdrawPassword: /[\s]/g,
      utrNumber: /[^0-9]/g
    };
    if (n[e]) {
      let s = t.replace(n[e], "");
      return r && (s = s.slice(0, r)), s;
    }
    return t;
  },
  sanitizeNumber(e, t) {
    if (e != "") {
      let r = e.toString();
      r = r.replace(/[^0-9]/g, "").replace(/[+-]/g, "");
      let n = "";
      return t == 999999 ? n = r.slice(0, 6) ?? "" : n = r == "" ? "" : Math.max(0, Math.min(t, r)).toString(), n;
    }
    return e;
  },
  //----- sanitization helpers
  positive(e) {
    return e < 0 ? e * -1 : e;
  },
  addCommas(t) {
    var t = parseFloat(t).toFixed(2);
    t += "";
    for (var r = t.split("."), n = r[0], s = r.length > 1 ? "." + r[1] : "", i = /(\d+)(\d{3})/; i.test(n); )
      n = n.replace(i, "$1,$2");
    var o = n + s;
    return o;
  },
  scrollToElement(e) {
    setTimeout(() => {
      e.scrollIntoView({
        behavior: "smooth",
        inline: "nearest"
      });
    }, 200);
  },
  currencyConverter(e, t = 1) {
    let r = {
      1: 1,
      2: 2,
      3: 0.01,
      4: 0.01
    };
    return e && r[t] ? r[t] * e : e;
  },
  formatTime(e) {
    return e < 10 ? `0${e}` : e;
  },
  checkForNonNumericals(e, t = null) {
    /^[a-zA-Z0-9]+$/.test(e.key.toLowerCase()) || e.preventDefault();
  },
  getKFormatter(e) {
    return Math.abs(e) > 999 ? Math.sign(e) * (Math.abs(e) / 1e3).toFixed(1) + "k" : Math.sign(e) * Math.abs(e);
  },
  getPaginationData(e) {
    return {
      currPage: e.current_page,
      from: e.from,
      to: e.to,
      lastPage: e.last_page,
      perPage: e.per_page,
      total: e.total
    };
  },
  applySharedComputed(e, t) {
    Object.assign(e.$options.computed, t);
  }
};
function ov(e) {
  var r, n, s, i, o, a, l, u, c, d, f, g, _, p, y, b, A, v, D;
  if (!(e != null && e.response))
    return Promise.reject(["Error CORS: Check your NETWORK agian and refresh the page."]);
  const t = (r = e == null ? void 0 : e.response) == null ? void 0 : r.status;
  switch (t) {
    case 422:
      return e.response.data.details ? Promise.reject(`Error ${t}: ${(l = (s = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data) == null ? void 0 : s.details) == null ? void 0 : l[(a = Object.keys((o = (i = e == null ? void 0 : e.response) == null ? void 0 : i.data) == null ? void 0 : o.details)) == null ? void 0 : a[0]]}`) : Promise.reject([`Error ${t}: ${((c = (u = e == null ? void 0 : e.response) == null ? void 0 : u.data) == null ? void 0 : c.errors) ?? ((f = (d = e == null ? void 0 : e.response) == null ? void 0 : d.data) == null ? void 0 : f.message) ?? ((_ = (g = e == null ? void 0 : e.response) == null ? void 0 : g.data) == null ? void 0 : _.error)}`]);
    case 401:
      m("You Have Been Logged Out From This Device."), av();
      break;
    case 400:
    case 500:
      return Promise.reject([`Error ${t}: ${((y = (p = e == null ? void 0 : e.response) == null ? void 0 : p.data) == null ? void 0 : y.message) || ((A = (b = e == null ? void 0 : e.response) == null ? void 0 : b.data) == null ? void 0 : A.error) || ((D = (v = e == null ? void 0 : e.response) == null ? void 0 : v.data) == null ? void 0 : D.errors)}`]);
    default:
      return Promise.reject([`Error ${t}: Refresh the page and try again.`]);
  }
}
function av() {
  try {
    window.cookies.keys().forEach((e) => window.cookies.remove(e)), window.store.dispatch("resetAllState"), window.router.push({ name: "Home" }), setTimeout(() => {
      location.reload();
    }, 100);
  } catch (e) {
    console.log(e);
  }
}
const Mr = (e) => Re.create({
  baseURL: e,
  timeout: iv
}), lv = Mr("https://click11.hurry2.com/"), cv = Mr("https://central.zplay1.in/pb/api/"), uv = Mr("https://zplay1.in/"), dv = Mr("https://pool-main.zplay1.in"), fv = Mr("https://bonus.zplay1.in"), pv = Mr("https://new-notification.zplay1.in"), hv = Mr("https://api.transaction1.live/api/v1"), zd = {
  user: lv,
  sports: cv,
  fantasy: uv,
  pool: dv,
  bonus: fv,
  notification: pv,
  wallet: hv
  // walletConfig: walletConigApiInstance,
  // walletRequest: walletRequestApiInstance,
};
Object.values(zd).forEach((e) => {
  e.interceptors.response.use(
    (t) => Promise.resolve(t),
    (t) => ov(t)
  );
});
const oc = {
  user: {
    GET_SITE_SETTINGS: "api/site-settings",
    WALLET_BALANCE: "api/user-info",
    AUTH_REFRESH: "api/auth-refresh",
    LOGIN_API: "api/user-login",
    DEMO_LOGIN_API: "api/demo-user",
    LOGOUT_API: "api/logout",
    GET_FAVOURITE_LIST: "api/favorite-list",
    GET_EVENT_EXPOSURES: "api/get-event-book-and-fancy-exposures-by-event-id/:matchId",
    // OPEN_BETS_EVENT_LISTING: 'api/get-my-bets',
    SAVE_BETS: "api/save-bet",
    BET_CASHOUT: "api/cashout",
    GET_FANCY_BOOK: "api/get-fancy-book",
    MAKE_FAVOURITE: "api/make-event-favorite",
    CHANGE_STAKE_VALUES: "api/change-stake-values",
    GET_WALLET_GETWAY: "api/get-payment-getway-iframe-url",
    GET_CASINO_GAMES: "api/get-casino-games",
    GET_MY_MARKETS: "api/get-my-markets/:sport_type",
    GET_THIRD_PARTY_API: "api/load-third-party-url",
    GET_SITE_RULES: "api/get-site-rules",
    UPDATE_WALLET_TYPE: "api/wallet-switch",
    SEND_OTP: "api/send-otp",
    LOGIN_WITH_OTP: "api/login-with-otp",
    REGISTER: "api/registration",
    FORGOT_PASSWORD: "api/reset-forgot-password",
    CHANGE_MY_PASSWORD: "api/change-my-password",
    GET_SITE_VERSION: "api/site-status-version",
    GET_MATKA_SINGLE_BETS: "api/get-matka-single-bets/:id",
    SAVE_WORLI_MATKA_BET: "api/save-worli-matka-bet",
    GET_STATEMENTS: "api/get-statements",
    GET_STATEMENT_INFO: "api/get-statements-info",
    UPDATE_USER_NAME: "api/update-display-name",
    OPEN_BETS_EVENT_LISTING: "api/open-bets-event-listing",
    GET_PROFIT_LOSS: "api/get-user-pl-info",
    GET_PROFIT_LOSS_DETAIL: "api/get-profit-loss-detail",
    GET_PROFIT_LOSS_MATCH_DETAIL: "api/get-user-match-statements",
    GET_PROFIT_LOSS_PL_DETAIL: "api/get-user-pl-statements",
    // GET_MARKET_BETS: 'api/get-market-bets',
    GET_LIVE_POCKER_URL: "api/get-live-poker-url/:game_code",
    DREAM_CASINO: "api/dreamcasino/load-game/:game_code/:sm_id",
    UNIVERSE_CASINO: "api/universe/",
    GET_CHATBOT_IFRAME: "api/chatbot/get-iframe-url",
    GET_CHATBOT_IFRAME_GUEST: "api/chatbot/get-iframe-url-for-guest",
    GET_CHAT_LIST: "api/fetch-user-messages/:id",
    SEND_CHAT_MESSAGE: "api/send-message",
    DELETE_MESSAGE: "api/send-message",
    SEND_EDIT_MESSAGE: "api/editMessage",
    GET_ALL_MARKET_BOOK: "api/get-all-event-book-and-fancy-exposures-by-event-id",
    GET_BET_HISTORY: "api/get-my-bets",
    GET_MARKET_BETS: "api/my-markets",
    GET_OPEN_BETS: "api/get-open-bets",
    GET_SEARCH_EVENTS: "api/searching-event/:searchKey",
    CHANGE_USER_BONUS: "api/change-user-bonus",
    CHANGE_PASSWORD: "api/change-my-password",
    GET_BONUS_STATEMENT: "api/user-bonus-statement/:bonusType",
    REDEEM_USER_BONUS: "api/redeem-user-bonus",
    //BONUS
    GET_REFERED_USER: "api/get-referred-users",
    CLAIM_BONUS: "api/claim-bonus",
    //POOL ZONE
    JOIN_POOL: "api/join-pool",
    //AFFILIATE
    GET_AFFILIATE_DASHBOARD: "api/get-affiliate-dashboard",
    GET_AFFILIATE_USERSLIST: "api/get-affiliate-user-lists",
    GET_PROFIT_LOSS_EVENT_USERS: "api/get-affiliate-profit-loss-events",
    AFFILIATE_REGISTER: "api/add-user",
    GET_AFFILIATE_REGISTER_USER_COUNT: "api/get-affiliate-registered-users-count",
    GET_PAYMENT_WALLET_GETWAY: "api/get-payment-getway-token",
    GET_ID_WALLET_WITHDRAW: "api/get-id/wallet-withdraw"
  },
  pool: {
    GET_POOLS: "api/get-pools",
    POOL_LEADER_BOARD: "api/pool-leader-board",
    POOL_WALLET: "api/user-info",
    GET_FANCY_BOOK: "api/get-fancy-book",
    GET_EVENT_EXPOSURES: "api/get-event-book-and-fancy-exposures-by-event-id/:matchId",
    GET_POOL_OPEN_BETS: "api/pool-bets",
    GET_POOL_WINNERS: "api/pool-winners"
  },
  bonus: {
    GET_BONUS_LOGS: "api/v1/get-bonus-log",
    GET_BONUS_LOGS_DETAILS: "api/v1/get-bonus-log-details",
    GET_USER_LOCKED_BONUS: "api/v1/get-user-locked-bonus",
    GET_LOCKED_EARNED_BONUS: "api/v1/get-locked-earn-bonus"
  },
  notification: {
    NOTIFICATIONS_LIST_API: "api/get-notification",
    UNREAD_NOTIFICATION_COUNT: "api/get-unread-notifications-count",
    SUBSCRIBE_NOTIFICATION: "api/subscribe-notification"
  },
  sports: {
    MATCHES_BY_SPORT_ID: "v1/events/matches/:sport_id",
    GET_SPORTS: "v1/sports/management/getSport",
    GET_MATCH_DETAILS: "v1/events/matchDetails/:event_id",
    FIND_BY_IDS: "v1/events/findByIds",
    INPLAY_MATCHES_COUNT: "v1/events/count",
    GET_MATKAS: "/v1/worli/public/matches",
    GET_MATKA_MARKETS: "/v1/worli/public/matches/:id/all/markets",
    INPLAY_MATCHES_LIST: "v1/events/matches/inplay",
    GET_SPORTS_BOOK_URL: "/get-sap-sportsbook-url",
    GET_UPCOMING_SPORTS: "v1/events/sports/all",
    //POOL ZONE
    INPLAY_POOL_LIST: "v1/events/matches/inplay/pool"
  },
  fantasy: {
    FANTASY_SETUP_DATA: "/get-setup-data",
    GET_REMEMBERED_MATCHES: "/get-remembered-matches",
    ADD_MATCH_REMINDER: "/add-match-reminder",
    REMOVE_MATCH_REMINDER: "/remove-match-reminder",
    PLAYERS_LIST_API: "/get-match-players-list/:matchId",
    GET_MY_STAKES: "/get-my-stakes",
    UPDATE_MY_STAKES: "/update-my-stakes",
    ADD_MY_TEAM: "/add-my-team",
    UPDATE_MYTEAM_NAME: "/update-my-teamname",
    BET_DETAILS: "/get-match-bet-details",
    PLACE_BET: "/place-bet",
    MY_CONTESTS_LIST: "/get-my-contests",
    MY_CONTEST_BET_LIST: "/get-match-teams-and-bet-details",
    CANCEL_BET: "/cancel-bet",
    GET_TEAM_DETAILS: "/get-team-details/:id",
    RESET_MYTEAM: "/reset-my-team",
    GET_MATCHES_LIST: "/get-matches-list"
  },
  wallet: {
    //Config
    GET_WALLET_CONFIG: "client/config",
    UPDATE_TXN_PASSWORD: "client/update-txn-password",
    // Deposit
    PARENT_PAYMENT_METHODS: "client/accounts-master-list",
    GET_AUTO_UTR: "/api/user/get-auto-utr",
    WALLET_DEPOSIT: "client/client-account-transaction",
    PAYMENT_GATEWAY: "client/payment-url",
    // Withdraw
    ACCOUNT_DETAILS: "client/client-account",
    DELETE_ACCOUNT: "client/delete-client-account/:accountId",
    ADD_ACCOUNT: "client/create-client-account",
    UPLOAD_AND_FETCH_QR_DATA: "/dir/settings/getSignedUrl",
    // History
    WALLET_HISTORY: "client/client-account-transaction",
    SENT_OTP_TO_MOBILE: "client/transaction-password/send-otp",
    RESET_WITHDRAWAL_PASSWORD: "client/transaction-password/verify-otp",
    CANCEL_REQUEST: "client/cancel-transaction-request/:transactionId"
  }
}, Jd = {
  "Content-Type": "application/json",
  Authorization: window.authorization_token
}, gv = {
  "Content-Type": "application/json",
  Authorization: window.wallet_token
};
function DO() {
  Jd.Authorization = window.authorization_token;
}
function IO() {
  gv.Authorization = window.wallet_token;
}
let ac = null;
const _v = (e, t) => {
  const r = oc[t] && oc[t][e];
  if (!r)
    throw new Error(`Route not found for type: ${t} and name: ${e}`);
  return r;
}, $ = (e = "get", t, r = null, n = "user", s = null, i = null) => {
  if (!t)
    throw new Error("routeName is required");
  let o = _v(t, n), a = { ...Jd };
  n == "fantasy" && (e == "get" ? o = "api/fantasycricket" + o : e == "post" && (o = "api/fantasy" + o, n = "user")), s && Object.keys(s).forEach((c) => {
    o.includes(`:${c}`) && (o = o.replace(`:${c}`, s[c]), delete s[c]);
  }), r instanceof FormData ? delete a["Content-Type"] : a["Content-Type"] = "application/json";
  let l = ["GET_SITE_SETTINGS", "GET_SITE_VERSION"];
  if (ac == "UPDATE_WALLET_TYPE" && t == "WALLET_BALANCE")
    return Promise.reject({ message: "Calling Wallet Switch", retry: !0 });
  ac = t;
  let u = {
    method: e,
    url: o,
    data: r,
    params: s
  };
  return n != "sports" && !l.includes(t) && (u.headers = a), zd[n](u);
};
function pi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ms = { exports: {} }, mv = ms.exports, lc;
function yv() {
  return lc || (lc = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(mv, function() {
      var r = 1e3, n = 6e4, s = 36e5, i = "millisecond", o = "second", a = "minute", l = "hour", u = "day", c = "week", d = "month", f = "quarter", g = "year", _ = "date", p = "Invalid Date", y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, A = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(J) {
        var B = ["th", "st", "nd", "rd"], R = J % 100;
        return "[" + J + (B[(R - 20) % 10] || B[R] || B[0]) + "]";
      } }, v = function(J, B, R) {
        var x = String(J);
        return !x || x.length >= B ? J : "" + Array(B + 1 - x.length).join(R) + J;
      }, D = { s: v, z: function(J) {
        var B = -J.utcOffset(), R = Math.abs(B), x = Math.floor(R / 60), M = R % 60;
        return (B <= 0 ? "+" : "-") + v(x, 2, "0") + ":" + v(M, 2, "0");
      }, m: function J(B, R) {
        if (B.date() < R.date()) return -J(R, B);
        var x = 12 * (R.year() - B.year()) + (R.month() - B.month()), M = B.clone().add(x, d), T = R - M < 0, S = B.clone().add(x + (T ? -1 : 1), d);
        return +(-(x + (R - M) / (T ? M - S : S - M)) || 0);
      }, a: function(J) {
        return J < 0 ? Math.ceil(J) || 0 : Math.floor(J);
      }, p: function(J) {
        return { M: d, y: g, w: c, d: u, D: _, h: l, m: a, s: o, ms: i, Q: f }[J] || String(J || "").toLowerCase().replace(/s$/, "");
      }, u: function(J) {
        return J === void 0;
      } }, w = "en", j = {};
      j[w] = A;
      var z = "$isDayjsObject", Z = function(J) {
        return J instanceof fe || !(!J || !J[z]);
      }, Q = function J(B, R, x) {
        var M;
        if (!B) return w;
        if (typeof B == "string") {
          var T = B.toLowerCase();
          j[T] && (M = T), R && (j[T] = R, M = T);
          var S = B.split("-");
          if (!M && S.length > 1) return J(S[0]);
        } else {
          var I = B.name;
          j[I] = B, M = I;
        }
        return !x && M && (w = M), M || !x && w;
      }, ee = function(J, B) {
        if (Z(J)) return J.clone();
        var R = typeof B == "object" ? B : {};
        return R.date = J, R.args = arguments, new fe(R);
      }, X = D;
      X.l = Q, X.i = Z, X.w = function(J, B) {
        return ee(J, { locale: B.$L, utc: B.$u, x: B.$x, $offset: B.$offset });
      };
      var fe = function() {
        function J(R) {
          this.$L = Q(R.locale, null, !0), this.parse(R), this.$x = this.$x || R.x || {}, this[z] = !0;
        }
        var B = J.prototype;
        return B.parse = function(R) {
          this.$d = function(x) {
            var M = x.date, T = x.utc;
            if (M === null) return /* @__PURE__ */ new Date(NaN);
            if (X.u(M)) return /* @__PURE__ */ new Date();
            if (M instanceof Date) return new Date(M);
            if (typeof M == "string" && !/Z$/i.test(M)) {
              var S = M.match(y);
              if (S) {
                var I = S[2] - 1 || 0, K = (S[7] || "0").substring(0, 3);
                return T ? new Date(Date.UTC(S[1], I, S[3] || 1, S[4] || 0, S[5] || 0, S[6] || 0, K)) : new Date(S[1], I, S[3] || 1, S[4] || 0, S[5] || 0, S[6] || 0, K);
              }
            }
            return new Date(M);
          }(R), this.init();
        }, B.init = function() {
          var R = this.$d;
          this.$y = R.getFullYear(), this.$M = R.getMonth(), this.$D = R.getDate(), this.$W = R.getDay(), this.$H = R.getHours(), this.$m = R.getMinutes(), this.$s = R.getSeconds(), this.$ms = R.getMilliseconds();
        }, B.$utils = function() {
          return X;
        }, B.isValid = function() {
          return this.$d.toString() !== p;
        }, B.isSame = function(R, x) {
          var M = ee(R);
          return this.startOf(x) <= M && M <= this.endOf(x);
        }, B.isAfter = function(R, x) {
          return ee(R) < this.startOf(x);
        }, B.isBefore = function(R, x) {
          return this.endOf(x) < ee(R);
        }, B.$g = function(R, x, M) {
          return X.u(R) ? this[x] : this.set(M, R);
        }, B.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, B.valueOf = function() {
          return this.$d.getTime();
        }, B.startOf = function(R, x) {
          var M = this, T = !!X.u(x) || x, S = X.p(R), I = function(ne, re) {
            var ue = X.w(M.$u ? Date.UTC(M.$y, re, ne) : new Date(M.$y, re, ne), M);
            return T ? ue : ue.endOf(u);
          }, K = function(ne, re) {
            return X.w(M.toDate()[ne].apply(M.toDate("s"), (T ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(re)), M);
          }, Y = this.$W, te = this.$M, pe = this.$D, Se = "set" + (this.$u ? "UTC" : "");
          switch (S) {
            case g:
              return T ? I(1, 0) : I(31, 11);
            case d:
              return T ? I(1, te) : I(0, te + 1);
            case c:
              var ve = this.$locale().weekStart || 0, ye = (Y < ve ? Y + 7 : Y) - ve;
              return I(T ? pe - ye : pe + (6 - ye), te);
            case u:
            case _:
              return K(Se + "Hours", 0);
            case l:
              return K(Se + "Minutes", 1);
            case a:
              return K(Se + "Seconds", 2);
            case o:
              return K(Se + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, B.endOf = function(R) {
          return this.startOf(R, !1);
        }, B.$set = function(R, x) {
          var M, T = X.p(R), S = "set" + (this.$u ? "UTC" : ""), I = (M = {}, M[u] = S + "Date", M[_] = S + "Date", M[d] = S + "Month", M[g] = S + "FullYear", M[l] = S + "Hours", M[a] = S + "Minutes", M[o] = S + "Seconds", M[i] = S + "Milliseconds", M)[T], K = T === u ? this.$D + (x - this.$W) : x;
          if (T === d || T === g) {
            var Y = this.clone().set(_, 1);
            Y.$d[I](K), Y.init(), this.$d = Y.set(_, Math.min(this.$D, Y.daysInMonth())).$d;
          } else I && this.$d[I](K);
          return this.init(), this;
        }, B.set = function(R, x) {
          return this.clone().$set(R, x);
        }, B.get = function(R) {
          return this[X.p(R)]();
        }, B.add = function(R, x) {
          var M, T = this;
          R = Number(R);
          var S = X.p(x), I = function(te) {
            var pe = ee(T);
            return X.w(pe.date(pe.date() + Math.round(te * R)), T);
          };
          if (S === d) return this.set(d, this.$M + R);
          if (S === g) return this.set(g, this.$y + R);
          if (S === u) return I(1);
          if (S === c) return I(7);
          var K = (M = {}, M[a] = n, M[l] = s, M[o] = r, M)[S] || 1, Y = this.$d.getTime() + R * K;
          return X.w(Y, this);
        }, B.subtract = function(R, x) {
          return this.add(-1 * R, x);
        }, B.format = function(R) {
          var x = this, M = this.$locale();
          if (!this.isValid()) return M.invalidDate || p;
          var T = R || "YYYY-MM-DDTHH:mm:ssZ", S = X.z(this), I = this.$H, K = this.$m, Y = this.$M, te = M.weekdays, pe = M.months, Se = M.meridiem, ve = function(re, ue, Ie, h) {
            return re && (re[ue] || re(x, T)) || Ie[ue].slice(0, h);
          }, ye = function(re) {
            return X.s(I % 12 || 12, re, "0");
          }, ne = Se || function(re, ue, Ie) {
            var h = re < 12 ? "AM" : "PM";
            return Ie ? h.toLowerCase() : h;
          };
          return T.replace(b, function(re, ue) {
            return ue || function(Ie) {
              switch (Ie) {
                case "YY":
                  return String(x.$y).slice(-2);
                case "YYYY":
                  return X.s(x.$y, 4, "0");
                case "M":
                  return Y + 1;
                case "MM":
                  return X.s(Y + 1, 2, "0");
                case "MMM":
                  return ve(M.monthsShort, Y, pe, 3);
                case "MMMM":
                  return ve(pe, Y);
                case "D":
                  return x.$D;
                case "DD":
                  return X.s(x.$D, 2, "0");
                case "d":
                  return String(x.$W);
                case "dd":
                  return ve(M.weekdaysMin, x.$W, te, 2);
                case "ddd":
                  return ve(M.weekdaysShort, x.$W, te, 3);
                case "dddd":
                  return te[x.$W];
                case "H":
                  return String(I);
                case "HH":
                  return X.s(I, 2, "0");
                case "h":
                  return ye(1);
                case "hh":
                  return ye(2);
                case "a":
                  return ne(I, K, !0);
                case "A":
                  return ne(I, K, !1);
                case "m":
                  return String(K);
                case "mm":
                  return X.s(K, 2, "0");
                case "s":
                  return String(x.$s);
                case "ss":
                  return X.s(x.$s, 2, "0");
                case "SSS":
                  return X.s(x.$ms, 3, "0");
                case "Z":
                  return S;
              }
              return null;
            }(re) || S.replace(":", "");
          });
        }, B.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, B.diff = function(R, x, M) {
          var T, S = this, I = X.p(x), K = ee(R), Y = (K.utcOffset() - this.utcOffset()) * n, te = this - K, pe = function() {
            return X.m(S, K);
          };
          switch (I) {
            case g:
              T = pe() / 12;
              break;
            case d:
              T = pe();
              break;
            case f:
              T = pe() / 3;
              break;
            case c:
              T = (te - Y) / 6048e5;
              break;
            case u:
              T = (te - Y) / 864e5;
              break;
            case l:
              T = te / s;
              break;
            case a:
              T = te / n;
              break;
            case o:
              T = te / r;
              break;
            default:
              T = te;
          }
          return M ? T : X.a(T);
        }, B.daysInMonth = function() {
          return this.endOf(d).$D;
        }, B.$locale = function() {
          return j[this.$L];
        }, B.locale = function(R, x) {
          if (!R) return this.$L;
          var M = this.clone(), T = Q(R, x, !0);
          return T && (M.$L = T), M;
        }, B.clone = function() {
          return X.w(this.$d, this);
        }, B.toDate = function() {
          return new Date(this.valueOf());
        }, B.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, B.toISOString = function() {
          return this.$d.toISOString();
        }, B.toString = function() {
          return this.$d.toUTCString();
        }, J;
      }(), ce = fe.prototype;
      return ee.prototype = ce, [["$ms", i], ["$s", o], ["$m", a], ["$H", l], ["$W", u], ["$M", d], ["$y", g], ["$D", _]].forEach(function(J) {
        ce[J[1]] = function(B) {
          return this.$g(B, J[0], J[1]);
        };
      }), ee.extend = function(J, B) {
        return J.$i || (J(B, fe, ee), J.$i = !0), ee;
      }, ee.locale = Q, ee.isDayjs = Z, ee.unix = function(J) {
        return ee(1e3 * J);
      }, ee.en = j[w], ee.Ls = j, ee.p = {}, ee;
    });
  }(ms)), ms.exports;
}
var Ev = yv();
const Me = /* @__PURE__ */ pi(Ev);
var ys = { exports: {} }, vv = ys.exports, cc;
function bv() {
  return cc || (cc = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(vv, function() {
      var r = "minute", n = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
      return function(i, o, a) {
        var l = o.prototype;
        a.utc = function(p) {
          var y = { date: p, utc: !0, args: arguments };
          return new o(y);
        }, l.utc = function(p) {
          var y = a(this.toDate(), { locale: this.$L, utc: !0 });
          return p ? y.add(this.utcOffset(), r) : y;
        }, l.local = function() {
          return a(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var u = l.parse;
        l.parse = function(p) {
          p.utc && (this.$u = !0), this.$utils().u(p.$offset) || (this.$offset = p.$offset), u.call(this, p);
        };
        var c = l.init;
        l.init = function() {
          if (this.$u) {
            var p = this.$d;
            this.$y = p.getUTCFullYear(), this.$M = p.getUTCMonth(), this.$D = p.getUTCDate(), this.$W = p.getUTCDay(), this.$H = p.getUTCHours(), this.$m = p.getUTCMinutes(), this.$s = p.getUTCSeconds(), this.$ms = p.getUTCMilliseconds();
          } else c.call(this);
        };
        var d = l.utcOffset;
        l.utcOffset = function(p, y) {
          var b = this.$utils().u;
          if (b(p)) return this.$u ? 0 : b(this.$offset) ? d.call(this) : this.$offset;
          if (typeof p == "string" && (p = function(w) {
            w === void 0 && (w = "");
            var j = w.match(n);
            if (!j) return null;
            var z = ("" + j[0]).match(s) || ["-", 0, 0], Z = z[0], Q = 60 * +z[1] + +z[2];
            return Q === 0 ? 0 : Z === "+" ? Q : -Q;
          }(p), p === null)) return this;
          var A = Math.abs(p) <= 16 ? 60 * p : p, v = this;
          if (y) return v.$offset = A, v.$u = p === 0, v;
          if (p !== 0) {
            var D = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (v = this.local().add(A + D, r)).$offset = A, v.$x.$localOffset = D;
          } else v = this.utc();
          return v;
        };
        var f = l.format;
        l.format = function(p) {
          var y = p || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return f.call(this, y);
        }, l.valueOf = function() {
          var p = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * p;
        }, l.isUTC = function() {
          return !!this.$u;
        }, l.toISOString = function() {
          return this.toDate().toISOString();
        }, l.toString = function() {
          return this.toDate().toUTCString();
        };
        var g = l.toDate;
        l.toDate = function(p) {
          return p === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : g.call(this);
        };
        var _ = l.diff;
        l.diff = function(p, y, b) {
          if (p && this.$u === p.$u) return _.call(this, p, y, b);
          var A = this.local(), v = a(p).local();
          return _.call(A, v, y, b);
        };
      };
    });
  }(ys)), ys.exports;
}
var wv = bv();
const Tv = /* @__PURE__ */ pi(wv);
var Es = { exports: {} }, Sv = Es.exports, uc;
function Ov() {
  return uc || (uc = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Sv, function() {
      var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
      return function(s, i, o) {
        var a, l = function(f, g, _) {
          _ === void 0 && (_ = {});
          var p = new Date(f), y = function(b, A) {
            A === void 0 && (A = {});
            var v = A.timeZoneName || "short", D = b + "|" + v, w = n[D];
            return w || (w = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: b, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: v }), n[D] = w), w;
          }(g, _);
          return y.formatToParts(p);
        }, u = function(f, g) {
          for (var _ = l(f, g), p = [], y = 0; y < _.length; y += 1) {
            var b = _[y], A = b.type, v = b.value, D = r[A];
            D >= 0 && (p[D] = parseInt(v, 10));
          }
          var w = p[3], j = w === 24 ? 0 : w, z = p[0] + "-" + p[1] + "-" + p[2] + " " + j + ":" + p[4] + ":" + p[5] + ":000", Z = +f;
          return (o.utc(z).valueOf() - (Z -= Z % 1e3)) / 6e4;
        }, c = i.prototype;
        c.tz = function(f, g) {
          f === void 0 && (f = a);
          var _, p = this.utcOffset(), y = this.toDate(), b = y.toLocaleString("en-US", { timeZone: f }), A = Math.round((y - new Date(b)) / 1e3 / 60), v = 15 * -Math.round(y.getTimezoneOffset() / 15) - A;
          if (!Number(v)) _ = this.utcOffset(0, g);
          else if (_ = o(b, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(v, !0), g) {
            var D = _.utcOffset();
            _ = _.add(p - D, "minute");
          }
          return _.$x.$timezone = f, _;
        }, c.offsetName = function(f) {
          var g = this.$x.$timezone || o.tz.guess(), _ = l(this.valueOf(), g, { timeZoneName: f }).find(function(p) {
            return p.type.toLowerCase() === "timezonename";
          });
          return _ && _.value;
        };
        var d = c.startOf;
        c.startOf = function(f, g) {
          if (!this.$x || !this.$x.$timezone) return d.call(this, f, g);
          var _ = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return d.call(_, f, g).tz(this.$x.$timezone, !0);
        }, o.tz = function(f, g, _) {
          var p = _ && g, y = _ || g || a, b = u(+o(), y);
          if (typeof f != "string") return o(f).tz(y);
          var A = function(j, z, Z) {
            var Q = j - 60 * z * 1e3, ee = u(Q, Z);
            if (z === ee) return [Q, z];
            var X = u(Q -= 60 * (ee - z) * 1e3, Z);
            return ee === X ? [Q, ee] : [j - 60 * Math.min(ee, X) * 1e3, Math.max(ee, X)];
          }(o.utc(f, p).valueOf(), b, y), v = A[0], D = A[1], w = o(v).utcOffset(D);
          return w.$x.$timezone = y, w;
        }, o.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(f) {
          a = f;
        };
      };
    });
  }(Es)), Es.exports;
}
var Av = Ov();
const Nv = /* @__PURE__ */ pi(Av);
var vs = { exports: {} }, Cv = vs.exports, dc;
function Dv() {
  return dc || (dc = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Cv, function() {
      var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, n = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, s = /\d/, i = /\d\d/, o = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, l = {}, u = function(y) {
        return (y = +y) + (y > 68 ? 1900 : 2e3);
      }, c = function(y) {
        return function(b) {
          this[y] = +b;
        };
      }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(y) {
        (this.zone || (this.zone = {})).offset = function(b) {
          if (!b || b === "Z") return 0;
          var A = b.match(/([+-]|\d\d)/g), v = 60 * A[1] + (+A[2] || 0);
          return v === 0 ? 0 : A[0] === "+" ? -v : v;
        }(y);
      }], f = function(y) {
        var b = l[y];
        return b && (b.indexOf ? b : b.s.concat(b.f));
      }, g = function(y, b) {
        var A, v = l.meridiem;
        if (v) {
          for (var D = 1; D <= 24; D += 1) if (y.indexOf(v(D, 0, b)) > -1) {
            A = D > 12;
            break;
          }
        } else A = y === (b ? "pm" : "PM");
        return A;
      }, _ = { A: [a, function(y) {
        this.afternoon = g(y, !1);
      }], a: [a, function(y) {
        this.afternoon = g(y, !0);
      }], Q: [s, function(y) {
        this.month = 3 * (y - 1) + 1;
      }], S: [s, function(y) {
        this.milliseconds = 100 * +y;
      }], SS: [i, function(y) {
        this.milliseconds = 10 * +y;
      }], SSS: [/\d{3}/, function(y) {
        this.milliseconds = +y;
      }], s: [o, c("seconds")], ss: [o, c("seconds")], m: [o, c("minutes")], mm: [o, c("minutes")], H: [o, c("hours")], h: [o, c("hours")], HH: [o, c("hours")], hh: [o, c("hours")], D: [o, c("day")], DD: [i, c("day")], Do: [a, function(y) {
        var b = l.ordinal, A = y.match(/\d+/);
        if (this.day = A[0], b) for (var v = 1; v <= 31; v += 1) b(v).replace(/\[|\]/g, "") === y && (this.day = v);
      }], w: [o, c("week")], ww: [i, c("week")], M: [o, c("month")], MM: [i, c("month")], MMM: [a, function(y) {
        var b = f("months"), A = (f("monthsShort") || b.map(function(v) {
          return v.slice(0, 3);
        })).indexOf(y) + 1;
        if (A < 1) throw new Error();
        this.month = A % 12 || A;
      }], MMMM: [a, function(y) {
        var b = f("months").indexOf(y) + 1;
        if (b < 1) throw new Error();
        this.month = b % 12 || b;
      }], Y: [/[+-]?\d+/, c("year")], YY: [i, function(y) {
        this.year = u(y);
      }], YYYY: [/\d{4}/, c("year")], Z: d, ZZ: d };
      function p(y) {
        var b, A;
        b = y, A = l && l.formats;
        for (var v = (y = b.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(ee, X, fe) {
          var ce = fe && fe.toUpperCase();
          return X || A[fe] || r[fe] || A[ce].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(J, B, R) {
            return B || R.slice(1);
          });
        })).match(n), D = v.length, w = 0; w < D; w += 1) {
          var j = v[w], z = _[j], Z = z && z[0], Q = z && z[1];
          v[w] = Q ? { regex: Z, parser: Q } : j.replace(/^\[|\]$/g, "");
        }
        return function(ee) {
          for (var X = {}, fe = 0, ce = 0; fe < D; fe += 1) {
            var J = v[fe];
            if (typeof J == "string") ce += J.length;
            else {
              var B = J.regex, R = J.parser, x = ee.slice(ce), M = B.exec(x)[0];
              R.call(X, M), ee = ee.replace(M, "");
            }
          }
          return function(T) {
            var S = T.afternoon;
            if (S !== void 0) {
              var I = T.hours;
              S ? I < 12 && (T.hours += 12) : I === 12 && (T.hours = 0), delete T.afternoon;
            }
          }(X), X;
        };
      }
      return function(y, b, A) {
        A.p.customParseFormat = !0, y && y.parseTwoDigitYear && (u = y.parseTwoDigitYear);
        var v = b.prototype, D = v.parse;
        v.parse = function(w) {
          var j = w.date, z = w.utc, Z = w.args;
          this.$u = z;
          var Q = Z[1];
          if (typeof Q == "string") {
            var ee = Z[2] === !0, X = Z[3] === !0, fe = ee || X, ce = Z[2];
            X && (ce = Z[2]), l = this.$locale(), !ee && ce && (l = A.Ls[ce]), this.$d = function(x, M, T, S) {
              try {
                if (["x", "X"].indexOf(M) > -1) return new Date((M === "X" ? 1e3 : 1) * x);
                var I = p(M)(x), K = I.year, Y = I.month, te = I.day, pe = I.hours, Se = I.minutes, ve = I.seconds, ye = I.milliseconds, ne = I.zone, re = I.week, ue = /* @__PURE__ */ new Date(), Ie = te || (K || Y ? 1 : ue.getDate()), h = K || ue.getFullYear(), E = 0;
                K && !Y || (E = Y > 0 ? Y - 1 : ue.getMonth());
                var N, k = pe || 0, L = Se || 0, P = ve || 0, G = ye || 0;
                return ne ? new Date(Date.UTC(h, E, Ie, k, L, P, G + 60 * ne.offset * 1e3)) : T ? new Date(Date.UTC(h, E, Ie, k, L, P, G)) : (N = new Date(h, E, Ie, k, L, P, G), re && (N = S(N).week(re).toDate()), N);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            }(j, Q, z, A), this.init(), ce && ce !== !0 && (this.$L = this.locale(ce).$L), fe && j != this.format(Q) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
          } else if (Q instanceof Array) for (var J = Q.length, B = 1; B <= J; B += 1) {
            Z[1] = Q[B - 1];
            var R = A.apply(this, Z);
            if (R.isValid()) {
              this.$d = R.$d, this.$L = R.$L, this.init();
              break;
            }
            B === J && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else D.call(this, w);
        };
      };
    });
  }(vs)), vs.exports;
}
var Iv = Dv();
const Mv = /* @__PURE__ */ pi(Iv);
Me.extend(Nv);
Me.extend(Tv);
Me.extend(Mv);
const Te = {
  sportItemDate: (e, t = "D MMM, h:mm A", r = "Asia/Kolkata") => Me.utc(e).tz(r).format(t),
  NotInplaySportItemDateOnly(e, t = "DD MMM") {
    return Me(e).isSame(Me(), "day") ? "Today" : this.sportItemDate(e, t);
  },
  convertUnixDate: (e, t = "DD MMM YYYY HH:mm:ss") => Me.unix(e).format(t),
  currentTimestamp: () => Me().unix(),
  convertToTimestamp(e) {
    return Me(e).unix();
  },
  convertDateToTimstamp(e) {
    return Me(e).unix();
  },
  getcurrentDate: (e, t = "YYYY-MM-DD") => Me(e).format(t),
  getDateSaperatedByDays: (e, t = /* @__PURE__ */ new Date(), r = "YYYY-MM-DD") => Me(t).subtract(e, "day").format(r),
  getDateAddedByDays: (e, t = /* @__PURE__ */ new Date(), r = "YYYY-MM-DD") => Me(t).add(e, "day").format(r),
  convertOnlyTime: (e, t = "hh:mm A") => Me(e, "HH:mm").format(t),
  convertUtcDate: (e) => Me.utc(e),
  // Wallet
  getUTCTime: (e = "HH:mm:ss") => Me.utc().format(e),
  getPreviousDate: (e = 1, t = "YYYY-MM-DD") => Me().subtract(e, "day").format(t),
  getcurrentTime: (e = "HH:mm:ss") => Me().format(e),
  getLocalDate: (e, t = "DD MMM hh:mm A") => Me.utc(e).local().format(t),
  convertDate: (e, t = "DD MMM YYYY HH:mm:ss") => Me(e).format(t),
  // Matka
  isCurrentDateInRange: (e, t) => {
    const r = Me().startOf("day"), n = r.add(1, "day"), s = Me(e).startOf("day"), i = Me(t).startOf("day");
    if (s.isSame(r) && i.isSame(r))
      return "Today";
    if (s.isSame(n) && i.isSame(n))
      return "Tomorrow";
    if (s.isBefore(r) || i.isBefore(r))
      return s.format("DD-MM-YYYY");
  },
  convertDate: (e, t = "DD MMM YYYY HH:mm:ss") => Me(e).format(t),
  // affiliate -----------------------------------------
  getaffcurrentDate: (e, t = "YYYY-MM-DD") => Me(e).format(t)
};
/**
* @vue/shared v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function cn(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const r of e.split(",")) t[r] = 1;
  return (r) => r in t;
}
const Ce = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, In = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], xe = () => {
}, Rv = () => !1, qn = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Bs = (e) => e.startsWith("onUpdate:"), Ve = Object.assign, Ra = (e, t) => {
  const r = e.indexOf(t);
  r > -1 && e.splice(r, 1);
}, Lv = Object.prototype.hasOwnProperty, we = (e, t) => Lv.call(e, t), ae = Array.isArray, jr = (e) => hi(e) === "[object Map]", xv = (e) => hi(e) === "[object Set]", de = (e) => typeof e == "function", Pe = (e) => typeof e == "string", un = (e) => typeof e == "symbol", De = (e) => e !== null && typeof e == "object", La = (e) => (De(e) || de(e)) && de(e.then) && de(e.catch), kv = Object.prototype.toString, hi = (e) => kv.call(e), xa = (e) => hi(e).slice(8, -1), Pv = (e) => hi(e) === "[object Object]", ka = (e) => Pe(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Mn = /* @__PURE__ */ cn(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), $v = /* @__PURE__ */ cn(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), gi = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (r) => t[r] || (t[r] = e(r));
}, Fv = /-(\w)/g, yt = gi(
  (e) => e.replace(Fv, (t, r) => r ? r.toUpperCase() : "")
), Vv = /\B([A-Z])/g, or = gi(
  (e) => e.replace(Vv, "-$1").toLowerCase()
), _i = gi((e) => e.charAt(0).toUpperCase() + e.slice(1)), hr = gi(
  (e) => e ? `on${_i(e)}` : ""
), br = (e, t) => !Object.is(e, t), En = (e, ...t) => {
  for (let r = 0; r < e.length; r++)
    e[r](...t);
}, Us = (e, t, r, n = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: n,
    value: r
  });
}, Bv = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
};
let fc;
const rr = () => fc || (fc = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Pa(e) {
  if (ae(e)) {
    const t = {};
    for (let r = 0; r < e.length; r++) {
      const n = e[r], s = Pe(n) ? Yv(n) : Pa(n);
      if (s)
        for (const i in s)
          t[i] = s[i];
    }
    return t;
  } else if (Pe(e) || De(e))
    return e;
}
const Uv = /;(?![^(]*\))/g, Hv = /:([^]+)/, jv = /\/\*[^]*?\*\//g;
function Yv(e) {
  const t = {};
  return e.replace(jv, "").split(Uv).forEach((r) => {
    if (r) {
      const n = r.split(Hv);
      n.length > 1 && (t[n[0].trim()] = n[1].trim());
    }
  }), t;
}
function $a(e) {
  let t = "";
  if (Pe(e))
    t = e;
  else if (ae(e))
    for (let r = 0; r < e.length; r++) {
      const n = $a(e[r]);
      n && (t += n + " ");
    }
  else if (De(e))
    for (const r in e)
      e[r] && (t += r + " ");
  return t.trim();
}
const Gv = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", Wv = /* @__PURE__ */ cn(Gv);
function Xd(e) {
  return !!e || e === "";
}
/**
* @vue/reactivity v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Bt(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let ze;
class qv {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = ze, !t && ze && (this.index = (ze.scopes || (ze.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, r;
      if (this.scopes)
        for (t = 0, r = this.scopes.length; t < r; t++)
          this.scopes[t].pause();
      for (t = 0, r = this.effects.length; t < r; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, r;
      if (this.scopes)
        for (t = 0, r = this.scopes.length; t < r; t++)
          this.scopes[t].resume();
      for (t = 0, r = this.effects.length; t < r; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const r = ze;
      try {
        return ze = this, t();
      } finally {
        ze = r;
      }
    } else process.env.NODE_ENV !== "production" && Bt("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = ze, ze = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    this._on > 0 && --this._on === 0 && (ze = this.prevScope, this.prevScope = void 0);
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let r, n;
      for (r = 0, n = this.effects.length; r < n; r++)
        this.effects[r].stop();
      for (this.effects.length = 0, r = 0, n = this.cleanups.length; r < n; r++)
        this.cleanups[r]();
      if (this.cleanups.length = 0, this.scopes) {
        for (r = 0, n = this.scopes.length; r < n; r++)
          this.scopes[r].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function Kv() {
  return ze;
}
let Ae;
const Wi = /* @__PURE__ */ new WeakSet();
class Qd {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, ze && ze.active && ze.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Wi.has(this) && (Wi.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || ef(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, pc(this), tf(this);
    const t = Ae, r = Et;
    Ae = this, Et = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && Ae !== this && Bt(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), rf(this), Ae = t, Et = r, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Ba(t);
      this.deps = this.depsTail = void 0, pc(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Wi.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Uo(this) && this.run();
  }
  get dirty() {
    return Uo(this);
  }
}
let Zd = 0, Rn, Ln;
function ef(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = Ln, Ln = e;
    return;
  }
  e.next = Rn, Rn = e;
}
function Fa() {
  Zd++;
}
function Va() {
  if (--Zd > 0)
    return;
  if (Ln) {
    let t = Ln;
    for (Ln = void 0; t; ) {
      const r = t.next;
      t.next = void 0, t.flags &= -9, t = r;
    }
  }
  let e;
  for (; Rn; ) {
    let t = Rn;
    for (Rn = void 0; t; ) {
      const r = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (n) {
          e || (e = n);
        }
      t = r;
    }
  }
  if (e) throw e;
}
function tf(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function rf(e) {
  let t, r = e.depsTail, n = r;
  for (; n; ) {
    const s = n.prevDep;
    n.version === -1 ? (n === r && (r = s), Ba(n), zv(n)) : t = n, n.dep.activeLink = n.prevActiveLink, n.prevActiveLink = void 0, n = s;
  }
  e.deps = t, e.depsTail = r;
}
function Uo(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (nf(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function nf(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Pn) || (e.globalVersion = Pn, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Uo(e))))
    return;
  e.flags |= 2;
  const t = e.dep, r = Ae, n = Et;
  Ae = e, Et = !0;
  try {
    tf(e);
    const s = e.fn(e._value);
    (t.version === 0 || br(s, e._value)) && (e.flags |= 128, e._value = s, t.version++);
  } catch (s) {
    throw t.version++, s;
  } finally {
    Ae = r, Et = n, rf(e), e.flags &= -3;
  }
}
function Ba(e, t = !1) {
  const { dep: r, prevSub: n, nextSub: s } = e;
  if (n && (n.nextSub = s, e.prevSub = void 0), s && (s.prevSub = n, e.nextSub = void 0), process.env.NODE_ENV !== "production" && r.subsHead === e && (r.subsHead = s), r.subs === e && (r.subs = n, !n && r.computed)) {
    r.computed.flags &= -5;
    for (let i = r.computed.deps; i; i = i.nextDep)
      Ba(i, !0);
  }
  !t && !--r.sc && r.map && r.map.delete(r.key);
}
function zv(e) {
  const { prevDep: t, nextDep: r } = e;
  t && (t.nextDep = r, e.prevDep = void 0), r && (r.prevDep = t, e.nextDep = void 0);
}
let Et = !0;
const sf = [];
function bt() {
  sf.push(Et), Et = !1;
}
function wt() {
  const e = sf.pop();
  Et = e === void 0 ? !0 : e;
}
function pc(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const r = Ae;
    Ae = void 0;
    try {
      t();
    } finally {
      Ae = r;
    }
  }
}
let Pn = 0;
class Jv {
  constructor(t, r) {
    this.sub = t, this.dep = r, this.version = r.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class of {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!Ae || !Et || Ae === this.computed)
      return;
    let r = this.activeLink;
    if (r === void 0 || r.sub !== Ae)
      r = this.activeLink = new Jv(Ae, this), Ae.deps ? (r.prevDep = Ae.depsTail, Ae.depsTail.nextDep = r, Ae.depsTail = r) : Ae.deps = Ae.depsTail = r, af(r);
    else if (r.version === -1 && (r.version = this.version, r.nextDep)) {
      const n = r.nextDep;
      n.prevDep = r.prevDep, r.prevDep && (r.prevDep.nextDep = n), r.prevDep = Ae.depsTail, r.nextDep = void 0, Ae.depsTail.nextDep = r, Ae.depsTail = r, Ae.deps === r && (Ae.deps = n);
    }
    return process.env.NODE_ENV !== "production" && Ae.onTrack && Ae.onTrack(
      Ve(
        {
          effect: Ae
        },
        t
      )
    ), r;
  }
  trigger(t) {
    this.version++, Pn++, this.notify(t);
  }
  notify(t) {
    Fa();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let r = this.subsHead; r; r = r.nextSub)
          r.sub.onTrigger && !(r.sub.flags & 8) && r.sub.onTrigger(
            Ve(
              {
                effect: r.sub
              },
              t
            )
          );
      for (let r = this.subs; r; r = r.prevSub)
        r.sub.notify() && r.sub.dep.notify();
    } finally {
      Va();
    }
  }
}
function af(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let n = t.deps; n; n = n.nextDep)
        af(n);
    }
    const r = e.dep.subs;
    r !== e && (e.prevSub = r, r && (r.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const Ho = /* @__PURE__ */ new WeakMap(), wr = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), jo = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), $n = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function $e(e, t, r) {
  if (Et && Ae) {
    let n = Ho.get(e);
    n || Ho.set(e, n = /* @__PURE__ */ new Map());
    let s = n.get(r);
    s || (n.set(r, s = new of()), s.map = n, s.key = r), process.env.NODE_ENV !== "production" ? s.track({
      target: e,
      type: t,
      key: r
    }) : s.track();
  }
}
function Rt(e, t, r, n, s, i) {
  const o = Ho.get(e);
  if (!o) {
    Pn++;
    return;
  }
  const a = (l) => {
    l && (process.env.NODE_ENV !== "production" ? l.trigger({
      target: e,
      type: t,
      key: r,
      newValue: n,
      oldValue: s,
      oldTarget: i
    }) : l.trigger());
  };
  if (Fa(), t === "clear")
    o.forEach(a);
  else {
    const l = ae(e), u = l && ka(r);
    if (l && r === "length") {
      const c = Number(n);
      o.forEach((d, f) => {
        (f === "length" || f === $n || !un(f) && f >= c) && a(d);
      });
    } else
      switch ((r !== void 0 || o.has(void 0)) && a(o.get(r)), u && a(o.get($n)), t) {
        case "add":
          l ? u && a(o.get("length")) : (a(o.get(wr)), jr(e) && a(o.get(jo)));
          break;
        case "delete":
          l || (a(o.get(wr)), jr(e) && a(o.get(jo)));
          break;
        case "set":
          jr(e) && a(o.get(wr));
          break;
      }
  }
  Va();
}
function kr(e) {
  const t = me(e);
  return t === e ? t : ($e(t, "iterate", $n), nt(e) ? t : t.map(rt));
}
function Ua(e) {
  return $e(e = me(e), "iterate", $n), e;
}
const Xv = {
  __proto__: null,
  [Symbol.iterator]() {
    return qi(this, Symbol.iterator, rt);
  },
  concat(...e) {
    return kr(this).concat(
      ...e.map((t) => ae(t) ? kr(t) : t)
    );
  },
  entries() {
    return qi(this, "entries", (e) => (e[1] = rt(e[1]), e));
  },
  every(e, t) {
    return jt(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return jt(this, "filter", e, t, (r) => r.map(rt), arguments);
  },
  find(e, t) {
    return jt(this, "find", e, t, rt, arguments);
  },
  findIndex(e, t) {
    return jt(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return jt(this, "findLast", e, t, rt, arguments);
  },
  findLastIndex(e, t) {
    return jt(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return jt(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return Ki(this, "includes", e);
  },
  indexOf(...e) {
    return Ki(this, "indexOf", e);
  },
  join(e) {
    return kr(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return Ki(this, "lastIndexOf", e);
  },
  map(e, t) {
    return jt(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return vn(this, "pop");
  },
  push(...e) {
    return vn(this, "push", e);
  },
  reduce(e, ...t) {
    return hc(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return hc(this, "reduceRight", e, t);
  },
  shift() {
    return vn(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return jt(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return vn(this, "splice", e);
  },
  toReversed() {
    return kr(this).toReversed();
  },
  toSorted(e) {
    return kr(this).toSorted(e);
  },
  toSpliced(...e) {
    return kr(this).toSpliced(...e);
  },
  unshift(...e) {
    return vn(this, "unshift", e);
  },
  values() {
    return qi(this, "values", rt);
  }
};
function qi(e, t, r) {
  const n = Ua(e), s = n[t]();
  return n !== e && !nt(e) && (s._next = s.next, s.next = () => {
    const i = s._next();
    return i.value && (i.value = r(i.value)), i;
  }), s;
}
const Qv = Array.prototype;
function jt(e, t, r, n, s, i) {
  const o = Ua(e), a = o !== e && !nt(e), l = o[t];
  if (l !== Qv[t]) {
    const d = l.apply(e, i);
    return a ? rt(d) : d;
  }
  let u = r;
  o !== e && (a ? u = function(d, f) {
    return r.call(this, rt(d), f, e);
  } : r.length > 2 && (u = function(d, f) {
    return r.call(this, d, f, e);
  }));
  const c = l.call(o, u, n);
  return a && s ? s(c) : c;
}
function hc(e, t, r, n) {
  const s = Ua(e);
  let i = r;
  return s !== e && (nt(e) ? r.length > 3 && (i = function(o, a, l) {
    return r.call(this, o, a, l, e);
  }) : i = function(o, a, l) {
    return r.call(this, o, rt(a), l, e);
  }), s[t](i, ...n);
}
function Ki(e, t, r) {
  const n = me(e);
  $e(n, "iterate", $n);
  const s = n[t](...r);
  return (s === -1 || s === !1) && Hs(r[0]) ? (r[0] = me(r[0]), n[t](...r)) : s;
}
function vn(e, t, r = []) {
  bt(), Fa();
  const n = me(e)[t].apply(e, r);
  return Va(), wt(), n;
}
const Zv = /* @__PURE__ */ cn("__proto__,__v_isRef,__isVue"), lf = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(un)
);
function e0(e) {
  un(e) || (e = String(e));
  const t = me(this);
  return $e(t, "has", e), t.hasOwnProperty(e);
}
class cf {
  constructor(t = !1, r = !1) {
    this._isReadonly = t, this._isShallow = r;
  }
  get(t, r, n) {
    if (r === "__v_skip") return t.__v_skip;
    const s = this._isReadonly, i = this._isShallow;
    if (r === "__v_isReactive")
      return !s;
    if (r === "__v_isReadonly")
      return s;
    if (r === "__v_isShallow")
      return i;
    if (r === "__v_raw")
      return n === (s ? i ? gf : hf : i ? pf : ff).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(n) ? t : void 0;
    const o = ae(t);
    if (!s) {
      let l;
      if (o && (l = Xv[r]))
        return l;
      if (r === "hasOwnProperty")
        return e0;
    }
    const a = Reflect.get(
      t,
      r,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      Fe(t) ? t : n
    );
    return (un(r) ? lf.has(r) : Zv(r)) || (s || $e(t, "get", r), i) ? a : Fe(a) ? o && ka(r) ? a : a.value : De(a) ? s ? _f(a) : Ha(a) : a;
  }
}
class uf extends cf {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, r, n, s) {
    let i = t[r];
    if (!this._isShallow) {
      const l = ar(i);
      if (!nt(n) && !ar(n) && (i = me(i), n = me(n)), !ae(t) && Fe(i) && !Fe(n))
        return l ? !1 : (i.value = n, !0);
    }
    const o = ae(t) && ka(r) ? Number(r) < t.length : we(t, r), a = Reflect.set(
      t,
      r,
      n,
      Fe(t) ? t : s
    );
    return t === me(s) && (o ? br(n, i) && Rt(t, "set", r, n, i) : Rt(t, "add", r, n)), a;
  }
  deleteProperty(t, r) {
    const n = we(t, r), s = t[r], i = Reflect.deleteProperty(t, r);
    return i && n && Rt(t, "delete", r, void 0, s), i;
  }
  has(t, r) {
    const n = Reflect.has(t, r);
    return (!un(r) || !lf.has(r)) && $e(t, "has", r), n;
  }
  ownKeys(t) {
    return $e(
      t,
      "iterate",
      ae(t) ? "length" : wr
    ), Reflect.ownKeys(t);
  }
}
class df extends cf {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, r) {
    return process.env.NODE_ENV !== "production" && Bt(
      `Set operation on key "${String(r)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, r) {
    return process.env.NODE_ENV !== "production" && Bt(
      `Delete operation on key "${String(r)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const t0 = /* @__PURE__ */ new uf(), r0 = /* @__PURE__ */ new df(), n0 = /* @__PURE__ */ new uf(!0), s0 = /* @__PURE__ */ new df(!0), Yo = (e) => e, is = (e) => Reflect.getPrototypeOf(e);
function i0(e, t, r) {
  return function(...n) {
    const s = this.__v_raw, i = me(s), o = jr(i), a = e === "entries" || e === Symbol.iterator && o, l = e === "keys" && o, u = s[e](...n), c = r ? Yo : t ? Go : rt;
    return !t && $e(
      i,
      "iterate",
      l ? jo : wr
    ), {
      // iterator protocol
      next() {
        const { value: d, done: f } = u.next();
        return f ? { value: d, done: f } : {
          value: a ? [c(d[0]), c(d[1])] : c(d),
          done: f
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function os(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const r = t[0] ? `on key "${t[0]}" ` : "";
      Bt(
        `${_i(e)} operation ${r}failed: target is readonly.`,
        me(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function o0(e, t) {
  const r = {
    get(s) {
      const i = this.__v_raw, o = me(i), a = me(s);
      e || (br(s, a) && $e(o, "get", s), $e(o, "get", a));
      const { has: l } = is(o), u = t ? Yo : e ? Go : rt;
      if (l.call(o, s))
        return u(i.get(s));
      if (l.call(o, a))
        return u(i.get(a));
      i !== o && i.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !e && $e(me(s), "iterate", wr), Reflect.get(s, "size", s);
    },
    has(s) {
      const i = this.__v_raw, o = me(i), a = me(s);
      return e || (br(s, a) && $e(o, "has", s), $e(o, "has", a)), s === a ? i.has(s) : i.has(s) || i.has(a);
    },
    forEach(s, i) {
      const o = this, a = o.__v_raw, l = me(a), u = t ? Yo : e ? Go : rt;
      return !e && $e(l, "iterate", wr), a.forEach((c, d) => s.call(i, u(c), u(d), o));
    }
  };
  return Ve(
    r,
    e ? {
      add: os("add"),
      set: os("set"),
      delete: os("delete"),
      clear: os("clear")
    } : {
      add(s) {
        !t && !nt(s) && !ar(s) && (s = me(s));
        const i = me(this);
        return is(i).has.call(i, s) || (i.add(s), Rt(i, "add", s, s)), this;
      },
      set(s, i) {
        !t && !nt(i) && !ar(i) && (i = me(i));
        const o = me(this), { has: a, get: l } = is(o);
        let u = a.call(o, s);
        u ? process.env.NODE_ENV !== "production" && gc(o, a, s) : (s = me(s), u = a.call(o, s));
        const c = l.call(o, s);
        return o.set(s, i), u ? br(i, c) && Rt(o, "set", s, i, c) : Rt(o, "add", s, i), this;
      },
      delete(s) {
        const i = me(this), { has: o, get: a } = is(i);
        let l = o.call(i, s);
        l ? process.env.NODE_ENV !== "production" && gc(i, o, s) : (s = me(s), l = o.call(i, s));
        const u = a ? a.call(i, s) : void 0, c = i.delete(s);
        return l && Rt(i, "delete", s, void 0, u), c;
      },
      clear() {
        const s = me(this), i = s.size !== 0, o = process.env.NODE_ENV !== "production" ? jr(s) ? new Map(s) : new Set(s) : void 0, a = s.clear();
        return i && Rt(
          s,
          "clear",
          void 0,
          void 0,
          o
        ), a;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    r[s] = i0(s, e, t);
  }), r;
}
function mi(e, t) {
  const r = o0(e, t);
  return (n, s, i) => s === "__v_isReactive" ? !e : s === "__v_isReadonly" ? e : s === "__v_raw" ? n : Reflect.get(
    we(r, s) && s in n ? r : n,
    s,
    i
  );
}
const a0 = {
  get: /* @__PURE__ */ mi(!1, !1)
}, l0 = {
  get: /* @__PURE__ */ mi(!1, !0)
}, c0 = {
  get: /* @__PURE__ */ mi(!0, !1)
}, u0 = {
  get: /* @__PURE__ */ mi(!0, !0)
};
function gc(e, t, r) {
  const n = me(r);
  if (n !== r && t.call(e, n)) {
    const s = xa(e);
    Bt(
      `Reactive ${s} contains both the raw and reactive versions of the same object${s === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const ff = /* @__PURE__ */ new WeakMap(), pf = /* @__PURE__ */ new WeakMap(), hf = /* @__PURE__ */ new WeakMap(), gf = /* @__PURE__ */ new WeakMap();
function d0(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function f0(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : d0(xa(e));
}
function Ha(e) {
  return ar(e) ? e : yi(
    e,
    !1,
    t0,
    a0,
    ff
  );
}
function p0(e) {
  return yi(
    e,
    !1,
    n0,
    l0,
    pf
  );
}
function _f(e) {
  return yi(
    e,
    !0,
    r0,
    c0,
    hf
  );
}
function Lt(e) {
  return yi(
    e,
    !0,
    s0,
    u0,
    gf
  );
}
function yi(e, t, r, n, s) {
  if (!De(e))
    return process.env.NODE_ENV !== "production" && Bt(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const i = f0(e);
  if (i === 0)
    return e;
  const o = s.get(e);
  if (o)
    return o;
  const a = new Proxy(
    e,
    i === 2 ? n : r
  );
  return s.set(e, a), a;
}
function Yr(e) {
  return ar(e) ? Yr(e.__v_raw) : !!(e && e.__v_isReactive);
}
function ar(e) {
  return !!(e && e.__v_isReadonly);
}
function nt(e) {
  return !!(e && e.__v_isShallow);
}
function Hs(e) {
  return e ? !!e.__v_raw : !1;
}
function me(e) {
  const t = e && e.__v_raw;
  return t ? me(t) : e;
}
function h0(e) {
  return !we(e, "__v_skip") && Object.isExtensible(e) && Us(e, "__v_skip", !0), e;
}
const rt = (e) => De(e) ? Ha(e) : e, Go = (e) => De(e) ? _f(e) : e;
function Fe(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function g0(e) {
  return Fe(e) ? e.value : e;
}
const _0 = {
  get: (e, t, r) => t === "__v_raw" ? e : g0(Reflect.get(e, t, r)),
  set: (e, t, r, n) => {
    const s = e[t];
    return Fe(s) && !Fe(r) ? (s.value = r, !0) : Reflect.set(e, t, r, n);
  }
};
function mf(e) {
  return Yr(e) ? e : new Proxy(e, _0);
}
class m0 {
  constructor(t, r, n) {
    this.fn = t, this.setter = r, this._value = void 0, this.dep = new of(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Pn - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !r, this.isSSR = n;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    Ae !== this)
      return ef(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return nf(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && Bt("Write operation failed: computed value is readonly");
  }
}
function y0(e, t, r = !1) {
  let n, s;
  de(e) ? n = e : (n = e.get, s = e.set);
  const i = new m0(n, s, r);
  return process.env.NODE_ENV, i;
}
const as = {}, js = /* @__PURE__ */ new WeakMap();
let gr;
function E0(e, t = !1, r = gr) {
  if (r) {
    let n = js.get(r);
    n || js.set(r, n = []), n.push(e);
  } else process.env.NODE_ENV !== "production" && !t && Bt(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function v0(e, t, r = Ce) {
  const { immediate: n, deep: s, once: i, scheduler: o, augmentJob: a, call: l } = r, u = (w) => {
    (r.onWarn || Bt)(
      "Invalid watch source: ",
      w,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, c = (w) => s ? w : nt(w) || s === !1 || s === 0 ? Zt(w, 1) : Zt(w);
  let d, f, g, _, p = !1, y = !1;
  if (Fe(e) ? (f = () => e.value, p = nt(e)) : Yr(e) ? (f = () => c(e), p = !0) : ae(e) ? (y = !0, p = e.some((w) => Yr(w) || nt(w)), f = () => e.map((w) => {
    if (Fe(w))
      return w.value;
    if (Yr(w))
      return c(w);
    if (de(w))
      return l ? l(w, 2) : w();
    process.env.NODE_ENV !== "production" && u(w);
  })) : de(e) ? t ? f = l ? () => l(e, 2) : e : f = () => {
    if (g) {
      bt();
      try {
        g();
      } finally {
        wt();
      }
    }
    const w = gr;
    gr = d;
    try {
      return l ? l(e, 3, [_]) : e(_);
    } finally {
      gr = w;
    }
  } : (f = xe, process.env.NODE_ENV !== "production" && u(e)), t && s) {
    const w = f, j = s === !0 ? 1 / 0 : s;
    f = () => Zt(w(), j);
  }
  const b = Kv(), A = () => {
    d.stop(), b && b.active && Ra(b.effects, d);
  };
  if (i && t) {
    const w = t;
    t = (...j) => {
      w(...j), A();
    };
  }
  let v = y ? new Array(e.length).fill(as) : as;
  const D = (w) => {
    if (!(!(d.flags & 1) || !d.dirty && !w))
      if (t) {
        const j = d.run();
        if (s || p || (y ? j.some((z, Z) => br(z, v[Z])) : br(j, v))) {
          g && g();
          const z = gr;
          gr = d;
          try {
            const Z = [
              j,
              // pass undefined as the old value when it's changed for the first time
              v === as ? void 0 : y && v[0] === as ? [] : v,
              _
            ];
            v = j, l ? l(t, 3, Z) : (
              // @ts-expect-error
              t(...Z)
            );
          } finally {
            gr = z;
          }
        }
      } else
        d.run();
  };
  return a && a(D), d = new Qd(f), d.scheduler = o ? () => o(D, !1) : D, _ = (w) => E0(w, !1, d), g = d.onStop = () => {
    const w = js.get(d);
    if (w) {
      if (l)
        l(w, 4);
      else
        for (const j of w) j();
      js.delete(d);
    }
  }, process.env.NODE_ENV !== "production" && (d.onTrack = r.onTrack, d.onTrigger = r.onTrigger), t ? n ? D(!0) : v = d.run() : o ? o(D.bind(null, !0), !0) : d.run(), A.pause = d.pause.bind(d), A.resume = d.resume.bind(d), A.stop = A, A;
}
function Zt(e, t = 1 / 0, r) {
  if (t <= 0 || !De(e) || e.__v_skip || (r = r || /* @__PURE__ */ new Set(), r.has(e)))
    return e;
  if (r.add(e), t--, Fe(e))
    Zt(e.value, t, r);
  else if (ae(e))
    for (let n = 0; n < e.length; n++)
      Zt(e[n], t, r);
  else if (xv(e) || jr(e))
    e.forEach((n) => {
      Zt(n, t, r);
    });
  else if (Pv(e)) {
    for (const n in e)
      Zt(e[n], t, r);
    for (const n of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, n) && Zt(e[n], t, r);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Tr = [];
function bs(e) {
  Tr.push(e);
}
function ws() {
  Tr.pop();
}
let zi = !1;
function q(e, ...t) {
  if (zi) return;
  zi = !0, bt();
  const r = Tr.length ? Tr[Tr.length - 1].component : null, n = r && r.appContext.config.warnHandler, s = b0();
  if (n)
    dn(
      n,
      r,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((i) => {
          var o, a;
          return (a = (o = i.toString) == null ? void 0 : o.call(i)) != null ? a : JSON.stringify(i);
        }).join(""),
        r && r.proxy,
        s.map(
          ({ vnode: i }) => `at <${wi(r, i.type)}>`
        ).join(`
`),
        s
      ]
    );
  else {
    const i = [`[Vue warn]: ${e}`, ...t];
    s.length && i.push(`
`, ...w0(s)), console.warn(...i);
  }
  wt(), zi = !1;
}
function b0() {
  let e = Tr[Tr.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const r = t[0];
    r && r.vnode === e ? r.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const n = e.component && e.component.parent;
    e = n && n.vnode;
  }
  return t;
}
function w0(e) {
  const t = [];
  return e.forEach((r, n) => {
    t.push(...n === 0 ? [] : [`
`], ...T0(r));
  }), t;
}
function T0({ vnode: e, recurseCount: t }) {
  const r = t > 0 ? `... (${t} recursive calls)` : "", n = e.component ? e.component.parent == null : !1, s = ` at <${wi(
    e.component,
    e.type,
    n
  )}`, i = ">" + r;
  return e.props ? [s, ...S0(e.props), i] : [s + i];
}
function S0(e) {
  const t = [], r = Object.keys(e);
  return r.slice(0, 3).forEach((n) => {
    t.push(...yf(n, e[n]));
  }), r.length > 3 && t.push(" ..."), t;
}
function yf(e, t, r) {
  return Pe(t) ? (t = JSON.stringify(t), r ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? r ? t : [`${e}=${t}`] : Fe(t) ? (t = yf(e, me(t.value), !0), r ? t : [`${e}=Ref<`, t, ">"]) : de(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = me(t), r ? t : [`${e}=`, t]);
}
const ja = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function dn(e, t, r, n) {
  try {
    return n ? e(...n) : e();
  } catch (s) {
    Kn(s, t, r);
  }
}
function Ut(e, t, r, n) {
  if (de(e)) {
    const s = dn(e, t, r, n);
    return s && La(s) && s.catch((i) => {
      Kn(i, t, r);
    }), s;
  }
  if (ae(e)) {
    const s = [];
    for (let i = 0; i < e.length; i++)
      s.push(Ut(e[i], t, r, n));
    return s;
  } else process.env.NODE_ENV !== "production" && q(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function Kn(e, t, r, n = !0) {
  const s = t ? t.vnode : null, { errorHandler: i, throwUnhandledErrorInProduction: o } = t && t.appContext.config || Ce;
  if (t) {
    let a = t.parent;
    const l = t.proxy, u = process.env.NODE_ENV !== "production" ? ja[r] : `https://vuejs.org/error-reference/#runtime-${r}`;
    for (; a; ) {
      const c = a.ec;
      if (c) {
        for (let d = 0; d < c.length; d++)
          if (c[d](e, l, u) === !1)
            return;
      }
      a = a.parent;
    }
    if (i) {
      bt(), dn(i, null, 10, [
        e,
        l,
        u
      ]), wt();
      return;
    }
  }
  O0(e, r, s, n, o);
}
function O0(e, t, r, n = !0, s = !1) {
  if (process.env.NODE_ENV !== "production") {
    const i = ja[t];
    if (r && bs(r), q(`Unhandled error${i ? ` during execution of ${i}` : ""}`), r && ws(), n)
      throw e;
    console.error(e);
  } else {
    if (s)
      throw e;
    console.error(e);
  }
}
const Ge = [];
let It = -1;
const Gr = [];
let Xt = null, Ur = 0;
const Ef = /* @__PURE__ */ Promise.resolve();
let Ys = null;
const A0 = 100;
function N0(e) {
  const t = Ys || Ef;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function C0(e) {
  let t = It + 1, r = Ge.length;
  for (; t < r; ) {
    const n = t + r >>> 1, s = Ge[n], i = Fn(s);
    i < e || i === e && s.flags & 2 ? t = n + 1 : r = n;
  }
  return t;
}
function Ei(e) {
  if (!(e.flags & 1)) {
    const t = Fn(e), r = Ge[Ge.length - 1];
    !r || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= Fn(r) ? Ge.push(e) : Ge.splice(C0(t), 0, e), e.flags |= 1, vf();
  }
}
function vf() {
  Ys || (Ys = Ef.then(Tf));
}
function bf(e) {
  ae(e) ? Gr.push(...e) : Xt && e.id === -1 ? Xt.splice(Ur + 1, 0, e) : e.flags & 1 || (Gr.push(e), e.flags |= 1), vf();
}
function _c(e, t, r = It + 1) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); r < Ge.length; r++) {
    const n = Ge[r];
    if (n && n.flags & 2) {
      if (e && n.id !== e.uid || process.env.NODE_ENV !== "production" && Ya(t, n))
        continue;
      Ge.splice(r, 1), r--, n.flags & 4 && (n.flags &= -2), n(), n.flags & 4 || (n.flags &= -2);
    }
  }
}
function wf(e) {
  if (Gr.length) {
    const t = [...new Set(Gr)].sort(
      (r, n) => Fn(r) - Fn(n)
    );
    if (Gr.length = 0, Xt) {
      Xt.push(...t);
      return;
    }
    for (Xt = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), Ur = 0; Ur < Xt.length; Ur++) {
      const r = Xt[Ur];
      process.env.NODE_ENV !== "production" && Ya(e, r) || (r.flags & 4 && (r.flags &= -2), r.flags & 8 || r(), r.flags &= -2);
    }
    Xt = null, Ur = 0;
  }
}
const Fn = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Tf(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (r) => Ya(e, r) : xe;
  try {
    for (It = 0; It < Ge.length; It++) {
      const r = Ge[It];
      if (r && !(r.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(r))
          continue;
        r.flags & 4 && (r.flags &= -2), dn(
          r,
          r.i,
          r.i ? 15 : 14
        ), r.flags & 4 || (r.flags &= -2);
      }
    }
  } finally {
    for (; It < Ge.length; It++) {
      const r = Ge[It];
      r && (r.flags &= -2);
    }
    It = -1, Ge.length = 0, wf(e), Ys = null, (Ge.length || Gr.length) && Tf(e);
  }
}
function Ya(e, t) {
  const r = e.get(t) || 0;
  if (r > A0) {
    const n = t.i, s = n && tp(n.type);
    return Kn(
      `Maximum recursive updates exceeded${s ? ` in component <${s}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, r + 1), !1;
}
let xt = !1;
const Ts = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (rr().__VUE_HMR_RUNTIME__ = {
  createRecord: Ji(Sf),
  rerender: Ji(M0),
  reload: Ji(R0)
});
const Cr = /* @__PURE__ */ new Map();
function D0(e) {
  const t = e.type.__hmrId;
  let r = Cr.get(t);
  r || (Sf(t, e.type), r = Cr.get(t)), r.instances.add(e);
}
function I0(e) {
  Cr.get(e.type.__hmrId).instances.delete(e);
}
function Sf(e, t) {
  return Cr.has(e) ? !1 : (Cr.set(e, {
    initialDef: Gs(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function Gs(e) {
  return rp(e) ? e.__vccOpts : e;
}
function M0(e, t) {
  const r = Cr.get(e);
  r && (r.initialDef.render = t, [...r.instances].forEach((n) => {
    t && (n.render = t, Gs(n.type).render = t), n.renderCache = [], xt = !0, n.update(), xt = !1;
  }));
}
function R0(e, t) {
  const r = Cr.get(e);
  if (!r) return;
  t = Gs(t), mc(r.initialDef, t);
  const n = [...r.instances];
  for (let s = 0; s < n.length; s++) {
    const i = n[s], o = Gs(i.type);
    let a = Ts.get(o);
    a || (o !== r.initialDef && mc(o, t), Ts.set(o, a = /* @__PURE__ */ new Set())), a.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (a.add(i), i.ceReload(t.styles), a.delete(i)) : i.parent ? Ei(() => {
      xt = !0, i.parent.update(), xt = !1, a.delete(i);
    }) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(o);
  }
  bf(() => {
    Ts.clear();
  });
}
function mc(e, t) {
  Ve(e, t);
  for (const r in e)
    r !== "__file" && !(r in t) && delete e[r];
}
function Ji(e) {
  return (t, r) => {
    try {
      return e(t, r);
    } catch (n) {
      console.error(n), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let gt, On = [], Wo = !1;
function zn(e, ...t) {
  gt ? gt.emit(e, ...t) : Wo || On.push({ event: e, args: t });
}
function Ga(e, t) {
  var r, n;
  gt = e, gt ? (gt.enabled = !0, On.forEach(({ event: s, args: i }) => gt.emit(s, ...i)), On = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((n = (r = window.navigator) == null ? void 0 : r.userAgent) != null && n.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((i) => {
    Ga(i, t);
  }), setTimeout(() => {
    gt || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Wo = !0, On = []);
  }, 3e3)) : (Wo = !0, On = []);
}
function L0(e, t) {
  zn("app:init", e, t, {
    Fragment: Mt,
    Text: Jn,
    Comment: vt,
    Static: As
  });
}
function x0(e) {
  zn("app:unmount", e);
}
const k0 = /* @__PURE__ */ Wa(
  "component:added"
  /* COMPONENT_ADDED */
), Of = /* @__PURE__ */ Wa(
  "component:updated"
  /* COMPONENT_UPDATED */
), P0 = /* @__PURE__ */ Wa(
  "component:removed"
  /* COMPONENT_REMOVED */
), $0 = (e) => {
  gt && typeof gt.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !gt.cleanupBuffer(e) && P0(e);
};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Wa(e) {
  return (t) => {
    zn(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const F0 = /* @__PURE__ */ Af(
  "perf:start"
  /* PERFORMANCE_START */
), V0 = /* @__PURE__ */ Af(
  "perf:end"
  /* PERFORMANCE_END */
);
function Af(e) {
  return (t, r, n) => {
    zn(e, t.appContext.app, t.uid, t, r, n);
  };
}
function B0(e, t, r) {
  zn(
    "component:emit",
    e.appContext.app,
    e,
    t,
    r
  );
}
let Xe = null, Nf = null;
function Ws(e) {
  const t = Xe;
  return Xe = e, Nf = e && e.type.__scopeId || null, t;
}
function U0(e, t = Xe, r) {
  if (!t || e._n)
    return e;
  const n = (...s) => {
    n._d && Dc(-1);
    const i = Ws(t);
    let o;
    try {
      o = e(...s);
    } finally {
      Ws(i), n._d && Dc(1);
    }
    return (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && Of(t), o;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
function Cf(e) {
  $v(e) && q("Do not use built-in directive ids as custom directive id: " + e);
}
function fr(e, t, r, n) {
  const s = e.dirs, i = t && t.dirs;
  for (let o = 0; o < s.length; o++) {
    const a = s[o];
    i && (a.oldValue = i[o].value);
    let l = a.dir[n];
    l && (bt(), Ut(l, r, 8, [
      e.el,
      a,
      e,
      t
    ]), wt());
  }
}
const H0 = Symbol("_vte"), j0 = (e) => e.__isTeleport;
function qa(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, qa(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function Df(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
const Y0 = /* @__PURE__ */ new WeakSet();
function qs(e, t, r, n, s = !1) {
  if (ae(e)) {
    e.forEach(
      (_, p) => qs(
        _,
        t && (ae(t) ? t[p] : t),
        r,
        n,
        s
      )
    );
    return;
  }
  if (xn(n) && !s) {
    n.shapeFlag & 512 && n.type.__asyncResolved && n.component.subTree.component && qs(e, t, r, n.component.subTree);
    return;
  }
  const i = n.shapeFlag & 4 ? tl(n.component) : n.el, o = s ? null : i, { i: a, r: l } = e;
  if (process.env.NODE_ENV !== "production" && !a) {
    q(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const u = t && t.r, c = a.refs === Ce ? a.refs = {} : a.refs, d = a.setupState, f = me(d), g = d === Ce ? () => !1 : (_) => process.env.NODE_ENV !== "production" && (we(f, _) && !Fe(f[_]) && q(
    `Template ref "${_}" used on a non-ref value. It will not work in the production build.`
  ), Y0.has(f[_])) ? !1 : we(f, _);
  if (u != null && u !== l && (Pe(u) ? (c[u] = null, g(u) && (d[u] = null)) : Fe(u) && (u.value = null)), de(l))
    dn(l, a, 12, [o, c]);
  else {
    const _ = Pe(l), p = Fe(l);
    if (_ || p) {
      const y = () => {
        if (e.f) {
          const b = _ ? g(l) ? d[l] : c[l] : l.value;
          s ? ae(b) && Ra(b, i) : ae(b) ? b.includes(i) || b.push(i) : _ ? (c[l] = [i], g(l) && (d[l] = c[l])) : (l.value = [i], e.k && (c[e.k] = l.value));
        } else _ ? (c[l] = o, g(l) && (d[l] = o)) : p ? (l.value = o, e.k && (c[e.k] = o)) : process.env.NODE_ENV !== "production" && q("Invalid template ref type:", l, `(${typeof l})`);
      };
      o ? (y.id = -1, tt(y, r)) : y();
    } else process.env.NODE_ENV !== "production" && q("Invalid template ref type:", l, `(${typeof l})`);
  }
}
rr().requestIdleCallback;
rr().cancelIdleCallback;
const xn = (e) => !!e.type.__asyncLoader, Ka = (e) => e.type.__isKeepAlive;
function G0(e, t) {
  If(e, "a", t);
}
function W0(e, t) {
  If(e, "da", t);
}
function If(e, t, r = Be) {
  const n = e.__wdc || (e.__wdc = () => {
    let s = r;
    for (; s; ) {
      if (s.isDeactivated)
        return;
      s = s.parent;
    }
    return e();
  });
  if (vi(t, n, r), r) {
    let s = r.parent;
    for (; s && s.parent; )
      Ka(s.parent.vnode) && q0(n, t, r, s), s = s.parent;
  }
}
function q0(e, t, r, n) {
  const s = vi(
    t,
    e,
    n,
    !0
    /* prepend */
  );
  Mf(() => {
    Ra(n[t], s);
  }, r);
}
function vi(e, t, r = Be, n = !1) {
  if (r) {
    const s = r[e] || (r[e] = []), i = t.__weh || (t.__weh = (...o) => {
      bt();
      const a = Xn(r), l = Ut(t, r, e, o);
      return a(), wt(), l;
    });
    return n ? s.unshift(i) : s.push(i), i;
  } else if (process.env.NODE_ENV !== "production") {
    const s = hr(ja[e].replace(/ hook$/, ""));
    q(
      `${s} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const zt = (e) => (t, r = Be) => {
  (!Vn || e === "sp") && vi(e, (...n) => t(...n), r);
}, K0 = zt("bm"), z0 = zt("m"), J0 = zt(
  "bu"
), X0 = zt("u"), Q0 = zt(
  "bum"
), Mf = zt("um"), Z0 = zt(
  "sp"
), eb = zt("rtg"), tb = zt("rtc");
function rb(e, t = Be) {
  vi("ec", e, t);
}
const nb = Symbol.for("v-ndc"), qo = (e) => e ? Zf(e) ? tl(e) : qo(e.parent) : null, Sr = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ Ve(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? Lt(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? Lt(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? Lt(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? Lt(e.refs) : e.refs,
    $parent: (e) => qo(e.parent),
    $root: (e) => qo(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => __VUE_OPTIONS_API__ ? xf(e) : e.type,
    $forceUpdate: (e) => e.f || (e.f = () => {
      Ei(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = N0.bind(e.proxy)),
    $watch: (e) => __VUE_OPTIONS_API__ ? Pb.bind(e) : xe
  })
), za = (e) => e === "_" || e === "$", Xi = (e, t) => e !== Ce && !e.__isScriptSetup && we(e, t), Rf = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: r, setupState: n, data: s, props: i, accessCache: o, type: a, appContext: l } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let u;
    if (t[0] !== "$") {
      const g = o[t];
      if (g !== void 0)
        switch (g) {
          case 1:
            return n[t];
          case 2:
            return s[t];
          case 4:
            return r[t];
          case 3:
            return i[t];
        }
      else {
        if (Xi(n, t))
          return o[t] = 1, n[t];
        if (s !== Ce && we(s, t))
          return o[t] = 2, s[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (u = e.propsOptions[0]) && we(u, t)
        )
          return o[t] = 3, i[t];
        if (r !== Ce && we(r, t))
          return o[t] = 4, r[t];
        (!__VUE_OPTIONS_API__ || Ko) && (o[t] = 0);
      }
    }
    const c = Sr[t];
    let d, f;
    if (c)
      return t === "$attrs" ? ($e(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && Js()) : process.env.NODE_ENV !== "production" && t === "$slots" && $e(e, "get", t), c(e);
    if (
      // css module (injected by vue-loader)
      (d = a.__cssModules) && (d = d[t])
    )
      return d;
    if (r !== Ce && we(r, t))
      return o[t] = 4, r[t];
    if (
      // global properties
      f = l.config.globalProperties, we(f, t)
    )
      return f[t];
    process.env.NODE_ENV !== "production" && Xe && (!Pe(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (s !== Ce && za(t[0]) && we(s, t) ? q(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === Xe && q(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, r) {
    const { data: n, setupState: s, ctx: i } = e;
    return Xi(s, t) ? (s[t] = r, !0) : process.env.NODE_ENV !== "production" && s.__isScriptSetup && we(s, t) ? (q(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : n !== Ce && we(n, t) ? (n[t] = r, !0) : we(e.props, t) ? (process.env.NODE_ENV !== "production" && q(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && q(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(i, t, {
      enumerable: !0,
      configurable: !0,
      value: r
    }) : i[t] = r, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: r, ctx: n, appContext: s, propsOptions: i }
  }, o) {
    let a;
    return !!r[o] || e !== Ce && we(e, o) || Xi(t, o) || (a = i[0]) && we(a, o) || we(n, o) || we(Sr, o) || we(s.config.globalProperties, o);
  },
  defineProperty(e, t, r) {
    return r.get != null ? e._.accessCache[t] = 0 : we(r, "value") && this.set(e, t, r.value, null), Reflect.defineProperty(e, t, r);
  }
};
process.env.NODE_ENV !== "production" && (Rf.ownKeys = (e) => (q(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function sb(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(Sr).forEach((r) => {
    Object.defineProperty(t, r, {
      configurable: !0,
      enumerable: !1,
      get: () => Sr[r](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: xe
    });
  }), t;
}
function ib(e) {
  const {
    ctx: t,
    propsOptions: [r]
  } = e;
  r && Object.keys(r).forEach((n) => {
    Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[n],
      set: xe
    });
  });
}
function ob(e) {
  const { ctx: t, setupState: r } = e;
  Object.keys(me(r)).forEach((n) => {
    if (!r.__isScriptSetup) {
      if (za(n[0])) {
        q(
          `setup() return property ${JSON.stringify(
            n
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, n, {
        enumerable: !0,
        configurable: !0,
        get: () => r[n],
        set: xe
      });
    }
  });
}
function yc(e) {
  return ae(e) ? e.reduce(
    (t, r) => (t[r] = null, t),
    {}
  ) : e;
}
function ab() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, r) => {
    e[r] ? q(`${t} property "${r}" is already defined in ${e[r]}.`) : e[r] = t;
  };
}
let Ko = !0;
function lb(e) {
  const t = xf(e), r = e.proxy, n = e.ctx;
  Ko = !1, t.beforeCreate && Ec(t.beforeCreate, e, "bc");
  const {
    // state
    data: s,
    computed: i,
    methods: o,
    watch: a,
    provide: l,
    inject: u,
    // lifecycle
    created: c,
    beforeMount: d,
    mounted: f,
    beforeUpdate: g,
    updated: _,
    activated: p,
    deactivated: y,
    beforeDestroy: b,
    beforeUnmount: A,
    destroyed: v,
    unmounted: D,
    render: w,
    renderTracked: j,
    renderTriggered: z,
    errorCaptured: Z,
    serverPrefetch: Q,
    // public API
    expose: ee,
    inheritAttrs: X,
    // assets
    components: fe,
    directives: ce,
    filters: J
  } = t, B = process.env.NODE_ENV !== "production" ? ab() : null;
  if (process.env.NODE_ENV !== "production") {
    const [x] = e.propsOptions;
    if (x)
      for (const M in x)
        B("Props", M);
  }
  if (u && cb(u, n, B), o)
    for (const x in o) {
      const M = o[x];
      de(M) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(n, x, {
        value: M.bind(r),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : n[x] = M.bind(r), process.env.NODE_ENV !== "production" && B("Methods", x)) : process.env.NODE_ENV !== "production" && q(
        `Method "${x}" has type "${typeof M}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (s) {
    process.env.NODE_ENV !== "production" && !de(s) && q(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const x = s.call(r, r);
    if (process.env.NODE_ENV !== "production" && La(x) && q(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !De(x))
      process.env.NODE_ENV !== "production" && q("data() should return an object.");
    else if (e.data = Ha(x), process.env.NODE_ENV !== "production")
      for (const M in x)
        B("Data", M), za(M[0]) || Object.defineProperty(n, M, {
          configurable: !0,
          enumerable: !0,
          get: () => x[M],
          set: xe
        });
  }
  if (Ko = !0, i)
    for (const x in i) {
      const M = i[x], T = de(M) ? M.bind(r, r) : de(M.get) ? M.get.bind(r, r) : xe;
      process.env.NODE_ENV !== "production" && T === xe && q(`Computed property "${x}" has no getter.`);
      const S = !de(M) && de(M.set) ? M.set.bind(r) : process.env.NODE_ENV !== "production" ? () => {
        q(
          `Write operation failed: computed property "${x}" is readonly.`
        );
      } : xe, I = np({
        get: T,
        set: S
      });
      Object.defineProperty(n, x, {
        enumerable: !0,
        configurable: !0,
        get: () => I.value,
        set: (K) => I.value = K
      }), process.env.NODE_ENV !== "production" && B("Computed", x);
    }
  if (a)
    for (const x in a)
      Lf(a[x], n, r, x);
  if (l) {
    const x = de(l) ? l.call(r) : l;
    Reflect.ownKeys(x).forEach((M) => {
      gb(M, x[M]);
    });
  }
  c && Ec(c, e, "c");
  function R(x, M) {
    ae(M) ? M.forEach((T) => x(T.bind(r))) : M && x(M.bind(r));
  }
  if (R(K0, d), R(z0, f), R(J0, g), R(X0, _), R(G0, p), R(W0, y), R(rb, Z), R(tb, j), R(eb, z), R(Q0, A), R(Mf, D), R(Z0, Q), ae(ee))
    if (ee.length) {
      const x = e.exposed || (e.exposed = {});
      ee.forEach((M) => {
        Object.defineProperty(x, M, {
          get: () => r[M],
          set: (T) => r[M] = T
        });
      });
    } else e.exposed || (e.exposed = {});
  w && e.render === xe && (e.render = w), X != null && (e.inheritAttrs = X), fe && (e.components = fe), ce && (e.directives = ce), Q && Df(e);
}
function cb(e, t, r = xe) {
  ae(e) && (e = zo(e));
  for (const n in e) {
    const s = e[n];
    let i;
    De(s) ? "default" in s ? i = Ss(
      s.from || n,
      s.default,
      !0
    ) : i = Ss(s.from || n) : i = Ss(s), Fe(i) ? Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => i.value,
      set: (o) => i.value = o
    }) : t[n] = i, process.env.NODE_ENV !== "production" && r("Inject", n);
  }
}
function Ec(e, t, r) {
  Ut(
    ae(e) ? e.map((n) => n.bind(t.proxy)) : e.bind(t.proxy),
    t,
    r
  );
}
function Lf(e, t, r, n) {
  let s = n.includes(".") ? Wf(r, n) : () => r[n];
  if (Pe(e)) {
    const i = t[e];
    de(i) ? Zi(s, i) : process.env.NODE_ENV !== "production" && q(`Invalid watch handler specified by key "${e}"`, i);
  } else if (de(e))
    Zi(s, e.bind(r));
  else if (De(e))
    if (ae(e))
      e.forEach((i) => Lf(i, t, r, n));
    else {
      const i = de(e.handler) ? e.handler.bind(r) : t[e.handler];
      de(i) ? Zi(s, i, e) : process.env.NODE_ENV !== "production" && q(`Invalid watch handler specified by key "${e.handler}"`, i);
    }
  else process.env.NODE_ENV !== "production" && q(`Invalid watch option: "${n}"`, e);
}
function xf(e) {
  const t = e.type, { mixins: r, extends: n } = t, {
    mixins: s,
    optionsCache: i,
    config: { optionMergeStrategies: o }
  } = e.appContext, a = i.get(t);
  let l;
  return a ? l = a : !s.length && !r && !n ? l = t : (l = {}, s.length && s.forEach(
    (u) => Ks(l, u, o, !0)
  ), Ks(l, t, o)), De(t) && i.set(t, l), l;
}
function Ks(e, t, r, n = !1) {
  const { mixins: s, extends: i } = t;
  i && Ks(e, i, r, !0), s && s.forEach(
    (o) => Ks(e, o, r, !0)
  );
  for (const o in t)
    if (n && o === "expose")
      process.env.NODE_ENV !== "production" && q(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const a = ub[o] || r && r[o];
      e[o] = a ? a(e[o], t[o]) : t[o];
    }
  return e;
}
const ub = {
  data: vc,
  props: bc,
  emits: bc,
  // objects
  methods: An,
  computed: An,
  // lifecycle
  beforeCreate: Ye,
  created: Ye,
  beforeMount: Ye,
  mounted: Ye,
  beforeUpdate: Ye,
  updated: Ye,
  beforeDestroy: Ye,
  beforeUnmount: Ye,
  destroyed: Ye,
  unmounted: Ye,
  activated: Ye,
  deactivated: Ye,
  errorCaptured: Ye,
  serverPrefetch: Ye,
  // assets
  components: An,
  directives: An,
  // watch
  watch: fb,
  // provide / inject
  provide: vc,
  inject: db
};
function vc(e, t) {
  return t ? e ? function() {
    return Ve(
      de(e) ? e.call(this, this) : e,
      de(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function db(e, t) {
  return An(zo(e), zo(t));
}
function zo(e) {
  if (ae(e)) {
    const t = {};
    for (let r = 0; r < e.length; r++)
      t[e[r]] = e[r];
    return t;
  }
  return e;
}
function Ye(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function An(e, t) {
  return e ? Ve(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function bc(e, t) {
  return e ? ae(e) && ae(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : Ve(
    /* @__PURE__ */ Object.create(null),
    yc(e),
    yc(t ?? {})
  ) : t;
}
function fb(e, t) {
  if (!e) return t;
  if (!t) return e;
  const r = Ve(/* @__PURE__ */ Object.create(null), e);
  for (const n in t)
    r[n] = Ye(e[n], t[n]);
  return r;
}
function kf() {
  return {
    app: null,
    config: {
      isNativeTag: Rv,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let pb = 0;
function hb(e, t) {
  return function(n, s = null) {
    de(n) || (n = Ve({}, n)), s != null && !De(s) && (process.env.NODE_ENV !== "production" && q("root props passed to app.mount() must be an object."), s = null);
    const i = kf(), o = /* @__PURE__ */ new WeakSet(), a = [];
    let l = !1;
    const u = i.app = {
      _uid: pb++,
      _component: n,
      _props: s,
      _container: null,
      _context: i,
      _instance: null,
      version: Lc,
      get config() {
        return i.config;
      },
      set config(c) {
        process.env.NODE_ENV !== "production" && q(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(c, ...d) {
        return o.has(c) ? process.env.NODE_ENV !== "production" && q("Plugin has already been applied to target app.") : c && de(c.install) ? (o.add(c), c.install(u, ...d)) : de(c) ? (o.add(c), c(u, ...d)) : process.env.NODE_ENV !== "production" && q(
          'A plugin must either be a function or an object with an "install" function.'
        ), u;
      },
      mixin(c) {
        return __VUE_OPTIONS_API__ ? i.mixins.includes(c) ? process.env.NODE_ENV !== "production" && q(
          "Mixin has already been applied to target app" + (c.name ? `: ${c.name}` : "")
        ) : i.mixins.push(c) : process.env.NODE_ENV !== "production" && q("Mixins are only available in builds supporting Options API"), u;
      },
      component(c, d) {
        return process.env.NODE_ENV !== "production" && ea(c, i.config), d ? (process.env.NODE_ENV !== "production" && i.components[c] && q(`Component "${c}" has already been registered in target app.`), i.components[c] = d, u) : i.components[c];
      },
      directive(c, d) {
        return process.env.NODE_ENV !== "production" && Cf(c), d ? (process.env.NODE_ENV !== "production" && i.directives[c] && q(`Directive "${c}" has already been registered in target app.`), i.directives[c] = d, u) : i.directives[c];
      },
      mount(c, d, f) {
        if (l)
          process.env.NODE_ENV !== "production" && q(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && c.__vue_app__ && q(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const g = u._ceVNode || _t(n, s);
          return g.appContext = i, f === !0 ? f = "svg" : f === !1 && (f = void 0), process.env.NODE_ENV !== "production" && (i.reload = () => {
            const _ = lr(g);
            _.el = null, e(_, c, f);
          }), e(g, c, f), l = !0, u._container = c, c.__vue_app__ = u, (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (u._instance = g.component, L0(u, Lc)), tl(g.component);
        }
      },
      onUnmount(c) {
        process.env.NODE_ENV !== "production" && typeof c != "function" && q(
          `Expected function as first argument to app.onUnmount(), but got ${typeof c}`
        ), a.push(c);
      },
      unmount() {
        l ? (Ut(
          a,
          u._instance,
          16
        ), e(null, u._container), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (u._instance = null, x0(u)), delete u._container.__vue_app__) : process.env.NODE_ENV !== "production" && q("Cannot unmount an app that is not mounted.");
      },
      provide(c, d) {
        return process.env.NODE_ENV !== "production" && c in i.provides && (we(i.provides, c) ? q(
          `App already provides property with key "${String(c)}". It will be overwritten with the new value.`
        ) : q(
          `App already provides property with key "${String(c)}" inherited from its parent element. It will be overwritten with the new value.`
        )), i.provides[c] = d, u;
      },
      runWithContext(c) {
        const d = Wr;
        Wr = u;
        try {
          return c();
        } finally {
          Wr = d;
        }
      }
    };
    return u;
  };
}
let Wr = null;
function gb(e, t) {
  if (!Be)
    process.env.NODE_ENV !== "production" && q("provide() can only be used inside setup().");
  else {
    let r = Be.provides;
    const n = Be.parent && Be.parent.provides;
    n === r && (r = Be.provides = Object.create(n)), r[e] = t;
  }
}
function Ss(e, t, r = !1) {
  const n = Be || Xe;
  if (n || Wr) {
    let s = Wr ? Wr._context.provides : n ? n.parent == null || n.ce ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : void 0;
    if (s && e in s)
      return s[e];
    if (arguments.length > 1)
      return r && de(t) ? t.call(n && n.proxy) : t;
    process.env.NODE_ENV !== "production" && q(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && q("inject() can only be used inside setup() or functional components.");
}
const Pf = {}, $f = () => Object.create(Pf), Ff = (e) => Object.getPrototypeOf(e) === Pf;
function _b(e, t, r, n = !1) {
  const s = {}, i = $f();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Vf(e, t, s, i);
  for (const o in e.propsOptions[0])
    o in s || (s[o] = void 0);
  process.env.NODE_ENV !== "production" && Uf(t || {}, s, e), r ? e.props = n ? s : p0(s) : e.type.props ? e.props = s : e.props = i, e.attrs = i;
}
function mb(e) {
  for (; e; ) {
    if (e.type.__hmrId) return !0;
    e = e.parent;
  }
}
function yb(e, t, r, n) {
  const {
    props: s,
    attrs: i,
    vnode: { patchFlag: o }
  } = e, a = me(s), [l] = e.propsOptions;
  let u = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && mb(e)) && (n || o > 0) && !(o & 16)
  ) {
    if (o & 8) {
      const c = e.vnode.dynamicProps;
      for (let d = 0; d < c.length; d++) {
        let f = c[d];
        if (bi(e.emitsOptions, f))
          continue;
        const g = t[f];
        if (l)
          if (we(i, f))
            g !== i[f] && (i[f] = g, u = !0);
          else {
            const _ = yt(f);
            s[_] = Jo(
              l,
              a,
              _,
              g,
              e,
              !1
            );
          }
        else
          g !== i[f] && (i[f] = g, u = !0);
      }
    }
  } else {
    Vf(e, t, s, i) && (u = !0);
    let c;
    for (const d in a)
      (!t || // for camelCase
      !we(t, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = or(d)) === d || !we(t, c))) && (l ? r && // for camelCase
      (r[d] !== void 0 || // for kebab-case
      r[c] !== void 0) && (s[d] = Jo(
        l,
        a,
        d,
        void 0,
        e,
        !0
      )) : delete s[d]);
    if (i !== a)
      for (const d in i)
        (!t || !we(t, d)) && (delete i[d], u = !0);
  }
  u && Rt(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && Uf(t || {}, s, e);
}
function Vf(e, t, r, n) {
  const [s, i] = e.propsOptions;
  let o = !1, a;
  if (t)
    for (let l in t) {
      if (Mn(l))
        continue;
      const u = t[l];
      let c;
      s && we(s, c = yt(l)) ? !i || !i.includes(c) ? r[c] = u : (a || (a = {}))[c] = u : bi(e.emitsOptions, l) || (!(l in n) || u !== n[l]) && (n[l] = u, o = !0);
    }
  if (i) {
    const l = me(r), u = a || Ce;
    for (let c = 0; c < i.length; c++) {
      const d = i[c];
      r[d] = Jo(
        s,
        l,
        d,
        u[d],
        e,
        !we(u, d)
      );
    }
  }
  return o;
}
function Jo(e, t, r, n, s, i) {
  const o = e[r];
  if (o != null) {
    const a = we(o, "default");
    if (a && n === void 0) {
      const l = o.default;
      if (o.type !== Function && !o.skipFactory && de(l)) {
        const { propsDefaults: u } = s;
        if (r in u)
          n = u[r];
        else {
          const c = Xn(s);
          n = u[r] = l.call(
            null,
            t
          ), c();
        }
      } else
        n = l;
      s.ce && s.ce._setProp(r, n);
    }
    o[
      0
      /* shouldCast */
    ] && (i && !a ? n = !1 : o[
      1
      /* shouldCastTrue */
    ] && (n === "" || n === or(r)) && (n = !0));
  }
  return n;
}
const Eb = /* @__PURE__ */ new WeakMap();
function Bf(e, t, r = !1) {
  const n = __VUE_OPTIONS_API__ && r ? Eb : t.propsCache, s = n.get(e);
  if (s)
    return s;
  const i = e.props, o = {}, a = [];
  let l = !1;
  if (__VUE_OPTIONS_API__ && !de(e)) {
    const c = (d) => {
      l = !0;
      const [f, g] = Bf(d, t, !0);
      Ve(o, f), g && a.push(...g);
    };
    !r && t.mixins.length && t.mixins.forEach(c), e.extends && c(e.extends), e.mixins && e.mixins.forEach(c);
  }
  if (!i && !l)
    return De(e) && n.set(e, In), In;
  if (ae(i))
    for (let c = 0; c < i.length; c++) {
      process.env.NODE_ENV !== "production" && !Pe(i[c]) && q("props must be strings when using array syntax.", i[c]);
      const d = yt(i[c]);
      wc(d) && (o[d] = Ce);
    }
  else if (i) {
    process.env.NODE_ENV !== "production" && !De(i) && q("invalid props options", i);
    for (const c in i) {
      const d = yt(c);
      if (wc(d)) {
        const f = i[c], g = o[d] = ae(f) || de(f) ? { type: f } : Ve({}, f), _ = g.type;
        let p = !1, y = !0;
        if (ae(_))
          for (let b = 0; b < _.length; ++b) {
            const A = _[b], v = de(A) && A.name;
            if (v === "Boolean") {
              p = !0;
              break;
            } else v === "String" && (y = !1);
          }
        else
          p = de(_) && _.name === "Boolean";
        g[
          0
          /* shouldCast */
        ] = p, g[
          1
          /* shouldCastTrue */
        ] = y, (p || we(g, "default")) && a.push(d);
      }
    }
  }
  const u = [o, a];
  return De(e) && n.set(e, u), u;
}
function wc(e) {
  return e[0] !== "$" && !Mn(e) ? !0 : (process.env.NODE_ENV !== "production" && q(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function vb(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function Uf(e, t, r) {
  const n = me(t), s = r.propsOptions[0], i = Object.keys(e).map((o) => yt(o));
  for (const o in s) {
    let a = s[o];
    a != null && bb(
      o,
      n[o],
      a,
      process.env.NODE_ENV !== "production" ? Lt(n) : n,
      !i.includes(o)
    );
  }
}
function bb(e, t, r, n, s) {
  const { type: i, required: o, validator: a, skipCheck: l } = r;
  if (o && s) {
    q('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !o)) {
    if (i != null && i !== !0 && !l) {
      let u = !1;
      const c = ae(i) ? i : [i], d = [];
      for (let f = 0; f < c.length && !u; f++) {
        const { valid: g, expectedType: _ } = Tb(t, c[f]);
        d.push(_ || ""), u = g;
      }
      if (!u) {
        q(Sb(e, t, d));
        return;
      }
    }
    a && !a(t, n) && q('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const wb = /* @__PURE__ */ cn(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Tb(e, t) {
  let r;
  const n = vb(t);
  if (n === "null")
    r = e === null;
  else if (wb(n)) {
    const s = typeof e;
    r = s === n.toLowerCase(), !r && s === "object" && (r = e instanceof t);
  } else n === "Object" ? r = De(e) : n === "Array" ? r = ae(e) : r = e instanceof t;
  return {
    valid: r,
    expectedType: n
  };
}
function Sb(e, t, r) {
  if (r.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let n = `Invalid prop: type check failed for prop "${e}". Expected ${r.map(_i).join(" | ")}`;
  const s = r[0], i = xa(t), o = Tc(t, s), a = Tc(t, i);
  return r.length === 1 && Sc(s) && !Ob(s, i) && (n += ` with value ${o}`), n += `, got ${i} `, Sc(i) && (n += `with value ${a}.`), n;
}
function Tc(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function Sc(e) {
  return ["string", "number", "boolean"].some((r) => e.toLowerCase() === r);
}
function Ob(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Ja = (e) => e[0] === "_" || e === "$stable", Xa = (e) => ae(e) ? e.map(ht) : [ht(e)], Ab = (e, t, r) => {
  if (t._n)
    return t;
  const n = U0((...s) => (process.env.NODE_ENV !== "production" && Be && !(r === null && Xe) && !(r && r.root !== Be.root) && q(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), Xa(t(...s))), r);
  return n._c = !1, n;
}, Hf = (e, t, r) => {
  const n = e._ctx;
  for (const s in e) {
    if (Ja(s)) continue;
    const i = e[s];
    if (de(i))
      t[s] = Ab(s, i, n);
    else if (i != null) {
      process.env.NODE_ENV !== "production" && q(
        `Non-function value encountered for slot "${s}". Prefer function slots for better performance.`
      );
      const o = Xa(i);
      t[s] = () => o;
    }
  }
}, jf = (e, t) => {
  process.env.NODE_ENV !== "production" && !Ka(e.vnode) && q(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const r = Xa(t);
  e.slots.default = () => r;
}, Xo = (e, t, r) => {
  for (const n in t)
    (r || !Ja(n)) && (e[n] = t[n]);
}, Nb = (e, t, r) => {
  const n = e.slots = $f();
  if (e.vnode.shapeFlag & 32) {
    const s = t._;
    s ? (Xo(n, t, r), r && Us(n, "_", s, !0)) : Hf(t, n);
  } else t && jf(e, t);
}, Cb = (e, t, r) => {
  const { vnode: n, slots: s } = e;
  let i = !0, o = Ce;
  if (n.shapeFlag & 32) {
    const a = t._;
    a ? process.env.NODE_ENV !== "production" && xt ? (Xo(s, t, r), Rt(e, "set", "$slots")) : r && a === 1 ? i = !1 : Xo(s, t, r) : (i = !t.$stable, Hf(t, s)), o = t;
  } else t && (jf(e, t), o = { default: 1 });
  if (i)
    for (const a in s)
      !Ja(a) && o[a] == null && delete s[a];
};
let bn, er;
function Pr(e, t) {
  e.appContext.config.performance && zs() && er.mark(`vue-${t}-${e.uid}`), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && F0(e, t, zs() ? er.now() : Date.now());
}
function $r(e, t) {
  if (e.appContext.config.performance && zs()) {
    const r = `vue-${t}-${e.uid}`, n = r + ":end";
    er.mark(n), er.measure(
      `<${wi(e, e.type)}> ${t}`,
      r,
      n
    ), er.clearMarks(r), er.clearMarks(n);
  }
  (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && V0(e, t, zs() ? er.now() : Date.now());
}
function zs() {
  return bn !== void 0 || (typeof window < "u" && window.performance ? (bn = !0, er = window.performance) : bn = !1), bn;
}
function Db() {
  const e = [];
  if (typeof __VUE_OPTIONS_API__ != "boolean" && (process.env.NODE_ENV !== "production" && e.push("__VUE_OPTIONS_API__"), rr().__VUE_OPTIONS_API__ = !0), typeof __VUE_PROD_DEVTOOLS__ != "boolean" && (process.env.NODE_ENV !== "production" && e.push("__VUE_PROD_DEVTOOLS__"), rr().__VUE_PROD_DEVTOOLS__ = !1), typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ != "boolean" && (process.env.NODE_ENV !== "production" && e.push("__VUE_PROD_HYDRATION_MISMATCH_DETAILS__"), rr().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = !1), process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const tt = jb;
function Ib(e) {
  return Mb(e);
}
function Mb(e, t) {
  Db();
  const r = rr();
  r.__VUE__ = !0, (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && Ga(r.__VUE_DEVTOOLS_GLOBAL_HOOK__, r);
  const {
    insert: n,
    remove: s,
    patchProp: i,
    createElement: o,
    createText: a,
    createComment: l,
    setText: u,
    setElementText: c,
    parentNode: d,
    nextSibling: f,
    setScopeId: g = xe,
    insertStaticContent: _
  } = e, p = (h, E, N, k = null, L = null, P = null, G = void 0, U = null, H = process.env.NODE_ENV !== "production" && xt ? !1 : !!E.dynamicChildren) => {
    if (h === E)
      return;
    h && !wn(h, E) && (k = ye(h), Y(h, L, P, !0), h = null), E.patchFlag === -2 && (H = !1, E.dynamicChildren = null);
    const { type: V, ref: ie, shapeFlag: W } = E;
    switch (V) {
      case Jn:
        y(h, E, N, k);
        break;
      case vt:
        b(h, E, N, k);
        break;
      case As:
        h == null ? A(E, N, k, G) : process.env.NODE_ENV !== "production" && v(h, E, N, G);
        break;
      case Mt:
        ce(
          h,
          E,
          N,
          k,
          L,
          P,
          G,
          U,
          H
        );
        break;
      default:
        W & 1 ? j(
          h,
          E,
          N,
          k,
          L,
          P,
          G,
          U,
          H
        ) : W & 6 ? J(
          h,
          E,
          N,
          k,
          L,
          P,
          G,
          U,
          H
        ) : W & 64 || W & 128 ? V.process(
          h,
          E,
          N,
          k,
          L,
          P,
          G,
          U,
          H,
          ue
        ) : process.env.NODE_ENV !== "production" && q("Invalid VNode type:", V, `(${typeof V})`);
    }
    ie != null && L && qs(ie, h && h.ref, P, E || h, !E);
  }, y = (h, E, N, k) => {
    if (h == null)
      n(
        E.el = a(E.children),
        N,
        k
      );
    else {
      const L = E.el = h.el;
      E.children !== h.children && u(L, E.children);
    }
  }, b = (h, E, N, k) => {
    h == null ? n(
      E.el = l(E.children || ""),
      N,
      k
    ) : E.el = h.el;
  }, A = (h, E, N, k) => {
    [h.el, h.anchor] = _(
      h.children,
      E,
      N,
      k,
      h.el,
      h.anchor
    );
  }, v = (h, E, N, k) => {
    if (E.children !== h.children) {
      const L = f(h.anchor);
      w(h), [E.el, E.anchor] = _(
        E.children,
        N,
        L,
        k
      );
    } else
      E.el = h.el, E.anchor = h.anchor;
  }, D = ({ el: h, anchor: E }, N, k) => {
    let L;
    for (; h && h !== E; )
      L = f(h), n(h, N, k), h = L;
    n(E, N, k);
  }, w = ({ el: h, anchor: E }) => {
    let N;
    for (; h && h !== E; )
      N = f(h), s(h), h = N;
    s(E);
  }, j = (h, E, N, k, L, P, G, U, H) => {
    E.type === "svg" ? G = "svg" : E.type === "math" && (G = "mathml"), h == null ? z(
      E,
      N,
      k,
      L,
      P,
      G,
      U,
      H
    ) : ee(
      h,
      E,
      L,
      P,
      G,
      U,
      H
    );
  }, z = (h, E, N, k, L, P, G, U) => {
    let H, V;
    const { props: ie, shapeFlag: W, transition: se, dirs: le } = h;
    if (H = h.el = o(
      h.type,
      P,
      ie && ie.is,
      ie
    ), W & 8 ? c(H, h.children) : W & 16 && Q(
      h.children,
      H,
      null,
      k,
      L,
      Qi(h, P),
      G,
      U
    ), le && fr(h, null, k, "created"), Z(H, h, h.scopeId, G, k), ie) {
      for (const Oe in ie)
        Oe !== "value" && !Mn(Oe) && i(H, Oe, null, ie[Oe], P, k);
      "value" in ie && i(H, "value", null, ie.value, P), (V = ie.onVnodeBeforeMount) && Dt(V, k, h);
    }
    (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (Us(H, "__vnode", h, !0), Us(H, "__vueParentComponent", k, !0)), le && fr(h, null, k, "beforeMount");
    const Ee = Rb(L, se);
    Ee && se.beforeEnter(H), n(H, E, N), ((V = ie && ie.onVnodeMounted) || Ee || le) && tt(() => {
      V && Dt(V, k, h), Ee && se.enter(H), le && fr(h, null, k, "mounted");
    }, L);
  }, Z = (h, E, N, k, L) => {
    if (N && g(h, N), k)
      for (let P = 0; P < k.length; P++)
        g(h, k[P]);
    if (L) {
      let P = L.subTree;
      if (process.env.NODE_ENV !== "production" && P.patchFlag > 0 && P.patchFlag & 2048 && (P = Qa(P.children) || P), E === P || zf(P.type) && (P.ssContent === E || P.ssFallback === E)) {
        const G = L.vnode;
        Z(
          h,
          G,
          G.scopeId,
          G.slotScopeIds,
          L.parent
        );
      }
    }
  }, Q = (h, E, N, k, L, P, G, U, H = 0) => {
    for (let V = H; V < h.length; V++) {
      const ie = h[V] = U ? Qt(h[V]) : ht(h[V]);
      p(
        null,
        ie,
        E,
        N,
        k,
        L,
        P,
        G,
        U
      );
    }
  }, ee = (h, E, N, k, L, P, G) => {
    const U = E.el = h.el;
    (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (U.__vnode = E);
    let { patchFlag: H, dynamicChildren: V, dirs: ie } = E;
    H |= h.patchFlag & 16;
    const W = h.props || Ce, se = E.props || Ce;
    let le;
    if (N && pr(N, !1), (le = se.onVnodeBeforeUpdate) && Dt(le, N, E, h), ie && fr(E, h, N, "beforeUpdate"), N && pr(N, !0), process.env.NODE_ENV !== "production" && xt && (H = 0, G = !1, V = null), (W.innerHTML && se.innerHTML == null || W.textContent && se.textContent == null) && c(U, ""), V ? (X(
      h.dynamicChildren,
      V,
      U,
      N,
      k,
      Qi(E, L),
      P
    ), process.env.NODE_ENV !== "production" && Os(h, E)) : G || T(
      h,
      E,
      U,
      null,
      N,
      k,
      Qi(E, L),
      P,
      !1
    ), H > 0) {
      if (H & 16)
        fe(U, W, se, N, L);
      else if (H & 2 && W.class !== se.class && i(U, "class", null, se.class, L), H & 4 && i(U, "style", W.style, se.style, L), H & 8) {
        const Ee = E.dynamicProps;
        for (let Oe = 0; Oe < Ee.length; Oe++) {
          const Ne = Ee[Oe], et = W[Ne], Ke = se[Ne];
          (Ke !== et || Ne === "value") && i(U, Ne, et, Ke, L, N);
        }
      }
      H & 1 && h.children !== E.children && c(U, E.children);
    } else !G && V == null && fe(U, W, se, N, L);
    ((le = se.onVnodeUpdated) || ie) && tt(() => {
      le && Dt(le, N, E, h), ie && fr(E, h, N, "updated");
    }, k);
  }, X = (h, E, N, k, L, P, G) => {
    for (let U = 0; U < E.length; U++) {
      const H = h[U], V = E[U], ie = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        H.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (H.type === Mt || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !wn(H, V) || // - In the case of a component, it could contain anything.
        H.shapeFlag & 198) ? d(H.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          N
        )
      );
      p(
        H,
        V,
        ie,
        null,
        k,
        L,
        P,
        G,
        !0
      );
    }
  }, fe = (h, E, N, k, L) => {
    if (E !== N) {
      if (E !== Ce)
        for (const P in E)
          !Mn(P) && !(P in N) && i(
            h,
            P,
            E[P],
            null,
            L,
            k
          );
      for (const P in N) {
        if (Mn(P)) continue;
        const G = N[P], U = E[P];
        G !== U && P !== "value" && i(h, P, U, G, L, k);
      }
      "value" in N && i(h, "value", E.value, N.value, L);
    }
  }, ce = (h, E, N, k, L, P, G, U, H) => {
    const V = E.el = h ? h.el : a(""), ie = E.anchor = h ? h.anchor : a("");
    let { patchFlag: W, dynamicChildren: se, slotScopeIds: le } = E;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (xt || W & 2048) && (W = 0, H = !1, se = null), le && (U = U ? U.concat(le) : le), h == null ? (n(V, N, k), n(ie, N, k), Q(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      E.children || [],
      N,
      ie,
      L,
      P,
      G,
      U,
      H
    )) : W > 0 && W & 64 && se && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    h.dynamicChildren ? (X(
      h.dynamicChildren,
      se,
      N,
      L,
      P,
      G,
      U
    ), process.env.NODE_ENV !== "production" ? Os(h, E) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (E.key != null || L && E === L.subTree) && Os(
        h,
        E,
        !0
        /* shallow */
      )
    )) : T(
      h,
      E,
      N,
      ie,
      L,
      P,
      G,
      U,
      H
    );
  }, J = (h, E, N, k, L, P, G, U, H) => {
    E.slotScopeIds = U, h == null ? E.shapeFlag & 512 ? L.ctx.activate(
      E,
      N,
      k,
      G,
      H
    ) : B(
      E,
      N,
      k,
      L,
      P,
      G,
      H
    ) : R(h, E, H);
  }, B = (h, E, N, k, L, P, G) => {
    const U = h.component = Xb(
      h,
      k,
      L
    );
    if (process.env.NODE_ENV !== "production" && U.type.__hmrId && D0(U), process.env.NODE_ENV !== "production" && (bs(h), Pr(U, "mount")), Ka(h) && (U.ctx.renderer = ue), process.env.NODE_ENV !== "production" && Pr(U, "init"), ew(U, !1, G), process.env.NODE_ENV !== "production" && $r(U, "init"), process.env.NODE_ENV !== "production" && xt && (h.el = null), U.asyncDep) {
      if (L && L.registerDep(U, x, G), !h.el) {
        const H = U.subTree = _t(vt);
        b(null, H, E, N);
      }
    } else
      x(
        U,
        h,
        E,
        N,
        L,
        P,
        G
      );
    process.env.NODE_ENV !== "production" && (ws(), $r(U, "mount"));
  }, R = (h, E, N) => {
    const k = E.component = h.component;
    if (Ub(h, E, N))
      if (k.asyncDep && !k.asyncResolved) {
        process.env.NODE_ENV !== "production" && bs(E), M(k, E, N), process.env.NODE_ENV !== "production" && ws();
        return;
      } else
        k.next = E, k.update();
    else
      E.el = h.el, k.vnode = E;
  }, x = (h, E, N, k, L, P, G) => {
    const U = () => {
      if (h.isMounted) {
        let { next: W, bu: se, u: le, parent: Ee, vnode: Oe } = h;
        {
          const At = Yf(h);
          if (At) {
            W && (W.el = Oe.el, M(h, W, G)), At.asyncDep.then(() => {
              h.isUnmounted || U();
            });
            return;
          }
        }
        let Ne = W, et;
        process.env.NODE_ENV !== "production" && bs(W || h.vnode), pr(h, !1), W ? (W.el = Oe.el, M(h, W, G)) : W = Oe, se && En(se), (et = W.props && W.props.onVnodeBeforeUpdate) && Dt(et, Ee, W, Oe), pr(h, !0), process.env.NODE_ENV !== "production" && Pr(h, "render");
        const Ke = Ac(h);
        process.env.NODE_ENV !== "production" && $r(h, "render");
        const Ot = h.subTree;
        h.subTree = Ke, process.env.NODE_ENV !== "production" && Pr(h, "patch"), p(
          Ot,
          Ke,
          // parent may have changed if it's in a teleport
          d(Ot.el),
          // anchor may have changed if it's in a fragment
          ye(Ot),
          h,
          L,
          P
        ), process.env.NODE_ENV !== "production" && $r(h, "patch"), W.el = Ke.el, Ne === null && Hb(h, Ke.el), le && tt(le, L), (et = W.props && W.props.onVnodeUpdated) && tt(
          () => Dt(et, Ee, W, Oe),
          L
        ), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && Of(h), process.env.NODE_ENV !== "production" && ws();
      } else {
        let W;
        const { el: se, props: le } = E, { bm: Ee, m: Oe, parent: Ne, root: et, type: Ke } = h, Ot = xn(E);
        pr(h, !1), Ee && En(Ee), !Ot && (W = le && le.onVnodeBeforeMount) && Dt(W, Ne, E), pr(h, !0);
        {
          et.ce && et.ce._injectChildStyle(Ke), process.env.NODE_ENV !== "production" && Pr(h, "render");
          const At = h.subTree = Ac(h);
          process.env.NODE_ENV !== "production" && $r(h, "render"), process.env.NODE_ENV !== "production" && Pr(h, "patch"), p(
            null,
            At,
            N,
            k,
            h,
            L,
            P
          ), process.env.NODE_ENV !== "production" && $r(h, "patch"), E.el = At.el;
        }
        if (Oe && tt(Oe, L), !Ot && (W = le && le.onVnodeMounted)) {
          const At = E;
          tt(
            () => Dt(W, Ne, At),
            L
          );
        }
        (E.shapeFlag & 256 || Ne && xn(Ne.vnode) && Ne.vnode.shapeFlag & 256) && h.a && tt(h.a, L), h.isMounted = !0, (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && k0(h), E = N = k = null;
      }
    };
    h.scope.on();
    const H = h.effect = new Qd(U);
    h.scope.off();
    const V = h.update = H.run.bind(H), ie = h.job = H.runIfDirty.bind(H);
    ie.i = h, ie.id = h.uid, H.scheduler = () => Ei(ie), pr(h, !0), process.env.NODE_ENV !== "production" && (H.onTrack = h.rtc ? (W) => En(h.rtc, W) : void 0, H.onTrigger = h.rtg ? (W) => En(h.rtg, W) : void 0), V();
  }, M = (h, E, N) => {
    E.component = h;
    const k = h.vnode.props;
    h.vnode = E, h.next = null, yb(h, E.props, k, N), Cb(h, E.children, N), bt(), _c(h), wt();
  }, T = (h, E, N, k, L, P, G, U, H = !1) => {
    const V = h && h.children, ie = h ? h.shapeFlag : 0, W = E.children, { patchFlag: se, shapeFlag: le } = E;
    if (se > 0) {
      if (se & 128) {
        I(
          V,
          W,
          N,
          k,
          L,
          P,
          G,
          U,
          H
        );
        return;
      } else if (se & 256) {
        S(
          V,
          W,
          N,
          k,
          L,
          P,
          G,
          U,
          H
        );
        return;
      }
    }
    le & 8 ? (ie & 16 && ve(V, L, P), W !== V && c(N, W)) : ie & 16 ? le & 16 ? I(
      V,
      W,
      N,
      k,
      L,
      P,
      G,
      U,
      H
    ) : ve(V, L, P, !0) : (ie & 8 && c(N, ""), le & 16 && Q(
      W,
      N,
      k,
      L,
      P,
      G,
      U,
      H
    ));
  }, S = (h, E, N, k, L, P, G, U, H) => {
    h = h || In, E = E || In;
    const V = h.length, ie = E.length, W = Math.min(V, ie);
    let se;
    for (se = 0; se < W; se++) {
      const le = E[se] = H ? Qt(E[se]) : ht(E[se]);
      p(
        h[se],
        le,
        N,
        null,
        L,
        P,
        G,
        U,
        H
      );
    }
    V > ie ? ve(
      h,
      L,
      P,
      !0,
      !1,
      W
    ) : Q(
      E,
      N,
      k,
      L,
      P,
      G,
      U,
      H,
      W
    );
  }, I = (h, E, N, k, L, P, G, U, H) => {
    let V = 0;
    const ie = E.length;
    let W = h.length - 1, se = ie - 1;
    for (; V <= W && V <= se; ) {
      const le = h[V], Ee = E[V] = H ? Qt(E[V]) : ht(E[V]);
      if (wn(le, Ee))
        p(
          le,
          Ee,
          N,
          null,
          L,
          P,
          G,
          U,
          H
        );
      else
        break;
      V++;
    }
    for (; V <= W && V <= se; ) {
      const le = h[W], Ee = E[se] = H ? Qt(E[se]) : ht(E[se]);
      if (wn(le, Ee))
        p(
          le,
          Ee,
          N,
          null,
          L,
          P,
          G,
          U,
          H
        );
      else
        break;
      W--, se--;
    }
    if (V > W) {
      if (V <= se) {
        const le = se + 1, Ee = le < ie ? E[le].el : k;
        for (; V <= se; )
          p(
            null,
            E[V] = H ? Qt(E[V]) : ht(E[V]),
            N,
            Ee,
            L,
            P,
            G,
            U,
            H
          ), V++;
      }
    } else if (V > se)
      for (; V <= W; )
        Y(h[V], L, P, !0), V++;
    else {
      const le = V, Ee = V, Oe = /* @__PURE__ */ new Map();
      for (V = Ee; V <= se; V++) {
        const je = E[V] = H ? Qt(E[V]) : ht(E[V]);
        je.key != null && (process.env.NODE_ENV !== "production" && Oe.has(je.key) && q(
          "Duplicate keys found during update:",
          JSON.stringify(je.key),
          "Make sure keys are unique."
        ), Oe.set(je.key, V));
      }
      let Ne, et = 0;
      const Ke = se - Ee + 1;
      let Ot = !1, At = 0;
      const gn = new Array(Ke);
      for (V = 0; V < Ke; V++) gn[V] = 0;
      for (V = le; V <= W; V++) {
        const je = h[V];
        if (et >= Ke) {
          Y(je, L, P, !0);
          continue;
        }
        let Nt;
        if (je.key != null)
          Nt = Oe.get(je.key);
        else
          for (Ne = Ee; Ne <= se; Ne++)
            if (gn[Ne - Ee] === 0 && wn(je, E[Ne])) {
              Nt = Ne;
              break;
            }
        Nt === void 0 ? Y(je, L, P, !0) : (gn[Nt - Ee] = V + 1, Nt >= At ? At = Nt : Ot = !0, p(
          je,
          E[Nt],
          N,
          null,
          L,
          P,
          G,
          U,
          H
        ), et++);
      }
      const cl = Ot ? Lb(gn) : In;
      for (Ne = cl.length - 1, V = Ke - 1; V >= 0; V--) {
        const je = Ee + V, Nt = E[je], ul = je + 1 < ie ? E[je + 1].el : k;
        gn[V] === 0 ? p(
          null,
          Nt,
          N,
          ul,
          L,
          P,
          G,
          U,
          H
        ) : Ot && (Ne < 0 || V !== cl[Ne] ? K(Nt, N, ul, 2) : Ne--);
      }
    }
  }, K = (h, E, N, k, L = null) => {
    const { el: P, type: G, transition: U, children: H, shapeFlag: V } = h;
    if (V & 6) {
      K(h.component.subTree, E, N, k);
      return;
    }
    if (V & 128) {
      h.suspense.move(E, N, k);
      return;
    }
    if (V & 64) {
      G.move(h, E, N, ue);
      return;
    }
    if (G === Mt) {
      n(P, E, N);
      for (let W = 0; W < H.length; W++)
        K(H[W], E, N, k);
      n(h.anchor, E, N);
      return;
    }
    if (G === As) {
      D(h, E, N);
      return;
    }
    if (k !== 2 && V & 1 && U)
      if (k === 0)
        U.beforeEnter(P), n(P, E, N), tt(() => U.enter(P), L);
      else {
        const { leave: W, delayLeave: se, afterLeave: le } = U, Ee = () => {
          h.ctx.isUnmounted ? s(P) : n(P, E, N);
        }, Oe = () => {
          W(P, () => {
            Ee(), le && le();
          });
        };
        se ? se(P, Ee, Oe) : Oe();
      }
    else
      n(P, E, N);
  }, Y = (h, E, N, k = !1, L = !1) => {
    const {
      type: P,
      props: G,
      ref: U,
      children: H,
      dynamicChildren: V,
      shapeFlag: ie,
      patchFlag: W,
      dirs: se,
      cacheIndex: le
    } = h;
    if (W === -2 && (L = !1), U != null && (bt(), qs(U, null, N, h, !0), wt()), le != null && (E.renderCache[le] = void 0), ie & 256) {
      E.ctx.deactivate(h);
      return;
    }
    const Ee = ie & 1 && se, Oe = !xn(h);
    let Ne;
    if (Oe && (Ne = G && G.onVnodeBeforeUnmount) && Dt(Ne, E, h), ie & 6)
      Se(h.component, N, k);
    else {
      if (ie & 128) {
        h.suspense.unmount(N, k);
        return;
      }
      Ee && fr(h, null, E, "beforeUnmount"), ie & 64 ? h.type.remove(
        h,
        E,
        N,
        ue,
        k
      ) : V && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !V.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (P !== Mt || W > 0 && W & 64) ? ve(
        V,
        E,
        N,
        !1,
        !0
      ) : (P === Mt && W & 384 || !L && ie & 16) && ve(H, E, N), k && te(h);
    }
    (Oe && (Ne = G && G.onVnodeUnmounted) || Ee) && tt(() => {
      Ne && Dt(Ne, E, h), Ee && fr(h, null, E, "unmounted");
    }, N);
  }, te = (h) => {
    const { type: E, el: N, anchor: k, transition: L } = h;
    if (E === Mt) {
      process.env.NODE_ENV !== "production" && h.patchFlag > 0 && h.patchFlag & 2048 && L && !L.persisted ? h.children.forEach((G) => {
        G.type === vt ? s(G.el) : te(G);
      }) : pe(N, k);
      return;
    }
    if (E === As) {
      w(h);
      return;
    }
    const P = () => {
      s(N), L && !L.persisted && L.afterLeave && L.afterLeave();
    };
    if (h.shapeFlag & 1 && L && !L.persisted) {
      const { leave: G, delayLeave: U } = L, H = () => G(N, P);
      U ? U(h.el, P, H) : H();
    } else
      P();
  }, pe = (h, E) => {
    let N;
    for (; h !== E; )
      N = f(h), s(h), h = N;
    s(E);
  }, Se = (h, E, N) => {
    process.env.NODE_ENV !== "production" && h.type.__hmrId && I0(h);
    const {
      bum: k,
      scope: L,
      job: P,
      subTree: G,
      um: U,
      m: H,
      a: V,
      parent: ie,
      slots: { __: W }
    } = h;
    Oc(H), Oc(V), k && En(k), ie && ae(W) && W.forEach((se) => {
      ie.renderCache[se] = void 0;
    }), L.stop(), P && (P.flags |= 8, Y(G, h, E, N)), U && tt(U, E), tt(() => {
      h.isUnmounted = !0;
    }, E), E && E.pendingBranch && !E.isUnmounted && h.asyncDep && !h.asyncResolved && h.suspenseId === E.pendingId && (E.deps--, E.deps === 0 && E.resolve()), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && $0(h);
  }, ve = (h, E, N, k = !1, L = !1, P = 0) => {
    for (let G = P; G < h.length; G++)
      Y(h[G], E, N, k, L);
  }, ye = (h) => {
    if (h.shapeFlag & 6)
      return ye(h.component.subTree);
    if (h.shapeFlag & 128)
      return h.suspense.next();
    const E = f(h.anchor || h.el), N = E && E[H0];
    return N ? f(N) : E;
  };
  let ne = !1;
  const re = (h, E, N) => {
    h == null ? E._vnode && Y(E._vnode, null, null, !0) : p(
      E._vnode || null,
      h,
      E,
      null,
      null,
      null,
      N
    ), E._vnode = h, ne || (ne = !0, _c(), wf(), ne = !1);
  }, ue = {
    p,
    um: Y,
    m: K,
    r: te,
    mt: B,
    mc: Q,
    pc: T,
    pbc: X,
    n: ye,
    o: e
  };
  return {
    render: re,
    hydrate: void 0,
    createApp: hb(re)
  };
}
function Qi({ type: e, props: t }, r) {
  return r === "svg" && e === "foreignObject" || r === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : r;
}
function pr({ effect: e, job: t }, r) {
  r ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function Rb(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function Os(e, t, r = !1) {
  const n = e.children, s = t.children;
  if (ae(n) && ae(s))
    for (let i = 0; i < n.length; i++) {
      const o = n[i];
      let a = s[i];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = s[i] = Qt(s[i]), a.el = o.el), !r && a.patchFlag !== -2 && Os(o, a)), a.type === Jn && (a.el = o.el), a.type === vt && !a.el && (a.el = o.el), process.env.NODE_ENV !== "production" && a.el && (a.el.__vnode = a);
    }
}
function Lb(e) {
  const t = e.slice(), r = [0];
  let n, s, i, o, a;
  const l = e.length;
  for (n = 0; n < l; n++) {
    const u = e[n];
    if (u !== 0) {
      if (s = r[r.length - 1], e[s] < u) {
        t[n] = s, r.push(n);
        continue;
      }
      for (i = 0, o = r.length - 1; i < o; )
        a = i + o >> 1, e[r[a]] < u ? i = a + 1 : o = a;
      u < e[r[i]] && (i > 0 && (t[n] = r[i - 1]), r[i] = n);
    }
  }
  for (i = r.length, o = r[i - 1]; i-- > 0; )
    r[i] = o, o = t[o];
  return r;
}
function Yf(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : Yf(t);
}
function Oc(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const xb = Symbol.for("v-scx"), kb = () => {
  {
    const e = Ss(xb);
    return e || process.env.NODE_ENV !== "production" && q(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function Zi(e, t, r) {
  return process.env.NODE_ENV !== "production" && !de(t) && q(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), Gf(e, t, r);
}
function Gf(e, t, r = Ce) {
  const { immediate: n, deep: s, flush: i, once: o } = r;
  process.env.NODE_ENV !== "production" && !t && (n !== void 0 && q(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), s !== void 0 && q(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), o !== void 0 && q(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const a = Ve({}, r);
  process.env.NODE_ENV !== "production" && (a.onWarn = q);
  const l = t && n || !t && i !== "post";
  let u;
  if (Vn) {
    if (i === "sync") {
      const g = kb();
      u = g.__watcherHandles || (g.__watcherHandles = []);
    } else if (!l) {
      const g = () => {
      };
      return g.stop = xe, g.resume = xe, g.pause = xe, g;
    }
  }
  const c = Be;
  a.call = (g, _, p) => Ut(g, c, _, p);
  let d = !1;
  i === "post" ? a.scheduler = (g) => {
    tt(g, c && c.suspense);
  } : i !== "sync" && (d = !0, a.scheduler = (g, _) => {
    _ ? g() : Ei(g);
  }), a.augmentJob = (g) => {
    t && (g.flags |= 4), d && (g.flags |= 2, c && (g.id = c.uid, g.i = c));
  };
  const f = v0(e, t, a);
  return Vn && (u ? u.push(f) : l && f()), f;
}
function Pb(e, t, r) {
  const n = this.proxy, s = Pe(e) ? e.includes(".") ? Wf(n, e) : () => n[e] : e.bind(n, n);
  let i;
  de(t) ? i = t : (i = t.handler, r = t);
  const o = Xn(this), a = Gf(s, i.bind(n), r);
  return o(), a;
}
function Wf(e, t) {
  const r = t.split(".");
  return () => {
    let n = e;
    for (let s = 0; s < r.length && n; s++)
      n = n[r[s]];
    return n;
  };
}
const $b = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${yt(t)}Modifiers`] || e[`${or(t)}Modifiers`];
function Fb(e, t, ...r) {
  if (e.isUnmounted) return;
  const n = e.vnode.props || Ce;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: c,
      propsOptions: [d]
    } = e;
    if (c)
      if (!(t in c))
        (!d || !(hr(yt(t)) in d)) && q(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${hr(yt(t))}" prop.`
        );
      else {
        const f = c[t];
        de(f) && (f(...r) || q(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let s = r;
  const i = t.startsWith("update:"), o = i && $b(n, t.slice(7));
  if (o && (o.trim && (s = r.map((c) => Pe(c) ? c.trim() : c)), o.number && (s = r.map(Bv))), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && B0(e, t, s), process.env.NODE_ENV !== "production") {
    const c = t.toLowerCase();
    c !== t && n[hr(c)] && q(
      `Event "${c}" is emitted in component ${wi(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${or(
        t
      )}" instead of "${t}".`
    );
  }
  let a, l = n[a = hr(t)] || // also try camelCase event handler (#2249)
  n[a = hr(yt(t))];
  !l && i && (l = n[a = hr(or(t))]), l && Ut(
    l,
    e,
    6,
    s
  );
  const u = n[a + "Once"];
  if (u) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[a])
      return;
    e.emitted[a] = !0, Ut(
      u,
      e,
      6,
      s
    );
  }
}
function qf(e, t, r = !1) {
  const n = t.emitsCache, s = n.get(e);
  if (s !== void 0)
    return s;
  const i = e.emits;
  let o = {}, a = !1;
  if (__VUE_OPTIONS_API__ && !de(e)) {
    const l = (u) => {
      const c = qf(u, t, !0);
      c && (a = !0, Ve(o, c));
    };
    !r && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !i && !a ? (De(e) && n.set(e, null), null) : (ae(i) ? i.forEach((l) => o[l] = null) : Ve(o, i), De(e) && n.set(e, o), o);
}
function bi(e, t) {
  return !e || !qn(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), we(e, t[0].toLowerCase() + t.slice(1)) || we(e, or(t)) || we(e, t));
}
let Qo = !1;
function Js() {
  Qo = !0;
}
function Ac(e) {
  const {
    type: t,
    vnode: r,
    proxy: n,
    withProxy: s,
    propsOptions: [i],
    slots: o,
    attrs: a,
    emit: l,
    render: u,
    renderCache: c,
    props: d,
    data: f,
    setupState: g,
    ctx: _,
    inheritAttrs: p
  } = e, y = Ws(e);
  let b, A;
  process.env.NODE_ENV !== "production" && (Qo = !1);
  try {
    if (r.shapeFlag & 4) {
      const w = s || n, j = process.env.NODE_ENV !== "production" && g.__isScriptSetup ? new Proxy(w, {
        get(z, Z, Q) {
          return q(
            `Property '${String(
              Z
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(z, Z, Q);
        }
      }) : w;
      b = ht(
        u.call(
          j,
          w,
          c,
          process.env.NODE_ENV !== "production" ? Lt(d) : d,
          g,
          f,
          _
        )
      ), A = a;
    } else {
      const w = t;
      process.env.NODE_ENV !== "production" && a === d && Js(), b = ht(
        w.length > 1 ? w(
          process.env.NODE_ENV !== "production" ? Lt(d) : d,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return Js(), Lt(a);
            },
            slots: o,
            emit: l
          } : { attrs: a, slots: o, emit: l }
        ) : w(
          process.env.NODE_ENV !== "production" ? Lt(d) : d,
          null
        )
      ), A = t.props ? a : Vb(a);
    }
  } catch (w) {
    Kn(w, e, 1), b = _t(vt);
  }
  let v = b, D;
  if (process.env.NODE_ENV !== "production" && b.patchFlag > 0 && b.patchFlag & 2048 && ([v, D] = Kf(b)), A && p !== !1) {
    const w = Object.keys(A), { shapeFlag: j } = v;
    if (w.length) {
      if (j & 7)
        i && w.some(Bs) && (A = Bb(
          A,
          i
        )), v = lr(v, A, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !Qo && v.type !== vt) {
        const z = Object.keys(a), Z = [], Q = [];
        for (let ee = 0, X = z.length; ee < X; ee++) {
          const fe = z[ee];
          qn(fe) ? Bs(fe) || Z.push(fe[2].toLowerCase() + fe.slice(3)) : Q.push(fe);
        }
        Q.length && q(
          `Extraneous non-props attributes (${Q.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
        ), Z.length && q(
          `Extraneous non-emits event listeners (${Z.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return r.dirs && (process.env.NODE_ENV !== "production" && !Nc(v) && q(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), v = lr(v, null, !1, !0), v.dirs = v.dirs ? v.dirs.concat(r.dirs) : r.dirs), r.transition && (process.env.NODE_ENV !== "production" && !Nc(v) && q(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), qa(v, r.transition)), process.env.NODE_ENV !== "production" && D ? D(v) : b = v, Ws(y), b;
}
const Kf = (e) => {
  const t = e.children, r = e.dynamicChildren, n = Qa(t, !1);
  if (n) {
    if (process.env.NODE_ENV !== "production" && n.patchFlag > 0 && n.patchFlag & 2048)
      return Kf(n);
  } else return [e, void 0];
  const s = t.indexOf(n), i = r ? r.indexOf(n) : -1, o = (a) => {
    t[s] = a, r && (i > -1 ? r[i] = a : a.patchFlag > 0 && (e.dynamicChildren = [...r, a]));
  };
  return [ht(n), o];
};
function Qa(e, t = !0) {
  let r;
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    if (tn(s)) {
      if (s.type !== vt || s.children === "v-if") {
        if (r)
          return;
        if (r = s, process.env.NODE_ENV !== "production" && t && r.patchFlag > 0 && r.patchFlag & 2048)
          return Qa(r.children);
      }
    } else
      return;
  }
  return r;
}
const Vb = (e) => {
  let t;
  for (const r in e)
    (r === "class" || r === "style" || qn(r)) && ((t || (t = {}))[r] = e[r]);
  return t;
}, Bb = (e, t) => {
  const r = {};
  for (const n in e)
    (!Bs(n) || !(n.slice(9) in t)) && (r[n] = e[n]);
  return r;
}, Nc = (e) => e.shapeFlag & 7 || e.type === vt;
function Ub(e, t, r) {
  const { props: n, children: s, component: i } = e, { props: o, children: a, patchFlag: l } = t, u = i.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (s || a) && xt || t.dirs || t.transition)
    return !0;
  if (r && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return n ? Cc(n, o, u) : !!o;
    if (l & 8) {
      const c = t.dynamicProps;
      for (let d = 0; d < c.length; d++) {
        const f = c[d];
        if (o[f] !== n[f] && !bi(u, f))
          return !0;
      }
    }
  } else
    return (s || a) && (!a || !a.$stable) ? !0 : n === o ? !1 : n ? o ? Cc(n, o, u) : !0 : !!o;
  return !1;
}
function Cc(e, t, r) {
  const n = Object.keys(t);
  if (n.length !== Object.keys(e).length)
    return !0;
  for (let s = 0; s < n.length; s++) {
    const i = n[s];
    if (t[i] !== e[i] && !bi(r, i))
      return !0;
  }
  return !1;
}
function Hb({ vnode: e, parent: t }, r) {
  for (; t; ) {
    const n = t.subTree;
    if (n.suspense && n.suspense.activeBranch === e && (n.el = e.el), n === e)
      (e = t.vnode).el = r, t = t.parent;
    else
      break;
  }
}
const zf = (e) => e.__isSuspense;
function jb(e, t) {
  t && t.pendingBranch ? ae(e) ? t.effects.push(...e) : t.effects.push(e) : bf(e);
}
const Mt = Symbol.for("v-fgt"), Jn = Symbol.for("v-txt"), vt = Symbol.for("v-cmt"), As = Symbol.for("v-stc");
let tr = null, Za = 1;
function Dc(e, t = !1) {
  Za += e, e < 0 && tr && t && (tr.hasOnce = !0);
}
function tn(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function wn(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const r = Ts.get(t.type);
    if (r && r.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
const Yb = (...e) => Xf(
  ...e
), Jf = ({ key: e }) => e ?? null, Ns = ({
  ref: e,
  ref_key: t,
  ref_for: r
}) => (typeof e == "number" && (e = "" + e), e != null ? Pe(e) || Fe(e) || de(e) ? { i: Xe, r: e, k: t, f: !!r } : e : null);
function Gb(e, t = null, r = null, n = 0, s = null, i = e === Mt ? 0 : 1, o = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && Jf(t),
    ref: t && Ns(t),
    scopeId: Nf,
    slotScopeIds: null,
    children: r,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: n,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: Xe
  };
  return a ? (el(l, r), i & 128 && e.normalize(l)) : r && (l.shapeFlag |= Pe(r) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && q("VNode created with invalid key (NaN). VNode type:", l.type), Za > 0 && // avoid a block node from tracking itself
  !o && // has current parent block
  tr && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || i & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && tr.push(l), l;
}
const _t = process.env.NODE_ENV !== "production" ? Yb : Xf;
function Xf(e, t = null, r = null, n = 0, s = null, i = !1) {
  if ((!e || e === nb) && (process.env.NODE_ENV !== "production" && !e && q(`Invalid vnode type when creating vnode: ${e}.`), e = vt), tn(e)) {
    const a = lr(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return r && el(a, r), Za > 0 && !i && tr && (a.shapeFlag & 6 ? tr[tr.indexOf(e)] = a : tr.push(a)), a.patchFlag = -2, a;
  }
  if (rp(e) && (e = e.__vccOpts), t) {
    t = Wb(t);
    let { class: a, style: l } = t;
    a && !Pe(a) && (t.class = $a(a)), De(l) && (Hs(l) && !ae(l) && (l = Ve({}, l)), t.style = Pa(l));
  }
  const o = Pe(e) ? 1 : zf(e) ? 128 : j0(e) ? 64 : De(e) ? 4 : de(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && o & 4 && Hs(e) && (e = me(e), q(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), Gb(
    e,
    t,
    r,
    n,
    s,
    o,
    i,
    !0
  );
}
function Wb(e) {
  return e ? Hs(e) || Ff(e) ? Ve({}, e) : e : null;
}
function lr(e, t, r = !1, n = !1) {
  const { props: s, ref: i, patchFlag: o, children: a, transition: l } = e, u = t ? Kb(s || {}, t) : s, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: u,
    key: u && Jf(u),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      r && i ? ae(i) ? i.concat(Ns(t)) : [i, Ns(t)] : Ns(t)
    ) : i,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && o === -1 && ae(a) ? a.map(Qf) : a,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== Mt ? o === -1 ? 16 : o | 16 : o,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && lr(e.ssContent),
    ssFallback: e.ssFallback && lr(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return l && n && qa(
    c,
    l.clone(c)
  ), c;
}
function Qf(e) {
  const t = lr(e);
  return ae(e.children) && (t.children = e.children.map(Qf)), t;
}
function qb(e = " ", t = 0) {
  return _t(Jn, null, e, t);
}
function ht(e) {
  return e == null || typeof e == "boolean" ? _t(vt) : ae(e) ? _t(
    Mt,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : tn(e) ? Qt(e) : _t(Jn, null, String(e));
}
function Qt(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : lr(e);
}
function el(e, t) {
  let r = 0;
  const { shapeFlag: n } = e;
  if (t == null)
    t = null;
  else if (ae(t))
    r = 16;
  else if (typeof t == "object")
    if (n & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), el(e, s()), s._c && (s._d = !0));
      return;
    } else {
      r = 32;
      const s = t._;
      !s && !Ff(t) ? t._ctx = Xe : s === 3 && Xe && (Xe.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else de(t) ? (t = { default: t, _ctx: Xe }, r = 32) : (t = String(t), n & 64 ? (r = 16, t = [qb(t)]) : r = 8);
  e.children = t, e.shapeFlag |= r;
}
function Kb(...e) {
  const t = {};
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    for (const s in n)
      if (s === "class")
        t.class !== n.class && (t.class = $a([t.class, n.class]));
      else if (s === "style")
        t.style = Pa([t.style, n.style]);
      else if (qn(s)) {
        const i = t[s], o = n[s];
        o && i !== o && !(ae(i) && i.includes(o)) && (t[s] = i ? [].concat(i, o) : o);
      } else s !== "" && (t[s] = n[s]);
  }
  return t;
}
function Dt(e, t, r, n = null) {
  Ut(e, t, 7, [
    r,
    n
  ]);
}
const zb = kf();
let Jb = 0;
function Xb(e, t, r) {
  const n = e.type, s = (t ? t.appContext : e.appContext) || zb, i = {
    uid: Jb++,
    vnode: e,
    type: n,
    parent: t,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new qv(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(s.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Bf(n, s),
    emitsOptions: qf(n, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: Ce,
    // inheritAttrs
    inheritAttrs: n.inheritAttrs,
    // state
    ctx: Ce,
    data: Ce,
    props: Ce,
    attrs: Ce,
    slots: Ce,
    refs: Ce,
    setupState: Ce,
    setupContext: null,
    // suspense related
    suspense: r,
    suspenseId: r ? r.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? i.ctx = sb(i) : i.ctx = { _: i }, i.root = t ? t.root : i, i.emit = Fb.bind(null, i), e.ce && e.ce(i), i;
}
let Be = null;
const Qb = () => Be || Xe;
let Xs, Zo;
{
  const e = rr(), t = (r, n) => {
    let s;
    return (s = e[r]) || (s = e[r] = []), s.push(n), (i) => {
      s.length > 1 ? s.forEach((o) => o(i)) : s[0](i);
    };
  };
  Xs = t(
    "__VUE_INSTANCE_SETTERS__",
    (r) => Be = r
  ), Zo = t(
    "__VUE_SSR_SETTERS__",
    (r) => Vn = r
  );
}
const Xn = (e) => {
  const t = Be;
  return Xs(e), e.scope.on(), () => {
    e.scope.off(), Xs(t);
  };
}, Ic = () => {
  Be && Be.scope.off(), Xs(null);
}, Zb = /* @__PURE__ */ cn("slot,component");
function ea(e, { isNativeTag: t }) {
  (Zb(e) || t(e)) && q(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function Zf(e) {
  return e.vnode.shapeFlag & 4;
}
let Vn = !1;
function ew(e, t = !1, r = !1) {
  t && Zo(t);
  const { props: n, children: s } = e.vnode, i = Zf(e);
  _b(e, n, i, t), Nb(e, s, r || t);
  const o = i ? tw(e, t) : void 0;
  return t && Zo(!1), o;
}
function tw(e, t) {
  var r;
  const n = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (n.name && ea(n.name, e.appContext.config), n.components) {
      const i = Object.keys(n.components);
      for (let o = 0; o < i.length; o++)
        ea(i[o], e.appContext.config);
    }
    if (n.directives) {
      const i = Object.keys(n.directives);
      for (let o = 0; o < i.length; o++)
        Cf(i[o]);
    }
    n.compilerOptions && rw() && q(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, Rf), process.env.NODE_ENV !== "production" && ib(e);
  const { setup: s } = n;
  if (s) {
    bt();
    const i = e.setupContext = s.length > 1 ? sw(e) : null, o = Xn(e), a = dn(
      s,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? Lt(e.props) : e.props,
        i
      ]
    ), l = La(a);
    if (wt(), o(), (l || e.sp) && !xn(e) && Df(e), l) {
      if (a.then(Ic, Ic), t)
        return a.then((u) => {
          Mc(e, u, t);
        }).catch((u) => {
          Kn(u, e, 0);
        });
      if (e.asyncDep = a, process.env.NODE_ENV !== "production" && !e.suspense) {
        const u = (r = n.name) != null ? r : "Anonymous";
        q(
          `Component <${u}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      Mc(e, a, t);
  } else
    ep(e, t);
}
function Mc(e, t, r) {
  de(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : De(t) ? (process.env.NODE_ENV !== "production" && tn(t) && q(
    "setup() should not return VNodes directly - return a render function instead."
  ), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (e.devtoolsRawSetupState = t), e.setupState = mf(t), process.env.NODE_ENV !== "production" && ob(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && q(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), ep(e, r);
}
const rw = () => !0;
function ep(e, t, r) {
  const n = e.type;
  if (e.render || (e.render = n.render || xe), __VUE_OPTIONS_API__) {
    const s = Xn(e);
    bt();
    try {
      lb(e);
    } finally {
      wt(), s();
    }
  }
  process.env.NODE_ENV !== "production" && !n.render && e.render === xe && !t && (n.template ? q(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : q("Component is missing template or render function: ", n));
}
const Rc = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return Js(), $e(e, "get", ""), e[t];
  },
  set() {
    return q("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return q("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return $e(e, "get", ""), e[t];
  }
};
function nw(e) {
  return new Proxy(e.slots, {
    get(t, r) {
      return $e(e, "get", "$slots"), t[r];
    }
  });
}
function sw(e) {
  const t = (r) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && q("expose() should be called only once per setup()."), r != null)) {
      let n = typeof r;
      n === "object" && (ae(r) ? n = "array" : Fe(r) && (n = "ref")), n !== "object" && q(
        `expose() should be passed a plain object, received ${n}.`
      );
    }
    e.exposed = r || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let r, n;
    return Object.freeze({
      get attrs() {
        return r || (r = new Proxy(e.attrs, Rc));
      },
      get slots() {
        return n || (n = nw(e));
      },
      get emit() {
        return (s, ...i) => e.emit(s, ...i);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, Rc),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function tl(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(mf(h0(e.exposed)), {
    get(t, r) {
      if (r in t)
        return t[r];
      if (r in Sr)
        return Sr[r](e);
    },
    has(t, r) {
      return r in t || r in Sr;
    }
  })) : e.proxy;
}
const iw = /(?:^|[-_])(\w)/g, ow = (e) => e.replace(iw, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function tp(e, t = !0) {
  return de(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function wi(e, t, r = !1) {
  let n = tp(t);
  if (!n && t.__file) {
    const s = t.__file.match(/([^/\\]+)\.\w+$/);
    s && (n = s[1]);
  }
  if (!n && e && e.parent) {
    const s = (i) => {
      for (const o in i)
        if (i[o] === t)
          return o;
    };
    n = s(
      e.components || e.parent.type.components
    ) || s(e.appContext.components);
  }
  return n ? ow(n) : r ? "App" : "Anonymous";
}
function rp(e) {
  return de(e) && "__vccOpts" in e;
}
const np = (e, t) => {
  const r = y0(e, t, Vn);
  if (process.env.NODE_ENV !== "production") {
    const n = Qb();
    n && n.appContext.config.warnRecursiveComputed && (r._warnRecursive = !0);
  }
  return r;
};
function aw(e, t, r) {
  const n = arguments.length;
  return n === 2 ? De(t) && !ae(t) ? tn(t) ? _t(e, null, [t]) : _t(e, t) : _t(e, null, t) : (n > 3 ? r = Array.prototype.slice.call(arguments, 2) : n === 3 && tn(r) && (r = [r]), _t(e, t, r));
}
function lw() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, r = { style: "color:#f5222d" }, n = { style: "color:#eb2f96" }, s = {
    __vue_custom_formatter: !0,
    header(d) {
      if (!De(d))
        return null;
      if (d.__isVue)
        return ["div", e, "VueInstance"];
      if (Fe(d)) {
        bt();
        const f = d.value;
        return wt(), [
          "div",
          {},
          ["span", e, c(d)],
          "<",
          a(f),
          ">"
        ];
      } else {
        if (Yr(d))
          return [
            "div",
            {},
            ["span", e, nt(d) ? "ShallowReactive" : "Reactive"],
            "<",
            a(d),
            `>${ar(d) ? " (readonly)" : ""}`
          ];
        if (ar(d))
          return [
            "div",
            {},
            ["span", e, nt(d) ? "ShallowReadonly" : "Readonly"],
            "<",
            a(d),
            ">"
          ];
      }
      return null;
    },
    hasBody(d) {
      return d && d.__isVue;
    },
    body(d) {
      if (d && d.__isVue)
        return [
          "div",
          {},
          ...i(d.$)
        ];
    }
  };
  function i(d) {
    const f = [];
    d.type.props && d.props && f.push(o("props", me(d.props))), d.setupState !== Ce && f.push(o("setup", d.setupState)), d.data !== Ce && f.push(o("data", me(d.data)));
    const g = l(d, "computed");
    g && f.push(o("computed", g));
    const _ = l(d, "inject");
    return _ && f.push(o("injected", _)), f.push([
      "div",
      {},
      [
        "span",
        {
          style: n.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: d }]
    ]), f;
  }
  function o(d, f) {
    return f = Ve({}, f), Object.keys(f).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        d
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(f).map((g) => [
          "div",
          {},
          ["span", n, g + ": "],
          a(f[g], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function a(d, f = !0) {
    return typeof d == "number" ? ["span", t, d] : typeof d == "string" ? ["span", r, JSON.stringify(d)] : typeof d == "boolean" ? ["span", n, d] : De(d) ? ["object", { object: f ? me(d) : d }] : ["span", r, String(d)];
  }
  function l(d, f) {
    const g = d.type;
    if (de(g))
      return;
    const _ = {};
    for (const p in d.ctx)
      u(g, p, f) && (_[p] = d.ctx[p]);
    return _;
  }
  function u(d, f, g) {
    const _ = d[g];
    if (ae(_) && _.includes(f) || De(_) && f in _ || d.extends && u(d.extends, f, g) || d.mixins && d.mixins.some((p) => u(p, f, g)))
      return !0;
  }
  function c(d) {
    return nt(d) ? "ShallowRef" : d.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(s) : window.devtoolsFormatters = [s];
}
const Lc = "3.5.16", Ti = process.env.NODE_ENV !== "production" ? q : xe;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* @vue/runtime-dom v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let ta;
const xc = typeof window < "u" && window.trustedTypes;
if (xc)
  try {
    ta = /* @__PURE__ */ xc.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
    process.env.NODE_ENV !== "production" && Ti(`Error creating trusted types policy: ${e}`);
  }
const sp = ta ? (e) => ta.createHTML(e) : (e) => e, cw = "http://www.w3.org/2000/svg", uw = "http://www.w3.org/1998/Math/MathML", Yt = typeof document < "u" ? document : null, kc = Yt && /* @__PURE__ */ Yt.createElement("template"), dw = {
  insert: (e, t, r) => {
    t.insertBefore(e, r || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, r, n) => {
    const s = t === "svg" ? Yt.createElementNS(cw, e) : t === "mathml" ? Yt.createElementNS(uw, e) : r ? Yt.createElement(e, { is: r }) : Yt.createElement(e);
    return e === "select" && n && n.multiple != null && s.setAttribute("multiple", n.multiple), s;
  },
  createText: (e) => Yt.createTextNode(e),
  createComment: (e) => Yt.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => Yt.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, r, n, s, i) {
    const o = r ? r.previousSibling : t.lastChild;
    if (s && (s === i || s.nextSibling))
      for (; t.insertBefore(s.cloneNode(!0), r), !(s === i || !(s = s.nextSibling)); )
        ;
    else {
      kc.innerHTML = sp(
        n === "svg" ? `<svg>${e}</svg>` : n === "mathml" ? `<math>${e}</math>` : e
      );
      const a = kc.content;
      if (n === "svg" || n === "mathml") {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      t.insertBefore(a, r);
    }
    return [
      // first
      o ? o.nextSibling : t.firstChild,
      // last
      r ? r.previousSibling : t.lastChild
    ];
  }
}, fw = Symbol("_vtc");
function pw(e, t, r) {
  const n = e[fw];
  n && (t = (t ? [t, ...n] : [...n]).join(" ")), t == null ? e.removeAttribute("class") : r ? e.setAttribute("class", t) : e.className = t;
}
const Pc = Symbol("_vod"), hw = Symbol("_vsh");
process.env.NODE_ENV;
const gw = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : ""), _w = /(^|;)\s*display\s*:/;
function mw(e, t, r) {
  const n = e.style, s = Pe(r);
  let i = !1;
  if (r && !s) {
    if (t)
      if (Pe(t))
        for (const o of t.split(";")) {
          const a = o.slice(0, o.indexOf(":")).trim();
          r[a] == null && Cs(n, a, "");
        }
      else
        for (const o in t)
          r[o] == null && Cs(n, o, "");
    for (const o in r)
      o === "display" && (i = !0), Cs(n, o, r[o]);
  } else if (s) {
    if (t !== r) {
      const o = n[gw];
      o && (r += ";" + o), n.cssText = r, i = _w.test(r);
    }
  } else t && e.removeAttribute("style");
  Pc in e && (e[Pc] = i ? n.display : "", e[hw] && (n.display = "none"));
}
const yw = /[^\\];\s*$/, $c = /\s*!important$/;
function Cs(e, t, r) {
  if (ae(r))
    r.forEach((n) => Cs(e, t, n));
  else if (r == null && (r = ""), process.env.NODE_ENV !== "production" && yw.test(r) && Ti(
    `Unexpected semicolon at the end of '${t}' style value: '${r}'`
  ), t.startsWith("--"))
    e.setProperty(t, r);
  else {
    const n = Ew(e, t);
    $c.test(r) ? e.setProperty(
      or(n),
      r.replace($c, ""),
      "important"
    ) : e[n] = r;
  }
}
const Fc = ["Webkit", "Moz", "ms"], eo = {};
function Ew(e, t) {
  const r = eo[t];
  if (r)
    return r;
  let n = yt(t);
  if (n !== "filter" && n in e)
    return eo[t] = n;
  n = _i(n);
  for (let s = 0; s < Fc.length; s++) {
    const i = Fc[s] + n;
    if (i in e)
      return eo[t] = i;
  }
  return t;
}
const Vc = "http://www.w3.org/1999/xlink";
function Bc(e, t, r, n, s, i = Wv(t)) {
  n && t.startsWith("xlink:") ? r == null ? e.removeAttributeNS(Vc, t.slice(6, t.length)) : e.setAttributeNS(Vc, t, r) : r == null || i && !Xd(r) ? e.removeAttribute(t) : e.setAttribute(
    t,
    i ? "" : un(r) ? String(r) : r
  );
}
function Uc(e, t, r, n, s) {
  if (t === "innerHTML" || t === "textContent") {
    r != null && (e[t] = t === "innerHTML" ? sp(r) : r);
    return;
  }
  const i = e.tagName;
  if (t === "value" && i !== "PROGRESS" && // custom elements may use _value internally
  !i.includes("-")) {
    const a = i === "OPTION" ? e.getAttribute("value") || "" : e.value, l = r == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(r);
    (a !== l || !("_value" in e)) && (e.value = l), r == null && e.removeAttribute(t), e._value = r;
    return;
  }
  let o = !1;
  if (r === "" || r == null) {
    const a = typeof e[t];
    a === "boolean" ? r = Xd(r) : r == null && a === "string" ? (r = "", o = !0) : a === "number" && (r = 0, o = !0);
  }
  try {
    e[t] = r;
  } catch (a) {
    process.env.NODE_ENV !== "production" && !o && Ti(
      `Failed setting prop "${t}" on <${i.toLowerCase()}>: value ${r} is invalid.`,
      a
    );
  }
  o && e.removeAttribute(s || t);
}
function vw(e, t, r, n) {
  e.addEventListener(t, r, n);
}
function bw(e, t, r, n) {
  e.removeEventListener(t, r, n);
}
const Hc = Symbol("_vei");
function ww(e, t, r, n, s = null) {
  const i = e[Hc] || (e[Hc] = {}), o = i[t];
  if (n && o)
    o.value = process.env.NODE_ENV !== "production" ? Yc(n, t) : n;
  else {
    const [a, l] = Tw(t);
    if (n) {
      const u = i[t] = Aw(
        process.env.NODE_ENV !== "production" ? Yc(n, t) : n,
        s
      );
      vw(e, a, u, l);
    } else o && (bw(e, a, o, l), i[t] = void 0);
  }
}
const jc = /(?:Once|Passive|Capture)$/;
function Tw(e) {
  let t;
  if (jc.test(e)) {
    t = {};
    let n;
    for (; n = e.match(jc); )
      e = e.slice(0, e.length - n[0].length), t[n[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : or(e.slice(2)), t];
}
let to = 0;
const Sw = /* @__PURE__ */ Promise.resolve(), Ow = () => to || (Sw.then(() => to = 0), to = Date.now());
function Aw(e, t) {
  const r = (n) => {
    if (!n._vts)
      n._vts = Date.now();
    else if (n._vts <= r.attached)
      return;
    Ut(
      Nw(n, r.value),
      t,
      5,
      [n]
    );
  };
  return r.value = e, r.attached = Ow(), r;
}
function Yc(e, t) {
  return de(e) || ae(e) ? e : (Ti(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), xe);
}
function Nw(e, t) {
  if (ae(t)) {
    const r = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      r.call(e), e._stopped = !0;
    }, t.map(
      (n) => (s) => !s._stopped && n && n(s)
    );
  } else
    return t;
}
const Gc = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Cw = (e, t, r, n, s, i) => {
  const o = s === "svg";
  t === "class" ? pw(e, n, o) : t === "style" ? mw(e, r, n) : qn(t) ? Bs(t) || ww(e, t, r, n, i) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Dw(e, t, n, o)) ? (Uc(e, t, n), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && Bc(e, t, n, o, i, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !Pe(n)) ? Uc(e, yt(t), n, i, t) : (t === "true-value" ? e._trueValue = n : t === "false-value" && (e._falseValue = n), Bc(e, t, n, o));
};
function Dw(e, t, r, n) {
  if (n)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Gc(t) && de(r));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "autocorrect" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const s = e.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return Gc(t) && Pe(r) ? !1 : t in e;
}
const Iw = /* @__PURE__ */ Ve({ patchProp: Cw }, dw);
let Wc;
function Mw() {
  return Wc || (Wc = Ib(Iw));
}
const Rw = (...e) => {
  Mw().render(...e);
};
/**
* vue v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Lw() {
  lw();
}
process.env.NODE_ENV !== "production" && Lw();
let ra = null, na = null;
function MO(e) {
  return new Promise((t) => {
    ra = e, kw(), t();
  });
}
function xw() {
  return ra || {};
}
function RO(e) {
  na = e;
}
const Ue = (...e) => typeof na == "function" ? na(...e) : (console.warn("translatedData function not set!"), e[1]);
let O = {}, at = [], fn = !1;
const kw = () => {
  var e, t;
  (!O || !Object.keys(O).length) && (O = xw()), at = ((e = O.getters) == null ? void 0 : e.eventManage) || [], fn = ((t = O.getters) == null ? void 0 : t.isAuthenticated) || !1;
}, ge = () => ({
  status: O.getters.isAuthenticated,
  user: O.getters.stateUser
});
let qc = null, Kc = null, zc = null;
const LO = {
  gameData: {
    gameUrl: null,
    gameName: null
  },
  resolvePromise: null,
  confirmModal: null,
  gameItem: null,
  userData: null,
  setComponents(e) {
    e.GamesIframe && (qc = e.GamesIframe), e.GamePop1 && (Kc = e.GamePop1), e.GamePop2 && (zc = e.GamePop2);
  },
  loadGame(e, t) {
    switch (this.gameItem = e, this.userData = ge().user, t.currency) {
      case 1:
        e.only_hkd == 1 ? this.getPointsConfiramtion(1) : e.only_hkd == 0 && this.callForGamesApi();
        break;
      case 2:
        e.only_hkd == 1 ? this.getPointsConfiramtion(1) : e.only_hkd == 0 && this.getPointsConfiramtion(2);
        break;
      case 3:
      case 4:
        this.callForGamesApi();
        break;
    }
  },
  getDreamCasinoLoadGames() {
    window.store.dispatch("setGlobalLoader", !0);
    let e = {
      type: "casino",
      game_code: this.gameItem.game_code,
      section_id: this.gameItem.sm_id
    };
    $("post", "GET_THIRD_PARTY_API", e, "user").then((t) => {
      var r;
      if (t && t.status == 200)
        if (window.store.dispatch("setGlobalLoader", !1), t.data.error)
          m(t.data.error);
        else {
          let n = (r = t == null ? void 0 : t.data) == null ? void 0 : r.url;
          if (n == null || n == null || n == "") {
            m("URL not found.");
            return;
          }
          this.gameData = {
            gameUrl: n,
            gameName: this.gameItem.game_name
          }, this.loadIframe(), window.store.dispatch("setGlobalLoader", !1);
        }
    }).catch((t) => {
      t && (window.store.dispatch("setGlobalLoader", !1), m(t[0]));
    });
  },
  async getPointsConfiramtion(e) {
    new Promise((r) => {
      this.resolvePromise = r, this.pointsConfirmationInit(e), this.confirmModal.show();
    }).then((r) => {
      r.isConfirmed && (this.confirmModal.hide(), this.callForGamesApi());
    });
  },
  callForGamesApi() {
    var e;
    if (((e = window.store.getters.stateUser) == null ? void 0 : e.actw) == "WB") {
      m("Casino not allowed in welcome balance.");
      return;
    }
    this.getDreamCasinoLoadGames();
  },
  createModal(e, t, r) {
    if (!document.getElementById(`games-modal-${r}`)) {
      const n = document.getElementById("app"), s = document.createElement("div");
      s.id = `games-modal-${r}`, n.appendChild(s);
      let i = aw(e, t);
      Rw(i, s);
    }
    this.confirmModal = new $t(document.getElementById(r));
  },
  pointsConfirmationInit(e) {
    const t = e === 1 ? Kc : zc, r = e === 1 ? "gamePop1" : "gamePop2";
    this.createModal(t, { onAgreed: this.handleAgreed.bind(this) }, r);
  },
  handleAgreed() {
    this.resolvePromise && this.resolvePromise({ isConfirmed: !0 }), this.confirmModal.hide();
  },
  loadIframe() {
    this.createModal(
      qc,
      {
        gameData: this.gameData,
        onCloseGame: this.closeGame.bind(this),
        userData: this.userData
      },
      "gamesIframe"
    ), this.confirmModal.show();
  },
  closeGame() {
    this.confirmModal.hide();
    const e = document.getElementById("games-modal-gamesIframe");
    e && e.remove(), this.confirmModal = null;
  }
};
let ro = null, ls = {
  langData: {}
};
const xO = async (e, t = null, r = !0, n) => {
  try {
    ro || (ro = n), t = t ?? (localStorage.getItem("selectedLanguageCode") || "en");
    let s = e.find((i) => i.lang_code === t);
    if (!s || t == "en")
      return ls.langData = {}, localStorage.removeItem("selectedLanguageCode"), ls.langData;
    try {
      let i = await Pw(s.lang_url, ro);
      return ls.langData = i.data, localStorage.setItem("selectedLanguageCode", t), ls.langData;
    } catch {
      return { errorMessage: "Failed to change language. Try different language." };
    }
  } catch {
    return r ? !1 : { errorMessage: "Failed to change language. Try different language." };
  }
}, Pw = async (e, t) => await Re.get(t + "/" + e), Ht = /* @__PURE__ */ Object.create(null);
Ht.open = "0";
Ht.close = "1";
Ht.ping = "2";
Ht.pong = "3";
Ht.message = "4";
Ht.upgrade = "5";
Ht.noop = "6";
const Ds = /* @__PURE__ */ Object.create(null);
Object.keys(Ht).forEach((e) => {
  Ds[Ht[e]] = e;
});
const sa = { type: "error", data: "parser error" }, ip = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", op = typeof ArrayBuffer == "function", ap = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, rl = ({ type: e, data: t }, r, n) => ip && t instanceof Blob ? r ? n(t) : Jc(t, n) : op && (t instanceof ArrayBuffer || ap(t)) ? r ? n(t) : Jc(new Blob([t]), n) : n(Ht[e] + (t || "")), Jc = (e, t) => {
  const r = new FileReader();
  return r.onload = function() {
    const n = r.result.split(",")[1];
    t("b" + (n || ""));
  }, r.readAsDataURL(e);
};
function Xc(e) {
  return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
let no;
function $w(e, t) {
  if (ip && e.data instanceof Blob)
    return e.data.arrayBuffer().then(Xc).then(t);
  if (op && (e.data instanceof ArrayBuffer || ap(e.data)))
    return t(Xc(e.data));
  rl(e, !1, (r) => {
    no || (no = new TextEncoder()), t(no.encode(r));
  });
}
const Qc = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Nn = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < Qc.length; e++)
  Nn[Qc.charCodeAt(e)] = e;
const Fw = (e) => {
  let t = e.length * 0.75, r = e.length, n, s = 0, i, o, a, l;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  const u = new ArrayBuffer(t), c = new Uint8Array(u);
  for (n = 0; n < r; n += 4)
    i = Nn[e.charCodeAt(n)], o = Nn[e.charCodeAt(n + 1)], a = Nn[e.charCodeAt(n + 2)], l = Nn[e.charCodeAt(n + 3)], c[s++] = i << 2 | o >> 4, c[s++] = (o & 15) << 4 | a >> 2, c[s++] = (a & 3) << 6 | l & 63;
  return u;
}, Vw = typeof ArrayBuffer == "function", nl = (e, t) => {
  if (typeof e != "string")
    return {
      type: "message",
      data: lp(e, t)
    };
  const r = e.charAt(0);
  return r === "b" ? {
    type: "message",
    data: Bw(e.substring(1), t)
  } : Ds[r] ? e.length > 1 ? {
    type: Ds[r],
    data: e.substring(1)
  } : {
    type: Ds[r]
  } : sa;
}, Bw = (e, t) => {
  if (Vw) {
    const r = Fw(e);
    return lp(r, t);
  } else
    return { base64: !0, data: e };
}, lp = (e, t) => {
  switch (t) {
    case "blob":
      return e instanceof Blob ? e : new Blob([e]);
    case "arraybuffer":
    default:
      return e instanceof ArrayBuffer ? e : e.buffer;
  }
}, cp = "", Uw = (e, t) => {
  const r = e.length, n = new Array(r);
  let s = 0;
  e.forEach((i, o) => {
    rl(i, !1, (a) => {
      n[o] = a, ++s === r && t(n.join(cp));
    });
  });
}, Hw = (e, t) => {
  const r = e.split(cp), n = [];
  for (let s = 0; s < r.length; s++) {
    const i = nl(r[s], t);
    if (n.push(i), i.type === "error")
      break;
  }
  return n;
};
function jw() {
  return new TransformStream({
    transform(e, t) {
      $w(e, (r) => {
        const n = r.length;
        let s;
        if (n < 126)
          s = new Uint8Array(1), new DataView(s.buffer).setUint8(0, n);
        else if (n < 65536) {
          s = new Uint8Array(3);
          const i = new DataView(s.buffer);
          i.setUint8(0, 126), i.setUint16(1, n);
        } else {
          s = new Uint8Array(9);
          const i = new DataView(s.buffer);
          i.setUint8(0, 127), i.setBigUint64(1, BigInt(n));
        }
        e.data && typeof e.data != "string" && (s[0] |= 128), t.enqueue(s), t.enqueue(r);
      });
    }
  });
}
let so;
function cs(e) {
  return e.reduce((t, r) => t + r.length, 0);
}
function us(e, t) {
  if (e[0].length === t)
    return e.shift();
  const r = new Uint8Array(t);
  let n = 0;
  for (let s = 0; s < t; s++)
    r[s] = e[0][n++], n === e[0].length && (e.shift(), n = 0);
  return e.length && n < e[0].length && (e[0] = e[0].slice(n)), r;
}
function Yw(e, t) {
  so || (so = new TextDecoder());
  const r = [];
  let n = 0, s = -1, i = !1;
  return new TransformStream({
    transform(o, a) {
      for (r.push(o); ; ) {
        if (n === 0) {
          if (cs(r) < 1)
            break;
          const l = us(r, 1);
          i = (l[0] & 128) === 128, s = l[0] & 127, s < 126 ? n = 3 : s === 126 ? n = 1 : n = 2;
        } else if (n === 1) {
          if (cs(r) < 2)
            break;
          const l = us(r, 2);
          s = new DataView(l.buffer, l.byteOffset, l.length).getUint16(0), n = 3;
        } else if (n === 2) {
          if (cs(r) < 8)
            break;
          const l = us(r, 8), u = new DataView(l.buffer, l.byteOffset, l.length), c = u.getUint32(0);
          if (c > Math.pow(2, 21) - 1) {
            a.enqueue(sa);
            break;
          }
          s = c * Math.pow(2, 32) + u.getUint32(4), n = 3;
        } else {
          if (cs(r) < s)
            break;
          const l = us(r, s);
          a.enqueue(nl(i ? l : so.decode(l), t)), n = 0;
        }
        if (s === 0 || s > e) {
          a.enqueue(sa);
          break;
        }
      }
    }
  });
}
const up = 4;
function ke(e) {
  if (e) return Gw(e);
}
function Gw(e) {
  for (var t in ke.prototype)
    e[t] = ke.prototype[t];
  return e;
}
ke.prototype.on = ke.prototype.addEventListener = function(e, t) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
};
ke.prototype.once = function(e, t) {
  function r() {
    this.off(e, r), t.apply(this, arguments);
  }
  return r.fn = t, this.on(e, r), this;
};
ke.prototype.off = ke.prototype.removeListener = ke.prototype.removeAllListeners = ke.prototype.removeEventListener = function(e, t) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var r = this._callbacks["$" + e];
  if (!r) return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + e], this;
  for (var n, s = 0; s < r.length; s++)
    if (n = r[s], n === t || n.fn === t) {
      r.splice(s, 1);
      break;
    }
  return r.length === 0 && delete this._callbacks["$" + e], this;
};
ke.prototype.emit = function(e) {
  this._callbacks = this._callbacks || {};
  for (var t = new Array(arguments.length - 1), r = this._callbacks["$" + e], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  if (r) {
    r = r.slice(0);
    for (var n = 0, s = r.length; n < s; ++n)
      r[n].apply(this, t);
  }
  return this;
};
ke.prototype.emitReserved = ke.prototype.emit;
ke.prototype.listeners = function(e) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
};
ke.prototype.hasListeners = function(e) {
  return !!this.listeners(e).length;
};
const Si = typeof Promise == "function" && typeof Promise.resolve == "function" ? (t) => Promise.resolve().then(t) : (t, r) => r(t, 0), lt = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")(), Ww = "arraybuffer";
function dp(e, ...t) {
  return t.reduce((r, n) => (e.hasOwnProperty(n) && (r[n] = e[n]), r), {});
}
const qw = lt.setTimeout, Kw = lt.clearTimeout;
function Oi(e, t) {
  t.useNativeTimers ? (e.setTimeoutFn = qw.bind(lt), e.clearTimeoutFn = Kw.bind(lt)) : (e.setTimeoutFn = lt.setTimeout.bind(lt), e.clearTimeoutFn = lt.clearTimeout.bind(lt));
}
const zw = 1.33;
function Jw(e) {
  return typeof e == "string" ? Xw(e) : Math.ceil((e.byteLength || e.size) * zw);
}
function Xw(e) {
  let t = 0, r = 0;
  for (let n = 0, s = e.length; n < s; n++)
    t = e.charCodeAt(n), t < 128 ? r += 1 : t < 2048 ? r += 2 : t < 55296 || t >= 57344 ? r += 3 : (n++, r += 4);
  return r;
}
function fp() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function Qw(e) {
  let t = "";
  for (let r in e)
    e.hasOwnProperty(r) && (t.length && (t += "&"), t += encodeURIComponent(r) + "=" + encodeURIComponent(e[r]));
  return t;
}
function Zw(e) {
  let t = {}, r = e.split("&");
  for (let n = 0, s = r.length; n < s; n++) {
    let i = r[n].split("=");
    t[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
  }
  return t;
}
class eT extends Error {
  constructor(t, r, n) {
    super(t), this.description = r, this.context = n, this.type = "TransportError";
  }
}
class sl extends ke {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(t) {
    super(), this.writable = !1, Oi(this, t), this.opts = t, this.query = t.query, this.socket = t.socket, this.supportsBinary = !t.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(t, r, n) {
    return super.emitReserved("error", new eT(t, r, n)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(t) {
    this.readyState === "open" && this.write(t);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(t) {
    const r = nl(t, this.socket.binaryType);
    this.onPacket(r);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(t) {
    super.emitReserved("packet", t);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(t) {
    this.readyState = "closed", super.emitReserved("close", t);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(t) {
  }
  createUri(t, r = {}) {
    return t + "://" + this._hostname() + this._port() + this.opts.path + this._query(r);
  }
  _hostname() {
    const t = this.opts.hostname;
    return t.indexOf(":") === -1 ? t : "[" + t + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && +(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(t) {
    const r = Qw(t);
    return r.length ? "?" + r : "";
  }
}
class tT extends sl {
  constructor() {
    super(...arguments), this._polling = !1;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(t) {
    this.readyState = "pausing";
    const r = () => {
      this.readyState = "paused", t();
    };
    if (this._polling || !this.writable) {
      let n = 0;
      this._polling && (n++, this.once("pollComplete", function() {
        --n || r();
      })), this.writable || (n++, this.once("drain", function() {
        --n || r();
      }));
    } else
      r();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(t) {
    const r = (n) => {
      if (this.readyState === "opening" && n.type === "open" && this.onOpen(), n.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(n);
    };
    Hw(t, this.socket.binaryType).forEach(r), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const t = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? t() : this.once("open", t);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(t) {
    this.writable = !1, Uw(t, (r) => {
      this.doWrite(r, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "https" : "http", r = this.query || {};
    return this.opts.timestampRequests !== !1 && (r[this.opts.timestampParam] = fp()), !this.supportsBinary && !r.sid && (r.b64 = 1), this.createUri(t, r);
  }
}
let pp = !1;
try {
  pp = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const rT = pp;
function nT() {
}
class sT extends tT {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(t) {
    if (super(t), typeof location < "u") {
      const r = location.protocol === "https:";
      let n = location.port;
      n || (n = r ? "443" : "80"), this.xd = typeof location < "u" && t.hostname !== location.hostname || n !== t.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(t, r) {
    const n = this.request({
      method: "POST",
      data: t
    });
    n.on("success", r), n.on("error", (s, i) => {
      this.onError("xhr post error", s, i);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const t = this.request();
    t.on("data", this.onData.bind(this)), t.on("error", (r, n) => {
      this.onError("xhr poll error", r, n);
    }), this.pollXhr = t;
  }
}
let qr = class Is extends ke {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(t, r, n) {
    super(), this.createRequest = t, Oi(this, n), this._opts = n, this._method = n.method || "GET", this._uri = r, this._data = n.data !== void 0 ? n.data : null, this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var t;
    const r = dp(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    r.xdomain = !!this._opts.xd;
    const n = this._xhr = this.createRequest(r);
    try {
      n.open(this._method, this._uri, !0);
      try {
        if (this._opts.extraHeaders) {
          n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
          for (let s in this._opts.extraHeaders)
            this._opts.extraHeaders.hasOwnProperty(s) && n.setRequestHeader(s, this._opts.extraHeaders[s]);
        }
      } catch {
      }
      if (this._method === "POST")
        try {
          n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        n.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (t = this._opts.cookieJar) === null || t === void 0 || t.addCookies(n), "withCredentials" in n && (n.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (n.timeout = this._opts.requestTimeout), n.onreadystatechange = () => {
        var s;
        n.readyState === 3 && ((s = this._opts.cookieJar) === null || s === void 0 || s.parseCookies(
          // @ts-ignore
          n.getResponseHeader("set-cookie")
        )), n.readyState === 4 && (n.status === 200 || n.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
          this._onError(typeof n.status == "number" ? n.status : 0);
        }, 0));
      }, n.send(this._data);
    } catch (s) {
      this.setTimeoutFn(() => {
        this._onError(s);
      }, 0);
      return;
    }
    typeof document < "u" && (this._index = Is.requestsCount++, Is.requests[this._index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(t) {
    this.emitReserved("error", t, this._xhr), this._cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(t) {
    if (!(typeof this._xhr > "u" || this._xhr === null)) {
      if (this._xhr.onreadystatechange = nT, t)
        try {
          this._xhr.abort();
        } catch {
        }
      typeof document < "u" && delete Is.requests[this._index], this._xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const t = this._xhr.responseText;
    t !== null && (this.emitReserved("data", t), this.emitReserved("success"), this._cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
};
qr.requestsCount = 0;
qr.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", Zc);
  else if (typeof addEventListener == "function") {
    const e = "onpagehide" in lt ? "pagehide" : "unload";
    addEventListener(e, Zc, !1);
  }
}
function Zc() {
  for (let e in qr.requests)
    qr.requests.hasOwnProperty(e) && qr.requests[e].abort();
}
const iT = function() {
  const e = hp({
    xdomain: !1
  });
  return e && e.responseType !== null;
}();
class oT extends sT {
  constructor(t) {
    super(t);
    const r = t && t.forceBase64;
    this.supportsBinary = iT && !r;
  }
  request(t = {}) {
    return Object.assign(t, { xd: this.xd }, this.opts), new qr(hp, this.uri(), t);
  }
}
function hp(e) {
  const t = e.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!t || rT))
      return new XMLHttpRequest();
  } catch {
  }
  if (!t)
    try {
      return new lt[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
const gp = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class aT extends sl {
  get name() {
    return "websocket";
  }
  doOpen() {
    const t = this.uri(), r = this.opts.protocols, n = gp ? {} : dp(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
    try {
      this.ws = this.createSocket(t, r, n);
    } catch (s) {
      return this.emitReserved("error", s);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (t) => this.onClose({
      description: "websocket connection closed",
      context: t
    }), this.ws.onmessage = (t) => this.onData(t.data), this.ws.onerror = (t) => this.onError("websocket error", t);
  }
  write(t) {
    this.writable = !1;
    for (let r = 0; r < t.length; r++) {
      const n = t[r], s = r === t.length - 1;
      rl(n, this.supportsBinary, (i) => {
        try {
          this.doWrite(n, i);
        } catch {
        }
        s && Si(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.onerror = () => {
    }, this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "wss" : "ws", r = this.query || {};
    return this.opts.timestampRequests && (r[this.opts.timestampParam] = fp()), this.supportsBinary || (r.b64 = 1), this.createUri(t, r);
  }
}
const io = lt.WebSocket || lt.MozWebSocket;
class lT extends aT {
  createSocket(t, r, n) {
    return gp ? new io(t, r, n) : r ? new io(t, r) : new io(t);
  }
  doWrite(t, r) {
    this.ws.send(r);
  }
}
class cT extends sl {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (t) {
      return this.emitReserved("error", t);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch((t) => {
      this.onError("webtransport error", t);
    }), this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then((t) => {
        const r = Yw(Number.MAX_SAFE_INTEGER, this.socket.binaryType), n = t.readable.pipeThrough(r).getReader(), s = jw();
        s.readable.pipeTo(t.writable), this._writer = s.writable.getWriter();
        const i = () => {
          n.read().then(({ done: a, value: l }) => {
            a || (this.onPacket(l), i());
          }).catch((a) => {
          });
        };
        i();
        const o = { type: "open" };
        this.query.sid && (o.data = `{"sid":"${this.query.sid}"}`), this._writer.write(o).then(() => this.onOpen());
      });
    });
  }
  write(t) {
    this.writable = !1;
    for (let r = 0; r < t.length; r++) {
      const n = t[r], s = r === t.length - 1;
      this._writer.write(n).then(() => {
        s && Si(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var t;
    (t = this._transport) === null || t === void 0 || t.close();
  }
}
const uT = {
  websocket: lT,
  webtransport: cT,
  polling: oT
}, dT = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, fT = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function ia(e) {
  if (e.length > 8e3)
    throw "URI too long";
  const t = e, r = e.indexOf("["), n = e.indexOf("]");
  r != -1 && n != -1 && (e = e.substring(0, r) + e.substring(r, n).replace(/:/g, ";") + e.substring(n, e.length));
  let s = dT.exec(e || ""), i = {}, o = 14;
  for (; o--; )
    i[fT[o]] = s[o] || "";
  return r != -1 && n != -1 && (i.source = t, i.host = i.host.substring(1, i.host.length - 1).replace(/;/g, ":"), i.authority = i.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), i.ipv6uri = !0), i.pathNames = pT(i, i.path), i.queryKey = hT(i, i.query), i;
}
function pT(e, t) {
  const r = /\/{2,9}/g, n = t.replace(r, "/").split("/");
  return (t.slice(0, 1) == "/" || t.length === 0) && n.splice(0, 1), t.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function hT(e, t) {
  const r = {};
  return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(n, s, i) {
    s && (r[s] = i);
  }), r;
}
const oa = typeof addEventListener == "function" && typeof removeEventListener == "function", Ms = [];
oa && addEventListener("offline", () => {
  Ms.forEach((e) => e());
}, !1);
class nr extends ke {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(t, r) {
    if (super(), this.binaryType = Ww, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, t && typeof t == "object" && (r = t, t = null), t) {
      const n = ia(t);
      r.hostname = n.host, r.secure = n.protocol === "https" || n.protocol === "wss", r.port = n.port, n.query && (r.query = n.query);
    } else r.host && (r.hostname = ia(r.host).host);
    Oi(this, r), this.secure = r.secure != null ? r.secure : typeof location < "u" && location.protocol === "https:", r.hostname && !r.port && (r.port = this.secure ? "443" : "80"), this.hostname = r.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = r.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, r.transports.forEach((n) => {
      const s = n.prototype.name;
      this.transports.push(s), this._transportsByName[s] = n;
    }), this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, r), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = Zw(this.opts.query)), oa && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
      this._onClose("transport close", {
        description: "network connection lost"
      });
    }, Ms.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(t) {
    const r = Object.assign({}, this.opts.query);
    r.EIO = up, r.transport = t, this.id && (r.sid = this.id);
    const n = Object.assign({}, this.opts, {
      query: r,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[t]);
    return new this._transportsByName[t](n);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const t = this.opts.rememberUpgrade && nr.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const r = this.createTransport(t);
    r.open(), this.setTransport(r);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(t) {
    this.transport && this.transport.removeAllListeners(), this.transport = t, t.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (r) => this._onClose("transport close", r));
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    this.readyState = "open", nr.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", t), this.emitReserved("heartbeat"), t.type) {
        case "open":
          this.onHandshake(JSON.parse(t.data));
          break;
        case "ping":
          this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
          break;
        case "error":
          const r = new Error("server error");
          r.code = t.data, this._onError(r);
          break;
        case "message":
          this.emitReserved("data", t.data), this.emitReserved("message", t.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(t) {
    this.emitReserved("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this._pingInterval = t.pingInterval, this._pingTimeout = t.pingTimeout, this._maxPayload = t.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const t = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + t, this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, t), this.opts.autoUnref && this._pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const t = this._getWritablePackets();
      this.transport.send(t), this._prevBufferLen = t.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let r = 1;
    for (let n = 0; n < this.writeBuffer.length; n++) {
      const s = this.writeBuffer[n].data;
      if (s && (r += Jw(s)), n > 0 && r > this._maxPayload)
        return this.writeBuffer.slice(0, n);
      r += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime)
      return !0;
    const t = Date.now() > this._pingTimeoutTime;
    return t && (this._pingTimeoutTime = 0, Si(() => {
      this._onClose("ping timeout");
    }, this.setTimeoutFn)), t;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(t, r, n) {
    return this._sendPacket("message", t, r, n), this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(t, r, n) {
    return this._sendPacket("message", t, r, n), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(t, r, n, s) {
    if (typeof r == "function" && (s = r, r = void 0), typeof n == "function" && (s = n, n = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    n = n || {}, n.compress = n.compress !== !1;
    const i = {
      type: t,
      data: r,
      options: n
    };
    this.emitReserved("packetCreate", i), this.writeBuffer.push(i), s && this.once("flush", s), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const t = () => {
      this._onClose("forced close"), this.transport.close();
    }, r = () => {
      this.off("upgrade", r), this.off("upgradeError", r), t();
    }, n = () => {
      this.once("upgrade", r), this.once("upgradeError", r);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? n() : t();
    }) : this.upgrading ? n() : t()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(t) {
    if (nr.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening")
      return this.transports.shift(), this._open();
    this.emitReserved("error", t), this._onClose("transport error", t);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(t, r) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), oa && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
        const n = Ms.indexOf(this._offlineEventListener);
        n !== -1 && Ms.splice(n, 1);
      }
      this.readyState = "closed", this.id = null, this.emitReserved("close", t, r), this.writeBuffer = [], this._prevBufferLen = 0;
    }
  }
}
nr.protocol = up;
class gT extends nr {
  constructor() {
    super(...arguments), this._upgrades = [];
  }
  onOpen() {
    if (super.onOpen(), this.readyState === "open" && this.opts.upgrade)
      for (let t = 0; t < this._upgrades.length; t++)
        this._probe(this._upgrades[t]);
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(t) {
    let r = this.createTransport(t), n = !1;
    nr.priorWebsocketSuccess = !1;
    const s = () => {
      n || (r.send([{ type: "ping", data: "probe" }]), r.once("packet", (d) => {
        if (!n)
          if (d.type === "pong" && d.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", r), !r)
              return;
            nr.priorWebsocketSuccess = r.name === "websocket", this.transport.pause(() => {
              n || this.readyState !== "closed" && (c(), this.setTransport(r), r.send([{ type: "upgrade" }]), this.emitReserved("upgrade", r), r = null, this.upgrading = !1, this.flush());
            });
          } else {
            const f = new Error("probe error");
            f.transport = r.name, this.emitReserved("upgradeError", f);
          }
      }));
    };
    function i() {
      n || (n = !0, c(), r.close(), r = null);
    }
    const o = (d) => {
      const f = new Error("probe error: " + d);
      f.transport = r.name, i(), this.emitReserved("upgradeError", f);
    };
    function a() {
      o("transport closed");
    }
    function l() {
      o("socket closed");
    }
    function u(d) {
      r && d.name !== r.name && i();
    }
    const c = () => {
      r.removeListener("open", s), r.removeListener("error", o), r.removeListener("close", a), this.off("close", l), this.off("upgrading", u);
    };
    r.once("open", s), r.once("error", o), r.once("close", a), this.once("close", l), this.once("upgrading", u), this._upgrades.indexOf("webtransport") !== -1 && t !== "webtransport" ? this.setTimeoutFn(() => {
      n || r.open();
    }, 200) : r.open();
  }
  onHandshake(t) {
    this._upgrades = this._filterUpgrades(t.upgrades), super.onHandshake(t);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(t) {
    const r = [];
    for (let n = 0; n < t.length; n++)
      ~this.transports.indexOf(t[n]) && r.push(t[n]);
    return r;
  }
}
let _T = class extends gT {
  constructor(t, r = {}) {
    const n = typeof t == "object" ? t : r;
    (!n.transports || n.transports && typeof n.transports[0] == "string") && (n.transports = (n.transports || ["polling", "websocket", "webtransport"]).map((s) => uT[s]).filter((s) => !!s)), super(t, n);
  }
};
function mT(e, t = "", r) {
  let n = e;
  r = r || typeof location < "u" && location, e == null && (e = r.protocol + "//" + r.host), typeof e == "string" && (e.charAt(0) === "/" && (e.charAt(1) === "/" ? e = r.protocol + e : e = r.host + e), /^(https?|wss?):\/\//.test(e) || (typeof r < "u" ? e = r.protocol + "//" + e : e = "https://" + e), n = ia(e)), n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443")), n.path = n.path || "/";
  const i = n.host.indexOf(":") !== -1 ? "[" + n.host + "]" : n.host;
  return n.id = n.protocol + "://" + i + ":" + n.port + t, n.href = n.protocol + "://" + i + (r && r.port === n.port ? "" : ":" + n.port), n;
}
const yT = typeof ArrayBuffer == "function", ET = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, _p = Object.prototype.toString, vT = typeof Blob == "function" || typeof Blob < "u" && _p.call(Blob) === "[object BlobConstructor]", bT = typeof File == "function" || typeof File < "u" && _p.call(File) === "[object FileConstructor]";
function il(e) {
  return yT && (e instanceof ArrayBuffer || ET(e)) || vT && e instanceof Blob || bT && e instanceof File;
}
function Rs(e, t) {
  if (!e || typeof e != "object")
    return !1;
  if (Array.isArray(e)) {
    for (let r = 0, n = e.length; r < n; r++)
      if (Rs(e[r]))
        return !0;
    return !1;
  }
  if (il(e))
    return !0;
  if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1)
    return Rs(e.toJSON(), !0);
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && Rs(e[r]))
      return !0;
  return !1;
}
function wT(e) {
  const t = [], r = e.data, n = e;
  return n.data = aa(r, t), n.attachments = t.length, { packet: n, buffers: t };
}
function aa(e, t) {
  if (!e)
    return e;
  if (il(e)) {
    const r = { _placeholder: !0, num: t.length };
    return t.push(e), r;
  } else if (Array.isArray(e)) {
    const r = new Array(e.length);
    for (let n = 0; n < e.length; n++)
      r[n] = aa(e[n], t);
    return r;
  } else if (typeof e == "object" && !(e instanceof Date)) {
    const r = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (r[n] = aa(e[n], t));
    return r;
  }
  return e;
}
function TT(e, t) {
  return e.data = la(e.data, t), delete e.attachments, e;
}
function la(e, t) {
  if (!e)
    return e;
  if (e && e._placeholder === !0) {
    if (typeof e.num == "number" && e.num >= 0 && e.num < t.length)
      return t[e.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(e))
    for (let r = 0; r < e.length; r++)
      e[r] = la(e[r], t);
  else if (typeof e == "object")
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (e[r] = la(e[r], t));
  return e;
}
const ST = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
], OT = 5;
var be;
(function(e) {
  e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})(be || (be = {}));
class AT {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(t) {
    this.replacer = t;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(t) {
    return (t.type === be.EVENT || t.type === be.ACK) && Rs(t) ? this.encodeAsBinary({
      type: t.type === be.EVENT ? be.BINARY_EVENT : be.BINARY_ACK,
      nsp: t.nsp,
      data: t.data,
      id: t.id
    }) : [this.encodeAsString(t)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(t) {
    let r = "" + t.type;
    return (t.type === be.BINARY_EVENT || t.type === be.BINARY_ACK) && (r += t.attachments + "-"), t.nsp && t.nsp !== "/" && (r += t.nsp + ","), t.id != null && (r += t.id), t.data != null && (r += JSON.stringify(t.data, this.replacer)), r;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(t) {
    const r = wT(t), n = this.encodeAsString(r.packet), s = r.buffers;
    return s.unshift(n), s;
  }
}
function eu(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
class ol extends ke {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(t) {
    super(), this.reviver = t;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(t) {
    let r;
    if (typeof t == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      r = this.decodeString(t);
      const n = r.type === be.BINARY_EVENT;
      n || r.type === be.BINARY_ACK ? (r.type = n ? be.EVENT : be.ACK, this.reconstructor = new NT(r), r.attachments === 0 && super.emitReserved("decoded", r)) : super.emitReserved("decoded", r);
    } else if (il(t) || t.base64)
      if (this.reconstructor)
        r = this.reconstructor.takeBinaryData(t), r && (this.reconstructor = null, super.emitReserved("decoded", r));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + t);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(t) {
    let r = 0;
    const n = {
      type: Number(t.charAt(0))
    };
    if (be[n.type] === void 0)
      throw new Error("unknown packet type " + n.type);
    if (n.type === be.BINARY_EVENT || n.type === be.BINARY_ACK) {
      const i = r + 1;
      for (; t.charAt(++r) !== "-" && r != t.length; )
        ;
      const o = t.substring(i, r);
      if (o != Number(o) || t.charAt(r) !== "-")
        throw new Error("Illegal attachments");
      n.attachments = Number(o);
    }
    if (t.charAt(r + 1) === "/") {
      const i = r + 1;
      for (; ++r && !(t.charAt(r) === "," || r === t.length); )
        ;
      n.nsp = t.substring(i, r);
    } else
      n.nsp = "/";
    const s = t.charAt(r + 1);
    if (s !== "" && Number(s) == s) {
      const i = r + 1;
      for (; ++r; ) {
        const o = t.charAt(r);
        if (o == null || Number(o) != o) {
          --r;
          break;
        }
        if (r === t.length)
          break;
      }
      n.id = Number(t.substring(i, r + 1));
    }
    if (t.charAt(++r)) {
      const i = this.tryParse(t.substr(r));
      if (ol.isPayloadValid(n.type, i))
        n.data = i;
      else
        throw new Error("invalid payload");
    }
    return n;
  }
  tryParse(t) {
    try {
      return JSON.parse(t, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(t, r) {
    switch (t) {
      case be.CONNECT:
        return eu(r);
      case be.DISCONNECT:
        return r === void 0;
      case be.CONNECT_ERROR:
        return typeof r == "string" || eu(r);
      case be.EVENT:
      case be.BINARY_EVENT:
        return Array.isArray(r) && (typeof r[0] == "number" || typeof r[0] == "string" && ST.indexOf(r[0]) === -1);
      case be.ACK:
      case be.BINARY_ACK:
        return Array.isArray(r);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class NT {
  constructor(t) {
    this.packet = t, this.buffers = [], this.reconPack = t;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(t) {
    if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
      const r = TT(this.reconPack, this.buffers);
      return this.finishedReconstruction(), r;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const CT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: ol,
  Encoder: AT,
  get PacketType() {
    return be;
  },
  protocol: OT
}, Symbol.toStringTag, { value: "Module" }));
function pt(e, t, r) {
  return e.on(t, r), function() {
    e.off(t, r);
  };
}
const DT = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class mp extends ke {
  /**
   * `Socket` constructor.
   */
  constructor(t, r, n) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = t, this.nsp = r, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const t = this.io;
    this.subs = [
      pt(t, "open", this.onopen.bind(this)),
      pt(t, "packet", this.onpacket.bind(this)),
      pt(t, "error", this.onerror.bind(this)),
      pt(t, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...t) {
    return t.unshift("message"), this.emit.apply(this, t), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(t, ...r) {
    var n, s, i;
    if (DT.hasOwnProperty(t))
      throw new Error('"' + t.toString() + '" is a reserved event name');
    if (r.unshift(t), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(r), this;
    const o = {
      type: be.EVENT,
      data: r
    };
    if (o.options = {}, o.options.compress = this.flags.compress !== !1, typeof r[r.length - 1] == "function") {
      const c = this.ids++, d = r.pop();
      this._registerAckCallback(c, d), o.id = c;
    }
    const a = (s = (n = this.io.engine) === null || n === void 0 ? void 0 : n.transport) === null || s === void 0 ? void 0 : s.writable, l = this.connected && !(!((i = this.io.engine) === null || i === void 0) && i._hasPingExpired());
    return this.flags.volatile && !a || (l ? (this.notifyOutgoingListeners(o), this.packet(o)) : this.sendBuffer.push(o)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(t, r) {
    var n;
    const s = (n = this.flags.timeout) !== null && n !== void 0 ? n : this._opts.ackTimeout;
    if (s === void 0) {
      this.acks[t] = r;
      return;
    }
    const i = this.io.setTimeoutFn(() => {
      delete this.acks[t];
      for (let a = 0; a < this.sendBuffer.length; a++)
        this.sendBuffer[a].id === t && this.sendBuffer.splice(a, 1);
      r.call(this, new Error("operation has timed out"));
    }, s), o = (...a) => {
      this.io.clearTimeoutFn(i), r.apply(this, a);
    };
    o.withError = !0, this.acks[t] = o;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(t, ...r) {
    return new Promise((n, s) => {
      const i = (o, a) => o ? s(o) : n(a);
      i.withError = !0, r.push(i), this.emit(t, ...r);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(t) {
    let r;
    typeof t[t.length - 1] == "function" && (r = t.pop());
    const n = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: t,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    t.push((s, ...i) => n !== this._queue[0] ? void 0 : (s !== null ? n.tryCount > this._opts.retries && (this._queue.shift(), r && r(s)) : (this._queue.shift(), r && r(null, ...i)), n.pending = !1, this._drainQueue())), this._queue.push(n), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(t = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const r = this._queue[0];
    r.pending && !t || (r.pending = !0, r.tryCount++, this.flags = r.flags, this.emit.apply(this, r.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(t) {
    t.nsp = this.nsp, this.io._packet(t);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((t) => {
      this._sendConnectPacket(t);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(t) {
    this.packet({
      type: be.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, t) : t
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(t) {
    this.connected || this.emitReserved("connect_error", t);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(t, r) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", t, r), this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach((t) => {
      if (!this.sendBuffer.some((n) => String(n.id) === t)) {
        const n = this.acks[t];
        delete this.acks[t], n.withError && n.call(this, new Error("socket has been disconnected"));
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(t) {
    if (t.nsp === this.nsp)
      switch (t.type) {
        case be.CONNECT:
          t.data && t.data.sid ? this.onconnect(t.data.sid, t.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case be.EVENT:
        case be.BINARY_EVENT:
          this.onevent(t);
          break;
        case be.ACK:
        case be.BINARY_ACK:
          this.onack(t);
          break;
        case be.DISCONNECT:
          this.ondisconnect();
          break;
        case be.CONNECT_ERROR:
          this.destroy();
          const n = new Error(t.data.message);
          n.data = t.data.data, this.emitReserved("connect_error", n);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(t) {
    const r = t.data || [];
    t.id != null && r.push(this.ack(t.id)), this.connected ? this.emitEvent(r) : this.receiveBuffer.push(Object.freeze(r));
  }
  emitEvent(t) {
    if (this._anyListeners && this._anyListeners.length) {
      const r = this._anyListeners.slice();
      for (const n of r)
        n.apply(this, t);
    }
    super.emit.apply(this, t), this._pid && t.length && typeof t[t.length - 1] == "string" && (this._lastOffset = t[t.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(t) {
    const r = this;
    let n = !1;
    return function(...s) {
      n || (n = !0, r.packet({
        type: be.ACK,
        id: t,
        data: s
      }));
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(t) {
    const r = this.acks[t.id];
    typeof r == "function" && (delete this.acks[t.id], r.withError && t.data.unshift(null), r.apply(this, t.data));
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(t, r) {
    this.id = t, this.recovered = r && this._pid === r, this._pid = r, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((t) => this.emitEvent(t)), this.receiveBuffer = [], this.sendBuffer.forEach((t) => {
      this.notifyOutgoingListeners(t), this.packet(t);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((t) => t()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: be.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(t) {
    return this.flags.compress = t, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(t) {
    return this.flags.timeout = t, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(t) {
    if (!this._anyListeners)
      return this;
    if (t) {
      const r = this._anyListeners;
      for (let n = 0; n < r.length; n++)
        if (t === r[n])
          return r.splice(n, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(t) {
    if (!this._anyOutgoingListeners)
      return this;
    if (t) {
      const r = this._anyOutgoingListeners;
      for (let n = 0; n < r.length; n++)
        if (t === r[n])
          return r.splice(n, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(t) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const r = this._anyOutgoingListeners.slice();
      for (const n of r)
        n.apply(this, t.data);
    }
  }
}
function pn(e) {
  e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
pn.prototype.duration = function() {
  var e = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var t = Math.random(), r = Math.floor(t * this.jitter * e);
    e = (Math.floor(t * 10) & 1) == 0 ? e - r : e + r;
  }
  return Math.min(e, this.max) | 0;
};
pn.prototype.reset = function() {
  this.attempts = 0;
};
pn.prototype.setMin = function(e) {
  this.ms = e;
};
pn.prototype.setMax = function(e) {
  this.max = e;
};
pn.prototype.setJitter = function(e) {
  this.jitter = e;
};
class ca extends ke {
  constructor(t, r) {
    var n;
    super(), this.nsps = {}, this.subs = [], t && typeof t == "object" && (r = t, t = void 0), r = r || {}, r.path = r.path || "/socket.io", this.opts = r, Oi(this, r), this.reconnection(r.reconnection !== !1), this.reconnectionAttempts(r.reconnectionAttempts || 1 / 0), this.reconnectionDelay(r.reconnectionDelay || 1e3), this.reconnectionDelayMax(r.reconnectionDelayMax || 5e3), this.randomizationFactor((n = r.randomizationFactor) !== null && n !== void 0 ? n : 0.5), this.backoff = new pn({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(r.timeout == null ? 2e4 : r.timeout), this._readyState = "closed", this.uri = t;
    const s = r.parser || CT;
    this.encoder = new s.Encoder(), this.decoder = new s.Decoder(), this._autoConnect = r.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(t) {
    return arguments.length ? (this._reconnection = !!t, t || (this.skipReconnect = !0), this) : this._reconnection;
  }
  reconnectionAttempts(t) {
    return t === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = t, this);
  }
  reconnectionDelay(t) {
    var r;
    return t === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = t, (r = this.backoff) === null || r === void 0 || r.setMin(t), this);
  }
  randomizationFactor(t) {
    var r;
    return t === void 0 ? this._randomizationFactor : (this._randomizationFactor = t, (r = this.backoff) === null || r === void 0 || r.setJitter(t), this);
  }
  reconnectionDelayMax(t) {
    var r;
    return t === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = t, (r = this.backoff) === null || r === void 0 || r.setMax(t), this);
  }
  timeout(t) {
    return arguments.length ? (this._timeout = t, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(t) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new _T(this.uri, this.opts);
    const r = this.engine, n = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const s = pt(r, "open", function() {
      n.onopen(), t && t();
    }), i = (a) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", a), t ? t(a) : this.maybeReconnectOnOpen();
    }, o = pt(r, "error", i);
    if (this._timeout !== !1) {
      const a = this._timeout, l = this.setTimeoutFn(() => {
        s(), i(new Error("timeout")), r.close();
      }, a);
      this.opts.autoUnref && l.unref(), this.subs.push(() => {
        this.clearTimeoutFn(l);
      });
    }
    return this.subs.push(s), this.subs.push(o), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(t) {
    return this.open(t);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const t = this.engine;
    this.subs.push(
      pt(t, "ping", this.onping.bind(this)),
      pt(t, "data", this.ondata.bind(this)),
      pt(t, "error", this.onerror.bind(this)),
      pt(t, "close", this.onclose.bind(this)),
      // @ts-ignore
      pt(this.decoder, "decoded", this.ondecoded.bind(this))
    );
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(t) {
    try {
      this.decoder.add(t);
    } catch (r) {
      this.onclose("parse error", r);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(t) {
    Si(() => {
      this.emitReserved("packet", t);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(t) {
    this.emitReserved("error", t);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(t, r) {
    let n = this.nsps[t];
    return n ? this._autoConnect && !n.active && n.connect() : (n = new mp(this, t, r), this.nsps[t] = n), n;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(t) {
    const r = Object.keys(this.nsps);
    for (const n of r)
      if (this.nsps[n].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(t) {
    const r = this.encoder.encode(t);
    for (let n = 0; n < r.length; n++)
      this.engine.write(r[n], t.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((t) => t()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(t, r) {
    var n;
    this.cleanup(), (n = this.engine) === null || n === void 0 || n.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", t, r), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const t = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const r = this.backoff.duration();
      this._reconnecting = !0;
      const n = this.setTimeoutFn(() => {
        t.skipReconnect || (this.emitReserved("reconnect_attempt", t.backoff.attempts), !t.skipReconnect && t.open((s) => {
          s ? (t._reconnecting = !1, t.reconnect(), this.emitReserved("reconnect_error", s)) : t.onreconnect();
        }));
      }, r);
      this.opts.autoUnref && n.unref(), this.subs.push(() => {
        this.clearTimeoutFn(n);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const t = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", t);
  }
}
const Tn = {};
function Ls(e, t) {
  typeof e == "object" && (t = e, e = void 0), t = t || {};
  const r = mT(e, t.path || "/socket.io"), n = r.source, s = r.id, i = r.path, o = Tn[s] && i in Tn[s].nsps, a = t.forceNew || t["force new connection"] || t.multiplex === !1 || o;
  let l;
  return a ? l = new ca(n, t) : (Tn[s] || (Tn[s] = new ca(n, t)), l = Tn[s]), r.query && !t.query && (t.query = r.queryKey), l.socket(r.path, t);
}
Object.assign(Ls, {
  Manager: ca,
  Socket: mp,
  io: Ls,
  connect: Ls
});
const IT = Ls("https://zplay1.in", { transports: ["websocket"], upgrade: !1 });
class MT {
  constructor() {
    this.socketIo = IT, this.client = null, this.currSub = [], this.socketIo.on("connect", () => {
      this.client = this.socketIo.id, this.currSub.forEach((t) => {
        this.socketIo.emit(t.event, t.data);
      });
    });
  }
  on(t, r) {
    this.socketIo.on(t, r);
  }
  off(t) {
    this.socketIo.off(t);
  }
  emit(t, r) {
    t == "leave" ? r.forEach((n) => {
      this.currSub = this.currSub.filter((s) => s.data != n);
    }) : this.currSub.some((s) => s.event === t && s.data === r) || this.currSub.push({ event: t, data: r }), this.socketIo.connected && this.socketIo.emit(t, r);
  }
}
const kt = new MT();
let tu = !0;
const PO = () => {
  let e = null, t = 0, r = !1;
  return e = setTimeout(() => {
    t = window.scrollY, r = t > 80, clearTimeout(e), e = 0;
  }, 100), {
    scTimer: e,
    scY: t,
    showGoToTop: r
  };
}, RT = async (e, t, r) => {
  var n;
  try {
    let s = await $("get", "GET_SITE_VERSION", null, "user", { domain: window.location.hostname });
    if (s && s.status == 200) {
      let i = !1;
      if ((n = s == null ? void 0 : s.data) != null && n.error)
        m(s.data.error);
      else {
        let o = s.data.data, a = o == null ? void 0 : o.version, l = e || 0;
        if (!l || a != l || !t ? (r = !1, e = (await LT(e)).siteVersion) : yp(t, r), o != null && o.maintenance) {
          const { from_date: u, to_date: c } = o.maintenance, d = new Date(u).getTime(), f = new Date(c).getTime(), g = Date.now(), _ = d <= g && g <= f;
          d && f && _ && (O.dispatch("setUnderMaintenance", o.maintenance), i = !0);
        }
        setTimeout(() => {
          var u, c;
          RT(((u = O == null ? void 0 : O.getters) == null ? void 0 : u.siteVersion) || 0, (c = O == null ? void 0 : O.getters) == null ? void 0 : c.siteSettings, r);
        }, 3e4), r = !0;
      }
      return { isSiteStatusCalled: r, isMaintenance: i };
    }
  } catch (s) {
    console.log(s), s && m(s[0]);
  }
}, LT = async (e) => {
  var t;
  try {
    let r = await $("get", "GET_SITE_SETTINGS", null, "user", { domain: window.location.hostname });
    if (r && r.status == 200)
      if (((t = r == null ? void 0 : r.data) == null ? void 0 : t.status) === 0)
        m(r.data.debug[0]);
      else {
        let n = r == null ? void 0 : r.data.data;
        n.siteSetting.announcement = JSON.parse(n.siteSetting.announcement), n.siteSetting.offer = n.siteSetting.poster.find((i) => i.poster_type == 12);
        let s;
        try {
          n.casino_url ? s = await (async () => (await Re.get(n.casino_url)).data)() : s = n == null ? void 0 : n.casinoGames;
        } catch {
          console.log("Could not get casino games");
        }
        return O.dispatch("setSettings", n.siteSetting), O.dispatch("setGamesData", s), O.dispatch("setBonusData", n.bonus_data), O.dispatch("setSiteVersion", n.siteSetting.version), yp(n.siteSetting), {
          siteVersion: n.siteSetting.version
        };
      }
  } catch (r) {
    console.log(r), r && m(r[0]);
  }
}, yp = async (e, t) => {
  try {
    if (t) return;
    if (e.meta_tags && (document.head.innerHTML += e.meta_tags), e.g_tags && kT(e.g_tags), e.meta_pixel_code && PT(e.meta_pixel_code), e.site_map) {
      const n = document.createElement("link");
      n.rel = "sitemap", n.type = "application/xml", n.title = "Sitemap", n.href = e.aws_url + e.storage_path.site_map + e.site_map, document.head.appendChild(n);
    }
    if (O.dispatch("setSettings", e), xT(e), e.front_css != null && e.front_css != "") {
      const n = document.createElement("style");
      n.type = "text/css", n.appendChild(document.createTextNode(e.front_css)), document.head.insertAdjacentElement("beforeend", n);
    }
    const r = document.createElement("link");
    r.rel = "icon", r.href = e.aws_url + e.storage_path.domain_image + e.fav_logo, document.head.insertAdjacentElement("beforeend", r), ge().status && tu && (tu = !1, ua(), $T()), t = !0;
  } catch (r) {
    console.log(r), r && m(r[0]);
  }
}, xT = async (e) => {
  try {
    let r = e.domain_name.charAt(0).toUpperCase() + e.domain_name.slice(1).toLowerCase();
    var t = {
      name: r,
      short_name: r,
      start_url: window.location.origin,
      display: "standalone",
      icons: [{
        src: e.app_logo ? e.aws_url + e.storage_path.domain_image + e.app_logo : e.aws_url + e.storage_path.domain_image + e.fav_logo,
        sizes: "256x256 512x512 192x192 144x144",
        type: "image/png",
        purpose: "any"
      }]
    };
    const n = JSON.stringify(t), s = new Blob([n], { type: "application/json" }), i = URL.createObjectURL(s), o = document.createElement("link");
    o.rel = "manifest", o.href = i, document.head.insertAdjacentElement("beforeend", o);
    let a = e.aws_url + e.storage_path.domain_image + e.logo;
    document.querySelector("#appleIcon").setAttribute("href", a), document.querySelector("#appleLaunchIcon").setAttribute("href", a);
    const l = document.createElement("meta");
    l.setAttribute("name", "apple-mobile-web-app-title"), l.setAttribute("content", r), document.head.insertAdjacentElement("beforeend", l);
  } catch (r) {
    console.log(r), r && m(r[0]);
  }
}, kT = async (e) => {
  try {
    let t = document.createElement("script");
    t.async = !0, t.src = `https://www.googletagmanager.com/gtag/js?id=${e}`;
    let r = document.createElement("script");
    r.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${e}');
    `, document.head.appendChild(t), document.head.appendChild(r);
  } catch (t) {
    console.log(t), t && m(t[0]);
  }
}, PT = async (e) => {
  try {
    const t = document.createElement("script");
    t.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${e}');
        fbq('track', 'PageView');
    `, document.head.appendChild(t);
    const r = document.createElement("noscript");
    r.innerHTML = `
        <img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=${e}&ev=PageView&noscript=1"/>
    `, document.head.appendChild(r);
  } catch (t) {
    console.log(t), t && m(t[0]);
  }
}, $T = async () => {
  var n;
  try {
    let i = await $("post", "GET_FAVOURITE_LIST", {
      game_type: 1
    });
    if (i && i.status == 200 && ((n = i == null ? void 0 : i.data) == null ? void 0 : n.status) != 0) {
      for (var e = i.data.events, t = [], r = 0; r < e.length; r++)
        t.push(e[r]);
      O.dispatch("setFavouriteGames", t);
    }
  } catch (s) {
    console.log(s), s && m(s[0]);
  }
}, ua = async () => {
  try {
    let e = await $("post", "WALLET_BALANCE");
    if (e && e.status == 200 && e.data) {
      let t = O.getters.stateUser;
      t.balance = e.data.bl, t.expl = e.data.ex, t.bets_count = e.data.bc, t.earnBonus = e.data.eb, O.dispatch("setUser", t), setTimeout(function() {
        ua();
      }, 4e3);
    } else
      window.cookies.keys().forEach((t) => window.cookies.remove(t)), O.dispatch("resetAllState");
  } catch (e) {
    console.log(e), e.retry && setTimeout(function() {
      ua();
    }, 4e3), e && m(e[0]);
  }
}, $O = () => {
  try {
    ge().status && (kt.emit("sub", "DepositRequest-" + ge().user.userid), kt.on("DepositRequest", (e) => {
      successToast(e.msg);
    }));
  } catch (e) {
    console.log(e), e && m(e[0]);
  }
}, hn = (e, t, r, n) => fn && (r.length || n.length) ? !r.includes(parseInt(e)) && !n.includes(parseInt(t)) : !0, FT = (e) => fn ? !at.find((r) => r.type == e) : !0, VT = (e = null) => fn ? !at.filter((r) => r.type == "worli-matka").map((r) => r.type_id).includes(e) : !0, FO = () => fn && at ? !at.find((t) => t.type == "premium-fancy") : !0, Rr = (e) => {
  if (fn) {
    let t = at.filter((r) => r.type == "sports");
    if (t.length) {
      for (let r = 0; r < t.length; r++)
        if (t[r].type_id == e)
          return !1;
    }
  }
  return !0;
}, BT = (e) => {
  var t, r;
  try {
    let n = at == null ? void 0 : at.filter((o) => o.type == "casino-provider").map((o) => o.type_id), s = at == null ? void 0 : at.filter((o) => o.type == "provider-game").map((o) => o.type_id), i = (o, a, l, u) => l.length || u.length ? !u.includes(a) && !l.includes(o) : !0;
    for (let o in e) {
      let a = e[o];
      (t = a == null ? void 0 : a.menus) != null && t.length ? (a.menus.forEach((l) => {
        l.games = l.games.filter((u) => i(u.provider_id, u.id, n, s));
      }), a.menus = a.menus.filter((l) => l.games.length > 0)) : (r = a == null ? void 0 : a.games) != null && r.length && (a.games = a.games.filter((l) => i(l.provider_id, l.id, n, s)));
    }
  } catch {
    return e;
  }
}, VO = async (e) => {
  var t;
  try {
    let r = {}, n = await $("get", e, null, "sports");
    return n && n.status == 200 ? (r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.data, { allData: r }) : { allData: r };
  } catch (r) {
    r && m(r);
  }
}, BO = (e) => {
  ge().status && (BT(e), O.dispatch("setGamesData", e));
}, UO = async () => {
  try {
    let e = await $("get", "UNREAD_NOTIFICATION_COUNT", null);
    e && e.status == 200 && localStorage.setItem("unread_notification_count", e.data.data.count);
  } catch (e) {
    e && m(e[0]);
  }
}, HO = async () => {
  try {
    let e = await $("get", "GET_MATCHES_LIST", null, "fantasy"), t = null;
    return e && e.status == 200 && (t = e.data.data), { allMatchesList: t };
  } catch (e) {
    e && console.log(e[0]);
  }
}, jO = (e, t) => {
  try {
    for (var r = 0; r < (e == null ? void 0 : e.length); r++)
      t != null && t.includes(parseInt(e == null ? void 0 : e[r].event_id)) ? e[r].favourite = !0 : e[r].favourite = !1;
    return { matches: e };
  } catch (n) {
    n && console.log(n);
  }
}, Ep = (e) => {
  try {
    let t = [], r = [];
    return ge().status && e && (t = e == null ? void 0 : e.filter((n) => n.type == "match").map((n) => n.type_id), r = e == null ? void 0 : e.filter((n) => n.type == "league").map((n) => n.type_id)), { lockedMatchIds: t, lockedLeagueIds: r };
  } catch (t) {
    t && console.log(t);
  }
}, YO = (e, t, r) => {
  try {
    let s = Ep(r), i = s.lockedMatchIds, o = s.lockedLeagueIds;
    for (var n = 0; n < (e == null ? void 0 : e.length); n++)
      Rr(e[n].sport_id) && hn(e[n].event_id, e[n].league_id, i, o) && (e[n].sport_id == 4 ? t["cricket/4"].matches.push(e[n]) : e[n].sport_id == 1 ? t["soccer/1"].matches.push(e[n]) : e[n].sport_id == 2 ? t["tennis/2"].matches.push(e[n]) : (t[`${e[n].sport_name}/${e[n].sport_id}`] || (t[`${e[n].sport_name}/${e[n].sport_id}`] = { matches: [], filterKey: [] }), t[`${e[n].sport_name}/${e[n].sport_id}`].matches.push(e[n])));
    return { matchesObj: t };
  } catch (s) {
    s && console.log(s);
  }
}, GO = (e, t, r) => {
  try {
    let s = Ep(eventManage), i = s.lockedMatchIds, o = s.lockedLeagueIds;
    for (var n = 0; n < e.length; n++)
      Rr(e[n].sport_id) && hn(e[n].matchId, e[n].league_id, i, o) && (e[n].sport_id == 4 ? t.Cricket.push(e[n]) : e[n].sport_id == 1 ? t.Football.push(e[n]) : e[n].sport_id == 2 ? t.Tennis.push(e[n]) : (t[e[n].sport_name] || (t[e[n].sport_name] = []), t[e[n].sport_name].push(e[n])), r[e[n].market_id] = e[n].runners ?? []);
    Object.entries(e).length && (socketService.emit("sub", "inplay.markets"), socketService.on("inplay.markets", (a) => {
      for (let l in a) {
        let u = e[l], c = a[l];
        if (!u) return;
        if (c != null && c.runners)
          for (let d of c.runners) {
            let f = u.find((g) => g.sid == d.sid);
            f && (d.ex.b && (f.ex.b = d.ex.b), d.ex.l && (f.ex.l = d.ex.l));
          }
      }
    }));
  } catch (s) {
    s && console.log(s);
  }
}, WO = ({ matches: e, filterKey: t }) => !t || !Array.isArray(t) || t.length === 0 ? e : e.filter((r) => {
  const n = r.isMatchLive || r.inplay, s = r.is_exclusive;
  return t.includes("live") && t.includes("virtual") ? n || s : t.includes("live") ? n && !s : t.includes("virtual") ? s : !0;
}), qO = (e) => ({
  isAffiliate() {
    var t;
    return (t = e.bonusData) == null ? void 0 : t.find((r) => (r == null ? void 0 : r.bonusType) == "affiliate bonus");
  }
}), UT = (e) => {
  try {
    let t = [], r = [];
    return ge().status && e && (t = e == null ? void 0 : e.filter((n) => n.type == "match").map((n) => n.type_id), r = e == null ? void 0 : e.filter((n) => n.type == "league").map((n) => n.type_id)), { lockedMatchIds: t, lockedLeagueIds: r };
  } catch (t) {
    t && console.log(t);
  }
}, KO = async (e) => {
  var t;
  try {
    let r = {}, n = await $("get", "MATCHES_BY_SPORT_ID", null, "sports", { sport_id: e });
    return n && n.status == 200 ? (r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.data, { allData: r }) : { allData: r };
  } catch (r) {
    r && m(r);
  }
}, zO = (e, t, r) => {
  try {
    let n = UT(r), s = n.lockedMatchIds, i = n.lockedLeagueIds;
    return e = t.filter((o) => {
      var a;
      return Rr(o.sport_id) && hn(o.event_id, o.league_id, s, i) ? ((a = o.runners) == null || a.forEach((l) => {
        var c;
        const u = (c = o.runnerNames) == null ? void 0 : c.find((d) => d.SID === l.sid);
        u && (l.runner_name = u.RN);
      }), !0) : !1;
    }), e;
  } catch (n) {
    return console.log(n), [];
  }
}, JO = async (e) => {
  var t;
  try {
    let r = {
      match_id: e.event_id ?? e.eventId,
      game_type: 0
    }, n = await $("post", "MAKE_FAVOURITE", r);
    if ((n == null ? void 0 : n.status) == 200) {
      e.favourite = !e.favourite;
      let s = [...O.getters.favouriteGames];
      const i = Number(e.event_id ?? e.eventId);
      return s.includes(i) ? s = s.filter((o) => o != i) : s.push(Number(i)), O.dispatch("setFavouriteGames", s), _e((t = n == null ? void 0 : n.data) == null ? void 0 : t.success), n;
    }
  } catch (r) {
    r && m(r);
  }
}, XO = (e) => ({
  t1FilteredMatchList() {
    var t, r, n;
    return (t = e == null ? void 0 : e.selectedFilters) != null && t.includes("live") && ((r = e == null ? void 0 : e.selectedFilters) != null && r.includes("virtual")) ? e == null ? void 0 : e.matches_list : (n = e == null ? void 0 : e.matches_list) == null ? void 0 : n.filter(
      (s) => {
        var i, o;
        return (i = e == null ? void 0 : e.selectedFilters) != null && i.includes("live") ? !s.is_exclusive : (o = e == null ? void 0 : e.selectedFilters) != null && o.includes("virtual") ? s.is_exclusive : !0;
      }
    );
  }
}), HT = () => {
  var e, t, r, n, s;
  try {
    let i = [], o = [];
    return ge().status && ((e = O == null ? void 0 : O.getters) != null && e.eventManage) && (i = (r = (t = O == null ? void 0 : O.getters) == null ? void 0 : t.eventManage) == null ? void 0 : r.filter((a) => a.type == "match").map((a) => a.type_id), o = (s = (n = O == null ? void 0 : O.getters) == null ? void 0 : n.eventManage) == null ? void 0 : s.filter((a) => a.type == "league").map((a) => a.type_id)), { lockedMatchIds: i, lockedLeagueIds: o };
  } catch (i) {
    i && console.log(i);
  }
}, QO = (e) => {
  let t = HT(), r = t.lockedMatchIds, n = t.lockedLeagueIds;
  var s = { matches: [], filterKey: [] }, i = { matches: [], filterKey: [] }, o = { matches: [], filterKey: [] };
  let a = {}, l = {};
  for (var u = 0; u < e.length; u++)
    Rr(e[u].sport_id) && hn(e[u].event_id, e[u].league_id, r, n) && (e[u].sport_id == 4 ? s.matches.push(e[u]) : e[u].sport_id == 1 ? i.matches.push(e[u]) : e[u].sport_id == 2 ? o.matches.push(e[u]) : (l[e[u].sport_name] || (l[e[u].sport_name] = {
      matches: [],
      filterKey: []
    }), l[e[u].sport_name].matches.push(e[u])));
  return s.matches.length > 0 && (a.Cricket = s), i.matches.length > 0 && (a.Soccer = i), o.matches.length > 0 && (a.Tennis = o), { allMatches: a, allsecondaryMatches: l };
}, ru = (e, t) => {
  var r;
  return t ? (r = Object.keys(e)) == null ? void 0 : r.reduce((n, s) => ((s == null ? void 0 : s.toLowerCase()) === (t == null ? void 0 : t.toLowerCase()) && (n[s] = e[s]), n), {}) : e;
}, ZO = (e) => ({
  t5SportsMenu() {
    var t, r, n, s, i;
    return [...(r = (t = e == null ? void 0 : e.sportList) == null ? void 0 : t.non_custom) == null ? void 0 : r.filter((o) => [1, 2, 3, 4].includes(o.rank)), ...(s = (n = e == null ? void 0 : e.sportList) == null ? void 0 : n.non_custom) == null ? void 0 : s.filter((o) => ![1, 2, 3, 4].includes(o.rank)), ...(i = e == null ? void 0 : e.sportList) == null ? void 0 : i.custom];
  },
  t5FilteredMathces() {
    var r, n;
    const t = { ...e == null ? void 0 : e.allMatches, ...e == null ? void 0 : e.allsecondaryMatches };
    if (((r = e == null ? void 0 : e.searchKey) == null ? void 0 : r.length) > 2) {
      const s = new Set((n = e == null ? void 0 : e.searchMatchResult) == null ? void 0 : n.map((o) => o.event_id)), i = Object.fromEntries(
        Object.entries(t).map(([o, a]) => {
          const l = a.matches.filter(
            (u) => s.has(u.event_id)
          );
          return [o, { ...a, matches: l }];
        }).filter(([o, a]) => a.matches.length > 0)
      );
      return ru(i, e == null ? void 0 : e.selectedSport);
    } else
      return ru(t, e == null ? void 0 : e.selectedSport);
  }
}), eA = {
  methods: {
    callCashout() {
      clearTimeout(this.cashoutTimeOut);
      for (let e in this.cashoutMarketData) {
        let t = this.cashoutMarketData[e], r;
        if (t.type == "market") {
          if (r = this.matchOddsData.find((i) => i.mid == e), !r) continue;
        } else if (r = this.bookmakerData.ml.find((i) => i.mi == e), !r) continue;
        let { value: n, bet: s } = this.getCashoutValue(r, t.type);
        t.value = n, t.bet = s;
      }
      this.cashoutTimeOut = setTimeout(() => {
        this.callCashout();
      }, 2e3);
    },
    calculateCashoutStake(e) {
      if (e.book) {
        let t = e.book.sort((l, u) => l.pl - u.pl), r = t[0], n = t[1];
        r.pl = parseFloat(r.pl).toFixed(2), n.pl = parseFloat(n.pl).toFixed(2);
        let s, i, o, a;
        return s = -1, a = r.back_odds, s == 1 ? (i = (n.pl - r.pl) / a, o = {
          run1: parseFloat(r.pl) + i,
          run2: parseFloat(n.pl) + -1 * ((a - 1) * 100 * i) / 100
        }) : s == -1 && (i = (n.pl - r.pl) / a, o = {
          run1: parseFloat(r.pl) + i * ((a - 1) * 100) / 100,
          run2: parseFloat(n.pl) - i
        }), [{ ...r, betOdds: a, betType: s, betStake: i, cashoutStake: o }];
      }
    },
    calculateAlternateCashoutStake(e) {
      let t = e.sort((l, u) => u.pl - l.pl), r = t[0], n = t[1], s = -1, i, o, a;
      return a = n.back_odds, i = (r.pl - n.pl) / a, o = {
        run1: parseFloat(r.pl) - i,
        run2: parseFloat(n.pl) + n.back_odds * i - i
      }, [{ ...n, betOdds: a, betType: s, betStake: i, cashoutStake: o }];
    },
    calculateCashoutStakeForBookmaker(e) {
      if (e.book) {
        let t = e.book.sort((c, d) => c.pl - d.pl), r = t[0], n = t[1];
        r.pl = parseFloat(r.pl).toFixed(2), n.pl = parseFloat(n.pl).toFixed(2);
        let s, i, o, a, l = r;
        if (e.unavailableRunners == 1)
          r.ss == "SUSPEND" ? (s = 1, a = n.lay_odds, l = n) : (s = -1, a = r.back_odds);
        else if (!e.unavailableRunners)
          s = -1, a = r.back_odds;
        else
          return null;
        s == 1 ? (i = (n.pl - r.pl) / a, o = {
          run1: parseFloat(r.pl) + i,
          run2: parseFloat(n.pl) + -1 * ((a - 1) * 100 * i) / 100
        }) : s == -1 && (i = (n.pl - r.pl) / a, o = {
          run1: parseFloat(r.pl) + i * ((a - 1) * 100) / 100,
          run2: parseFloat(n.pl) - i
        });
        let u = parseFloat(((a - 1) * 100).toFixed(2));
        return [{ ...l, betOdds: a, betType: s, betStake: i, cashoutStake: o, realBetOdds: u }];
      }
    },
    getBook(e, t) {
      var r, n, s, i, o, a, l, u;
      try {
        if (t == "market") {
          if (this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook.length) {
            let c = (r = this.marketBookAndExposure.marketsBook.find((d) => d.id == e.mid)) == null ? void 0 : r.runner_book;
            if (c = Object.create(c), c)
              if (e.marketName == "Who Will Win The Match?") {
                for (let d = 0; d < c.length; d++)
                  for (let f = 0; f < e.runners.length; f++)
                    c[d].selection_id == e.runners[f].sid && (c[d] = {
                      ...c[d],
                      back_odds: (s = (n = e.runners[f].ex.b) == null ? void 0 : n[0]) == null ? void 0 : s.p,
                      lay_odds: 0,
                      sid: e.runners[f].sid,
                      s: e.runners[f].s,
                      runner_index: f
                    });
                return this.calculateAlternateCashoutStake(c);
              } else {
                let d = 0;
                for (let g = 0; g < c.length; g++)
                  for (let _ = 0; _ < e.runners.length; _++)
                    c[g].selection_id == e.runners[_].sid && (c[g] = {
                      ...c[g],
                      back_odds: (o = (i = e.runners[_].ex.b) == null ? void 0 : i[0]) == null ? void 0 : o.p,
                      lay_odds: (l = (a = e.runners[_].ex.l) == null ? void 0 : a[0]) == null ? void 0 : l.p,
                      sid: e.runners[_].sid,
                      s: e.runners[_].s,
                      runner_index: _
                    }, !d && (!c[g].back_odds || !c[g].lay_odds || e.runners[_].s != "ACTIVE") && (d = !0));
                if (d)
                  return null;
                let f = {
                  book: c
                };
                return this.calculateCashoutStake(f);
              }
            else return null;
          }
        } else if (t == "bookmaker" && this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook.length) {
          let c = (u = this.marketBookAndExposure.bookmakersBook.find((d) => d.id == e.mi)) == null ? void 0 : u.runner_book;
          if (!c || c.length == 3)
            return null;
          if (e.mn == "TOSS") {
            for (let f = 0; f < c.length; f++)
              for (let g = 0; g < e.sl.length; g++)
                c[f].selection_id == e.sl[g].si && (c[f] = {
                  ...c[f],
                  back_odds: e.sl[g].ss !== "ACTIVE" || e.sn !== "ONLINE" ? 0 : e.sl[g].b / 100 + 1,
                  lay_odds: e.sl[g].l,
                  si: e.sl[g].si,
                  ss: e.sl[g].ss,
                  runner_index: g
                });
            let d = {
              book: c,
              unavailableRunners: 0
            };
            return this.calculateCashoutStakeForBookmaker(d);
          } else {
            let d = 0;
            for (let g = 0; g < c.length; g++)
              for (let _ = 0; _ < e.sl.length; _++)
                c[g].selection_id == e.sl[_].si && ((e.sl[_].ss !== "ACTIVE" || e.sn !== "ONLINE") && (d += 1), c[g] = {
                  ...c[g],
                  back_odds: e.sl[_].ss !== "ACTIVE" || e.sn !== "ONLINE" ? 0 : e.sl[_].b / 100 + 1,
                  lay_odds: e.sl[_].ss !== "ACTIVE" || e.sn !== "ONLINE" ? 0 : e.sl[_].l / 100 + 1,
                  si: e.sl[_].si,
                  ss: e.sl[_].ss,
                  runner_index: _
                });
            let f = {
              book: c,
              unavailableRunners: d
            };
            return this.calculateCashoutStakeForBookmaker(f);
          }
        }
      } catch (c) {
        console.log("=====", c);
      }
    },
    getCashoutValue(e, t) {
      var r;
      try {
        let n = this.getBook(e, t)[0], s = {
          match_id: this.eventDetails.matchId,
          sport_id: this.eventDetails.sportId,
          event_id: this.eventDetails.eventId,
          selection_type: n.betType && n.betType == 1 ? "lay" : "back",
          bet_type: t,
          bet_delay: t == "bookmaker" ? e.bd || 0 : e.bet_delay || 0,
          runner_index: n.runner_index,
          market_id: t == "bookmaker" ? e.mi : e.mid,
          runner_name: n.name,
          runner_selection_id: n.selection_id,
          odds: t == "bookmaker" ? n.realBetOdds : n.betOdds,
          stake: n.betStake.toFixed(2),
          bet_id: this.$dateTime.currentTimestamp(),
          userId: this.$auth.user.userid,
          accept_any_odds: 0,
          is_cashout: !0,
          ...this.isPool && { pool_id: (r = this.chosenPool) == null ? void 0 : r.id }
        };
        return { value: this.chashOutRunnerBook(n), bet: s };
      } catch {
        return { value: null, bet: null };
      }
    },
    // chashOutRunnerBook(betData) {
    //     if (betData) {
    //         let finalBetStake = betData.cashoutStake?.run1;
    //         if (finalBetStake >= 0) {
    //             return '<span class="cashout back-win"><img class="back-win-icon" src="/images/dot-icon.svg" alt="arow-down">&nbsp' + parseFloat(finalBetStake).toFixed(2) + '</span>';
    //         } else {
    //             return '<span class="cashout lay-loss"><img class="lay-loss-icon" src="/images/red-dot.svg" alt="lay-loss-icon">&nbsp' + ((-1) * parseFloat(finalBetStake).toFixed(2)) + '</span>';
    //         }
    //     }
    // },
    cashoutServiceCall(e, t, r) {
      this.cashoutDetails.market = e, this.cashoutDetails.type = t, this.cashoutDetails.bet = r, this.cashoutSlipCloseTime = setTimeout(() => {
        this.CashoutLoader || this.$helper.closeModal("cashout");
      }, 1e4);
    }
  }
}, tA = {
  data() {
    return {
      shouldShowMainMarket: !1,
      selectedPool: null,
      pools: null
    };
  },
  computed: {
    chosenPool() {
      return this.selectedPool;
    }
  },
  provide() {
    return {
      pools: np(() => this.pools)
    };
  },
  methods: {
    getPools(e = null) {
      var t;
      this.$store.dispatch("setGlobalLoader", !0), this.$apiCall("get", "GET_POOLS", null, "pool", { match_id: (t = this.eventDetails) == null ? void 0 : t.matchId }).then((r) => {
        var n, s, i, o, a, l;
        if ((r == null ? void 0 : r.status) === 200 && ((s = (n = r == null ? void 0 : r.data) == null ? void 0 : n.data) != null && s.length)) {
          this.pools = (i = r == null ? void 0 : r.data) == null ? void 0 : i.data, this.pools.forEach((d) => {
            d.winning_limit = JSON.parse(d.winning_limit);
          });
          const u = (o = this.$route.query.poolAmount) == null ? void 0 : o.toString(), c = u ? this.pools.find((d) => d.entry_fees.toString() == u) : e ? (a = this.pools) == null ? void 0 : a.find((d) => (d == null ? void 0 : d.id) == (e == null ? void 0 : e.id)) : (l = this.pools) == null ? void 0 : l[0];
          return this.$store.dispatch("setGlobalLoader", !1), this.handlePoolSelection(c);
        } else
          throw this.pools = null, this.$store.dispatch("setGlobalLoader", !1), new Error("No pool data found or invalid response structure.");
      }).catch((r) => {
        this.$store.dispatch("setGlobalLoader", !1), this.$errorToast("Error fetching pools:", r, ". Please Try Again"), this.pools = null;
      });
    },
    async changeSelectedPool(e) {
      try {
        await new Promise((t) => {
          this.selectedPool = e, t();
        });
      } catch (t) {
        console.log("error", t), this.$errorToast("Error in Changing The SelectedPool:", t, ".Please Try Again");
      }
    },
    async handlePoolSelection(e) {
      var t, r, n;
      try {
        await this.changeSelectedPool(e), (t = this.$auth) != null && t.status && ((r = this.chosenPool) != null && r.is_joined) && (this.getEventExposures(), await ((n = this.$refs.poolZone) == null ? void 0 : n.getPoolWallet()));
      } catch (s) {
        console.log(s), this.$errorToast("Error Handling The pool:", s, ".Please Try Again");
      }
    }
  }
}, rA = async (e) => {
  var s, i;
  try {
    let o = null, a = null, l = null, u = await $("get", "GET_MATCH_DETAILS", null, "sports", { event_id: e });
    if (u && u.status == 200) {
      if ((s = u == null ? void 0 : u.data) != null && s.error)
        m(u.data.error);
      else {
        kt.emit("sub", e), o = u.data.data.match, l = u.data.data.upcoming, a = o == null ? void 0 : o.matchOddData.sort((d, f) => d.marketName.localeCompare(f.marketName));
        for (var t = 0; t < a.length; t++)
          for (var r = 0; r < a[t].runners.length; r++)
            for (var n = 0; n < a[t].runnerName.length; n++)
              a[t].runners[r].sid == a[t].runnerName[n].SID && (a[t].runners[r].runner_name = a[t].runnerName[n].RN);
        let c = O.getters.favouriteGames;
        ge().status && (c != null && c.length) && c.includes(parseInt(o.eventId)) ? o.favourite = !0 : o.favourite = !1;
      }
      return { data: o, matchOddsData: a, upcoming: l };
    }
  } catch (o) {
    o && (m(((i = o == null ? void 0 : o.data) == null ? void 0 : i.message) || "404 Not Found"), window.router.push({ name: "Home" }));
  }
}, nA = async (e, t, r) => {
  var n;
  try {
    const s = {
      matchId: e == null ? void 0 : e.eventId
    };
    r && Object.assign(s, {
      pool_id: t,
      match_id: e == null ? void 0 : e.matchId
    });
    let i = null, o = await $("get", "GET_EVENT_EXPOSURES", null, r ? "pool" : "user", s);
    if (o && o.status == 200)
      return (n = o == null ? void 0 : o.data) != null && n.error ? m(o.data.error) : i = o.data, { data: i };
  } catch (s) {
    s && m(s);
  }
}, sA = async (e, t) => {
  var r, n, s;
  try {
    let i = {
      event_id: e.eventId
    }, o = null, a = await $("post", "GET_OPEN_BETS", i, "user", { page: t });
    if (a && a.status == 200)
      return (r = a == null ? void 0 : a.data) != null && r.error ? m(a.data.error) : o = (s = (n = a == null ? void 0 : a.data) == null ? void 0 : n.bets) == null ? void 0 : s.sort((l, u) => u.bet_timestamp_date - l.bet_timestamp_date), { data: o };
  } catch (i) {
    m(i[0]);
  }
}, iA = async (e, t, r) => {
  var n;
  try {
    let s = {
      type: t ? t.type : "markets",
      ...!t && { event_id: r || null },
      match_id: t == null ? void 0 : t.match_id
    }, i = null, o = await $("post", e, s, "user");
    if (o && o.status == 200)
      return (n = o == null ? void 0 : o.data) != null && n.error ? m(o.data.error) : i = o.data, { data: i };
  } catch (s) {
    s && m(s);
  }
}, oA = async (e) => {
  var t;
  try {
    if (FT("premium-fancy")) {
      let r = {
        type: "premium"
      }, { sport_radar_sport_id: n, sportsradar_id: s, sportId: i, eventId: o } = e, a = {
        sportId: n ? `sr:sport:${n}` : i,
        eventId: n ? `sr:match:${s}` : o
      }, l = null, u = await $("post", "GET_THIRD_PARTY_API", r, "user", a);
      if (u && u.status == 200)
        return (t = u == null ? void 0 : u.data) != null && t.error ? m(u.data.error) : l = u.data.url, { data: l };
    }
  } catch (r) {
    m(r);
  }
}, aA = async (e, t, r, n, s) => {
  var i;
  try {
    if (!ge().status || !(e && (e != null && e.fancyExposures) && (e != null && e.fancyExposures.length)) || (e == null ? void 0 : e.fancyExposures.findIndex((c) => c.id == r.mi)) < 0) return;
    let a = {
      id: r.mi,
      event_id: t.eventId,
      fancy_market_id: r.cat == "odd_even_markets" ? 4 : 1
    };
    n && Object.assign(a, {
      pool_id: s,
      match_id: t == null ? void 0 : t.matchId
    });
    let l = null, u = await $("post", "GET_FANCY_BOOK", a, n ? "pool" : "user");
    if (u && u.status == 200)
      return (i = u == null ? void 0 : u.data) != null && i.error ? m(u.data.error) : l = u.data.book, { data: l };
  } catch (o) {
    m(o);
  }
}, lA = async ({ market: e, runner: t, selection_type: r, bet_type: n, r_index: s, betDetails: i, eventDetails: o, logInModalId: a = null }) => {
  var l, u;
  try {
    if (i && i.betLoader) return;
    if ((l = ge()) != null && l.status) {
      let c = (u = ge()) == null ? void 0 : u.user;
      if (!e || (n == "market" || n == "bookmaker") && !t || n == "market" && (e && e.st != "OPEN" || t && t.s != "ACTIVE") || n == "bookmaker" && (e && e.sn != "ONLINE" || t && t.ss != "ACTIVE") || n == "fancy" && e.sn != "ONLINE" && e.sn != "ACTIVE") {
        m("market-not-active", "Market is not active!");
        return;
      }
      jT(e, n, o.eventId), i = {}, i.match_id = o.matchId, i.min_stake = n == "fancy" || n == "bookmaker" ? e.mins : e.min_stake_limit ? e.min_stake_limit : 100, i.max_stake = n == "fancy" || n == "bookmaker" ? e.ms : e.stake_limit ? e.stake_limit : 2e3, i.sport_id = o.sportId, i.eventId = o.eventId, i.selection_type = r, i.bet_type = n, i.bet_delay = n == "fancy" || n == "bookmaker" ? e.bd || 0 : e.bet_delay || 0, i.accept_any_odds = c.accept_any_odds === void 0 ? !1 : c.accept_any_odds, i.market = e, i.runner = t, i.rIndex = s, i.bet_time = Math.round(Date.now() / 1e3), i.bet_delay = n == "fancy" || n == "bookmaker" ? e.bd || 0 : e.bet_delay || 0, i.bet_type == "market" ? (i.market_id = e.mid, i.runner_name = t.runner_name, i.runner_selection_id = t.sid, i.odds = t.ex && t.ex[r == "back" ? "b" : "l"] && t.ex[r == "back" ? "b" : "l"][0] ? t.ex[r == "back" ? "b" : "l"][0].p : "", i.screen_odds = t.ex && t.ex[r == "back" ? "b" : "l"] && t.ex[r == "back" ? "b" : "l"][0] ? t.ex[r == "back" ? "b" : "l"][0].p : "") : i.bet_type == "bookmaker" ? (i.market_id = e.mi, i.runner_name = t.sln, i.runner_selection_id = t.si, i.odds = t[r == "back" ? "b" : "l"], i.screen_odds = t[r == "back" ? "b" : "l"]) : (i.runner_name = e.mn, i.market_id = e.mi, i.runner_selection_id = e.mi, i.odds = e[r == "back" ? "ry" : "rn"], i.screen_odds = e[r == "back" ? "ry" : "rn"], i.bhav = e.cat == "line_markets" ? 100 : e[r == "back" ? "oy" : "on"]);
    } else {
      a ? Le.openModal(a) : m("Please login to place the bets");
      return;
    }
    return { data: i };
  } catch (c) {
    m(c);
  }
}, jT = async (e, t, r) => {
  var n;
  try {
    let s = { ...(n = ge()) == null ? void 0 : n.user }, i = { ...s.betslipCount && s.betslipCount.eventId == r ? s.betslipCount : { eventId: r } }, o = {
      exp: Math.round(Date.now() / 1e3) + 180
      // 180 seconds for 3 minutes
    };
    t === "market" ? (i[e.mid] = i[e.mid] || [], i[e.mid].push(o)) : (t === "bookmaker" || t === "fancy") && (i[e.mi] = i[e.mi] || [], i[e.mi].push(o)), O.dispatch("setUser", { ...s, betslipCount: i });
  } catch (s) {
    m(s);
  }
}, cA = async ({
  cashout: e,
  betDetails: t,
  cashoutDetails: r,
  isPool: n,
  chosenPoolId: s,
  betCloseSetTimeOut: i,
  marketBookAndExposure: o,
  CashoutLoader: a,
  resetTimer: l,
  startTimer: u,
  cancelBetSlip: c,
  initalizeCashout: d
}) => {
  var f, g, _;
  try {
    if ((!t.stake || !t.odds) && !e)
      if (t.stake) {
        m("Odds field is required!");
        return;
      } else {
        m("Stake field is required!");
        return;
      }
    if (t.stake < t.min_stake || t.stake > t.max_stake)
      return m(`Stake value should be between ${t.min_stake} to ${t.max_stake} value.`);
    if (t.accept_any_odds || (t.accept_any_odds = 0), t.betLoader)
      return;
    let p = (f = ge()) == null ? void 0 : f.user, y = (g = p == null ? void 0 : p.betslipCount) == null ? void 0 : g[t.market_id], b = Math.round(Date.now() / 1e3);
    if (y && y.length) {
      for (let D = 0; D < y.length; D++)
        y[D].exp < b && y.splice(D, 1);
      y.length > 2 && (t.slip_count = y.length);
    }
    t.bet_user_guid = Math.random().toString(36), t.betLoader = !0;
    let A = YT(e, t, r, n, s);
    clearInterval(i), typeof u == "function" && u();
    let v = await $("post", "SAVE_BETS", { data: A });
    if (v && v.status == 200) {
      if (clearInterval(l), e && (a = !1, Le.closeModal("cashout")), (_ = v == null ? void 0 : v.data) != null && _.error) {
        t.betLoader = !1, typeof c == "function" && c(), m(v.data.error);
        return;
      } else {
        if (A.bet_type == "market") {
          if (o && o.marketsBook && o.marketsBook.length) {
            let D = o.marketsBook.find((w) => w.id == A.market_id);
            D ? (D.requiredCashout = !e, D.runner_book = v.data.runner_book) : o.marketsBook.push({
              id: A.market_id,
              requiredCashout: !e,
              runner_book: v.data.runner_book
            });
          } else
            o = {
              marketsBook: [{
                requiredCashout: !e,
                id: A.market_id,
                runner_book: v.data.runner_book
              }]
            };
          typeof d == "function" && d();
        } else if (A.bet_type == "bookmaker") {
          if (o && o.bookmakersBook && o.bookmakersBook.length) {
            let D = o.bookmakersBook.find((w) => w.id == A.market_id);
            D ? (D.requiredCashout = !e, D.runner_book = v.data.runner_book) : o.bookmakersBook.push({
              id: A.market_id,
              requiredCashout: !e,
              runner_book: v.data.runner_book
            });
          } else
            o = {
              bookmakersBook: [{
                requiredCashout: !e,
                id: A.market_id,
                runner_book: v.data.runner_book
              }]
            };
          typeof d == "function" && d();
        } else if (o && o.fancyExposures && o.fancyExposures.length || (o.fancyExposures = []), o && o.fancyExposures) {
          let D = o.fancyExposures.findIndex((w) => w.id == A.market_id);
          D >= 0 ? o.fancyExposures[D].exposures = v.data.exposures : o.fancyExposures.push({
            id: A.market_id,
            exposures: v.data.exposures
          });
        }
        p.exposure = v.data.total_exposure, p.betslipCount[t.market_id] = [], O.dispatch("setUser", p), typeof c == "function" && c(), _e(v.data.success), t.betLoader = !1;
      }
      return { data: v, CashoutLoader: a };
    } else
      clearInterval(l), m(v.data.success), typeof c == "function" && c();
  } catch (p) {
    t.betLoader = !1, clearInterval(l), e && (Le.closeModal("cashout"), a = !1), p && (Array.isArray(p) ? m(p[0]) : p.data.error ? m(p.data.error) : m(p)), typeof c == "function" && c();
  }
}, YT = (e, t, r, n, s) => {
  var i, o;
  return e ? r.bet : {
    match_id: t.match_id,
    sport_id: t.sport_id,
    event_id: t.eventId,
    selection_type: t.selection_type,
    bet_type: t.bet_type,
    bet_delay: t.bet_delay,
    runner_index: t.rIndex,
    market_id: t.market_id,
    runner_name: t.runner_name,
    runner_selection_id: t.runner_selection_id,
    odds: t.odds,
    stake: t.stake,
    bet_id: Te.currentTimestamp(),
    userId: (o = (i = ge()) == null ? void 0 : i.user) == null ? void 0 : o.userid,
    accept_any_odds: t.accept_any_odds,
    bhav: t.bhav,
    slip_count: t.slip_count,
    is_cashout: !1,
    screen_odds: t.screen_odds,
    ...n && { pool_id: s }
  };
}, uA = async () => {
  var e;
  try {
    let t = await ((e = ge()) == null ? void 0 : e.user);
    t.accept_any_odds === void 0 ? t.accept_any_odds = !0 : t.accept_any_odds ? t.accept_any_odds = !1 : t.accept_any_odds = !0, O.dispatch("setUser", t);
  } catch (t) {
    m(t);
  }
}, dA = (e, t) => {
  try {
    if (e.betLoader) return;
    var r = 0;
    parseFloat(e.odds).toFixed(2) > 1 && parseFloat(e.odds).toFixed(2) < 2 ? r = 0.01 : parseFloat(e.odds).toFixed(2) >= 2 && parseFloat(e.odds).toFixed(2) < 3 ? r = 0.02 : parseFloat(e.odds).toFixed(2) >= 3 && parseFloat(e.odds).toFixed(2) < 4 ? r = 0.05 : parseFloat(e.odds).toFixed(2) >= 4 && parseFloat(e.odds).toFixed(2) < 6 ? r = 0.1 : parseFloat(e.odds).toFixed(2) >= 6 && parseFloat(e.odds).toFixed(2) < 10 ? r = 0.2 : parseFloat(e.odds).toFixed(2) >= 10 && parseFloat(e.odds).toFixed(2) < 20 ? r = 0.5 : parseFloat(e.odds).toFixed(2) >= 20 && parseFloat(e.odds).toFixed(2) < 30 ? r = 1 : parseFloat(e.odds).toFixed(2) >= 30 && parseFloat(e.odds).toFixed(2) < 50 ? r = 2 : parseFloat(e.odds).toFixed(2) >= 50 && parseFloat(e.odds).toFixed(2) < 100 ? r = 5 : parseFloat(e.odds).toFixed(2) >= 100 && (r = 10), e.odds > 0 && (e.odds = (parseFloat(e.odds) + r).toFixed(2), Ai(e, t));
  } catch (n) {
    m(n);
  }
}, fA = (e, t) => {
  try {
    if (e.betLoader) return;
    var r = 0;
    parseFloat(e.odds).toFixed(2) > 1 && parseFloat(e.odds).toFixed(2) < 2 ? r = 0.01 : parseFloat(e.odds).toFixed(2) >= 2 && parseFloat(e.odds).toFixed(2) < 3 ? r = 0.02 : parseFloat(e.odds).toFixed(2) >= 3 && parseFloat(e.odds).toFixed(2) < 4 ? r = 0.05 : parseFloat(e.odds).toFixed(2) >= 4 && parseFloat(e.odds).toFixed(2) < 6 ? r = 0.1 : parseFloat(e.odds).toFixed(2) >= 6 && parseFloat(e.odds).toFixed(2) < 10 ? r = 0.2 : parseFloat(e.odds).toFixed(2) >= 10 && parseFloat(e.odds).toFixed(2) < 20 ? r = 0.5 : parseFloat(e.odds).toFixed(2) >= 20 && parseFloat(e.odds).toFixed(2) < 30 ? r = 1 : parseFloat(e.odds).toFixed(2) >= 30 && parseFloat(e.odds).toFixed(2) < 50 ? r = 2 : parseFloat(e.odds).toFixed(2) >= 50 && parseFloat(e.odds).toFixed(2) < 100 ? r = 5 : parseFloat(e.odds).toFixed(2) >= 100 && (r = 10), e.odds > 0 && (e.odds = (parseFloat(e.odds) - r).toFixed(2), Ai(e, t));
  } catch (n) {
    m(n);
  }
}, Ai = (e, t) => {
  try {
    if (e.pl = 0, e.bet_type == "bookmaker" ? e.pl = e.odds / 100 * (e.stake ?? 0) : e.bet_type == "market" ? e.pl = e.odds * (e.stake ?? 0) - (e.stake ?? 0) : e.pl = (e.stake ?? 0) * e.bhav / 100, e.bet_type == "fancy") return;
    GT(e, t);
  } catch (r) {
    m(r);
  }
}, GT = (e, t) => {
  try {
    e.runner_books = {};
    let n = [];
    if (e.bet_type == "market") {
      t && t.marketsBook && t.marketsBook.length ? (n = t.marketsBook.find((s) => s.id == e.market_id), n ? n = n.runner_book : n = e.market.runners) : n = e.market.runners;
      for (let s of n)
        e.runner_books[s.sid ? s.sid : s.selection_id] = s.pl ? s.pl : 0;
    } else if (e.bet_type == "bookmaker") {
      t && t.bookmakersBook && t.bookmakersBook.length ? (n = t.bookmakersBook.find((s) => s.id == e.market_id), n ? n = n.runner_book : n = e.market.sl) : n = e.market.sl;
      for (let s of n)
        e.runner_books[s.si ? s.si : s.selection_id] = s.pl ? s.pl : 0;
    }
    for (var r of Object.keys(e.runner_books))
      e.runner_books[r] = parseFloat(e.runner_books[r]), e.runner_selection_id == r ? e.selection_type == "back" ? e.runner_books[r] += parseFloat(e.pl) : e.runner_books[r] -= parseFloat(e.pl) : e.selection_type == "back" ? e.runner_books[r] -= parseFloat(e.stake ?? 0) : e.runner_books[r] += parseFloat(e.stake ?? 0);
  } catch (n) {
    m(n);
  }
}, pA = (e, t) => {
  e && e.betLoader || (e.stake = 0, Ai(e, t));
}, hA = (e, t, r, n) => {
  r.betLoader || (t ? r.stake = parseFloat(e) : r.stake = +(r.stake ? r.stake : 0) + parseFloat(e), WT(r), Ai(r, n));
}, WT = (e) => {
  var t = e.stake;
  t !== "" && parseInt(t) > e.max_stake && (e.stake = e.max_stake);
}, gA = (e, t) => {
  var r, n;
  try {
    let s = (r = ge()) == null ? void 0 : r.user;
    if (!((n = ge()) != null && n.status) || !s) {
      m("Please login to pin fancy!");
      return;
    }
    s.pinnedFancies ? s.pinnedFancies.includes(e.mi) ? (s.pinnedFancies.splice(s.pinnedFancies.indexOf(e.mi), 1), _e("Removed from Pin Fancy Market!")) : (s.pinnedFancies.push(e.mi), _e("Added this fancy under Pin Fancy Market")) : (s.pinnedFancies = [], s.pinnedFancies.push(e.mi), _e("Added this fancy under Pin Fancy Market")), t = s.pinnedFancies, O.dispatch("setUser", s);
  } catch (s) {
    m(s);
  }
}, _A = (e, t) => {
  try {
    return e ? t = JSON.parse(JSON.stringify([...O.getters.clickBetValue])) : t = [
      {
        value: 1e3,
        isSelected: !0
      },
      {
        value: 2e3,
        isSelected: !1
      },
      {
        value: 3e3,
        isSelected: !1
      },
      {
        value: 4e3,
        isSelected: !1
      }
    ], { data: t };
  } catch (r) {
    m(r);
  }
}, mA = (e, t) => {
  try {
    for (let r of e)
      if (!(r.value <= 5e3 && r.value >= 100)) {
        m("Value should be in between 100 to 5000.");
        return;
      }
    if (qT(e)) {
      m("repeated-stake-values-are-not-allowed", "Repeated stake values are not allowed!");
      return;
    } else
      return t = [], e.forEach((r) => {
        t.push(r);
      }), O.dispatch("setClickBetValue", [...t]), _e("clickbet-updated", "Click bet value updated successfully."), { saved: !0 };
  } catch (r) {
    m(r);
  }
}, qT = (e) => {
  const t = e.map((n) => n.value);
  return new Set(t).size !== t.length;
}, yA = async (e, t, r, n) => {
  try {
    kt.on("App\\\\Events\\\\SportsBroadcastData", (s) => {
      if (s && s.length)
        for (let i of s) {
          let o = e.find((a) => a.mid == i.mid);
          if (!(!o || i && !i.runners.length)) {
            i.st && (o.st = i.st);
            for (let a of i.runners) {
              let l = o.runners.find((u) => u.sid == a.sid);
              !l || a && !a.ex && !a.s || (a.s && (l.s = a.s), a.ex.b && (l.ex.b = a.ex.b), a.ex.l && (l.ex.l = a.ex.l));
            }
          }
        }
    }), kt.on("App\\\\Events\\\\BroadcastBookmaker", (s) => {
      if (s && s.length) {
        let i = s[0].ml;
        if (!i || i && !i.updated) return;
        let o = i.updated;
        if (o && o.length)
          for (let a of o) {
            let l = t.ml.find((c) => c.mi == a.mi);
            if (!l) continue;
            let u = Object.keys(a);
            for (let c of u)
              if (c != "mi")
                if (c == "sl")
                  for (let d of a.sl) {
                    let f = l.sl.find((_) => _.si == d.si);
                    if (!f) continue;
                    let g = Object.keys(d);
                    for (let _ of g)
                      f[_] = d[_];
                  }
                else
                  l[c] = a[c];
          }
      }
    }), kt.on("App\\\\Events\\\\BroadcastFancy", (s) => {
      if (s && s.length && !n) {
        let i = s[0].ml;
        if (!i || i && !i.updated && i && !i.added && i && !i.deleted) return;
        let o = i.updated, a = i.added, l = i.deleted;
        if (l && l.length && (r.ml = r.ml.filter(function(u) {
          return !l.includes(u.mi);
        })), o && o.length)
          for (let u of o) {
            let c = r.ml.find((f) => f.mi == u.mi);
            if (!c) continue;
            let d = Object.keys(u);
            for (let f of d)
              f != "mi" && (c[f] = u[f]);
          }
        if (a && a.length)
          for (let u = 0; u < a.length; u++)
            r.ml.find((d) => d.mi == a[u].mi) || (r.ml = [...r.ml, a[u]]);
      }
    });
  } catch (s) {
    s && console.log(s);
  }
}, EA = (e) => {
  try {
    kt.off("App\\\\Events\\\\SportsBroadcastData"), kt.off("App\\\\Events\\\\BroadcastBookmaker"), kt.off("App\\\\Events\\\\BroadcastFancy"), kt.emit("leave", [e]);
  } catch (t) {
    t && console.log(t);
  }
}, vA = (e) => ({
  scoreCardUrl() {
    const t = `https://scorecard.oddstrad.com/get-scorecard-iframe/${e == null ? void 0 : e.eventDetails.sportId}/${e == null ? void 0 : e.eventDetails.eventId}/${e == null ? void 0 : e.eventDetails.sportsradar_id}`, r = `https://scoreboarduser-ui.royalgame365.com/${e == null ? void 0 : e.eventDetails.eventId}`;
    return e.eventDetails.has_manual_scorecard ? r : t;
  },
  liveTvUrl() {
    return `https://vid.dreamcasino.live/GetAPI.html?MatchID=${e != null && e.eventDetails.tv_radar_id ? e == null ? void 0 : e.eventDetails.tv_radar_id : e == null ? void 0 : e.eventDetails.eventId}`;
  },
  filteredFancyList() {
    let t = [];
    for (let r of e.fancyCategories)
      r.fancies = [];
    if (e.selectedFancyCategory != null)
      if (e.selectedFancyCategory.value == "all") {
        if (e.fancyData && e.fancyData.ml) {
          t = [...e.fancyCategories];
          for (let r of e.fancyData.ml) {
            let n = t.find((s) => s.value == r.cat);
            n && n.fancies.push(r);
          }
        }
      } else
        e.fancyData && e.fancyData.ml && (e.selectedFancyCategory.fancies = e.fancyData.ml.filter((r) => r.cat == e.selectedFancyCategory.value), t = [e.selectedFancyCategory, ...t]);
    return t;
  },
  getPinnedFancies() {
    let t = [];
    return !(e.fancyData && e.fancyData.ml && e.fancyData.ml.length) || !(e.pinnedFancies && e.pinnedFancies.length) || (t = e.fancyData.ml.filter((r) => e.pinnedFancies.includes(r.mi))), t;
  },
  otherMarkets() {
    let t = [];
    return e.matchOddsData && e.matchOddsData.length && (t = e.matchOddsData.filter((r) => r.marketName != "Match Odds" && r.marketName != "Who Will Win The Match?").sort((r, n) => r.marketName.localeCompare(n.marketName))), t;
  },
  isFavourite() {
    return e.eventDetails.favourite;
  }
}), bA = async () => {
  var e;
  try {
    let t = {
      type: "sportsbook"
    }, r = null, n = await $("post", "GET_THIRD_PARTY_API", t, "user");
    if (n && n.status == 200)
      return (e = n == null ? void 0 : n.data) != null && e.error ? m(n.data.error) : r = n.data.url, { data: r };
  } catch (t) {
    t && m(t);
  }
}, wA = async ({
  pool: e,
  eventDetails: t,
  handlePoolSelection: r,
  poolWalletcCall: n,
  chosenPool: s
}) => {
  var i, o, a, l, u;
  try {
    if (!((i = ge()) != null && i.status)) {
      m("Please login to join pool"), Le.showLogin();
      return;
    }
    let c = {
      match_id: t == null ? void 0 : t.matchId,
      pool_id: e == null ? void 0 : e.id,
      userid: (a = (o = ge()) == null ? void 0 : o.user) == null ? void 0 : a.userid,
      match_name: t == null ? void 0 : t.eventName,
      event_id: t == null ? void 0 : t.eventId
    };
    console.log("dataaa", c), O.dispatch("setGlobalLoader", !0);
    let d = await $("post", "JOIN_POOL", c, "user");
    if (d && d.status == 200)
      if (O.dispatch("setGlobalLoader", !1), (l = d == null ? void 0 : d.data) != null && l.error)
        m(d.data.error);
      else
        return _e((u = d == null ? void 0 : d.data) == null ? void 0 : u.message), e.is_joined = !0, typeof r == "function" && r(e), await KT(t, n, s);
  } catch (c) {
    c && (O.dispatch("setGlobalLoader", !1), m(c[0] || "Error joining pools."));
  }
}, KT = async (e, t, r) => {
  var n, s;
  try {
    if (t && (clearTimeout(t), t = null), !(r != null && r.is_joined)) return;
    const i = {
      match_id: e == null ? void 0 : e.matchId,
      pool_id: r == null ? void 0 : r.id
    };
    let o = null, a = await $("post", "POOL_WALLET", i, "pool");
    if (a && a.status == 200)
      return (n = a == null ? void 0 : a.data) != null && n.error ? m(a.data.error) : (o = a.data, _e((s = a.data) == null ? void 0 : s.message)), { poolWallet: o, poolWalletcCall: t };
  } catch (i) {
    i && m((i == null ? void 0 : i.message) || "Error fetching pool wallet. Please try again.");
  }
}, TA = async (e) => {
  var t, r;
  try {
    let n = null;
    O.dispatch("setGlobalLoader", !0);
    let s = await $("get", "GET_POOL_WINNERS", null, "pool");
    if (O.dispatch("setGlobalLoader", !1), s && s.status == 200)
      return (t = s == null ? void 0 : s.data) != null && t.error ? m(s.data.error) : (n = s == null ? void 0 : s.data.members, _e((r = s == null ? void 0 : s.data) == null ? void 0 : r.message), setTimeout(() => {
        typeof e == "function" && e();
      }, 1e3)), { data: n };
  } catch (n) {
    O.dispatch("setGlobalLoader", !1), m(n[0] || "Error joining pools.");
  }
}, SA = async (e, t, r) => {
  var n, s;
  try {
    let i = {
      match_id: t == null ? void 0 : t.matchId
    };
    r ? i.pool_code = r : i.pool_id = e, O.dispatch("setGlobalLoader", !0);
    let o = null, a = await $("get", "POOL_LEADER_BOARD", null, "pool", i);
    if (O.dispatch("setGlobalLoader", !1), a && a.status == 200)
      return (n = a == null ? void 0 : a.data) != null && n.error ? (m(a.data.error), { data: o }) : (o && o.length || Le.openModal("#leaderModal"), o = (s = a == null ? void 0 : a.data) == null ? void 0 : s.data, _e("Leaderboard data loaded successfully."), { data: o });
  } catch (i) {
    O.dispatch("setGlobalLoader", !1), console.log("getLeaderBoardData Error:", i), m(i.message || "An unexpected error occurred while fetching leaderboard.");
  }
}, OA = async (e, t) => {
  var r, n;
  try {
    let s = {
      status: "open",
      match_id: e.matchId,
      pool_id: t == null ? void 0 : t.id
    };
    O.dispatch("setGlobalLoader", !0);
    let i = null, o = await $("post", "GET_POOL_OPEN_BETS", s, "pool");
    if (O.dispatch("setGlobalLoader", !1), o && o.status == 200)
      return (r = o == null ? void 0 : o.data) != null && r.error ? m(o.data.error) : (i = (n = o == null ? void 0 : o.data.data) == null ? void 0 : n.bets.data, Le.openModal("#open-bets-button")), { data: i };
  } catch (s) {
    O.dispatch("setGlobalLoader", !1), s && m(s[0]);
  }
}, AA = (e) => ({
  leaderBoardDataWithoutUser() {
    var t;
    return (t = e == null ? void 0 : e.leaderBoardData) == null ? void 0 : t.filter((r) => {
      var n, s;
      return (r == null ? void 0 : r.user_id) !== ((s = (n = ge()) == null ? void 0 : n.user) == null ? void 0 : s.id);
    });
  },
  userInfoFromLeaderBoard() {
    var t;
    return (t = e == null ? void 0 : e.leaderBoardData) == null ? void 0 : t.find((r) => {
      var n, s;
      return (r == null ? void 0 : r.user_id) == ((s = (n = ge()) == null ? void 0 : n.user) == null ? void 0 : s.id);
    });
  }
}), NA = (e) => ({
  setOpenBets() {
    var t;
    if (e != null && e.averageOdds) {
      let r = [];
      return (t = e == null ? void 0 : e.openBets) == null || t.forEach((n) => {
        var s;
        if ((s = n[e == null ? void 0 : e.activeOpenBetType]) != null && s.length) {
          let i = {
            event_name: n.event_name,
            lay: {
              odds: 0,
              stake: 0,
              pl: 0,
              betCount: 0
            },
            back: {
              odds: 0,
              stake: 0,
              pl: 0,
              betCount: 0
            }
          };
          for (let o = 0; o < n[e == null ? void 0 : e.activeOpenBetType].length; o++) {
            let a = n[e == null ? void 0 : e.activeOpenBetType][o];
            i[a.selection_type].odds += parseFloat(a.odds), i[a.selection_type].stake += parseFloat(a.stake), i[a.selection_type].pl += parseFloat(a.p_l), i[a.selection_type].betCount++;
          }
          ["lay", "back"].forEach((o) => {
            const a = i[o];
            a.betCount > 0 && (a.odds /= a.betCount), a.odds = parseFloat(a.odds.toFixed(2)), a.stake = parseFloat(a.stake.toFixed(2)), a.pl = parseFloat(a.pl.toFixed(2));
          }), r.push(i);
        }
      }), r;
    } else
      return e == null ? void 0 : e.openBets;
  }
}), CA = (e) => ({
  filteredBets() {
    var t, r;
    if (e.averageOdds) {
      let n = {
        bookmakers: { back: [], lay: [] },
        fancies: { back: [], lay: [] },
        main_market: { back: [], lay: [] }
      };
      return (t = e.openBets) == null || t.forEach((s) => {
        ["bookmakers", "fancies", "main_market"].forEach((i) => {
          s[i] && s[i].length > 0 && s[i].forEach((o) => {
            o.selection_type === "back" ? n[i].back.push(o) : o.selection_type === "lay" && n[i].lay.push(o);
          });
        });
      }), console.log(n), n;
    } else {
      let n = (r = e.openBets) == null ? void 0 : r.flatMap((s) => [...s.main_market, ...s.bookmakers, ...s.fancies]);
      return n == null ? void 0 : n.sort((s, i) => i.bet_timestamp_date - s.bet_timestamp_date);
    }
  }
}), DA = (e, t) => (e == null ? void 0 : e.marketName) == "Who Will Win The Match?" && (t == null ? void 0 : t.sportId) == 4, IA = (e) => (e == null ? void 0 : e.min_stake_limit) < 100 || (e == null ? void 0 : e.stake_limit) < 100, MA = (e, t) => t.s != "ACTIVE" || e.st != "OPEN", RA = (e, t) => e.sn != "ONLINE" || t.ss != "ACTIVE", LA = (e) => (e == null ? void 0 : e.mins) < 100 || (e == null ? void 0 : e.ms) < 100, xA = (e) => e.sn == "SUSPEND" || e.sn == "BALL_RUN", kA = (e) => (e == null ? void 0 : e.mins) < 100 || (e == null ? void 0 : e.ms) < 100, PA = (e, t) => t.s != "ACTIVE" || e.st != "OPEN", $A = (e) => (e == null ? void 0 : e.min_stake_limit) < 100 || (e == null ? void 0 : e.stake_limit) < 100, FA = (e) => {
  var t, r;
  return ((t = ge()) == null ? void 0 : t.status) && ((r = e == null ? void 0 : e.runners) == null ? void 0 : r.length) == 2;
}, VA = (e) => (e == null ? void 0 : e.min_stake_limit) < 100 || (e == null ? void 0 : e.stake_limit) < 100, BA = (e) => {
  var t;
  return ((t = ge()) == null ? void 0 : t.status) && e.sl.length == 2;
}, UA = (e) => (e == null ? void 0 : e.mins) < 100 || (e == null ? void 0 : e.ms) < 100, HA = (e) => {
  var t, r;
  return ((t = ge()) == null ? void 0 : t.status) && ((r = e == null ? void 0 : e.runners) == null ? void 0 : r.length) == 2;
}, jA = (e) => (e == null ? void 0 : e.min_stake_limit) < 100 || (e == null ? void 0 : e.stake_limit) < 100, YA = async (e) => {
  try {
    window.store.dispatch("setGlobalLoader", !0);
    const t = await $("post", "CLAIM_BONUS", { code: e }, "user");
    window.store.dispatch("setGlobalLoader", !1), (t == null ? void 0 : t.status) == 200 && _e(t.data.message);
  } catch (t) {
    window.store.dispatch("setGlobalLoader", !1), t && (console.log(t[0]), m(t[0]));
  }
}, GA = async () => {
  var e, t;
  try {
    O.dispatch("setGlobalLoader", !0);
    let r = null, n = await $("get", "GET_WALLET_CONFIG", null, "wallet");
    if (O.dispatch("setGlobalLoader", !1), n && n.status == 200) {
      if ((e = n == null ? void 0 : n.data) != null && e.error)
        m(n.data.error);
      else {
        r = n.data.data;
        const s = ["100", "200", "500", "1000"];
        let i = O.getters.userTransactionStakes || ((t = r.stake_button) != null && t.every((o) => Number(o) === 0) ? s : r.stake_button || s);
        r.stake_button = i, O.dispatch("setUserTransactionStakes", i);
      }
      return { data: r };
    }
  } catch (r) {
    O.dispatch("setGlobalLoader", !1), r && m(r);
  }
}, WA = (e, t, r) => {
  var n, s;
  try {
    return t = parseFloat(t) || 0, e = parseFloat(e) || 0, t += e, t > ((n = r == null ? void 0 : r.deposit_range) == null ? void 0 : n.max) && (t = (s = r == null ? void 0 : r.deposit_range) == null ? void 0 : s.max), t;
  } catch (i) {
    m(i);
  }
};
var oo = { exports: {} }, nu;
function zT() {
  return nu || (nu = 1, function(e) {
    var t = function(r) {
      var n = Object.prototype, s = n.hasOwnProperty, i = Object.defineProperty || function(T, S, I) {
        T[S] = I.value;
      }, o, a = typeof Symbol == "function" ? Symbol : {}, l = a.iterator || "@@iterator", u = a.asyncIterator || "@@asyncIterator", c = a.toStringTag || "@@toStringTag";
      function d(T, S, I) {
        return Object.defineProperty(T, S, {
          value: I,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), T[S];
      }
      try {
        d({}, "");
      } catch {
        d = function(S, I, K) {
          return S[I] = K;
        };
      }
      function f(T, S, I, K) {
        var Y = S && S.prototype instanceof v ? S : v, te = Object.create(Y.prototype), pe = new R(K || []);
        return i(te, "_invoke", { value: fe(T, I, pe) }), te;
      }
      r.wrap = f;
      function g(T, S, I) {
        try {
          return { type: "normal", arg: T.call(S, I) };
        } catch (K) {
          return { type: "throw", arg: K };
        }
      }
      var _ = "suspendedStart", p = "suspendedYield", y = "executing", b = "completed", A = {};
      function v() {
      }
      function D() {
      }
      function w() {
      }
      var j = {};
      d(j, l, function() {
        return this;
      });
      var z = Object.getPrototypeOf, Z = z && z(z(x([])));
      Z && Z !== n && s.call(Z, l) && (j = Z);
      var Q = w.prototype = v.prototype = Object.create(j);
      D.prototype = w, i(Q, "constructor", { value: w, configurable: !0 }), i(
        w,
        "constructor",
        { value: D, configurable: !0 }
      ), D.displayName = d(
        w,
        c,
        "GeneratorFunction"
      );
      function ee(T) {
        ["next", "throw", "return"].forEach(function(S) {
          d(T, S, function(I) {
            return this._invoke(S, I);
          });
        });
      }
      r.isGeneratorFunction = function(T) {
        var S = typeof T == "function" && T.constructor;
        return S ? S === D || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (S.displayName || S.name) === "GeneratorFunction" : !1;
      }, r.mark = function(T) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(T, w) : (T.__proto__ = w, d(T, c, "GeneratorFunction")), T.prototype = Object.create(Q), T;
      }, r.awrap = function(T) {
        return { __await: T };
      };
      function X(T, S) {
        function I(te, pe, Se, ve) {
          var ye = g(T[te], T, pe);
          if (ye.type === "throw")
            ve(ye.arg);
          else {
            var ne = ye.arg, re = ne.value;
            return re && typeof re == "object" && s.call(re, "__await") ? S.resolve(re.__await).then(function(ue) {
              I("next", ue, Se, ve);
            }, function(ue) {
              I("throw", ue, Se, ve);
            }) : S.resolve(re).then(function(ue) {
              ne.value = ue, Se(ne);
            }, function(ue) {
              return I("throw", ue, Se, ve);
            });
          }
        }
        var K;
        function Y(te, pe) {
          function Se() {
            return new S(function(ve, ye) {
              I(te, pe, ve, ye);
            });
          }
          return K = // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          K ? K.then(
            Se,
            // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            Se
          ) : Se();
        }
        i(this, "_invoke", { value: Y });
      }
      ee(X.prototype), d(X.prototype, u, function() {
        return this;
      }), r.AsyncIterator = X, r.async = function(T, S, I, K, Y) {
        Y === void 0 && (Y = Promise);
        var te = new X(
          f(T, S, I, K),
          Y
        );
        return r.isGeneratorFunction(S) ? te : te.next().then(function(pe) {
          return pe.done ? pe.value : te.next();
        });
      };
      function fe(T, S, I) {
        var K = _;
        return function(te, pe) {
          if (K === y)
            throw new Error("Generator is already running");
          if (K === b) {
            if (te === "throw")
              throw pe;
            return M();
          }
          for (I.method = te, I.arg = pe; ; ) {
            var Se = I.delegate;
            if (Se) {
              var ve = ce(Se, I);
              if (ve) {
                if (ve === A) continue;
                return ve;
              }
            }
            if (I.method === "next")
              I.sent = I._sent = I.arg;
            else if (I.method === "throw") {
              if (K === _)
                throw K = b, I.arg;
              I.dispatchException(I.arg);
            } else I.method === "return" && I.abrupt("return", I.arg);
            K = y;
            var ye = g(T, S, I);
            if (ye.type === "normal") {
              if (K = I.done ? b : p, ye.arg === A)
                continue;
              return {
                value: ye.arg,
                done: I.done
              };
            } else ye.type === "throw" && (K = b, I.method = "throw", I.arg = ye.arg);
          }
        };
      }
      function ce(T, S) {
        var I = S.method, K = T.iterator[I];
        if (K === o)
          return S.delegate = null, I === "throw" && T.iterator.return && (S.method = "return", S.arg = o, ce(T, S), S.method === "throw") || I !== "return" && (S.method = "throw", S.arg = new TypeError(
            "The iterator does not provide a '" + I + "' method"
          )), A;
        var Y = g(K, T.iterator, S.arg);
        if (Y.type === "throw")
          return S.method = "throw", S.arg = Y.arg, S.delegate = null, A;
        var te = Y.arg;
        if (!te)
          return S.method = "throw", S.arg = new TypeError("iterator result is not an object"), S.delegate = null, A;
        if (te.done)
          S[T.resultName] = te.value, S.next = T.nextLoc, S.method !== "return" && (S.method = "next", S.arg = o);
        else
          return te;
        return S.delegate = null, A;
      }
      ee(Q), d(Q, c, "Generator"), d(Q, l, function() {
        return this;
      }), d(Q, "toString", function() {
        return "[object Generator]";
      });
      function J(T) {
        var S = { tryLoc: T[0] };
        1 in T && (S.catchLoc = T[1]), 2 in T && (S.finallyLoc = T[2], S.afterLoc = T[3]), this.tryEntries.push(S);
      }
      function B(T) {
        var S = T.completion || {};
        S.type = "normal", delete S.arg, T.completion = S;
      }
      function R(T) {
        this.tryEntries = [{ tryLoc: "root" }], T.forEach(J, this), this.reset(!0);
      }
      r.keys = function(T) {
        var S = Object(T), I = [];
        for (var K in S)
          I.push(K);
        return I.reverse(), function Y() {
          for (; I.length; ) {
            var te = I.pop();
            if (te in S)
              return Y.value = te, Y.done = !1, Y;
          }
          return Y.done = !0, Y;
        };
      };
      function x(T) {
        if (T) {
          var S = T[l];
          if (S)
            return S.call(T);
          if (typeof T.next == "function")
            return T;
          if (!isNaN(T.length)) {
            var I = -1, K = function Y() {
              for (; ++I < T.length; )
                if (s.call(T, I))
                  return Y.value = T[I], Y.done = !1, Y;
              return Y.value = o, Y.done = !0, Y;
            };
            return K.next = K;
          }
        }
        return { next: M };
      }
      r.values = x;
      function M() {
        return { value: o, done: !0 };
      }
      return R.prototype = {
        constructor: R,
        reset: function(T) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = o, this.done = !1, this.delegate = null, this.method = "next", this.arg = o, this.tryEntries.forEach(B), !T)
            for (var S in this)
              S.charAt(0) === "t" && s.call(this, S) && !isNaN(+S.slice(1)) && (this[S] = o);
        },
        stop: function() {
          this.done = !0;
          var T = this.tryEntries[0], S = T.completion;
          if (S.type === "throw")
            throw S.arg;
          return this.rval;
        },
        dispatchException: function(T) {
          if (this.done)
            throw T;
          var S = this;
          function I(ve, ye) {
            return te.type = "throw", te.arg = T, S.next = ve, ye && (S.method = "next", S.arg = o), !!ye;
          }
          for (var K = this.tryEntries.length - 1; K >= 0; --K) {
            var Y = this.tryEntries[K], te = Y.completion;
            if (Y.tryLoc === "root")
              return I("end");
            if (Y.tryLoc <= this.prev) {
              var pe = s.call(Y, "catchLoc"), Se = s.call(Y, "finallyLoc");
              if (pe && Se) {
                if (this.prev < Y.catchLoc)
                  return I(Y.catchLoc, !0);
                if (this.prev < Y.finallyLoc)
                  return I(Y.finallyLoc);
              } else if (pe) {
                if (this.prev < Y.catchLoc)
                  return I(Y.catchLoc, !0);
              } else if (Se) {
                if (this.prev < Y.finallyLoc)
                  return I(Y.finallyLoc);
              } else
                throw new Error("try statement without catch or finally");
            }
          }
        },
        abrupt: function(T, S) {
          for (var I = this.tryEntries.length - 1; I >= 0; --I) {
            var K = this.tryEntries[I];
            if (K.tryLoc <= this.prev && s.call(K, "finallyLoc") && this.prev < K.finallyLoc) {
              var Y = K;
              break;
            }
          }
          Y && (T === "break" || T === "continue") && Y.tryLoc <= S && S <= Y.finallyLoc && (Y = null);
          var te = Y ? Y.completion : {};
          return te.type = T, te.arg = S, Y ? (this.method = "next", this.next = Y.finallyLoc, A) : this.complete(te);
        },
        complete: function(T, S) {
          if (T.type === "throw")
            throw T.arg;
          return T.type === "break" || T.type === "continue" ? this.next = T.arg : T.type === "return" ? (this.rval = this.arg = T.arg, this.method = "return", this.next = "end") : T.type === "normal" && S && (this.next = S), A;
        },
        finish: function(T) {
          for (var S = this.tryEntries.length - 1; S >= 0; --S) {
            var I = this.tryEntries[S];
            if (I.finallyLoc === T)
              return this.complete(I.completion, I.afterLoc), B(I), A;
          }
        },
        catch: function(T) {
          for (var S = this.tryEntries.length - 1; S >= 0; --S) {
            var I = this.tryEntries[S];
            if (I.tryLoc === T) {
              var K = I.completion;
              if (K.type === "throw") {
                var Y = K.arg;
                B(I);
              }
              return Y;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(T, S, I) {
          return this.delegate = {
            iterator: x(T),
            resultName: S,
            nextLoc: I
          }, this.method === "next" && (this.arg = o), A;
        }
      }, r;
    }(
      // If this script is executing as a CommonJS module, use module.exports
      // as the regeneratorRuntime namespace. Otherwise create a new empty
      // object. Either way, the resulting object will be used to initialize
      // the regeneratorRuntime variable at the top of this file.
      e.exports
    );
    try {
      regeneratorRuntime = t;
    } catch {
      typeof globalThis == "object" ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
    }
  }(oo)), oo.exports;
}
var ao, su;
function al() {
  return su || (su = 1, ao = (e, t) => `${e}-${t}-${Math.random().toString(16).slice(3, 8)}`), ao;
}
var lo, iu;
function vp() {
  if (iu) return lo;
  iu = 1;
  const e = al();
  let t = 0;
  return lo = ({
    id: r,
    action: n,
    payload: s = {}
  }) => {
    let i = r;
    return typeof i > "u" && (i = e("Job", t), t += 1), {
      id: i,
      action: n,
      payload: s
    };
  }, lo;
}
var Sn = {}, ou;
function ll() {
  if (ou) return Sn;
  ou = 1;
  let e = !1;
  return Sn.logging = e, Sn.setLogging = (t) => {
    e = t;
  }, Sn.log = (...t) => e ? console.log.apply(this, t) : null, Sn;
}
var co, au;
function JT() {
  if (au) return co;
  au = 1;
  const e = vp(), { log: t } = ll(), r = al();
  let n = 0;
  return co = () => {
    const s = r("Scheduler", n), i = {}, o = {};
    let a = [];
    n += 1;
    const l = () => a.length, u = () => Object.keys(i).length, c = () => {
      if (a.length !== 0) {
        const p = Object.keys(i);
        for (let y = 0; y < p.length; y += 1)
          if (typeof o[p[y]] > "u") {
            a[0](i[p[y]]);
            break;
          }
      }
    }, d = (p, y) => new Promise((b, A) => {
      const v = e({ action: p, payload: y });
      a.push(async (D) => {
        a.shift(), o[D.id] = v;
        try {
          b(await D[p].apply(this, [...y, v.id]));
        } catch (w) {
          A(w);
        } finally {
          delete o[D.id], c();
        }
      }), t(`[${s}]: Add ${v.id} to JobQueue`), t(`[${s}]: JobQueue length=${a.length}`), c();
    });
    return {
      addWorker: (p) => (i[p.id] = p, t(`[${s}]: Add ${p.id}`), t(`[${s}]: Number of workers=${u()}`), c(), p.id),
      addJob: async (p, ...y) => {
        if (u() === 0)
          throw Error(`[${s}]: You need to have at least one worker before adding jobs`);
        return d(p, y);
      },
      terminate: async () => {
        Object.keys(i).forEach(async (p) => {
          await i[p].terminate();
        }), a = [];
      },
      getQueueLen: l,
      getNumWorkers: u
    };
  }, co;
}
function XT(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var uo, lu;
function QT() {
  return lu || (lu = 1, uo = (e) => {
    const t = {};
    return typeof WorkerGlobalScope < "u" ? t.type = "webworker" : typeof document == "object" ? t.type = "browser" : typeof process == "object" && typeof XT == "function" && (t.type = "node"), typeof e > "u" ? t : t[e];
  }), uo;
}
var fo, cu;
function ZT() {
  if (cu) return fo;
  cu = 1;
  const t = QT()("type") === "browser" ? (r) => new URL(r, window.location.href).href : (r) => r;
  return fo = (r) => {
    const n = { ...r };
    return ["corePath", "workerPath", "langPath"].forEach((s) => {
      r[s] && (n[s] = t(n[s]));
    }), n;
  }, fo;
}
var po, uu;
function bp() {
  return uu || (uu = 1, po = {
    TESSERACT_ONLY: 0,
    LSTM_ONLY: 1,
    TESSERACT_LSTM_COMBINED: 2,
    DEFAULT: 3
  }), po;
}
const eS = "6.0.1", tS = {
  version: eS
};
var ho, du;
function rS() {
  return du || (du = 1, ho = {
    /*
     * Use BlobURL for worker script by default
     * TODO: remove this option
     *
     */
    workerBlobURL: !0,
    logger: () => {
    }
  }), ho;
}
var go, fu;
function nS() {
  if (fu) return go;
  fu = 1;
  const e = tS.version;
  return go = {
    ...rS(),
    workerPath: `https://cdn.jsdelivr.net/npm/tesseract.js@v${e}/dist/worker.min.js`
  }, go;
}
var _o, pu;
function sS() {
  return pu || (pu = 1, _o = ({ workerPath: e, workerBlobURL: t }) => {
    let r;
    if (Blob && URL && t) {
      const n = new Blob([`importScripts("${e}");`], {
        type: "application/javascript"
      });
      r = new Worker(URL.createObjectURL(n));
    } else
      r = new Worker(e);
    return r;
  }), _o;
}
var mo, hu;
function iS() {
  return hu || (hu = 1, mo = (e) => {
    e.terminate();
  }), mo;
}
var yo, gu;
function oS() {
  return gu || (gu = 1, yo = (e, t) => {
    e.onmessage = ({ data: r }) => {
      t(r);
    };
  }), yo;
}
var Eo, _u;
function aS() {
  return _u || (_u = 1, Eo = async (e, t) => {
    e.postMessage(t);
  }), Eo;
}
var vo, mu;
function lS() {
  if (mu) return vo;
  mu = 1;
  const e = (r) => new Promise((n, s) => {
    const i = new FileReader();
    i.onload = () => {
      n(i.result);
    }, i.onerror = ({ target: { error: { code: o } } }) => {
      s(Error(`File could not be read! Code=${o}`));
    }, i.readAsArrayBuffer(r);
  }), t = async (r) => {
    let n = r;
    if (typeof r > "u")
      return "undefined";
    if (typeof r == "string")
      /data:image\/([a-zA-Z]*);base64,([^"]*)/.test(r) ? n = atob(r.split(",")[1]).split("").map((s) => s.charCodeAt(0)) : n = await (await fetch(r)).arrayBuffer();
    else if (typeof HTMLElement < "u" && r instanceof HTMLElement)
      r.tagName === "IMG" && (n = await t(r.src)), r.tagName === "VIDEO" && (n = await t(r.poster)), r.tagName === "CANVAS" && await new Promise((s) => {
        r.toBlob(async (i) => {
          n = await e(i), s();
        });
      });
    else if (typeof OffscreenCanvas < "u" && r instanceof OffscreenCanvas) {
      const s = await r.convertToBlob();
      n = await e(s);
    } else (r instanceof File || r instanceof Blob) && (n = await e(r));
    return new Uint8Array(n);
  };
  return vo = t, vo;
}
var bo, yu;
function cS() {
  if (yu) return bo;
  yu = 1;
  const e = nS(), t = sS(), r = iS(), n = oS(), s = aS(), i = lS();
  return bo = {
    defaultOptions: e,
    spawnWorker: t,
    terminateWorker: r,
    onMessage: n,
    send: s,
    loadImage: i
  }, bo;
}
var wo, Eu;
function wp() {
  if (Eu) return wo;
  Eu = 1;
  const e = ZT(), t = vp(), { log: r } = ll(), n = al(), s = bp(), {
    defaultOptions: i,
    spawnWorker: o,
    terminateWorker: a,
    onMessage: l,
    loadImage: u,
    send: c
  } = cS();
  let d = 0;
  return wo = async (f = "eng", g = s.LSTM_ONLY, _ = {}, p = {}) => {
    const y = n("Worker", d), {
      logger: b,
      errorHandler: A,
      ...v
    } = e({
      ...i,
      ..._
    }), D = {}, w = typeof f == "string" ? f.split("+") : f;
    let j = g, z = p;
    const Z = [s.DEFAULT, s.LSTM_ONLY].includes(g) && !v.legacyCore;
    let Q, ee;
    const X = new Promise((ne, re) => {
      ee = ne, Q = re;
    }), fe = (ne) => {
      Q(ne.message);
    };
    let ce = o(v);
    ce.onerror = fe, d += 1;
    const J = ({ id: ne, action: re, payload: ue }) => new Promise((Ie, h) => {
      r(`[${y}]: Start ${ne}, action=${re}`);
      const E = `${re}-${ne}`;
      D[E] = { resolve: Ie, reject: h }, c(ce, {
        workerId: y,
        jobId: ne,
        action: re,
        payload: ue
      });
    }), B = () => console.warn("`load` is depreciated and should be removed from code (workers now come pre-loaded)"), R = (ne) => J(t({
      id: ne,
      action: "load",
      payload: { options: { lstmOnly: Z, corePath: v.corePath, logging: v.logging } }
    })), x = (ne, re, ue) => J(t({
      id: ue,
      action: "FS",
      payload: { method: "writeFile", args: [ne, re] }
    })), M = (ne, re) => J(t({
      id: re,
      action: "FS",
      payload: { method: "readFile", args: [ne, { encoding: "utf8" }] }
    })), T = (ne, re) => J(t({
      id: re,
      action: "FS",
      payload: { method: "unlink", args: [ne] }
    })), S = (ne, re, ue) => J(t({
      id: ue,
      action: "FS",
      payload: { method: ne, args: re }
    })), I = (ne, re) => J(t({
      id: re,
      action: "loadLanguage",
      payload: {
        langs: ne,
        options: {
          langPath: v.langPath,
          dataPath: v.dataPath,
          cachePath: v.cachePath,
          cacheMethod: v.cacheMethod,
          gzip: v.gzip,
          lstmOnly: [s.DEFAULT, s.LSTM_ONLY].includes(j) && !v.legacyLang
        }
      }
    })), K = (ne, re, ue, Ie) => J(t({
      id: Ie,
      action: "initialize",
      payload: { langs: ne, oem: re, config: ue }
    })), Y = (ne = "eng", re, ue, Ie) => {
      if (Z && [s.TESSERACT_ONLY, s.TESSERACT_LSTM_COMBINED].includes(re)) throw Error("Legacy model requested but code missing.");
      const h = re || j;
      j = h;
      const E = ue || z;
      z = E;
      const k = (typeof ne == "string" ? ne.split("+") : ne).filter((L) => !w.includes(L));
      return w.push(...k), k.length > 0 ? I(k, Ie).then(() => K(ne, h, E, Ie)) : K(ne, h, E, Ie);
    }, te = (ne = {}, re) => J(t({
      id: re,
      action: "setParameters",
      payload: { params: ne }
    })), pe = async (ne, re = {}, ue = {
      text: !0
    }, Ie) => J(t({
      id: Ie,
      action: "recognize",
      payload: { image: await u(ne), options: re, output: ue }
    })), Se = async (ne, re) => {
      if (Z) throw Error("`worker.detect` requires Legacy model, which was not loaded.");
      return J(t({
        id: re,
        action: "detect",
        payload: { image: await u(ne) }
      }));
    }, ve = async () => (ce !== null && (a(ce), ce = null), Promise.resolve());
    l(ce, ({
      workerId: ne,
      jobId: re,
      status: ue,
      action: Ie,
      data: h
    }) => {
      const E = `${Ie}-${re}`;
      if (ue === "resolve")
        r(`[${ne}]: Complete ${re}`), D[E].resolve({ jobId: re, data: h }), delete D[E];
      else if (ue === "reject")
        if (D[E].reject(h), delete D[E], Ie === "load" && Q(h), A)
          A(h);
        else
          throw Error(h);
      else ue === "progress" && b({ ...h, userJobId: re });
    });
    const ye = {
      id: y,
      worker: ce,
      load: B,
      writeText: x,
      readText: M,
      removeFile: T,
      FS: S,
      reinitialize: Y,
      setParameters: te,
      recognize: pe,
      detect: Se,
      terminate: ve
    };
    return R().then(() => I(f)).then(() => K(f, g, p)).then(() => ee(ye)).catch(() => {
    }), X;
  }, wo;
}
var To, vu;
function uS() {
  if (vu) return To;
  vu = 1;
  const e = wp();
  return To = {
    recognize: async (n, s, i) => {
      const o = await e(s, 1, i);
      return o.recognize(n).finally(async () => {
        await o.terminate();
      });
    },
    detect: async (n, s) => {
      const i = await e("osd", 0, s);
      return i.detect(n).finally(async () => {
        await i.terminate();
      });
    }
  }, To;
}
var So, bu;
function dS() {
  return bu || (bu = 1, So = {
    AFR: "afr",
    AMH: "amh",
    ARA: "ara",
    ASM: "asm",
    AZE: "aze",
    AZE_CYRL: "aze_cyrl",
    BEL: "bel",
    BEN: "ben",
    BOD: "bod",
    BOS: "bos",
    BUL: "bul",
    CAT: "cat",
    CEB: "ceb",
    CES: "ces",
    CHI_SIM: "chi_sim",
    CHI_TRA: "chi_tra",
    CHR: "chr",
    CYM: "cym",
    DAN: "dan",
    DEU: "deu",
    DZO: "dzo",
    ELL: "ell",
    ENG: "eng",
    ENM: "enm",
    EPO: "epo",
    EST: "est",
    EUS: "eus",
    FAS: "fas",
    FIN: "fin",
    FRA: "fra",
    FRK: "frk",
    FRM: "frm",
    GLE: "gle",
    GLG: "glg",
    GRC: "grc",
    GUJ: "guj",
    HAT: "hat",
    HEB: "heb",
    HIN: "hin",
    HRV: "hrv",
    HUN: "hun",
    IKU: "iku",
    IND: "ind",
    ISL: "isl",
    ITA: "ita",
    ITA_OLD: "ita_old",
    JAV: "jav",
    JPN: "jpn",
    KAN: "kan",
    KAT: "kat",
    KAT_OLD: "kat_old",
    KAZ: "kaz",
    KHM: "khm",
    KIR: "kir",
    KOR: "kor",
    KUR: "kur",
    LAO: "lao",
    LAT: "lat",
    LAV: "lav",
    LIT: "lit",
    MAL: "mal",
    MAR: "mar",
    MKD: "mkd",
    MLT: "mlt",
    MSA: "msa",
    MYA: "mya",
    NEP: "nep",
    NLD: "nld",
    NOR: "nor",
    ORI: "ori",
    PAN: "pan",
    POL: "pol",
    POR: "por",
    PUS: "pus",
    RON: "ron",
    RUS: "rus",
    SAN: "san",
    SIN: "sin",
    SLK: "slk",
    SLV: "slv",
    SPA: "spa",
    SPA_OLD: "spa_old",
    SQI: "sqi",
    SRP: "srp",
    SRP_LATN: "srp_latn",
    SWA: "swa",
    SWE: "swe",
    SYR: "syr",
    TAM: "tam",
    TEL: "tel",
    TGK: "tgk",
    TGL: "tgl",
    THA: "tha",
    TIR: "tir",
    TUR: "tur",
    UIG: "uig",
    UKR: "ukr",
    URD: "urd",
    UZB: "uzb",
    UZB_CYRL: "uzb_cyrl",
    VIE: "vie",
    YID: "yid"
  }), So;
}
var Oo, wu;
function fS() {
  return wu || (wu = 1, Oo = {
    OSD_ONLY: "0",
    AUTO_OSD: "1",
    AUTO_ONLY: "2",
    AUTO: "3",
    SINGLE_COLUMN: "4",
    SINGLE_BLOCK_VERT_TEXT: "5",
    SINGLE_BLOCK: "6",
    SINGLE_LINE: "7",
    SINGLE_WORD: "8",
    CIRCLE_WORD: "9",
    SINGLE_CHAR: "10",
    SPARSE_TEXT: "11",
    SPARSE_TEXT_OSD: "12",
    RAW_LINE: "13"
  }), Oo;
}
var Ao, Tu;
function pS() {
  if (Tu) return Ao;
  Tu = 1, zT();
  const e = JT(), t = wp(), r = uS(), n = dS(), s = bp(), i = fS(), { setLogging: o } = ll();
  return Ao = {
    languages: n,
    OEM: s,
    PSM: i,
    createScheduler: e,
    createWorker: t,
    setLogging: o,
    ...r
  }, Ao;
}
var hS = pS();
const qA = {
  data() {
    return {};
  },
  methods: {
    checkAll(e) {
      try {
        e = e.replace(/\n/g, " ").replace(/\\n/g, " ").split(" ");
        let t = [], r = "";
        for (let n = 0; n < e.length; n++)
          (e[n].length == 12 || e[n].length == 10) && e[n - 2] != "UPI" && e[n - 1] != "ID:" && t.push(e[n]);
        for (let n = 0; n < t.length && (!r || r && r.length == 10); n++)
          (!isNaN(t[n]) && t[n].length == 12 || !isNaN(t[n]) && t[n].length == 10) && (r = t[n]);
        return r;
      } catch {
        return !1;
      }
    }
  }
}, gS = async (e, t) => {
  var s;
  let r = null, n = null;
  try {
    O.dispatch("setGlobalLoader", !0), console.log(t);
    let i = await $("get", "PARENT_PAYMENT_METHODS", null, "wallet", { amount: t });
    if (O.dispatch("setGlobalLoader", !1), i && i.status == 200) {
      if ((s = i == null ? void 0 : i.data) != null && s.error)
        r = [], m(i.data.error);
      else {
        let o = i.data.data, a = Object.groupBy(o, ({ method_name: c }) => c), l = o.filter((c) => c.method === "social").map((c) => c.method_name), u = {};
        l.forEach((c) => {
          a[c] && (u[c] = a[c], delete a[c]);
        }), n = [...new Set(l)].length, Object.assign(u, a), r = u;
      }
      return { data: r, nonSocialStartIndex: n };
    }
  } catch (i) {
    O.dispatch("setGlobalLoader", !1), e < 3 && !i ? gS(e + 1) : i && (r = [], m(i[0]), window.router.back());
  }
}, KA = async (e, t) => {
  var r, n, s, i, o, a;
  try {
    const l = await $("get", "PAYMENT_GATEWAY", null, "wallet", { amount: e, master_account_id: t });
    (l == null ? void 0 : l.status) == 200 && ((r = l == null ? void 0 : l.data) != null && r.success ? (i = (s = l == null ? void 0 : l.data) == null ? void 0 : s.data) != null && i.url && (window.location.href = (a = (o = l == null ? void 0 : l.data) == null ? void 0 : o.data) == null ? void 0 : a.url) : m((n = l == null ? void 0 : l.data) == null ? void 0 : n.error), O.dispatch("setGlobalLoader", !1));
  } catch (l) {
    O.dispatch("setGlobalLoader", !1), l && m(l[0]);
  }
}, zA = async ({
  event: e,
  depositAmount: t,
  startTimer: r,
  resetTimer: n,
  sbtBtn: s,
  checkAll: i
}) => {
  try {
    const o = e.target.files[0];
    if (!o.type.startsWith("image/")) {
      e.target.value = "", m("Only Image Files are Allowed");
      return;
    }
    const a = 2 * 1024 * 1024;
    if (o.size > a) {
      e.target.value = "", m(`File ${o.name} should be size limit of 2 MB.`);
      return;
    }
    let l = URL.createObjectURL(o), u = o;
    typeof r == "function" && r();
    let c = null;
    c = await _S(l, i), console.log(c);
    let d = c, f = null;
    return c ? (f = {
      langKey: "found-img-utr-found",
      msg: "We find this as UTR Number from uploaded screenshot by you, If it's wrong Kindly make it correct manually for fast deposit."
    }, typeof n == "function" && n(), Le.scrollToElement(s), {
      manual_utr: c,
      utrMsg: f,
      uploadedImage: u,
      previewImage: l,
      tesseract_utr: d
    }) : (f = {
      langKey: "found-img-utr-not-found",
      msg: "We didn't find any UTR Number from uploaded screenshot by you, Kindly enter UTR Number manually for fast deposit."
    }, console.log("manual_utr", c), {
      manual_utr: c,
      utrMsg: f,
      uploadedImage: u,
      previewImage: l,
      tesseract_utr: d
    });
  } catch (o) {
    o && (typeof n == "function" && n(), m(o[0] ?? o + "refresh the page and try again!!"));
  }
}, _S = async (e, t) => {
  try {
    const r = e, n = await hS.createWorker("eng");
    let { data: { text: s } } = await n.recognize(r);
    if (await n.terminate(), typeof t == "function")
      return t(s);
  } catch {
    return null;
  }
}, JA = async ({
  accountDetails: e,
  uploadedImage: t,
  depositAmount: r,
  manual_utr: n,
  removeImage: s,
  has_edited_utr: i
}) => {
  var o, a;
  try {
    if (!t || t == null) {
      m("Please upload image");
      return;
    }
    if (!r || r == null) {
      m("Please Enter Deposit Amount");
      return;
    }
    O.dispatch("setGlobalLoader", !0);
    const l = await mS(t, "payment_method");
    let u = {
      amount: r,
      transaction_id: n,
      transaction_image_url: l,
      account_index: e.master_account_id,
      client_created_date: Te.sportItemDate(e.created_at, "YYYY-MM-DD HH:mm:ss"),
      has_edited_utr: i,
      type: "client_deposit"
    }, c = await $("post", "WALLET_DEPOSIT", u, "wallet");
    O.dispatch("setGlobalLoader", !1), c && c.status == 200 && ((o = c == null ? void 0 : c.data) != null && o.error ? m(c.data.error) : (window.router.push({ name: "Home" }), _e((a = c == null ? void 0 : c.data) == null ? void 0 : a.message), typeof resetTimer == "function" && s()));
  } catch (l) {
    O.dispatch("setGlobalLoader", !1), l && m(l[0]);
  }
}, mS = async (e, t) => {
  if (!e) return;
  if (![
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
    "image/svg+xml",
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ].includes(e.type))
    return m("Invalid file type");
  const n = {
    file_type: e.type,
    file_size: Math.round(e.size / 1024),
    // in KB
    file_name: e.name,
    type: t
  }, { data: s } = await $("post", "UPLOAD_AND_FETCH_QR_DATA", n, "wallet");
  if (!(s != null && s.success))
    throw new Error((s == null ? void 0 : s.message) || "Failed to get upload URL");
  return await yS(s.data.url, e);
}, yS = async (e, t) => {
  var r, n, s;
  try {
    const i = await Re.put(e, t, {
      headers: {
        "Content-Type": t.type,
        "x-amz-acl": "public-read"
      }
    });
    return console.log("S3 upload response:", i.status, i.statusText), (r = e.split("?")) == null ? void 0 : r[0];
  } catch (i) {
    throw console.error("S3 upload failed:", (n = i.response) == null ? void 0 : n.status, ((s = i.response) == null ? void 0 : s.data) || i.message), new Error("Failed to upload icon to storage");
  }
}, XA = (e) => ({
  paymentBonus() {
    if (!e.bonusData || !Array.isArray(e.bonusData))
      return {};
    const t = e.bonusData.filter((r) => r.bonusType === "payment bonus");
    return t.length === 0 ? {} : t.reduce((r, n) => {
      try {
        const s = JSON.parse(n.methodIds);
        Array.isArray(s) && s.forEach((i) => {
          r[i] = n.percentage;
        });
      } catch (s) {
        console.warn("Failed to parse methodIds for payment bonus:", n.methodIds, s);
      }
      return r;
    }, {});
  }
}), QA = async (e, t, r) => {
  var n, s;
  try {
    return e == null || +e < +((n = t == null ? void 0 : t.withdrawal_range) == null ? void 0 : n.min) ? (m("Please enter amount greater than equal to " + ((s = t == null ? void 0 : t.withdrawal_range) == null ? void 0 : s.min)), !1) : +e > +r ? (m("Insufficient Balance"), !1) : !0;
  } catch (i) {
    return console.log(i), !1;
  }
}, ES = async (e, t = 0) => {
  var n;
  let r = {
    withdrawAccountType: null,
    userAccounts: [],
    paymentMethods: []
  };
  try {
    O.dispatch("setGlobalLoader", !0);
    let s = await $("get", "ACCOUNT_DETAILS", null, "wallet");
    return O.dispatch("setGlobalLoader", !1), (n = s == null ? void 0 : s.data) != null && n.success ? (r.userAccounts = s.data.data.account_list.sort(
      (i, o) => Te.convertToTimestamp(o.created_at) - Te.convertToTimestamp(i.created_at)
    ), s.data.data.is_bank_only ? r.paymentMethods = e.filter((i) => i.method_type == "bank") : r.paymentMethods = e) : m(s.data.message), r;
  } catch (s) {
    O.dispatch("setGlobalLoader", !1), t < 3 && !s ? ES(t + 1) : s && m(s[0]);
  }
}, ZA = async (e) => {
  var t, r;
  try {
    let n = await $("delete", "DELETE_ACCOUNT", {}, "wallet", { accountId: e });
    return (t = n == null ? void 0 : n.data) != null && t.success ? (_e((r = n == null ? void 0 : n.data) == null ? void 0 : r.message), !0) : (m(n.data.message), !1);
  } catch (n) {
    return m(n[0]), !1;
  }
}, eN = async (e, t) => {
  var r;
  try {
    O.dispatch("setGlobalLoader", !0);
    let s = await $("post", "GET_ID_WALLET_WITHDRAW", {
      amount: e,
      client_account_index: t,
      // "client_created_date": dateTime.sportItemDate(accountDetails.created_at, 'YYYY-MM-DD HH:mm:ss'),
      type: "client_withdrawal"
    });
    return O.dispatch("setGlobalLoader", !1), s.data.error ? (m(s.data.error), { error: s.data.error }) : (_e((r = s == null ? void 0 : s.data) == null ? void 0 : r.message), !0);
  } catch (n) {
    if (O.dispatch("setGlobalLoader", !1), n)
      return m(n), { error: n };
  }
}, vS = async (e, t) => {
  if (!e) return;
  if (![
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/webp",
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ].includes(e.type))
    return m("Invalid file type");
  const n = {
    file_type: e.type,
    file_size: Math.round(e.size / 1024),
    // in KB
    file_name: e.name,
    type: t
  }, { data: s } = await $("post", "UPLOAD_AND_FETCH_QR_DATA", n, "wallet");
  if (!(s != null && s.success))
    throw new Error((s == null ? void 0 : s.message) || "Failed to get upload URL");
  return await bS(s.data.url, e);
}, bS = async (e, t) => {
  var r, n, s;
  try {
    const i = await Re.put(e, t, {
      headers: {
        "Content-Type": t.type,
        "x-amz-acl": "public-read"
      }
    });
    return (r = e.split("?")) == null ? void 0 : r[0];
  } catch (i) {
    throw console.error("S3 upload failed:", (n = i.response) == null ? void 0 : n.status, ((s = i.response) == null ? void 0 : s.data) || i.message), new Error("Failed to upload icon to storage");
  }
}, tN = async (e, t, r, n) => {
  var s, i;
  try {
    const o = {};
    if (o.payment_method = e.method_type, t == "bank")
      o.method_id = r.method_id, o.account_holder_name = r.account_holder_name, o.account_number = r.account_no, o.ifsc_code = r.ifsc_code, o.transaction_password = r.withdrawal_password;
    else {
      o.method_id = n.method_id, o.account_holder_name = n.account_holder_name, t == "upi" ? o.upi_id = n.upi_id : (o.crypto_wallet_id = n.upi_id, o.crypto_type = "USDT");
      let l = await vS(n.qr_code, "qr-code");
      console.log("res", l), o.qr_code = l, o.transaction_password = n.withdrawal_password;
    }
    let a = await $("post", "ADD_ACCOUNT", o, "wallet");
    return (s = a == null ? void 0 : a.data) != null && s.success ? (_e((i = a == null ? void 0 : a.data) == null ? void 0 : i.message), !0) : (m(a.data.message), !1);
  } catch (o) {
    return m(o[0]), !1;
  }
}, rN = async () => {
  var e, t, r, n;
  try {
    let s = await $("post", "SENT_OTP_TO_MOBILE", {}, "wallet");
    return (e = s == null ? void 0 : s.data) != null && e.success ? (_e((n = s == null ? void 0 : s.data) == null ? void 0 : n.message), !0) : (m((t = s == null ? void 0 : s.data) == null ? void 0 : t.message), { error: (r = s == null ? void 0 : s.data) == null ? void 0 : r.message });
  } catch (s) {
    return m(s[0]), { error: s };
  }
}, nN = (e) => {
  const t = /* @__PURE__ */ new Date(), r = new Date(t.getTime() + 5 * 60 * 1e3);
  let n = 5 * 60, s = !1;
  const i = setInterval(() => {
    n = Math.floor((r - /* @__PURE__ */ new Date()) / 1e3), n <= 0 && (clearInterval(i), n = 0, s = !0), e({ isResentOtpBtnVisiable: s, timeLeft: n, timer: i });
  }, 1e3);
}, sN = async (e) => {
  var t, r, n, s;
  try {
    let i = await $("post", "RESET_WITHDRAWAL_PASSWORD", e, "wallet");
    return (t = i == null ? void 0 : i.data) != null && t.success ? (_e((s = i == null ? void 0 : i.data) == null ? void 0 : s.message), !0) : (m((r = i == null ? void 0 : i.data) == null ? void 0 : r.message), { error: (n = i == null ? void 0 : i.data) == null ? void 0 : n.message });
  } catch (i) {
    return m(i), console.log(i), { error: i };
  }
}, iN = async (e) => {
  var r;
  let t = {
    walletHistoryData: null,
    error: !1
  };
  try {
    let n = {
      from: e.fromDate,
      to: Te.getDateAddedByDays(1, e.toDate)
    }, s = await $("get", "WALLET_HISTORY", null, "wallet", n);
    return (r = s == null ? void 0 : s.data) != null && r.success ? t.walletHistoryData = s.data.data : (m(s.data.message), t.error = !0), t;
  } catch (n) {
    return console.log("wallet", n), m(n), { error: n };
  }
}, oN = (e) => {
  switch (e) {
    case "pending":
      return { label: "Pending", class: "bg-warning" };
    case "approve_completed":
      return { label: "Approved", class: "bg-success" };
    case "approve_in_process":
      return { label: "Approve In Process", class: "bg-success" };
    case "reject_completed":
      return { label: "Rejected", class: "bg-danger" };
    case "reject_in_process":
      return { label: "Reject In Process", class: "bg-danger" };
    case "hold":
      return { label: "Hold", class: "bg-warning" };
    case "expired":
      return { label: "Expired", class: "bg-danger" };
    case "cancelled":
      return { label: "Cancelled", class: "bg-danger" };
  }
}, aN = async (e) => {
  var r;
  let t = {
    error: !1
  };
  try {
    let s = await $("patch", "CANCEL_REQUEST", {}, "wallet", {
      transactionId: e
    });
    return (r = s == null ? void 0 : s.data) != null && r.success ? _e(s.data.message) : (m(s.data.message), t.error = !0), t;
  } catch (n) {
    return m(n), t.error = !0, t;
  }
}, lN = (e) => ({
  transactionImageLists() {
    var t, r;
    return (r = (t = e == null ? void 0 : e.transactionDetails) == null ? void 0 : t.transaction_image_url) == null ? void 0 : r.split(",");
  }
}), cN = async () => {
  var e, t;
  try {
    let r = [], n = await $("get", "GET_MATKAS", null, "sports");
    return (n == null ? void 0 : n.status) === 200 && (((e = n == null ? void 0 : n.data) == null ? void 0 : e.status) === 0 ? m(n.data.debug[0]) : r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.data.filter((s) => s.is_active)), { matkasList: r };
  } catch (r) {
    r && m(r);
  }
}, uN = (e) => {
  try {
    if (!Array.isArray(e) || e.length === 0) return [];
    const t = /* @__PURE__ */ new Date();
    return e.map((r) => {
      let n = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
      try {
        const s = new Date(r.openDate), [i, o] = r.open_bids.split(":");
        s.setHours(parseInt(i)), s.setMinutes(parseInt(o));
        const a = new Date(r.closeDate), [l, u] = r.close_bids.split(":");
        a.setHours(parseInt(l)), a.setMinutes(parseInt(u));
        let c = null;
        if (t < s ? c = s : t >= s && t <= a && (c = a), c) {
          const d = c - t;
          d > 0 && (n.days = Math.floor(d / (1e3 * 60 * 60 * 24)), n.hours = Math.floor(d % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)), n.minutes = Math.floor(d % (1e3 * 60 * 60) / (1e3 * 60)), n.seconds = Math.floor(d % (1e3 * 60) / 1e3));
        }
      } catch (s) {
        console.warn("Countdown calculation error for item:", r, s);
      }
      return {
        ...r,
        countdown: n
      };
    });
  } catch (t) {
    return console.error("updateCountdownForMatka failed:", t), e;
  }
}, dN = (e) => ({
  filteredMatkaList() {
    var t;
    return (t = e == null ? void 0 : e.matkasList) == null ? void 0 : t.filter((r) => VT(r.id));
  },
  delhiMatket() {
    var t;
    return ((t = e == null ? void 0 : e.filteredMatkaList) == null ? void 0 : t.filter((r) => r.category_name == "DELHI MARKET")) || [];
  },
  matkaMatket() {
    var t;
    return ((t = e == null ? void 0 : e.filteredMatkaList) == null ? void 0 : t.filter((r) => r.category_name == "MATKA MARKET")) || [];
  }
}), fN = async (e) => {
  var t, r, n;
  try {
    const s = await $("get", "GET_MATKA_MARKETS", null, "sports", { id: e });
    let i = null;
    return (s == null ? void 0 : s.status) === 200 && (((t = s == null ? void 0 : s.data) == null ? void 0 : t.status) === 0 ? m(s.data.debug[0]) : (i = (r = s == null ? void 0 : s.data) == null ? void 0 : r.data, (!(i != null && i.is_active) || i != null && i.suspend) && m("No active market present. Please try different matka !!"))), {
      matkaDetail: (n = s == null ? void 0 : s.data) == null ? void 0 : n.data
    };
  } catch (s) {
    s && m(s[0]);
  }
}, pN = async (e) => {
  var t, r, n;
  try {
    let s = [];
    const i = await $("post", "GET_MATKA_SINGLE_BETS", {}, "user", { id: e });
    if ((i == null ? void 0 : i.status) === 200)
      return ((t = i == null ? void 0 : i.data) == null ? void 0 : t.status) === 0 ? m(i.data.debug[0]) : s = (n = (r = i == null ? void 0 : i.data) == null ? void 0 : r.bets) == null ? void 0 : n.sort(
        (o, a) => {
          var l, u;
          return (u = (l = a.created_at) == null ? void 0 : l.localeCompare) == null ? void 0 : u.call(l, o.created_at);
        }
      ), { matkaBetsList: s };
  } catch (s) {
    s && m(s[0]);
  }
}, hN = async (e, t, r, n, s, i) => {
  var o, a;
  try {
    let l = {
      date: Te.getcurrentDate(),
      market: e,
      bet_type: t,
      digits: r,
      stake: n == null ? void 0 : n.toString(),
      match_id: s,
      market_id: i
    };
    const u = await $("post", "SAVE_WORLI_MATKA_BET", l, "user");
    if (u)
      return u.status === 200 && (((o = u == null ? void 0 : u.data) == null ? void 0 : o.status) === 0 ? m(u.data.debug[0]) : (a = u == null ? void 0 : u.data) != null && a.error ? m(u.data.error) : _e(u.data.success)), u;
  } catch (l) {
    l && m(l[0]);
  }
}, gN = (e, t, r) => e == null || (e == null ? void 0 : e.length) === 0 ? (m("Please select a digit"), !1) : t == null || t < 10 || t > parseInt(r) ? (m("Please enter a stake value between 10 and " + r), !1) : !0, _N = (e, t) => {
  var s, i;
  let r = [], n = Array.isArray(e.markets) ? e.markets : (s = e.markets) == null ? void 0 : s.data;
  try {
    n.forEach((d) => {
      let f = {
        id: d.id,
        title: d.match_type.toUpperCase() + " (" + Te.convertUtcDate(d.match_time).add(5, "hours").add(30, "minutes").format("hh:mm A") + ")",
        type: d.match_type.toUpperCase(),
        disabled: t == "jodi" || d.is_suspend == 1,
        date: d.match_time
      };
      r.push(f);
    });
    let o = {
      id: n.find((d) => d.match_type == "close").id,
      title: "(Jodi)",
      type: "JODI",
      disabled: (i = n.find((d) => d.match_type == "close")) == null ? void 0 : i.is_suspend,
      date: n[1].match_time
    };
    r.push(o);
    let a = r.filter((d) => !d.disabled)[0], l = (e == null ? void 0 : e.suspend) || 0;
    a || (a = r[0], l = 1, m("No Market available at the moment. Please try different matka !!"));
    let u = Te.getcurrentDate(a.date, "DD-MM-YYYY");
    return { marketTypeList: r, isSuspend: l, currentDate: u, selectedMarketType: a };
  } catch (o) {
    console.log(o);
  }
}, mN = (e = !0, t, r, n, s) => {
  try {
    if (!e)
      for (var i = 0; i < (t == null ? void 0 : t.length); i++)
        t[i].pl = 0;
    for (var o = 0; o < (s == null ? void 0 : s.length); o++)
      if ((r == null ? void 0 : r.type) === "JODI" || (r == null ? void 0 : r.type) === s[o].type) {
        if (n === "jodi" || n === "single") {
          if (n === s[o].selection)
            for (var i = 0; i < t.length; i++)
              t[i].digit === s[o].odds ? t[i].pl = Math.round(
                t[i].pl + (s[o].p_l - s[o].stake)
              ) : t[i].pl = Math.round(
                t[i].pl - s[o].stake
              );
        } else if (s[o].selection.includes("patti"))
          for (var i = 0; i < t.length; i++)
            t[i].digit === s[o].odds ? t[i].pl = Math.round(
              t[i].pl + (s[o].p_l - s[o].stake)
            ) : t[i].pl = Math.round(
              t[i].pl - s[o].stake
            );
      }
    return t;
  } catch (a) {
    console.log(a);
  }
}, yN = (e, t) => {
  if (e.active = !e.active, e.active)
    t.push(e);
  else {
    const r = t.indexOf(e);
    r > -1 && t.splice(r, 1);
  }
  return { selectedDigits: t };
}, wS = (e, t, r) => {
  if (t.length >= r)
    return t;
  const n = Math.floor(Math.random() * e.length), s = e[n];
  return t.includes(s) || (s.active = !0, t.push(s)), wS(e, t, r);
}, EN = ({ digits: e, matkaBetsList: t, marketType: r }) => {
  var n, s, i;
  try {
    for (let o in e) {
      let a = e[o];
      for (let l = 0; l < (a == null ? void 0 : a.length); l++)
        a[l].pl = 0;
    }
    for (let o = 0; o < (t == null ? void 0 : t.length); o++)
      for (let a in e) {
        let l = a;
        if ((r == null ? void 0 : r.type) === ((n = t[o]) == null ? void 0 : n.type)) {
          if (l === "jodi" || l === "single") {
            if (l === t[o].selection)
              for (let u = 0; u < ((s = e[l]) == null ? void 0 : s.length); u++)
                e[l][u].digit == t[o].odds ? e[l][u].pl = Math.round(
                  e[l][u].pl + t[o].p_l
                ) : e[l][u].pl = Math.round(
                  e[l][u].pl - t[o].stake
                );
          } else if (t[o].selection.includes("patti"))
            for (let u = 0; u < ((i = e[l]) == null ? void 0 : i.length); u++)
              e[l][u].digit == t[o].odds ? e[l][u].pl = Math.round(
                e[l][u].pl + t[o].p_l
              ) : e[l][u].pl = Math.round(
                e[l][u].pl - t[o].stake
              );
        }
      }
    return e;
  } catch (o) {
    throw console.error("Error in getBookOfDigit:", o), o;
  }
}, vN = (e, t) => {
  const r = /* @__PURE__ */ new Date(), n = new Date(e), s = new Date(t);
  return r >= n && r <= s;
}, bN = (e) => ({
  checkMatkaActive() {
    var t, r;
    return !((t = e.matkaDetail) != null && t.is_active) || ((r = e.matkaDetail) == null ? void 0 : r.suspend);
  },
  // ------------------- Computed props for draggable design two ----------------------//
  t5FilterMatkaMarkets() {
    var t, r, n;
    if (e != null && e.worliMatkaBetType) {
      if (((t = e == null ? void 0 : e.Mtype) == null ? void 0 : t.type.toLowerCase()) == "open" || ((r = e == null ? void 0 : e.Mtype) == null ? void 0 : r.type.toLowerCase()) == "close")
        return Object.keys(e == null ? void 0 : e.worliMatkaBetType).filter((s) => s === "single" || s === "single patti" || s === "double patti" || s === "triple patti").reduce((s, i) => (s[i] = e == null ? void 0 : e.worliMatkaBetType[i], s), {});
      if (((n = e == null ? void 0 : e.Mtype) == null ? void 0 : n.type.toLowerCase()) == "jodi")
        return Object.keys(e == null ? void 0 : e.worliMatkaBetType).filter((s) => s === "jodi").reduce((s, i) => (s[i] = e == null ? void 0 : e.worliMatkaBetType[i], s), {});
    }
  },
  selectedStake() {
    return O == null ? void 0 : O.getters.selectedMatkaStake;
  }
}), wN = {
  single: [
    { digit: "0", active: !1, pl: 0 },
    { digit: "1", active: !1, pl: 0 },
    { digit: "2", active: !1, pl: 0 },
    { digit: "3", active: !1, pl: 0 },
    { digit: "4", active: !1, pl: 0 },
    { digit: "5", active: !1, pl: 0 },
    { digit: "6", active: !1, pl: 0 },
    { digit: "7", active: !1, pl: 0 },
    { digit: "8", active: !1, pl: 0 },
    { digit: "9", active: !1, pl: 0 }
  ],
  jodi: [
    { digit: "00", active: !1, pl: 0 },
    { digit: "01", active: !1, pl: 0 },
    { digit: "02", active: !1, pl: 0 },
    { digit: "03", active: !1, pl: 0 },
    { digit: "04", active: !1, pl: 0 },
    { digit: "05", active: !1, pl: 0 },
    { digit: "06", active: !1, pl: 0 },
    { digit: "07", active: !1, pl: 0 },
    { digit: "08", active: !1, pl: 0 },
    { digit: "09", active: !1, pl: 0 },
    { digit: "10", active: !1, pl: 0 },
    { digit: "11", active: !1, pl: 0 },
    { digit: "12", active: !1, pl: 0 },
    { digit: "13", active: !1, pl: 0 },
    { digit: "14", active: !1, pl: 0 },
    { digit: "15", active: !1, pl: 0 },
    { digit: "16", active: !1, pl: 0 },
    { digit: "17", active: !1, pl: 0 },
    { digit: "18", active: !1, pl: 0 },
    { digit: "19", active: !1, pl: 0 },
    { digit: "20", active: !1, pl: 0 },
    { digit: "21", active: !1, pl: 0 },
    { digit: "22", active: !1, pl: 0 },
    { digit: "23", active: !1, pl: 0 },
    { digit: "24", active: !1, pl: 0 },
    { digit: "25", active: !1, pl: 0 },
    { digit: "26", active: !1, pl: 0 },
    { digit: "27", active: !1, pl: 0 },
    { digit: "28", active: !1, pl: 0 },
    { digit: "29", active: !1, pl: 0 },
    { digit: "30", active: !1, pl: 0 },
    { digit: "31", active: !1, pl: 0 },
    { digit: "32", active: !1, pl: 0 },
    { digit: "33", active: !1, pl: 0 },
    { digit: "34", active: !1, pl: 0 },
    { digit: "35", active: !1, pl: 0 },
    { digit: "36", active: !1, pl: 0 },
    { digit: "37", active: !1, pl: 0 },
    { digit: "38", active: !1, pl: 0 },
    { digit: "39", active: !1, pl: 0 },
    { digit: "40", active: !1, pl: 0 },
    { digit: "41", active: !1, pl: 0 },
    { digit: "42", active: !1, pl: 0 },
    { digit: "43", active: !1, pl: 0 },
    { digit: "44", active: !1, pl: 0 },
    { digit: "45", active: !1, pl: 0 },
    { digit: "46", active: !1, pl: 0 },
    { digit: "47", active: !1, pl: 0 },
    { digit: "48", active: !1, pl: 0 },
    { digit: "49", active: !1, pl: 0 },
    { digit: "50", active: !1, pl: 0 },
    { digit: "51", active: !1, pl: 0 },
    { digit: "52", active: !1, pl: 0 },
    { digit: "53", active: !1, pl: 0 },
    { digit: "54", active: !1, pl: 0 },
    { digit: "55", active: !1, pl: 0 },
    { digit: "56", active: !1, pl: 0 },
    { digit: "57", active: !1, pl: 0 },
    { digit: "58", active: !1, pl: 0 },
    { digit: "59", active: !1, pl: 0 },
    { digit: "60", active: !1, pl: 0 },
    { digit: "61", active: !1, pl: 0 },
    { digit: "62", active: !1, pl: 0 },
    { digit: "63", active: !1, pl: 0 },
    { digit: "64", active: !1, pl: 0 },
    { digit: "65", active: !1, pl: 0 },
    { digit: "66", active: !1, pl: 0 },
    { digit: "67", active: !1, pl: 0 },
    { digit: "68", active: !1, pl: 0 },
    { digit: "69", active: !1, pl: 0 },
    { digit: "70", active: !1, pl: 0 },
    { digit: "71", active: !1, pl: 0 },
    { digit: "72", active: !1, pl: 0 },
    { digit: "73", active: !1, pl: 0 },
    { digit: "74", active: !1, pl: 0 },
    { digit: "75", active: !1, pl: 0 },
    { digit: "76", active: !1, pl: 0 },
    { digit: "77", active: !1, pl: 0 },
    { digit: "78", active: !1, pl: 0 },
    { digit: "79", active: !1, pl: 0 },
    { digit: "80", active: !1, pl: 0 },
    { digit: "81", active: !1, pl: 0 },
    { digit: "82", active: !1, pl: 0 },
    { digit: "83", active: !1, pl: 0 },
    { digit: "84", active: !1, pl: 0 },
    { digit: "85", active: !1, pl: 0 },
    { digit: "86", active: !1, pl: 0 },
    { digit: "87", active: !1, pl: 0 },
    { digit: "88", active: !1, pl: 0 },
    { digit: "89", active: !1, pl: 0 },
    { digit: "90", active: !1, pl: 0 },
    { digit: "91", active: !1, pl: 0 },
    { digit: "92", active: !1, pl: 0 },
    { digit: "93", active: !1, pl: 0 },
    { digit: "94", active: !1, pl: 0 },
    { digit: "95", active: !1, pl: 0 },
    { digit: "96", active: !1, pl: 0 },
    { digit: "97", active: !1, pl: 0 },
    { digit: "98", active: !1, pl: 0 },
    { digit: "99", active: !1, pl: 0 }
  ],
  "single patti": [
    { digit: "128", active: !1, pl: 0 },
    { digit: "137", active: !1, pl: 0 },
    { digit: "146", active: !1, pl: 0 },
    { digit: "236", active: !1, pl: 0 },
    { digit: "245", active: !1, pl: 0 },
    { digit: "290", active: !1, pl: 0 },
    { digit: "380", active: !1, pl: 0 },
    { digit: "470", active: !1, pl: 0 },
    { digit: "489", active: !1, pl: 0 },
    { digit: "560", active: !1, pl: 0 },
    { digit: "678", active: !1, pl: 0 },
    { digit: "579", active: !1, pl: 0 },
    { digit: "129", active: !1, pl: 0 },
    { digit: "138", active: !1, pl: 0 },
    { digit: "147", active: !1, pl: 0 },
    { digit: "156", active: !1, pl: 0 },
    { digit: "237", active: !1, pl: 0 },
    { digit: "246", active: !1, pl: 0 },
    { digit: "345", active: !1, pl: 0 },
    { digit: "390", active: !1, pl: 0 },
    { digit: "480", active: !1, pl: 0 },
    { digit: "570", active: !1, pl: 0 },
    { digit: "679", active: !1, pl: 0 },
    { digit: "589", active: !1, pl: 0 },
    { digit: "120", active: !1, pl: 0 },
    { digit: "139", active: !1, pl: 0 },
    { digit: "148", active: !1, pl: 0 },
    { digit: "157", active: !1, pl: 0 },
    { digit: "238", active: !1, pl: 0 },
    { digit: "247", active: !1, pl: 0 },
    { digit: "256", active: !1, pl: 0 },
    { digit: "346", active: !1, pl: 0 },
    { digit: "490", active: !1, pl: 0 },
    { digit: "580", active: !1, pl: 0 },
    { digit: "670", active: !1, pl: 0 },
    { digit: "689", active: !1, pl: 0 },
    { digit: "130", active: !1, pl: 0 },
    { digit: "149", active: !1, pl: 0 },
    { digit: "158", active: !1, pl: 0 },
    { digit: "167", active: !1, pl: 0 },
    { digit: "239", active: !1, pl: 0 },
    { digit: "248", active: !1, pl: 0 },
    { digit: "257", active: !1, pl: 0 },
    { digit: "347", active: !1, pl: 0 },
    { digit: "356", active: !1, pl: 0 },
    { digit: "590", active: !1, pl: 0 },
    { digit: "680", active: !1, pl: 0 },
    { digit: "789", active: !1, pl: 0 },
    { digit: "140", active: !1, pl: 0 },
    { digit: "159", active: !1, pl: 0 },
    { digit: "168", active: !1, pl: 0 },
    { digit: "230", active: !1, pl: 0 },
    { digit: "249", active: !1, pl: 0 },
    { digit: "258", active: !1, pl: 0 },
    { digit: "267", active: !1, pl: 0 },
    { digit: "348", active: !1, pl: 0 },
    { digit: "357", active: !1, pl: 0 },
    { digit: "456", active: !1, pl: 0 },
    { digit: "690", active: !1, pl: 0 },
    { digit: "780", active: !1, pl: 0 },
    { digit: "123", active: !1, pl: 0 },
    { digit: "150", active: !1, pl: 0 },
    { digit: "169", active: !1, pl: 0 },
    { digit: "178", active: !1, pl: 0 },
    { digit: "240", active: !1, pl: 0 },
    { digit: "259", active: !1, pl: 0 },
    { digit: "268", active: !1, pl: 0 },
    { digit: "349", active: !1, pl: 0 },
    { digit: "358", active: !1, pl: 0 },
    { digit: "457", active: !1, pl: 0 },
    { digit: "367", active: !1, pl: 0 },
    { digit: "790", active: !1, pl: 0 },
    { digit: "124", active: !1, pl: 0 },
    { digit: "160", active: !1, pl: 0 },
    { digit: "179", active: !1, pl: 0 },
    { digit: "250", active: !1, pl: 0 },
    { digit: "269", active: !1, pl: 0 },
    { digit: "278", active: !1, pl: 0 },
    { digit: "340", active: !1, pl: 0 },
    { digit: "359", active: !1, pl: 0 },
    { digit: "368", active: !1, pl: 0 },
    { digit: "458", active: !1, pl: 0 },
    { digit: "467", active: !1, pl: 0 },
    { digit: "890", active: !1, pl: 0 },
    { digit: "125", active: !1, pl: 0 },
    { digit: "134", active: !1, pl: 0 },
    { digit: "170", active: !1, pl: 0 },
    { digit: "189", active: !1, pl: 0 },
    { digit: "260", active: !1, pl: 0 },
    { digit: "279", active: !1, pl: 0 },
    { digit: "350", active: !1, pl: 0 },
    { digit: "369", active: !1, pl: 0 },
    { digit: "378", active: !1, pl: 0 },
    { digit: "459", active: !1, pl: 0 },
    { digit: "567", active: !1, pl: 0 },
    { digit: "468", active: !1, pl: 0 },
    { digit: "126", active: !1, pl: 0 },
    { digit: "135", active: !1, pl: 0 },
    { digit: "180", active: !1, pl: 0 },
    { digit: "234", active: !1, pl: 0 },
    { digit: "270", active: !1, pl: 0 },
    { digit: "289", active: !1, pl: 0 },
    { digit: "360", active: !1, pl: 0 },
    { digit: "379", active: !1, pl: 0 },
    { digit: "450", active: !1, pl: 0 },
    { digit: "469", active: !1, pl: 0 },
    { digit: "478", active: !1, pl: 0 },
    { digit: "568", active: !1, pl: 0 },
    { digit: "127", active: !1, pl: 0 },
    { digit: "136", active: !1, pl: 0 },
    { digit: "145", active: !1, pl: 0 },
    { digit: "190", active: !1, pl: 0 },
    { digit: "235", active: !1, pl: 0 },
    { digit: "280", active: !1, pl: 0 },
    { digit: "370", active: !1, pl: 0 },
    { digit: "479", active: !1, pl: 0 },
    { digit: "460", active: !1, pl: 0 },
    { digit: "569", active: !1, pl: 0 },
    { digit: "389", active: !1, pl: 0 },
    { digit: "578", active: !1, pl: 0 }
  ],
  "double patti": [
    { digit: "100", active: !1, pl: 0 },
    { digit: "119", active: !1, pl: 0 },
    { digit: "155", active: !1, pl: 0 },
    { digit: "227", active: !1, pl: 0 },
    { digit: "335", active: !1, pl: 0 },
    { digit: "344", active: !1, pl: 0 },
    { digit: "399", active: !1, pl: 0 },
    { digit: "588", active: !1, pl: 0 },
    { digit: "669", active: !1, pl: 0 },
    { digit: "110", active: !1, pl: 0 },
    { digit: "200", active: !1, pl: 0 },
    { digit: "228", active: !1, pl: 0 },
    { digit: "255", active: !1, pl: 0 },
    { digit: "336", active: !1, pl: 0 },
    { digit: "499", active: !1, pl: 0 },
    { digit: "660", active: !1, pl: 0 },
    { digit: "688", active: !1, pl: 0 },
    { digit: "778", active: !1, pl: 0 },
    { digit: "166", active: !1, pl: 0 },
    { digit: "229", active: !1, pl: 0 },
    { digit: "300", active: !1, pl: 0 },
    { digit: "337", active: !1, pl: 0 },
    { digit: "355", active: !1, pl: 0 },
    { digit: "445", active: !1, pl: 0 },
    { digit: "599", active: !1, pl: 0 },
    { digit: "779", active: !1, pl: 0 },
    { digit: "788", active: !1, pl: 0 },
    { digit: "112", active: !1, pl: 0 },
    { digit: "220", active: !1, pl: 0 },
    { digit: "266", active: !1, pl: 0 },
    { digit: "338", active: !1, pl: 0 },
    { digit: "400", active: !1, pl: 0 },
    { digit: "446", active: !1, pl: 0 },
    { digit: "455", active: !1, pl: 0 },
    { digit: "699", active: !1, pl: 0 },
    { digit: "770", active: !1, pl: 0 },
    { digit: "113", active: !1, pl: 0 },
    { digit: "122", active: !1, pl: 0 },
    { digit: "177", active: !1, pl: 0 },
    { digit: "339", active: !1, pl: 0 },
    { digit: "366", active: !1, pl: 0 },
    { digit: "447", active: !1, pl: 0 },
    { digit: "500", active: !1, pl: 0 },
    { digit: "799", active: !1, pl: 0 },
    { digit: "889", active: !1, pl: 0 },
    { digit: "114", active: !1, pl: 0 },
    { digit: "277", active: !1, pl: 0 },
    { digit: "330", active: !1, pl: 0 },
    { digit: "448", active: !1, pl: 0 },
    { digit: "466", active: !1, pl: 0 },
    { digit: "556", active: !1, pl: 0 },
    { digit: "600", active: !1, pl: 0 },
    { digit: "880", active: !1, pl: 0 },
    { digit: "899", active: !1, pl: 0 },
    { digit: "115", active: !1, pl: 0 },
    { digit: "133", active: !1, pl: 0 },
    { digit: "188", active: !1, pl: 0 },
    { digit: "223", active: !1, pl: 0 },
    { digit: "377", active: !1, pl: 0 },
    { digit: "449", active: !1, pl: 0 },
    { digit: "557", active: !1, pl: 0 },
    { digit: "566", active: !1, pl: 0 },
    { digit: "700", active: !1, pl: 0 },
    { digit: "116", active: !1, pl: 0 },
    { digit: "224", active: !1, pl: 0 },
    { digit: "233", active: !1, pl: 0 },
    { digit: "288", active: !1, pl: 0 },
    { digit: "440", active: !1, pl: 0 },
    { digit: "477", active: !1, pl: 0 },
    { digit: "558", active: !1, pl: 0 },
    { digit: "800", active: !1, pl: 0 },
    { digit: "990", active: !1, pl: 0 },
    { digit: "117", active: !1, pl: 0 },
    { digit: "144", active: !1, pl: 0 },
    { digit: "199", active: !1, pl: 0 },
    { digit: "225", active: !1, pl: 0 },
    { digit: "388", active: !1, pl: 0 },
    { digit: "559", active: !1, pl: 0 },
    { digit: "577", active: !1, pl: 0 },
    { digit: "667", active: !1, pl: 0 },
    { digit: "900", active: !1, pl: 0 },
    { digit: "118", active: !1, pl: 0 },
    { digit: "226", active: !1, pl: 0 },
    { digit: "244", active: !1, pl: 0 },
    { digit: "299", active: !1, pl: 0 },
    { digit: "334", active: !1, pl: 0 },
    { digit: "488", active: !1, pl: 0 },
    { digit: "550", active: !1, pl: 0 },
    { digit: "668", active: !1, pl: 0 },
    { digit: "677", active: !1, pl: 0 }
  ],
  "triple patti": [
    { digit: "000", active: !1, pl: 0 },
    { digit: "111", active: !1, pl: 0 },
    { digit: "222", active: !1, pl: 0 },
    { digit: "333", active: !1, pl: 0 },
    { digit: "444", active: !1, pl: 0 },
    { digit: "555", active: !1, pl: 0 },
    { digit: "666", active: !1, pl: 0 },
    { digit: "777", active: !1, pl: 0 },
    { digit: "888", active: !1, pl: 0 },
    { digit: "999", active: !1, pl: 0 }
  ]
}, TN = (e, t) => {
  if (e && t) {
    let r = 0, n = 0;
    for (; e; )
      r += e % 10, e = Math.floor(e / 10);
    for (; t; )
      n += t % 10, t = Math.floor(t / 10);
    return r % 10 + " " + n % 10;
  } else
    return "NYD";
}, SN = async (e) => e.mobileNo ? e.mobileNo.toString().length != 10 ? (m(Ue("phone-number-must-10", "Phone Number Must be 10 digit.")), !1) : !0 : (m(Ue("please-enter-phone-number", "Please Enter Phone Number.")), !1), ON = async (e, t, r) => {
  var s, i;
  let n = {
    otpErrorRes: null,
    otpSuccessRes: null,
    reactiveState: r
  };
  try {
    let o = {
      type: e,
      mobile: t.mobileNo,
      countrycode: t.code.includes("+") ? (s = t == null ? void 0 : t.code) == null ? void 0 : s.replace("+", "") : t.code
    }, a = await $("post", "SEND_OTP", o);
    return a && a.status == 200 ? (n.reactiveState.isOtpApiCalled = !0, n.reactiveState.otpSent = !0, n.reactiveState.isDisabled = !1, n.reactiveState.resendOtp = !0, n.reactiveState.timerRunning = !0, n.reactiveState.minutes = 5, n.reactiveState.seconds = 0, n.reactiveState.loadingOtp = !1, n.otpSuccessRes = { status: a.status, message: a.data.data }, _e(a.data.data)) : (n.otpErrorRes = ((i = a == null ? void 0 : a.data) == null ? void 0 : i.error) || "Something went wrong", n.reactiveState.loadingOtp = !1), n;
  } catch (o) {
    return console.log(o[0]), m(o[0] || "Something went wrong"), {
      otpErrorRes: o[0] || "Something went wrong",
      loadingOtp: !1
    };
  }
}, Ni = (e) => e.otp ? +e.otp : "", AN = async (e, t, r) => e === 0 && t === 0 ? (r = !1, { minutes: e, seconds: t, timerRunning: r, countDown: !1 }) : (t === 0 ? (e--, t = 59) : t--, { minutes: e, seconds: t, timerRunning: r, countDown: !0 }), NN = async (e, t, r) => (e == "password" ? t = t === "password" ? "text" : "password" : r = r === "password" ? "text" : "password", { passwordFieldType: t, confPasswordFieldType: r }), CN = async (e, t, r, n, s) => {
  var o, a, l, u, c, d, f, g, _, p, y, b;
  let i = {
    userData: null,
    loginErrorRes: null,
    loginSuccessRes: null
  };
  try {
    let A = {
      userid: r.toString(),
      type: TS(n),
      password: n.password,
      countrycode: n.code
    }, v = await $("post", e, t != "demo" ? A : null);
    return v && v.status == 200 ? ((o = v == null ? void 0 : v.data) == null ? void 0 : o.status) == 0 || (a = v == null ? void 0 : v.data) != null && a.error || (l = v == null ? void 0 : v.data) != null && l.msg ? ((u = v == null ? void 0 : v.data) != null && u.msg ? i.loginErrorRes = "Something went wrong" : i.loginErrorRes = (c = v == null ? void 0 : v.data) == null ? void 0 : c.error, m((d = v == null ? void 0 : v.data) == null ? void 0 : d.error)) : (_e((f = v == null ? void 0 : v.data) == null ? void 0 : f.success), i.loginSuccessRes = v.data.success, i.userData = v == null ? void 0 : v.data, O.dispatch("setClickBetValue", [...s]), O.dispatch("setToken", `Bearer ${(_ = (g = i.userData) == null ? void 0 : g.user) == null ? void 0 : _.token}`), t == "demo" && (i.userData.demo = !0), Tp(i.userData), Sp((y = (p = i.userData) == null ? void 0 : p.user) == null ? void 0 : y.userid, n)) : i.loginErrorRes = ((b = v == null ? void 0 : v.data) == null ? void 0 : b.error) || "Something went wrong", i;
  } catch (A) {
    return console.log(A), {
      loginErrorRes: A || "Something went wrong"
    };
  }
}, TS = (e) => (O.getters.siteSettings.business_type == 1 && (e.type = 2), e.type == 2 ? "userid" : "phone"), DN = async (e, t, r) => {
  var s, i, o, a, l, u, c, d, f, g, _, p;
  let n = {
    userData: null,
    loginErrorRes: null,
    loginSuccessRes: null
  };
  try {
    let y = {
      mobile: e.toString(),
      countrycode: t.code,
      otp: t.otp
    }, b = await $("post", "LOGIN_WITH_OTP", y);
    return b && b.status == 200 ? ((s = b == null ? void 0 : b.data) == null ? void 0 : s.status) == 0 || (i = b == null ? void 0 : b.data) != null && i.error || (o = b == null ? void 0 : b.data) != null && o.msg ? ((a = b == null ? void 0 : b.data) != null && a.msg ? n.loginErrorRes = "Something went wrong" : n.loginErrorRes = (l = b == null ? void 0 : b.data) == null ? void 0 : l.error, m((u = b == null ? void 0 : b.data) == null ? void 0 : u.error)) : (_e((c = b == null ? void 0 : b.data) == null ? void 0 : c.success), n.loginSuccessRes = b.data.success, n.userData = b == null ? void 0 : b.data, O.dispatch("setClickBetValue", [...r]), O.dispatch("setToken", `Bearer ${(f = (d = n.userData) == null ? void 0 : d.user) == null ? void 0 : f.token}`), Tp(n == null ? void 0 : n.userData), Sp((_ = (g = n == null ? void 0 : n.userData) == null ? void 0 : g.user) == null ? void 0 : _.userid, t)) : n.loginErrorRes = ((p = b == null ? void 0 : b.data) == null ? void 0 : p.error) || "Something went wrong", n;
  } catch (y) {
    return console.log(y), {
      loginErrorRes: y || "Something went wrong"
    };
  }
}, IN = (e) => (e.type = 1, e.userId = "demouser", e.password = "demopass", e), MN = (e, t) => {
  var r;
  return ((r = t == null ? void 0 : t.data) == null ? void 0 : r.business_type) == 2 && e.type == 1 ? e.mobileNo : e.userId;
}, Tp = async (e) => {
  var r;
  let t = {
    notificationSubscribed: null,
    notificationUnsubscribed: null,
    isDemo: (e == null ? void 0 : e.demo) || !1
  };
  O.dispatch("setUser", { ...e == null ? void 0 : e.user, ...t }), O.dispatch("setChips", (r = e == null ? void 0 : e.user) == null ? void 0 : r.chips), O.dispatch("setEventManage", e == null ? void 0 : e.event_manage);
}, Sp = (e, t) => {
  var n, s, i, o;
  let r = ((s = (n = O.getters) == null ? void 0 : n.logInData) == null ? void 0 : s.userIds) || [];
  if (t.type == 2) {
    (o = (i = ge()) == null ? void 0 : i.user) != null && o.last_login_at && r.push(e);
    let a = {
      logInWithMobile: !1,
      userIds: r
    };
    O.dispatch("setLogInData", a);
  } else {
    let a = {
      logInWithMobile: !0,
      userIds: r
    };
    O.dispatch("setLogInData", a);
  }
}, RN = async (e) => {
  var r, n, s, i, o, a, l, u, c;
  let t = {
    data: null,
    signUpErrorRes: null,
    signUpSuccessRes: null
  };
  try {
    let d = No("downline", window.location.href), f = No("af_code", window.location.href), g = f ? "" : No("refer_code", window.location.href), _ = {
      userid: e.userName,
      mobile: e.mobileNo,
      password: e.password,
      otp: Ni(e),
      isDownLine: d || !1,
      refer_code: g || e.referCode,
      country_code: e.code.includes("+") ? (r = e == null ? void 0 : e.code) == null ? void 0 : r.replace("+", "") : e.code,
      affiliate_code: f
    }, p = await $("post", "REGISTER", _);
    return p && p.status == 200 ? ((n = p == null ? void 0 : p.data) == null ? void 0 : n.status) == 0 || (s = p == null ? void 0 : p.data) != null && s.error || (i = p == null ? void 0 : p.data) != null && i.msg ? ((o = p == null ? void 0 : p.data) != null && o.msg ? t.signUpErrorRes = "Something went wrong" : t.signUpErrorRes = (a = p == null ? void 0 : p.data) == null ? void 0 : a.error, m((l = p == null ? void 0 : p.data) == null ? void 0 : l.error)) : (_e((u = p == null ? void 0 : p.data) == null ? void 0 : u.success), t.signUpSuccessRes = p.data.success, t.data = p == null ? void 0 : p.data) : t.signUpErrorRes = ((c = p == null ? void 0 : p.data) == null ? void 0 : c.error) || "Something went wrong", t;
  } catch (d) {
    return console.log(d), {
      signUpErrorRes: d
    };
  }
}, LN = async (e, t, r) => {
  try {
    if (e) {
      var n = /^(?=.*?[a-z])(?=.*?[0-9]).{8,20}$/, s = /^.{6,25}$/;
      let i = Ni(t);
      if (t.mobileNo) {
        if (i.toString().length != 6 || t.password == "" || t.confirmPassword == "")
          return m(Ue("please-fill-all-fields", "Please fill all fields.")), !1;
        if (n.test(t.password)) {
          if (t.password != t.confirmPassword)
            return m(Ue("password-mismatch-msg", "Password and confirm password not same.")), !1;
          if (!s.test(t.userName) && r && t.userName)
            m("User ID length should be between 6 and 25 characters.");
          else
            return !0;
        } else return m(Ue("forget-valid-msg", "Must Contain At Least 1 In Capital Case. Must Be Between 8-20 Characters And Should Be Alphanumeric.")), !1;
      } else return m(Ue("please-enter-mobile-number", "Please enter mobile number.")), !1;
    } else
      return m("Call for OTP."), !1;
  } catch (i) {
    return console.log(i), !1;
  }
}, No = (e, t) => {
  t || (t = location.href), e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var r = "[\\?&]" + e + "=([^&#]*)", n = new RegExp(r), s = n.exec(t);
  return s == null ? null : s[1];
}, xN = async (e) => {
  var r, n, s, i, o, a, l, u, c;
  let t = {
    data: null,
    forgotPassErrorRes: null,
    forgotPassSuccessRes: null
  };
  try {
    let d = {
      mobile: e.mobileNo,
      countrycode: e.code.includes("+") ? (r = e == null ? void 0 : e.code) == null ? void 0 : r.replace("+", "") : e.code,
      password: e.password,
      confirm_password: e.confirmPassword,
      otp: Ni(e)
    }, f = await $("post", "FORGOT_PASSWORD", d);
    return f && f.status == 200 ? ((n = f == null ? void 0 : f.data) == null ? void 0 : n.status) == 0 || (s = f == null ? void 0 : f.data) != null && s.error || (i = f == null ? void 0 : f.data) != null && i.msg ? ((o = f == null ? void 0 : f.data) != null && o.msg ? t.forgotPassErrorRes = "Something went wrong" : t.forgotPassErrorRes = (a = f == null ? void 0 : f.data) == null ? void 0 : a.error, m((l = f == null ? void 0 : f.data) == null ? void 0 : l.error)) : (_e((u = f == null ? void 0 : f.data) == null ? void 0 : u.success), t.forgotPassSuccessRes = f.data.success, t.data = f == null ? void 0 : f.data) : t.forgotPassErrorRes = ((c = f == null ? void 0 : f.data) == null ? void 0 : c.error) || "Something went wrong", t;
  } catch (d) {
    return console.log(d), {
      forgotPassErrorRes: d
    };
  }
}, kN = async (e, t) => {
  let r = {
    passwordValidation: !1,
    continueForgetCall: !0
  };
  try {
    if (!e)
      return r.continueForgetCall = !1, r;
    let n = Ni(t);
    r.passwordValidation = !1;
    let s = /^(?=.*?[a-z])(?=.*?[0-9]).{8,20}$/, i = typeof n == "number" ? n.toString().length : typeof n == "string" ? n.length : 0;
    if (t.mobileNo) {
      if (i != 6 || t.password == "" || t.confirmPassword == "")
        return console.log(n), console.log(t), m("Please fill all fields."), r.continueForgetCall = !1;
      if (s.test(t.password)) {
        if (t.password != t.confirmPassword)
          return m("Password and confirm password not same."), r.continueForgetCall = !1;
      } else return m("Must Contain At Least 1 In Capital Case. Must Be Between 8-20 Characters And Should Be Alphanumeric."), r.continueForgetCall = !1;
    } else return m("Please enter mobile number."), r.continueForgetCall = !1;
    return r;
  } catch (n) {
    return console.log(n), r.continueForgetCall = !1, r;
  }
}, PN = async (e, t, r, n = "") => {
  var i, o, a, l, u, c, d, f, g, _, p, y, b, A, v;
  let s = {
    userData: null,
    changeErrorRes: null
  };
  try {
    const D = new FormData();
    D.append("current_password", e), D.append("password", t), D.append("confirm_password", r);
    let w = await $("post", "CHANGE_MY_PASSWORD", D);
    if (w && w.status == 200)
      if (((i = w == null ? void 0 : w.data) == null ? void 0 : i.status) == 0 || (o = w == null ? void 0 : w.data) != null && o.error || (a = w == null ? void 0 : w.data) != null && a.msg)
        w.data.msg ? s.changeErrorRes = "Something went wrong" : s.changeErrorRes = (l = w == null ? void 0 : w.data) == null ? void 0 : l.error, m((u = w == null ? void 0 : w.data) == null ? void 0 : u.error);
      else {
        if (((c = O.getters.siteSettings) == null ? void 0 : c.business_type) == 2 && !((f = (d = ge()) == null ? void 0 : d.user) != null && f.last_login_at) && n && !((_ = (g = ge()) == null ? void 0 : g.user) != null && _.phone)) {
          let z = await SS(n);
          if (z)
            return s.changeErrorRes = z, m(z), s;
        }
        _e((p = w == null ? void 0 : w.data) == null ? void 0 : p.success);
        let j = ge().user;
        if (j.is_fresh = 0, j.is_password_secure = 1, j.is_withDraw_password = !0, OS(), !((b = (y = O.getters) == null ? void 0 : y.stateUser) != null && b.last_login_at)) {
          let z = (A = O.getters) == null ? void 0 : A.stateUser;
          z.last_login_at = parseInt(Date.now() / 1e3), O.dispatch("setUser", z);
        }
      }
    else
      s.changeErrorRes = ((v = w == null ? void 0 : w.data) == null ? void 0 : v.error) || "Something went wrong";
    return s;
  } catch (D) {
    return console.log(D), {
      changeErrorRes: D || "Something went wrong"
    };
  }
}, SS = async (e) => {
  var t;
  try {
    let r = await $("post", "UPDATE_TXN_PASSWORD", { txn_password: e }, "wallet");
    return !r || r.status !== 200 ? ((t = r == null ? void 0 : r.data) == null ? void 0 : t.error) || "Something went wrong" : void 0;
  } catch (r) {
    return console.error(r), r[0] || "Something went wrong";
  }
}, OS = async () => {
  var n, s, i, o, a, l;
  (s = (n = ge()) == null ? void 0 : n.user) == null || s.userid;
  let e = ((o = (i = O.getters) == null ? void 0 : i.logInData) == null ? void 0 : o.userIds) || [], r = {
    logInWithMobile: (l = (a = O.getters) == null ? void 0 : a.logInData) == null ? void 0 : l.logInWithMobile,
    userIds: e
  };
  O.dispatch("setLogInData", r);
}, $N = async () => {
  var e, t, r, n;
  try {
    let s = await $("post", "LOGOUT_API");
    if (s && s.status == 200) {
      if (((e = s == null ? void 0 : s.data) == null ? void 0 : e.status) == 0)
        return m(s.data.debug[0]), { error: s.data.debug[0] };
      {
        O.dispatch("setIs_offer", !0), _e((t = s == null ? void 0 : s.data) == null ? void 0 : t.success), O.dispatch("resetAllState");
        let i = {
          logInWithMobile: !1,
          userIds: (n = (r = O.getters) == null ? void 0 : r.logInData) == null ? void 0 : n.userIds
        };
        return O.dispatch("setLogInData", i), { error: !1 };
      }
    }
  } catch (s) {
    return console.log(s), { error: response.data.debug[0] };
  }
}, FN = async (e) => {
  try {
    let t = {
      chips: {
        ...e
      }
    }, r = await $("post", "CHANGE_STAKE_VALUES", t);
    if (r && r.status == 200)
      return O.dispatch("setChips", e), _e(Ue("saved-successfully", "Saved successfully.")), { error: !1 };
  } catch (t) {
    return m(t[0]), { error: t[0] };
  }
}, VN = async (e) => {
  var r, n;
  let t = {
    error: !1,
    isWelcomeBonus: null,
    userData: null
  };
  try {
    let i = await $("post", "CHANGE_USER_BONUS", {
      password: e
    });
    if (i && i.status == 200)
      return i.data.error ? (m(i.data.error), t.isWelcomeBonus = !1, t.error = !0, t) : (_e(i.data.success), t.userData = i == null ? void 0 : i.data, O.dispatch("setToken", `Bearer ${(n = (r = t == null ? void 0 : t.userData) == null ? void 0 : r.user) == null ? void 0 : n.token}`), AS(t.userData), t);
  } catch (s) {
    return t.isWelcomeBonus = !1, t.error = !0, m(s[0]), t;
  }
}, AS = (e) => {
  var t;
  O.dispatch("setUser", e == null ? void 0 : e.user), O.dispatch("setChips", (t = e == null ? void 0 : e.user) == null ? void 0 : t.chips), O.dispatch("setEventManage", e == null ? void 0 : e.event_manage);
}, BN = async () => {
  var t;
  let e = {
    error: !1,
    lockedEarnedData: null
  };
  try {
    let r = await $("get", "GET_LOCKED_EARNED_BONUS", null, "bonus");
    if (r && r.status == 200)
      return r.data.error ? (m(r.data.error), e.error = !0, e) : (e.lockedEarnedData = r.data.data, e.lockedEarnedData.earnBonus = (t = ge()) == null ? void 0 : t.user.earnBonus, O.dispatch("setUserBonus", e.lockedEarnedData), e);
  } catch (r) {
    return e.error = !0, m(r[0]), e;
  }
}, UN = async (e, t, r) => {
  try {
    const n = Te.currentTimestamp();
    let s = r - n;
    if (s <= 0)
      return clearInterval(t), e = { hours: 0, minutes: 0, seconds: 0 }, { countdown: e, timer: t };
    const i = String(Math.floor(s / 3600)).padStart(2, "0"), o = String(Math.floor(s % 3600 / 60)).padStart(2, "0"), a = String(s % 60).padStart(2, "0");
    return e = { hours: i, minutes: o, seconds: a }, { countdown: e, timer: t };
  } catch (n) {
    console.log(n);
  }
}, HN = async (e) => {
  let t = {
    error: !1,
    getWalletType: e,
    data: null
  };
  try {
    let r = await $("post", "UPDATE_WALLET_TYPE", {});
    if (r && r.status == 200) {
      if (r.data.error)
        return m(r.data.error), t.error = !0, t.getWalletType = !e, t;
      {
        t.data = r.data;
        let n = ge().user;
        return n.actw = r.data.active_wallet, n.token = r.data.token, O.dispatch("setUser", n), O.dispatch("setGlobalLoader", !0), _e("Changed Successfully"), O.dispatch("setToken", `Bearer ${r.data.token}`), t;
      }
    }
  } catch (r) {
    return m(r[0]), t.error = !0, t.getWalletType = !e, t;
  }
}, jN = async (e) => {
  if (navigator.clipboard && window.isSecureContext)
    navigator.clipboard.writeText(e).then(() => {
    }).catch((t) => {
      console.error("Failed to copy: ", t);
    });
  else {
    let t = document.createElement("textarea");
    t.value = e, document.body.appendChild(t), t.select(), document.execCommand("copy"), document.body.removeChild(t);
  }
}, YN = async (e) => {
  var t;
  try {
    let r = await $("post", "UPDATE_USER_NAME", { display_name: e });
    if (r && r.status == 200)
      return (t = r == null ? void 0 : r.data) != null && t.error ? (m(r.data.error), { error: r.data.error }) : (ge().user.name = e, _e(r.data.message), { error: !1 });
  } catch (r) {
    return m(r[0]), { error: r[0] };
  }
}, GN = async (e, t) => {
  let r = {
    amount: e.userBonusData.welcomeBonusData.bonus_settings.amount,
    type: "welcomeBonus"
  }, n = await $("post", "REDEEM_USER_BONUS", r, "user");
  n && (n.data.error ? m(n.data.error) : (_e(n.data), setTimeout(() => {
    t.go();
  }, 2e3)));
}, WN = (e) => ({
  isAffiliate() {
    var t;
    return (t = e == null ? void 0 : e.bonusData) == null ? void 0 : t.find((r) => (r == null ? void 0 : r.bonusType) == "affiliate bonus");
  }
}), qN = (e) => ({
  chipValues() {
    var t;
    return (t = Object.keys(e == null ? void 0 : e.chips)) == null ? void 0 : t.filter((r) => r.startsWith("chip_val"));
  }
}), KN = async () => {
  var t, r, n, s, i, o, a, l;
  let e = {
    error: null,
    iframeUrl: null
  };
  try {
    const u = (r = (t = ge()) == null ? void 0 : t.user) == null ? void 0 : r.user_id, c = (n = ge()) != null && n.status ? "GET_CHATBOT_IFRAME" : "GET_CHATBOT_IFRAME_GUEST", d = u && !((s = ge()) != null && s.status) ? { userid: u } : {}, f = await $("post", c, d);
    if (f && f.status == 200) {
      if ((i = f == null ? void 0 : f.data) != null && i.error)
        return m((o = f == null ? void 0 : f.data) == null ? void 0 : o.error), e.error = (a = f == null ? void 0 : f.data) == null ? void 0 : a.error, e;
      (l = f == null ? void 0 : f.data) != null && l.chat_bot_url && (e.iframeUrl = f.data.chat_bot_url);
    }
    return e;
  } catch (u) {
    m(u);
  }
}, zN = (e) => ({
  userName() {
    var t, r;
    return ((r = (t = O.getters) == null ? void 0 : t.stateUser) == null ? void 0 : r.userid) || null;
  }
}), JN = async (e, t, r) => {
  var n = document.createElement("textarea");
  n.innerHTML = e == "code" ? t.user.refer_code : r, document.body.appendChild(n), n.select(), document.execCommand("copy"), document.body.removeChild(n), _e(e == "code" ? "Code Successfully copied." : "Link Successfully copied.");
}, XN = async (e) => {
  var r, n;
  let t = {
    error: !1,
    statementType: null,
    activeBonusData: null,
    totalBonusData: null
  };
  try {
    let s = {
      error: !1,
      statementType: null,
      activeBonusData: null,
      totalBonusData: null
    }, i = await $("get", "GET_BONUS_STATEMENT", null, "user", { bonusType: e });
    if (i)
      return (r = i == null ? void 0 : i.data) != null && r.error ? (m((n = i == null ? void 0 : i.data) == null ? void 0 : n.error), s.error = !0) : (s.error = !1, s.statementType = e, s.activeBonusData = i.data.data, s.totalBonusData = i.data.total), s;
  } catch (s) {
    return t.error = s, t;
  }
}, QN = async () => {
  var t, r, n;
  let e = {
    error: !1,
    referBonusData: null
  };
  try {
    let s = await $("get", "GET_REFERED_USER");
    if (s)
      return (t = s == null ? void 0 : s.data) != null && t.error ? (m((r = s == null ? void 0 : s.data) == null ? void 0 : r.error), e.error = !0) : (e.error = !1, e.referBonusData = (n = s == null ? void 0 : s.data) == null ? void 0 : n.data), e;
  } catch (s) {
    return console.log(s, "err"), e.error = s, e;
  }
}, ZN = async (e) => {
  var r, n;
  let t = {
    error: !1,
    referUserLog: null
  };
  try {
    let s = await $("get", "GET_BONUS_LOGS", null, "bonus", { refer_to: e.user_id });
    return s && ((r = s == null ? void 0 : s.data) != null && r.error ? (m((n = s == null ? void 0 : s.data) == null ? void 0 : n.error), t.error = !0) : (t.error = !1, t.referUserLog = s.data.data)), t;
  } catch (s) {
    return console.log(s), t.error = s, t;
  }
}, eC = async (e, t, r) => {
  var n;
  try {
    let s = await $("post", "REDEEM_USER_BONUS", { type: t[r], id: e }, "user");
    s && ((n = s == null ? void 0 : s.data) != null && n.error ? m(s.data.error) : _e(s.data));
  } catch (s) {
    console.log(s);
  }
}, tC = (e, t) => parseFloat(t / e * 100).toFixed(2), rC = (e, t, r) => r ? parseFloat(t / e * r).toFixed(2) : 0, nC = (e) => ({
  getReferLink() {
    var t, r;
    return window.location.origin + "/register?refer_code=" + ((r = (t = ge()) == null ? void 0 : t.user) == null ? void 0 : r.refer_code);
  },
  referAndEarnBonus() {
    var t, r;
    return (r = (t = O == null ? void 0 : O.getters) == null ? void 0 : t.bonusData) == null ? void 0 : r.find((n) => n.bonusType == "first refer&earn");
  },
  t5GetReferLink() {
    var t, r;
    return window.location.origin + "/sign-up?refer_code=" + ((r = (t = ge()) == null ? void 0 : t.user) == null ? void 0 : r.refer_code);
  }
}), sC = async () => {
  var e, t;
  try {
    let n = {
      userId: O.getters.stateUser.userid,
      domainName: window.location.hostname
    }, s = await $("post", "NOTIFICATIONS_LIST_API", n, "notification");
    return s ? {
      error: !1,
      all_notifications_List: s.data.data.sort((i, o) => new Date(o.created_at) - new Date(i.created_at))
    } : (m((e = error == null ? void 0 : error.data) == null ? void 0 : e.message), { error: !0 });
  } catch (r) {
    return console.log(r), { error: (t = r == null ? void 0 : r.data) == null ? void 0 : t.message };
  }
}, iC = (e) => ({
  unreadNotifications() {
    var t;
    return (t = e == null ? void 0 : e.allNotificationsList) == null ? void 0 : t.filter((r) => (r == null ? void 0 : r.is_read) == !1);
  }
}), oC = async (e, t) => {
  var n, s, i, o;
  let r = {
    error: !1,
    marketList: null,
    selectedMarketItem: null
  };
  try {
    let a = await $("get", "GET_MY_MARKETS", null, "user", { sport_type: e, page: t });
    if (a)
      return (n = a == null ? void 0 : a.data) != null && n.error ? (m((s = a == null ? void 0 : a.data) == null ? void 0 : s.error), r.error = (i = a == null ? void 0 : a.data) == null ? void 0 : i.error) : (r.marketList = (o = a.data.data) == null ? void 0 : o.sort((l, u) => ((u == null ? void 0 : u.event_timestamp_date) ?? (u == null ? void 0 : u.worli_timestamp_date) ?? 0) - ((l == null ? void 0 : l.event_timestamp_date) ?? (l == null ? void 0 : l.worli_timestamp_date) ?? 0)), r.selectedMarketItem = e, r.pagination = Le.getPaginationData(a == null ? void 0 : a.data)), r;
  } catch (a) {
    return m(a[0]), r.error = a == null ? void 0 : a[0], r;
  }
}, aC = async (e, t) => {
  var o, a, l, u, c;
  let r = ((o = O == null ? void 0 : O.getters) == null ? void 0 : o.favouriteGames) || e, n = ((a = O == null ? void 0 : O.getters) == null ? void 0 : a.eventManage) || t, s = {
    error: !1,
    favouriteSportsList: null,
    marketOdds: {}
  };
  try {
    let d = await $("get", "FIND_BY_IDS", null, "sports", { eventIds: r.join() });
    if (d && d.status == 200) {
      if (((l = d == null ? void 0 : d.data) == null ? void 0 : l.status) == 0)
        m(d.data.debug[0]), s.error = d.data.debug[0];
      else {
        s.favouriteSportsList = (u = d == null ? void 0 : d.data) == null ? void 0 : u.data;
        let f = [], g = [];
        (c = ge()) != null && c.status && n && (f = n == null ? void 0 : n.filter((p) => p.type == "match").map((p) => p.type_id), g = n == null ? void 0 : n.filter((p) => p.type == "league").map((p) => p.type_id)), s.favouriteSportsList = s.favouriteSportsList.filter((p) => Rr(p.sport_id) && hn(p.event_id, p.league_id, f, g) ? (p.favourite = !0, !0) : !1);
        let _ = (p) => {
          let y = p;
          for (var b = 0; b < y.runners.length; b++)
            for (var A = 0; A < y.runnerNames.length; A++)
              y.runners[b].sid == y.runnerNames[A].SID && (y.runners[b].runner_name = y.runnerNames[A].RN);
          return p;
        };
        for (var i = 0; i < s.favouriteSportsList.length; i++)
          _(s.favouriteSportsList[i]);
        for (let p of s.favouriteSportsList)
          s.marketOdds[p.market_id] = p.runners;
      }
      return s;
    }
  } catch (d) {
    return console.log(d), m(d), s.error = d, s;
  }
}, lC = async () => {
  var t;
  let e = {
    error: !1,
    marketBookAndExposure: null,
    marketOdds: {}
  };
  try {
    const r = await $("get", "GET_ALL_MARKET_BOOK", null);
    return r && r.status == 200 && (e.marketBookAndExposure = r.data.data), e;
  } catch (r) {
    return m(r), e.error = (t = r == null ? void 0 : r.data) == null ? void 0 : t.message, e;
  }
}, cC = async (e) => {
  var r, n, s, i;
  let t = {
    error: null,
    virtualSportsUrl: null
  };
  try {
    let a = await $("post", "GET_THIRD_PARTY_API", {
      type: "virtual-betradar",
      productType: e ?? "vci"
    }, "user");
    if (a) {
      if ((r = a == null ? void 0 : a.data) != null && r.error)
        return m((n = a == null ? void 0 : a.data) == null ? void 0 : n.error), t.error = (i = (s = a == null ? void 0 : a.data) == null ? void 0 : s.error) == null ? void 0 : i.toString(), t;
      t.virtualSportsUrl = a.data.url;
    }
    return t;
  } catch {
    return m("Something went wrong please refresh the page !"), t.error = "Something went wrong please refresh the page !", t;
  }
}, uC = (e) => ({
  isAffiliate() {
    var t;
    return (t = e == null ? void 0 : e.bonusData) == null ? void 0 : t.find((r) => (r == null ? void 0 : r.bonusType) == "affiliate bonus");
  }
}), dC = async (e, t, r) => {
  var s, i, o, a, l, u, c, d;
  let n = {
    error: null
  };
  try {
    let f = {
      userid: e.userName,
      mobile: e.mobileNo,
      password: e.password,
      otp: Op(r),
      country_code: e.code.includes("+") ? (s = e == null ? void 0 : e.code) == null ? void 0 : s.replace("+", "") : e.code,
      affiliate_code: (o = (i = ge()) == null ? void 0 : i.user) == null ? void 0 : o.affiliate_code,
      confirm_password: e.confirmPassword,
      self_password: t
    }, g = await $("post", "AFFILIATE_REGISTER", f);
    return g && g.status == 200 ? ((a = g == null ? void 0 : g.data) == null ? void 0 : a.status) == 0 || (l = g == null ? void 0 : g.data) != null && l.error || (u = g == null ? void 0 : g.data) != null && u.msg ? ((c = g == null ? void 0 : g.data) != null && c.msg ? (n.error = !0, m("Something went wrong")) : (n.error = !0, m(g.data.error)), n) : (_e((d = g == null ? void 0 : g.data) == null ? void 0 : d.success), n) : n;
  } catch (f) {
    return n.error = !0, console.log(f), n;
  }
}, fC = async (e, t, r, n) => {
  try {
    var s = /^(?=.*?[a-z])(?=.*?[0-9]).{8,20}$/;
    let i = Op(n);
    return t.mobileNo && !e ? (m(Ue("please-request-otp", "Please request OTP.")), !1) : t.mobileNo && (i == null ? void 0 : i.length) !== 6 ? (m(Ue("please-enter-otp", "Please enter OTP.")), !1) : s.test(t.password) ? t.password !== t.confirmPassword ? (m(Ue("password-mismatch-msg", "Password and confirm password not same.")), !1) : r ? !0 : (m(Ue("enter-user-password", "Please enter your password.")), !1) : (m(Ue("forget-valid-msg", "Must Contain At Least 1 In Capital Case. Must Be Between 8-20 Characters And Should Be Alphanumeric.")), !1);
  } catch (i) {
    return console.log(i), !1;
  }
}, Op = (e) => e == null ? void 0 : e.join().toString().replaceAll(",", ""), pC = async (e, t) => {
  var n, s, i;
  let r = {
    error: null,
    reactiveState: t
  };
  try {
    let o = {
      type: "registration",
      mobile: e.mobileNo,
      countrycode: e.code.includes("+") ? (n = e == null ? void 0 : e.code) == null ? void 0 : n.replace("+", "") : e.code
    }, a = await $("post", "SEND_OTP", o);
    return a && a.status == 200 ? (_e(a.data.data), r.reactiveState.isOtpApiCalled = !0, r.reactiveState.timerRunning = !0, r.reactiveState.minutes = 5, r.reactiveState.seconds = 0, r.error = !1) : (r.error = ((s = a == null ? void 0 : a.data) == null ? void 0 : s.error) || "Something went wrong", m(((i = a == null ? void 0 : a.data) == null ? void 0 : i.error) || "Something went wrong")), r;
  } catch (o) {
    return console.log(o[0]), m(o[0] || "Something went wrong"), r.error = o[0] || "Something went wrong";
  }
}, hC = async (e, t) => {
  let r = e || t;
  navigator.clipboard.writeText(r).then(() => {
    _e("Successfully copied.");
  }).catch((n) => {
    console.error("Failed to copy text: ", n), m("Failed to copy.");
  });
}, gC = async (e) => {
  var r, n, s, i, o;
  let t = {
    error: null,
    reactiveState: e
  };
  try {
    let a = await $("get", "GET_AFFILIATE_DASHBOARD", null, "user");
    if (a && a.status == 200) {
      if (((r = a == null ? void 0 : a.data) == null ? void 0 : r.status) == 0)
        return m(a.data.debug[0]), t.error = a.data.debug[0], t;
      t.reactiveState.dashboardData = a.data, ((s = (n = t.reactiveState.dashboardData) == null ? void 0 : n.profit_loss) == null ? void 0 : s.length) > 0 && (t.reactiveState.profitLossEvent = t.reactiveState.dashboardData.profit_loss[0]), t.reactiveState.chartOptions = {
        ...t.reactiveState.chartOptions,
        xaxis: {
          categories: (i = t.reactiveState.dashboardData) == null ? void 0 : i.lossing_users.map((l) => l.userid)
        }
      }, t.reactiveState.chartSeries = [{
        name: "Loose Amount",
        data: (o = t.reactiveState.dashboardData) == null ? void 0 : o.lossing_users.map((l) => -1 * parseFloat(l.pl).toFixed(2))
      }];
    }
    return t;
  } catch (a) {
    return m(a), t.error = a[0], t;
  }
}, _C = async () => {
  try {
    const e = document.getElementById("qrCanvas"), t = document.createElement("a");
    t.href = e.toDataURL("image/png"), t.download = "qrcode.png", t.click();
  } catch (e) {
    console.log(e);
  }
}, mC = async (e, t) => {
  var n;
  let r = {
    error: null,
    affPl: null
  };
  try {
    let s = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD")
    }, i = await $("post", "GET_PROFIT_LOSS_EVENT_USERS", s);
    if (i && i.status == 200) {
      if (((n = i == null ? void 0 : i.data) == null ? void 0 : n.status) === 0 || i.data.error)
        return m(i.data.error), r.error = i.data.error, r;
      r.affPl = i.data.data;
    }
    return r;
  } catch (s) {
    return m(s == null ? void 0 : s[0]), r.error = s == null ? void 0 : s[0], r;
  }
}, yC = async (e, t, r, n) => {
  var i, o, a, l;
  let s = {
    error: null,
    currReportType: r,
    affReport: null
  };
  try {
    if (r == "commision" && n)
      return s.error = !0, s;
    s.currReportType = "commision";
    let u = {
      type: "ab",
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD")
    }, c = await $("post", "GET_STATEMENTS", u);
    if (c && c.status == 200) {
      if ((i = c == null ? void 0 : c.data) != null && i.error)
        return m((o = c == null ? void 0 : c.data) == null ? void 0 : o.error), s.error = (a = c == null ? void 0 : c.data) == null ? void 0 : a.error, s;
      s.affReport = (l = c == null ? void 0 : c.data) == null ? void 0 : l.data;
    }
    return s;
  } catch (u) {
    return m(u), s.error = u[0], s;
  }
}, EC = async (e, t, r, n) => {
  var i, o, a, l;
  let s = {
    error: null,
    currReportType: r,
    affReport: null
  };
  try {
    if (r == "user" && n)
      return s.error = !0, s;
    s.currReportType = "user";
    let u = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD")
    }, c = await $("post", "GET_AFFILIATE_REGISTER_USER_COUNT", u);
    if (c && c.status == 200) {
      if ((i = c == null ? void 0 : c.data) != null && i.error)
        return m((o = c == null ? void 0 : c.data) == null ? void 0 : o.error), s.error = (a = c == null ? void 0 : c.data) == null ? void 0 : a.error, s;
      s.affReport = (l = c == null ? void 0 : c.data) == null ? void 0 : l.data;
    }
    return s;
  } catch (u) {
    return m(u), s.error = u[0], s;
  }
}, vC = async (e, t, r) => {
  var s, i;
  let n = {
    error: null,
    affReport: null,
    totalPage: null
  };
  try {
    let a = await $("get", "GET_AFFILIATE_USERSLIST", null, "user", {
      type: r,
      from: e,
      to: t
    });
    if (a && a.status == 200) {
      if (((s = a == null ? void 0 : a.data) == null ? void 0 : s.status) === 0)
        return m(a.data.debug[0]), n.error = a.data.debug[0], n;
      {
        let l = (i = a.data) == null ? void 0 : i.userList;
        n.totalPage = l == null ? void 0 : l.last_page, n.affReport = l == null ? void 0 : l.data;
      }
    }
    return n;
  } catch (o) {
    return m(o), n.error = o[0], n;
  }
}, bC = async (e, t, r) => {
  var s, i, o, a, l, u;
  let n = {
    error: null,
    statementsList: null
  };
  try {
    let c = {
      type: (e == null ? void 0 : e.reportType) != "all" && (e == null ? void 0 : e.reportType) != "dw" ? e == null ? void 0 : e.gameSubType : e == null ? void 0 : e.reportType,
      page_entries: 25,
      sub_type: null,
      from: Te.getcurrentDate(e.fromDate, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, e.toDate, "YYYY-MM-DD"),
      affiliate_user_id: t
    }, d = await $("post", "GET_STATEMENTS", c, "user", { page: r });
    if (d && d.status == 200) {
      if ((s = d == null ? void 0 : d.data) != null && s.error)
        return m((i = d == null ? void 0 : d.data) == null ? void 0 : i.error), n.error = (o = d == null ? void 0 : d.data) == null ? void 0 : o.error, n;
      (l = (a = d == null ? void 0 : d.data) == null ? void 0 : a.data) != null && l.statements || (n.statementsList = (u = d == null ? void 0 : d.data) == null ? void 0 : u.data, n.pagination = Le.getPaginationData(d == null ? void 0 : d.data));
    }
    return n;
  } catch (c) {
    return m(c), n.error = c[0], n;
  }
}, wC = async (e, t) => {
  var n, s, i, o, a;
  let r = {
    error: null,
    profitLossList: null
  };
  try {
    let l = {
      from: Te.getcurrentDate(e.fromDate, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, e.toDate, "YYYY-MM-DD"),
      affiliate_user_id: t
    }, u = await $("post", "GET_PROFIT_LOSS", l, "user");
    if (u && u.status == 200) {
      if ((n = u == null ? void 0 : u.data) != null && n.error)
        return m((s = u == null ? void 0 : u.data) == null ? void 0 : s.error), r.error = (i = u == null ? void 0 : u.data) == null ? void 0 : i.error, r;
      (o = u == null ? void 0 : u.data) != null && o.data.statements || (r.profitLossList = (a = u == null ? void 0 : u.data) == null ? void 0 : a.data);
    }
    return r;
  } catch (l) {
    return m(l), r.error = l[0], r;
  }
}, TC = async (e, t) => {
  var n, s, i, o, a, l, u;
  const r = [];
  if (!t || t.length === 0) {
    m("No Data Found");
    return;
  }
  for (let c = 0; c < t.length; c++) {
    let d = {
      No: c + 1,
      "Event Name": (n = t[c]) == null ? void 0 : n.event_name,
      "Match Date": Te.convertUnixDate((s = t[c]) == null ? void 0 : s.bet_timestamp_date),
      Odds: (i = t[c]) == null ? void 0 : i.odds,
      "Profit Loss": (o = t[c]) == null ? void 0 : o.p_l,
      Selection: (a = t[c]) == null ? void 0 : a.selection,
      "Selection Type": (l = t[c]) == null ? void 0 : l.selection_type,
      Stake: (u = t[c]) == null ? void 0 : u.stake
    };
    r.push(d);
  }
  r.length > 0 ? e == "E" ? Le.downloadExcel(r, "Bets.xlsx") : e == "P" && Le.downloadPdf(r, "Bets.pdf") : m("No Data Found");
}, SC = async (e, t) => {
  var r, n, s, i, o, a, l, u, c;
  if (t && t.length != 0) {
    const d = [];
    for (let f = 0; f < t.length; f++) {
      let g = {
        No: f + 1,
        "Match Date": (r = t[f]) == null ? void 0 : r.bet_place_time,
        Commission: (s = (n = t[f]) == null ? void 0 : n.commission) == null ? void 0 : s.toFixed(2),
        // 'Liability': openBetsList[i]?.liability,
        Odds: (i = t[f]) == null ? void 0 : i.odds,
        "Profit Loss": (o = t[f]) == null ? void 0 : o.p_l,
        Rate: (a = t[f]) == null ? void 0 : a.rate,
        Selection: (l = t[f]) == null ? void 0 : l.selection,
        Stake: (u = t[f]) == null ? void 0 : u.stake,
        Type: (c = t[f]) == null ? void 0 : c.type
      };
      d.push(g);
    }
    e == "E" ? Le.downloadExcel(d, "Bets.xlsx") : e == "P" && Le.downloadPdf(d, "Bets.pdf");
  } else
    m("No Data Found");
}, OC = async (e, t) => {
  var r, n, s, i, o, a, l, u;
  if (t && t.length != 0) {
    const c = [];
    for (let d = 0; d < t.length; d++) {
      let f = {
        No: d + 1,
        Date: Te.convertDate((r = t == null ? void 0 : t[d]) == null ? void 0 : r.date, "DD MMM YYYY, hh:mm:ss A"),
        Description: (n = t[d]) == null ? void 0 : n.des,
        Credit: ((s = t[d]) == null ? void 0 : s.pl) >= 0 ? parseFloat(Le.formatNumber((i = t[d]) == null ? void 0 : i.pl)) : 0,
        Debit: ((o = t[d]) == null ? void 0 : o.pl) < 0 ? parseFloat(Le.formatNumber((a = t[d]) == null ? void 0 : a.pl)) : 0,
        Balance: Le.formatNumber((l = t[d]) == null ? void 0 : l.balance),
        Remark: ((u = t[d]) == null ? void 0 : u.remark) || "-"
      };
      c.push(f);
    }
    e == "E" ? (Le.downloadExcel(c, "Statement.xlsx"), _e("Excel File Successfully Downloaded")) : e == "P" && (Le.downloadPdf(c, "Statement.pdf"), _e("Pdf File Successfully Downloaded"));
  } else
    m("No Data Found");
}, AC = async (e, t) => {
  var r, n, s, i, o, a;
  if (t && t.length != 0) {
    const l = [];
    for (let u = 0; u < t.length; u++) {
      let c = {
        No: u + 1,
        Date: Te.convertUnixDate((r = t[u]) == null ? void 0 : r.date),
        Event: (n = t[u]) == null ? void 0 : n.match_name,
        Commission: (i = (s = t[u]) == null ? void 0 : s.com) == null ? void 0 : i.toFixed(2),
        Type: (o = t[u]) == null ? void 0 : o.type,
        PL: (a = t[u]) == null ? void 0 : a.pl
      };
      l.push(c);
    }
    e == "E" ? Le.downloadExcel(l, "ProfitLoss.xlsx") : e == "P" && Le.downloadPdf(l, "ProfitLoss.pdf");
  } else
    m("No Data Found");
}, NC = async (e, t, r, n, s) => {
  var o, a, l, u, c;
  let i = {
    error: null,
    profitAndLossList: null
  };
  try {
    let d = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD"),
      type: r.type,
      sport_id: r.sport_id,
      affiliate_user_id: s
    }, f = await $("post", "GET_PROFIT_LOSS_PL_DETAIL", d, "user", { page: n });
    if (f && f.status == 200) {
      if ((o = f == null ? void 0 : f.data) != null && o.error)
        return m((a = f == null ? void 0 : f.data) == null ? void 0 : a.error), i.error = (l = f == null ? void 0 : f.data) == null ? void 0 : l.error, i;
      r.sport_id ? i.profitAndLossList = (u = f == null ? void 0 : f.data) == null ? void 0 : u.data : i.profitAndLossList = (c = f == null ? void 0 : f.data) == null ? void 0 : c.data.data;
    }
    return i;
  } catch (d) {
    return m(d), i.error = d[0], i;
  }
}, CC = async (e, t, r, n) => {
  var i, o, a;
  let s = {
    error: null,
    marketBets: null
  };
  try {
    let l = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD"),
      match_id: r,
      affiliate_user_id: n
    }, u = await $("post", "GET_PROFIT_LOSS_MATCH_DETAIL", l);
    if (u && u.status == 200) {
      if ((i = u == null ? void 0 : u.data) != null && i.error)
        return m((o = u == null ? void 0 : u.data) == null ? void 0 : o.error), s.error = (a = u == null ? void 0 : u.data) == null ? void 0 : a.error, s;
      s.marketBets = u.data.data;
    }
    return s;
  } catch (l) {
    return m(l), s.error = l[0], s;
  }
}, DC = async () => {
  var e, t, r;
  try {
    const n = await $("get", "FANTASY_SETUP_DATA", null, "fantasy");
    if (n && n.status === 200)
      return ((e = n == null ? void 0 : n.data) == null ? void 0 : e.status) === 0 && m((r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.debug) == null ? void 0 : r[0]), n;
  } catch (n) {
    n && m(n[0]);
  }
}, IC = async (e) => {
  var t, r, n;
  try {
    const i = await $("post", "GET_REMEMBERED_MATCHES", {
      match_ids: e
    }, "fantasy");
    if (i && i.status == 200)
      return ((t = i == null ? void 0 : i.data) == null ? void 0 : t.status) == 0 && m((n = (r = i == null ? void 0 : i.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]), i;
  } catch (s) {
    s && m(s[0]);
  }
}, MC = async (e, t) => {
  var r, n, s, i;
  try {
    const a = await $("post", "ADD_MATCH_REMINDER", {
      match_id: e,
      before_minute: t
    }, "fantasy");
    if (a && a.status == 200)
      if (((r = a == null ? void 0 : a.data) == null ? void 0 : r.status) == 0)
        m((s = (n = a == null ? void 0 : a.data) == null ? void 0 : n.debug) == null ? void 0 : s[0]);
      else
        return a;
  } catch (o) {
    o && m((i = o[0].split(" ")) == null ? void 0 : i.slice(2).join(" "));
  }
}, RC = async (e) => {
  var t, r, n;
  try {
    const s = await $("post", "REMOVE_MATCH_REMINDER", { match_id: e.id }, "fantasy");
    if (s && s.status == 200)
      if (((t = s == null ? void 0 : s.data) == null ? void 0 : t.status) == 0)
        m((n = (r = s == null ? void 0 : s.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]);
      else
        return s;
  } catch (s) {
    s && m(s[0]);
  }
}, LC = (e) => {
  const t = Date.now() / 1e3;
  return e.map((r) => {
    let n = r.event_date_timestamp - t, s, i, o;
    return n <= 0 ? r.remainingTime = "LIVE" : (s = Math.floor(n / 86400), r.remainingTime = s + "D : ", n -= s * 86400, i = Math.floor(n / 3600) % 24, r.remainingTime += i + "H : ", n -= i * 3600, o = Math.floor(n / 60) % 60, r.remainingTime += o + "M : ", n -= o * 60, r.remainingTime += Math.floor(n % 60) + "S"), r;
  });
}, xC = async (e) => {
  var t, r, n;
  try {
    let s = null;
    const i = await $("get", "PLAYERS_LIST_API", null, "fantasy", { matchId: e });
    if (i && i.status == 200)
      return ((t = i == null ? void 0 : i.data) == null ? void 0 : t.status) == 0 ? m((n = (r = i == null ? void 0 : i.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : s = i.data.data.sort(() => Math.random() - 0.5), { MatchPlayersList: s };
  } catch (s) {
    m(s[0]);
  }
}, kC = async () => {
  var e, t, r;
  try {
    const n = await $("post", "GET_MY_STAKES", null, "fantasy");
    if (n && n.status == 200)
      return ((e = n == null ? void 0 : n.data) == null ? void 0 : e.status) == 0 && m((r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.debug) == null ? void 0 : r[0]), n;
  } catch (n) {
    m(n[0]);
  }
}, PC = async (e, t, r, n) => {
  var s, i, o, a, l;
  try {
    let u = {
      match_id: parseInt(e),
      user_team_players: t == null ? void 0 : t.toString(),
      fight_team_players: r == null ? void 0 : r.toString(),
      team_name: n
    }, c = await $("post", "ADD_MY_TEAM", u, "fantasy");
    if (c && c.status == 200)
      return ((s = c == null ? void 0 : c.data) == null ? void 0 : s.status) == 0 && m((o = (i = c == null ? void 0 : c.data) == null ? void 0 : i.debug) == null ? void 0 : o[0]), c;
  } catch (u) {
    m((l = (a = u[0]) == null ? void 0 : a.split(" ")) == null ? void 0 : l.slice(2).join(" "));
  }
}, $C = async (e) => {
  var t, r, n;
  try {
    let s = null;
    const i = await $("post", "GET_TEAM_DETAILS", null, "fantasy", { id: e });
    return i && i.status == 200 && (((t = i == null ? void 0 : i.data) == null ? void 0 : t.status) == 0 ? m((n = (r = i == null ? void 0 : i.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : (console.log(s, i.data.data, "response data"), s = i.data.data)), { resData: s };
  } catch (s) {
    m(s[0]);
  }
}, FC = async (e, t) => {
  var r, n, s;
  try {
    const o = await $("post", "UPDATE_MYTEAM_NAME", {
      team_id: e,
      team_name: t
    }, "fantasy");
    if (o && o.status == 200)
      return ((r = o == null ? void 0 : o.data) == null ? void 0 : r.status) == 0 && m((s = (n = o == null ? void 0 : o.data) == null ? void 0 : n.debug) == null ? void 0 : s[0]), o;
  } catch (i) {
    console.log(i), m(i[0]);
  }
}, VC = async (e, t) => {
  var r, n, s, i;
  try {
    let o = await $("post", "BET_DETAILS", { match_id: e }, "fantasy");
    if ((o == null ? void 0 : o.status) === 200 && ((r = o.data) == null ? void 0 : r.status) !== 0) {
      const a = o.data;
      a.forEach((c) => c.date = c.placed_at);
      const l = (n = a.sort((c, d) => d.date - c.date)) == null ? void 0 : n.filter((c) => c.team.team_id == t), u = (c) => l.filter((d) => d.bet_type === c).length;
      return {
        myBetLists: l,
        teamBetTypeCount: u(1),
        runBetTypeCount: u(2),
        ballBetTypeCount: u(3)
      };
    } else
      m((i = (s = o == null ? void 0 : o.data) == null ? void 0 : s.debug) == null ? void 0 : i[0]);
  } catch (o) {
    m(o[0]);
  }
}, BC = async (e, t, r, n, s) => {
  var o, a, l, u;
  if (e.bet_lock)
    return m(Ue("bet-not-allowed", "Bet is not allowed for this event currently!"));
  if (t && Object.keys(t).length > 0) {
    if (!NS(r, t)) return;
  } else {
    let c = {};
    if (r.stakeAmount < 10 && (c.stakeError = "The Amount Must Be At Least 10"), r.stakeRange > 50 && (c.stakeRange = "The Range Must Be At less than 50"), (o = Object.keys(c)) != null && o.length)
      return c;
  }
  const i = {
    bets: {
      [r.betType]: {
        bet_type: r.betType,
        match_id: parseInt(s),
        stake_amount: parseInt(r.stakeAmount),
        stake_range: r.stakeRange ? parseInt(r.stakeRange) : 0,
        team_id: n.players_team_id
      }
    },
    match_id: s
  };
  try {
    const c = await $("post", "PLACE_BET", i, "fantasy");
    if (((a = c == null ? void 0 : c.data) == null ? void 0 : a.status) == 0)
      m((u = (l = c == null ? void 0 : c.data) == null ? void 0 : l.debug) == null ? void 0 : u[0]);
    else
      return c;
  } catch (c) {
    console.log(c), m(c[0]);
  }
}, NS = (e, t) => {
  const r = (s, i, o) => !(s > (i == null ? void 0 : i.max) || s < (i == null ? void 0 : i.min)), n = (s, i, o) => !(s > i);
  return e.betType === 1 ? r(e.stakeAmount, t.team_stake) : e.betType === 2 ? r(e.stakeAmount, t.run_stake) && n(e.stakeRange, t.run_count.max) : e.betType === 3 ? r(e.stakeAmount, t.ball_stake) && n(e.stakeRange, t.ball_count.max) : !0;
}, UC = async (e, t, r) => {
  const n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
  if (e === "amt_stake") {
    for (let i of t)
      if (i !== "" && (i = parseInt(i)), n.add(i), i < 10 || i > 1e7)
        return m(Ue("stake-limit-msg", "Stake value should be in between 10 to 10000000"));
    if (n.size !== t.length)
      return m(Ue("stake-duplicate-msg", "Edit stake Fields should not accept duplicate values"));
  }
  if (e === "rate_stake") {
    for (const [i, o] of r) {
      const a = parseInt(i), l = parseInt(o);
      if (n.add(a), s.add(l), a < 10 || a > 1e7)
        return m(Ue("stake-limit-msg", "Stake value should be in between 10 to 10000000"));
      if (l < 1 || l > 1e4)
        return m(Ue("ball-run-1-10000", "Ball/Run should be in between 1 to 10000"));
    }
    if (n.size !== r.length || s.size !== r.length)
      return m(Ue("stake-duplicate-msg", "Edit stake Fields should not accept duplicate values"));
  }
  try {
    return await $("post", "UPDATE_MY_STAKES", {
      type: e,
      stakes: e === "amt_stake" ? t : r
    }, "fantasy");
  } catch (i) {
    m(i[0]);
  }
}, HC = (e) => {
  const t = /* @__PURE__ */ new Date() / 1e3;
  let r = (e == null ? void 0 : e.event_date_timestamp) - t;
  const n = Math.floor(r / 86400);
  r -= n * 86400;
  const s = Math.floor(r / 3600);
  r -= s * 3600;
  const i = Math.floor(r / 60), o = Math.floor(r % 60), a = !(n <= 0 && s <= 0 && i <= 5);
  return { timeString: `${n}D : ${s}H : ${i}M : ${o}S`, cancelBetEnable: a };
}, jC = async (e, t) => {
  var i, o, a, l;
  const r = ((o = ((i = t == null ? void 0 : t.team) == null ? void 0 : i.team_id) || (t == null ? void 0 : t.team_id)) == null ? void 0 : o.split("0")) || [], n = ((l = ((a = t == null ? void 0 : t.team) == null ? void 0 : a.computer_team_id) || (t == null ? void 0 : t.computer_team_id)) == null ? void 0 : l.split("0")) || [], s = (u) => {
    const c = [];
    for (let d = 0; d < u.length; ) {
      const { player: f, offset: g } = Ap(e, u[d], u, d, 0);
      f ? (c.push(f[0]), d += g ? g + 1 : 1) : d++;
    }
    return c.sort((d, f) => d.category_id - f.category_id);
  };
  return {
    myBetTeamPlayers: s(r),
    computerBetTeamPlayers: s(n)
  };
}, Ap = (e, t, r, n, s) => {
  const i = e.filter((a) => a.player_id == t);
  if (i.length) return { player: i, offset: s };
  const o = t + "0" + r[n + ++s];
  return Ap(e, o, r, n, s);
}, YC = (e, t, r) => {
  const n = [], s = [];
  for (let i = 0; i < e.length; i++)
    for (let o = 0; o < t.length; o++)
      t[o] == e[i].player_id && n.push(e[i]);
  for (let i = 0; i < e.length; i++)
    for (let o = 0; o < r.length; o++)
      r[o] == e[i].player_id && s.push(e[i]);
  return n.sort((i, o) => i.category_id - o.category_id), s.sort((i, o) => i.category_id - o.category_id), {
    myTeam: n,
    computerTeam: s
  };
}, GC = async (e) => {
  try {
    const r = await $("post", "RESET_MYTEAM", {
      team_id: e
    }, "fantasy");
    return r && r.status == 200 && _e(r.data.message), r;
  } catch (t) {
    console.log(t);
  }
}, WC = (e, t, r, n) => {
  const s = t.indexOf(e.player_id);
  s !== -1 ? t.splice(s, 1) : t.push(e.player_id), n.forEach((i) => {
    if (i.category_id === e.category_id && i.player_id !== e.player_id) {
      const o = r.indexOf(i.player_id);
      o !== -1 ? r.splice(o, 1) : r.push(i.player_id);
    }
  });
}, qC = async (e) => {
  var t, r, n;
  try {
    const s = { type: e };
    let i = null;
    const o = await $("post", "MY_CONTESTS_LIST", s, "fantasy");
    return o && o.status == 200 && (((t = o == null ? void 0 : o.data) == null ? void 0 : t.status) == 0 ? (void 0).$errorToast((n = (r = o == null ? void 0 : o.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : i = o.data), { myContests: i };
  } catch (s) {
    return s && m(s[0]), s;
  }
}, KC = async (e) => {
  var t, r, n;
  try {
    const s = { match_id: e };
    let i = null;
    const o = await $("post", "MY_CONTEST_BET_LIST", s, "fantasy");
    return o && o.status == 200 && (((t = o == null ? void 0 : o.data) == null ? void 0 : t.status) == 0 ? (void 0).$errorToast((n = (r = o == null ? void 0 : o.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : i = o.data), { teamsBetList: i };
  } catch (s) {
    return s && m(s[0]), s;
  }
}, zC = (e, t) => {
  for (var r = { runs: 0, balls: 0 }, n = { runs: 0, balls: 0 }, s = 0; s < e.length; s++) {
    var i = e[s];
    i.abandoned || (r.runs += i.runs, r.balls += i.balls);
  }
  for (var s = 0; s < t.length; s++) {
    var i = t[s];
    i.abandoned || (n.runs += i.runs, n.balls += i.balls);
  }
  return {
    myScore: r,
    computerScore: n
  };
}, JC = async (e) => {
  var t, r, n;
  try {
    const s = { match_id: e };
    let i = [], o = null;
    const a = await $("post", "MY_CONTEST_BET_LIST", s, "fantasy");
    return a && a.status === 200 && (((t = a == null ? void 0 : a.data) == null ? void 0 : t.status) === 0 ? m((n = (r = a == null ? void 0 : a.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : (i = a.data, o = new Set(
      i.map((u) => u.team_id)
    ).size)), { teamsBetList: i, totalJoinedTeams: o };
  } catch (s) {
    return s && m(s[0]), s;
  }
}, XC = async (e, t, r, n, s, i) => {
  var a, l, u, c, d, f;
  let o = {
    error: null,
    openBetsList: null,
    from: ""
  };
  try {
    let g = {
      type: r,
      sub_type: t,
      status: e,
      page_entries: i,
      from: n.fromDate,
      to: n.toDate
    };
    r !== "sport" && (g.sub_type = null);
    let _ = await $("post", "OPEN_BETS_EVENT_LISTING", g, "user", { page: s });
    if (_ && _.status == 200) {
      if ((a = _ == null ? void 0 : _.data) != null && a.error)
        return m((l = _ == null ? void 0 : _.data) == null ? void 0 : l.error), o.error = (u = _ == null ? void 0 : _.data) == null ? void 0 : u.error, o;
      o.openBetsList = (d = (c = _ == null ? void 0 : _.data) == null ? void 0 : c.data) == null ? void 0 : d.data, o.pagination = Le.getPaginationData((f = _ == null ? void 0 : _.data) == null ? void 0 : f.data);
    }
    return o;
  } catch (g) {
    return m(g), o.error = g[0], o;
  }
}, QC = async (e, t, r) => {
  var s, i, o, a;
  let n = {
    error: null,
    statementsList: null
  };
  try {
    let l = {
      type: (e == null ? void 0 : e.reportType) != "all" && (e == null ? void 0 : e.reportType) != "dw" ? e == null ? void 0 : e.gameSubType : e == null ? void 0 : e.reportType,
      page_entries: r,
      sub_type: null,
      from: Te.getcurrentDate(e.fromDate, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, e.toDate, "YYYY-MM-DD")
    }, u = await $("post", "GET_STATEMENTS", l, "user", { page: t });
    if (u && u.status == 200) {
      if ((s = u == null ? void 0 : u.data) != null && s.error)
        return m((i = u == null ? void 0 : u.data) == null ? void 0 : i.error), n.error = (o = u == null ? void 0 : u.data) == null ? void 0 : o.error, n;
      n.statementsList = (a = u == null ? void 0 : u.data) == null ? void 0 : a.data, n.pagination = Le.getPaginationData(u == null ? void 0 : u.data);
    }
    return n;
  } catch (l) {
    return m(l), n.error = l[0], n;
  }
}, ZC = async (e, t) => {
  var n, s, i, o;
  let r = {
    error: null,
    profitLossList: null
  };
  try {
    let a = {
      from: Te.getcurrentDate(e.fromDate, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, e.toDate, "YYYY-MM-DD")
    }, l = await $("post", "GET_PROFIT_LOSS", a, "user", { page: t });
    if (l && l.status == 200) {
      if ((n = l == null ? void 0 : l.data) != null && n.error)
        return m((s = l == null ? void 0 : l.data) == null ? void 0 : s.error), r.error = (i = l == null ? void 0 : l.data) == null ? void 0 : i.error, r;
      r.profitLossList = (o = l == null ? void 0 : l.data) == null ? void 0 : o.data;
    }
    return r;
  } catch (a) {
    return m(a), r.error = a[0], r;
  }
}, eD = async (e) => {
  var n, s, i, o;
  let t = {
    error: null,
    statementInfo: null
  }, r = await $("post", "GET_STATEMENT_INFO", { id: e });
  if (r && r.status == 200) {
    if ((n = r == null ? void 0 : r.data) != null && n.error)
      return m((s = r == null ? void 0 : r.data) == null ? void 0 : s.error), t.error = (i = r == null ? void 0 : r.data) == null ? void 0 : i.error, t;
    t.statementInfo = (o = r == null ? void 0 : r.data) == null ? void 0 : o.data, Le.openModal("#statementInfoModal");
  }
  return t;
}, tD = (e, t, r, n, s, i) => {
  try {
    const o = t == null ? void 0 : t.toLowerCase().trim();
    switch (e) {
      case 1:
        return t ? r == null ? void 0 : r.filter((a) => {
          var l;
          return (l = a == null ? void 0 : a.event_name) == null ? void 0 : l.toLowerCase().includes(o);
        }) : r;
      case 2:
        return t ? n == null ? void 0 : n.filter((a) => {
          var l;
          return (l = a == null ? void 0 : a.event_name) == null ? void 0 : l.toLowerCase().includes(o);
        }) : n;
      case 3:
        return t ? s == null ? void 0 : s.filter((a) => {
          var l;
          return (l = a == null ? void 0 : a.des) == null ? void 0 : l.toLowerCase().includes(o);
        }) : s;
      case 4:
        return t ? Object.fromEntries(
          Object.entries(i || {}).filter(
            ([a, l]) => {
              var u;
              return (u = l == null ? void 0 : l.typeName) == null ? void 0 : u.toLowerCase().includes(o);
            }
          )
        ) : i;
      default:
        return [];
    }
  } catch (o) {
    console.log(o);
  }
}, rD = (e) => ({
  t8sortedStatementsList() {
    const t = e.getSearchList() || [], { key: r, order: n } = (e == null ? void 0 : e.currentSort) || {};
    return r ? t.sort((s, i) => {
      const o = s[r], a = i[r];
      return o < a ? n === "asc" ? -1 : 1 : o > a ? n === "asc" ? 1 : -1 : 0;
    }) : t;
  }
}), nD = async (e, t, r, n) => {
  var i, o, a, l, u;
  let s = {
    error: null,
    profitAndLossList: null
  };
  try {
    let c = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD"),
      type: r.type,
      sport_id: r.sport_id
    }, d = await $("post", "GET_PROFIT_LOSS_PL_DETAIL", c, "user", { page: n });
    if (d && d.status == 200) {
      if ((i = d == null ? void 0 : d.data) != null && i.error)
        return m((o = d == null ? void 0 : d.data) == null ? void 0 : o.error), s.error = (a = d == null ? void 0 : d.data) == null ? void 0 : a.error, s;
      r.sport_id ? s.profitAndLossList = (l = d == null ? void 0 : d.data) == null ? void 0 : l.data : s.profitAndLossList = (u = d == null ? void 0 : d.data) == null ? void 0 : u.data.data;
    }
    return s;
  } catch (c) {
    return m(c), s.error = c[0], s;
  }
}, sD = async (e, t, r) => {
  var s, i, o;
  let n = {
    error: null,
    marketBets: null
  };
  try {
    let a = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD"),
      match_id: r
    }, l = await $("post", "GET_PROFIT_LOSS_MATCH_DETAIL", a);
    if (l && l.status == 200) {
      if ((s = l == null ? void 0 : l.data) != null && s.error)
        return m((i = l == null ? void 0 : l.data) == null ? void 0 : i.error), n.error = (o = l == null ? void 0 : l.data) == null ? void 0 : o.error, n;
      n.marketBets = l.data.data;
    }
    return n;
  } catch (a) {
    return m(a), n.error = a[0], n;
  }
}, iD = (e, t, r = {}) => {
  if (!e || !t) return;
  const n = e.querySelector(t);
  n && typeof n.scrollIntoView == "function" && n.scrollIntoView({
    behavior: "smooth",
    inline: "center",
    block: "nearest",
    ...r
  });
}, oD = (e, t, r = null) => {
  if (!e || !Array.isArray(t)) return r;
  const n = t.findIndex((s) => (s == null ? void 0 : s.id) === (e == null ? void 0 : e.id));
  return n > 0 ? t[n - 1] : r;
}, aD = (e = "all", t, r = e) => {
  if (e == "all" && (t != null && t.length))
    return t[0];
  if (!e || !Array.isArray(t)) return r;
  const n = t.findIndex((s) => (s == null ? void 0 : s.id) === (e == null ? void 0 : e.id));
  return n >= 0 && n < t.length - 1 ? t[n + 1] : r;
}, lD = (e = [], t = []) => {
  const r = Array.isArray(e) && e.length > 0 ? e.flatMap((s) => s.games || []) : t || [], n = /* @__PURE__ */ new Map();
  for (const s of r)
    s != null && s.provider_id && (s != null && s.provider) && n.set(s.provider_id, {
      id: s.provider_id,
      provider_name: s.provider
    });
  return Array.from(n.values());
}, cD = (e, t) => e == null ? void 0 : e.reduce((r, n) => {
  var i;
  const s = (i = n.games) == null ? void 0 : i.filter((o) => o.provider_id === t);
  return s != null && s.length && r.push({ ...n, games: s }), r;
}, []), uD = (e) => {
  var n, s, i;
  let t = (n = O == null ? void 0 : O.getters) == null ? void 0 : n.gamesData, r = [];
  if ((s = t == null ? void 0 : t[e]) != null && s.menus) {
    let o = t[e].menus;
    return o == null || o.forEach((a) => {
      r.push(...a.games);
    }), { menuList: o, games: r };
  } else
    return r = (i = t == null ? void 0 : t[e]) == null ? void 0 : i.games, { games: r };
}, dD = (e) => {
  let t = [];
  return Object.values(O.getters.gamesData).forEach((r) => {
    r.games && r.games.forEach((n) => {
      n.provider_id === e && t.push(n);
    }), r.menus && r.menus.forEach((n) => {
      n.games && n.games.forEach((s) => {
        s.provider_id === e && t.push(s);
      });
    });
  }), t;
}, fD = () => {
  var t;
  const e = /* @__PURE__ */ new Map();
  return Object.values((t = O == null ? void 0 : O.getters) == null ? void 0 : t.gamesData).forEach((r) => {
    r != null && r.games && r.games.forEach((n) => {
      e.set(n.provider_id, { provider_id: n.provider_id, provider_name: n.provider });
    }), r != null && r.menus && r.menus.forEach((n) => {
      n.games && n.games.forEach((s) => {
        e.set(s.provider_id, { provider_id: s.provider_id, provider_name: s.provider });
      });
    });
  }), Array.from(e.values());
}, pD = (e) => ({
  t1FilterGamesList() {
    var n;
    let t = [];
    if (this.searchCasinoString != "" && ((n = e.searchCasinoString) == null ? void 0 : n.length) > 2)
      return e.searchGamesList.filter(
        (s) => s.game_name.toLowerCase().includes(e.searchCasinoString.toLowerCase())
      );
    if (e.gameList)
      return (e == null ? void 0 : e.selectedProvider) == "all" ? e.gameList : e.gameList.filter((s) => (s == null ? void 0 : s.provider_id) == e.selectedProvider);
    e.filteredMenus && e.selectedMenu && (e.selectedMenu == "all" ? e.filteredMenus.forEach((s) => {
      t.push(...s.games);
    }) : (t = e.filteredMenus.find((s) => s.id == e.selectedMenu.id), t = t.games));
    const r = new Intl.Collator(void 0, { numeric: !0, sensitivity: "base" });
    return t.sort((s, i) => r.compare(s.porder, i.porder)), t;
  }
}), hD = (e) => ({
  sitePosters() {
    var t, r, n, s, i, o;
    return (t = O.getters) != null && t.siteSettings && ((n = (r = O.getters) == null ? void 0 : r.siteSettings) != null && n.poster) && ((i = (s = O.getters) == null ? void 0 : s.siteSettings) != null && i.poster.length) ? (o = O.getters) == null ? void 0 : o.siteSettings.poster.filter((a) => a.poster_type == 1) : [];
  },
  siteLogo() {
    var t, r, n, s, i, o, a;
    return ((r = (t = O.getters) == null ? void 0 : t.siteSettings) == null ? void 0 : r.aws_url) + ((i = (s = (n = O.getters) == null ? void 0 : n.siteSettings) == null ? void 0 : s.storage_path) == null ? void 0 : i.domain_image) + ((a = (o = O.getters) == null ? void 0 : o.siteSettings) == null ? void 0 : a.logo);
  },
  checkIsOfferAvailable() {
    var t, r, n;
    return (n = (r = (t = O.getters) == null ? void 0 : t.siteSettings) == null ? void 0 : r.offer) == null ? void 0 : n.image;
  },
  offerImageUrl() {
    var t, r, n, s, i, o, a, l;
    return ((r = (t = O.getters) == null ? void 0 : t.siteSettings) == null ? void 0 : r.aws_url) + ((i = (s = (n = O.getters) == null ? void 0 : n.siteSettings) == null ? void 0 : s.storage_path) == null ? void 0 : i.poster_path) + ((l = (a = (o = O.getters) == null ? void 0 : o.siteSettings) == null ? void 0 : a.offer) == null ? void 0 : l.image);
  }
}), gD = (e) => ({
  languagesData() {
    var t;
    return (t = O.getters) == null ? void 0 : t.languagesData;
  },
  filteredLanguages() {
    var t;
    if (e != null && e.searchTerm) {
      const r = (t = e == null ? void 0 : e.searchTerm) == null ? void 0 : t.toLowerCase();
      return e == null ? void 0 : e.languagesData.filter((n) => {
        var s, i;
        return (i = (s = n.lang_name) == null ? void 0 : s.toLowerCase()) == null ? void 0 : i.includes(r);
      });
    }
    return e == null ? void 0 : e.languagesData;
  }
}), CS = (e) => {
  const t = e ?? {};
  return [
    { title: "How to Login", videoKey: "login_video", imageKey: "login_img" },
    { title: "How to Register", videoKey: "register_video", imageKey: "register_img" },
    { title: "Introduction", videoKey: "introduction_video", imageKey: null },
    { title: "How to Withdraw", videoKey: "withdrawal_video", imageKey: null },
    { title: "How to Play", videoKey: "play_video", imageKey: "play_img" },
    { title: "How to Play Bonus", videoKey: "use_bonus_video", imageKey: null },
    { title: "How to Deposit English", videoKey: "deposit_video_e", imageKey: null },
    { title: "How to Deposit Hindi", videoKey: "deposit_video_h", imageKey: null }
  ].filter((n) => !!t[n.videoKey]);
}, _D = (e) => ({
  domainName() {
    var t;
    return (t = O.getters) == null ? void 0 : t.domainName;
  },
  tutorials() {
    var t, r;
    return CS((r = (t = O.getters) == null ? void 0 : t.siteSettings) == null ? void 0 : r.user_journey);
  },
  isUserJourneyAvailable() {
    var r, n;
    const t = ((n = (r = O.getters) == null ? void 0 : r.siteSettings) == null ? void 0 : n.user_journey) || {};
    return t ? Object.values(t).some((s) => !!s) : !1;
  }
}), mD = async (e) => {
  var t, r, n, s, i;
  try {
    const o = (r = (t = ge()) == null ? void 0 : t.user) == null ? void 0 : r.cpi;
    if (!o) return { error: !0 };
    const a = ((n = O.getters.siteSettings) == null ? void 0 : n.support_numbers) || [], l = /* @__PURE__ */ new Date(), u = l.getHours() * 60 + l.getMinutes();
    return e.whatsappNumbers = a.filter((c) => c.id === o).flatMap(
      (c) => c.categories.flatMap((d) => {
        const f = d.value.split(","), g = f[u % f.length];
        return {
          category_name: d.name,
          link: d.type == "value" ? `https://wa.me/${g}` : d[d.type]
        };
      })
    ), (s = O.getters.siteSettings) != null && s.social_link.wati_link && !e.whatsappNumbers.length ? (window.open((i = O.getters.siteSettings) == null ? void 0 : i.social_link.wati_link, "blank"), { error: !0 }) : { error: !1 };
  } catch (o) {
    return m(o == null ? void 0 : o[0]), { error: !0 };
  }
}, yD = async () => {
  var t, r, n, s, i, o;
  let e = {
    error: null,
    miniGameUrl: null
  };
  try {
    let a = (r = (t = O.getters.gamesData["mini-games"]) == null ? void 0 : t.games) == null ? void 0 : r[0], l = {
      type: "casino",
      game_code: a.game_code,
      section_id: a.sm_id
    }, u = await $("post", "GET_THIRD_PARTY_API", l, "user");
    if (u) {
      if ((n = u == null ? void 0 : u.data) != null && n.error)
        return m((s = u == null ? void 0 : u.data) == null ? void 0 : s.error), e.error = (o = (i = u == null ? void 0 : u.data) == null ? void 0 : i.error) == null ? void 0 : o.toString(), e;
      e.miniGameUrl = u.data.url;
    }
    return e;
  } catch {
    return m("Mini Game Data Not Found !"), e.error = "Mini Game Data Not Found !", e;
  }
}, ED = (e, t) => {
  document.body.style.overflow = "hidden";
  const r = e.touches[0];
  t.dragging = !0, t.snapping = !1, t.offset.x = window.innerWidth - r.clientX - t.position.x, t.offset.y = r.clientY - t.position.y;
}, vD = async (e, t) => {
  if (t.dragging) {
    const r = e.touches[0];
    t.position.x = window.innerWidth - r.clientX - t.offset.x, t.position.y = r.clientY - t.offset.y;
  }
}, bD = async (e) => {
  e.dragging && (e.dragging = !1, document.body.style.overflow = "", Cp(e), e.visible && Np(e));
}, wD = (e, t) => {
  document.body.style.overflow = "hidden", t.dragging = !0, t.snapping = !1, t.offset.x = e.clientX - t.position.x, t.offset.y = e.clientY - t.position.y;
}, TD = async (e, t) => {
  t.dragging && (t.position.x = window.innerWidth - e.clientX - t.offset.x, t.position.y = e.clientY - t.offset.y);
}, SD = async (e) => {
  e.dragging && (e.dragging = !1, document.body.style.overflow = "", Cp(e), e.visible && Np(e));
}, Np = async (e) => {
  const r = window.innerWidth, n = window.innerHeight, s = 60;
  e.snapping = !0, e.position.y < 10 && (e.position.y = 10), e.position.y > n - s - 10 && (e.position.y = n - s - 10), e.position.x + s / 2 < r / 2 ? e.position.x = 10 : e.position.x = r - s - 10 * 2, setTimeout(() => {
    e.snapping = !1;
  }, 300);
}, Cp = async (e) => {
  const t = e.$refs.icon, r = e.$refs.closeZone;
  if (!t || !r) return;
  const n = t.getBoundingClientRect(), s = r.getBoundingClientRect();
  !(n.right < s.left || n.left > s.right || n.bottom < s.top || n.top > s.bottom) && (e.visible = !1);
}, OD = async () => {
  var t, r;
  let e = {
    error: !1,
    bonusLogs: null
  };
  try {
    let n = await $("get", "GET_BONUS_LOGS", null, "bonus");
    return n && ((t = n == null ? void 0 : n.data) != null && t.error ? (m((r = n == null ? void 0 : n.data) == null ? void 0 : r.error), e.error = !0) : (e.error = !1, e.bonusLogs = n.data.data)), e;
  } catch (n) {
    return console.log(n), e.error = n, e;
  }
}, AD = (e, t) => {
  try {
    setInterval(() => {
      var c;
      const n = new Date((c = e.maintananceData) == null ? void 0 : c.to_date).getTime(), s = Date.now(), i = n - s;
      if (i < 0) {
        O.dispatch("setUnderMaintenance", null), t.go(0);
        return;
      }
      const o = 1e3, a = o * 60, l = a * 60, u = l * 24;
      e.days = Math.floor(i / u), e.hours = Math.floor(i % u / l), e.minutes = Math.floor(i % l / a), e.seconds = Math.floor(i % a / o);
    }, 1e3);
  } catch (r) {
    console.log(r);
  }
}, ND = (e) => ({
  maintananceData() {
    var t;
    return (t = O.getters) == null ? void 0 : t.underMaintenance;
  }
}), CD = (e) => {
  if (navigator.clipboard && window.isSecureContext)
    navigator.clipboard.writeText(e).then(() => {
      _e("Successfully copied.");
    }).catch((t) => {
      console.error("Failed to copy: ", t);
    });
  else {
    let t = document.createElement("textarea");
    t.value = e, document.body.appendChild(t), t.select(), document.execCommand("copy"), _e("Successfully copied.");
  }
}, DD = (e, t) => {
  var r;
  try {
    let n = ((r = e.logInData) == null ? void 0 : r.userIds) || [];
    n.push(t);
    let s = {
      logInWithMobile: !0,
      userIds: n
    };
    O.dispatch("setLogInData", s);
  } catch (n) {
    console.log(n);
  }
}, ID = async (e, t) => {
  var n, s, i, o, a;
  let r = ((n = O == null ? void 0 : O.getters) == null ? void 0 : n.eventManage) || t;
  try {
    let l = null, u = [], c = await $("get", "GET_SEARCH_EVENTS", {}, "user", { searchKey: e.searchKey });
    if (c) {
      if ((s = c == null ? void 0 : c.data) != null && s.error)
        m((i = c == null ? void 0 : c.data) == null ? void 0 : i.error);
      else {
        l = (o = c == null ? void 0 : c.data) == null ? void 0 : o.data;
        for (let d = 0; d < l.length; d++) {
          let f = [], g = [];
          (a = ge()) != null && a.status && r && (f = r == null ? void 0 : r.filter((_) => _.type == "match").map((_) => _.type_id), g = r == null ? void 0 : r.filter((_) => _.type == "league").map((_) => _.type_id)), Rr(l[d].sportId) && hn(l[d].event_id, l[d].id, f, g) && u.push(l[d]);
        }
      }
      return { data: u };
    }
  } catch (l) {
    console.log(l, "err");
  }
}, MD = async () => {
  var n;
  try {
    let s = await $("get", "GET_SPORTS", null, "sports");
    if (s && s.status == 200) {
      var e = (n = s == null ? void 0 : s.data) == null ? void 0 : n.data;
      let i = [], o = [];
      for (var t = 0; t < (e == null ? void 0 : e.length); t++)
        Rr(e[t].id) && (e[t].is_custom == 0 ? i.push(e[t]) : o.push(e[t]));
      i.sort((a, l) => a.rank - l.rank);
      var r = {};
      r.custom = o, r.non_custom = i, O.dispatch("setSport", r);
    }
  } catch (s) {
    s && m(s);
  }
}, RD = async (e) => {
  try {
    let t = await $("get", "INPLAY_MATCHES_COUNT", null, "sports");
    if (t && t.status == 200) {
      let r = t.data.data, n = {
        cricket: 0,
        soccer: 0,
        tennis: 0,
        inplay: 0
      };
      for (const s in r) {
        if (s == 4)
          n.cricket = r[s].total;
        else if (s == 1)
          n.soccer = r[s].total;
        else if (s == 2)
          n.tennis = r[s].total;
        else {
          const i = r[s].sport_name;
          n[i] = r[s].total;
        }
        n.inplay += r[s].inplay;
      }
      e.matchCounts = n;
    }
  } catch (t) {
    m(t[0]);
  }
}, LD = (e) => ({
  primaryNonCustomSports() {
    var t, r;
    return (r = (t = e == null ? void 0 : e.sportList) == null ? void 0 : t.non_custom) == null ? void 0 : r.filter((n) => [1, 2, 4].includes(n.id));
  },
  secondaryNonCustomSports() {
    var t, r;
    return (r = (t = e == null ? void 0 : e.sportList) == null ? void 0 : t.non_custom) == null ? void 0 : r.filter((n) => ![1, 2, 4].includes(n.id));
  },
  customSports() {
    var t;
    return (t = e == null ? void 0 : e.sportList) == null ? void 0 : t.custom;
  }
}), DS = {
  user: null,
  chips: null,
  token: null,
  eventManage: null,
  eventDetailHideSections: [],
  siteVersion: null,
  is_offer: !0
}, IS = {
  isAuthenticated: (e) => !!(e != null && e.user),
  stateUser: (e) => e == null ? void 0 : e.user,
  chips: (e) => e == null ? void 0 : e.chips,
  token: (e) => e == null ? void 0 : e.token,
  eventManage: (e) => e == null ? void 0 : e.eventManage,
  eventDetailHideSections: (e) => e == null ? void 0 : e.eventDetailHideSections,
  siteVersion: (e) => e == null ? void 0 : e.siteVersion,
  is_offer: (e) => e == null ? void 0 : e.is_offer
}, MS = {
  setUser({ commit: e }, t) {
    e("setUser", t);
  },
  setChips({ commit: e }, t) {
    e("setChips", t);
  },
  setToken({ commit: e }, t) {
    e("setToken", t);
  },
  setEventManage({ commit: e }, t) {
    e("setEventManage", t);
  },
  seteventDetailHideSections({ commit: e }, t) {
    e("seteventDetailHideSections", t);
  },
  setSiteVersion({ commit: e }, t) {
    e("setSiteVersion", t);
  },
  setIs_offer({ commit: e }, t) {
    e("setIs_offer", t);
  }
}, RS = {
  setUser(e, t) {
    e.user = t;
  },
  setChips(e, t) {
    e.chips = t;
  },
  setToken(e, t) {
    e.token = t;
  },
  setEventManage(e, t) {
    e.eventManage = t;
  },
  seteventDetailHideSections(e, t) {
    e.eventDetailHideSections = t;
  },
  setSiteVersion(e, t) {
    e.siteVersion = t;
  },
  setIs_offer(e, t) {
    e.is_offer = t;
  }
}, xD = {
  state: DS,
  getters: IS,
  actions: MS,
  mutations: RS
}, LS = {
  siteSettings: null,
  gamesData: null,
  domainName: window.location.hostname.split(".").slice(-2)[0] ? window.location.hostname.split(".").slice(-2)[0].toUpperCase() : "",
  clickBetValue: null,
  favouriteGames: [],
  globalLoader: !1,
  captchaData: null,
  notification: 0,
  languagesData: null,
  sportList: null,
  successMsg: null,
  errorMsg: null,
  underMaintenance: null,
  bonusData: null,
  count: 0,
  logInData: {
    logInWithMobile: !1,
    userIds: []
  },
  matkaStakesList: null,
  selectedMatkaStake: null,
  sideMenuLeagueList: null,
  userTransactionStakes: null,
  downloadInfo: !0
}, xS = {
  siteSettings: (e) => e == null ? void 0 : e.siteSettings,
  languagesData: (e) => {
    var t;
    return (t = e == null ? void 0 : e.siteSettings) == null ? void 0 : t.languagesList;
  },
  gamesData: (e) => e == null ? void 0 : e.gamesData,
  bonusData: (e) => e == null ? void 0 : e.bonusData,
  domainName: (e) => e == null ? void 0 : e.domainName,
  clickBetValue: (e) => e == null ? void 0 : e.clickBetValue,
  clickBetActive: (e) => {
    var t;
    return ((t = e == null ? void 0 : e.clickBetValue) == null ? void 0 : t.find((r) => r.isSelected)) ?? !1;
  },
  favouriteGames: (e) => e == null ? void 0 : e.favouriteGames,
  globalLoader: (e) => e == null ? void 0 : e.globalLoader,
  captchaData: (e) => e == null ? void 0 : e.captchaData,
  getNotification: (e) => e == null ? void 0 : e.notification,
  sportList: (e) => e == null ? void 0 : e.sportList,
  successMsg: (e) => e == null ? void 0 : e.successMsg,
  errorMsg: (e) => e == null ? void 0 : e.errorMsg,
  underMaintenance: (e) => e == null ? void 0 : e.underMaintenance,
  count: (e) => e == null ? void 0 : e.count,
  logInData: (e) => e == null ? void 0 : e.logInData,
  matkaStakesList: (e) => e == null ? void 0 : e.matkaStakesList,
  selectedMatkaStake: (e) => e == null ? void 0 : e.selectedMatkaStake,
  sideMenuLeagueList: (e) => e == null ? void 0 : e.sideMenuLeagueList,
  userTransactionStakes: (e) => e == null ? void 0 : e.userTransactionStakes,
  downloadInfo: (e) => e == null ? void 0 : e.downloadInfo
}, kS = {
  setSettings({ commit: e }, t) {
    e("setSettings", t);
  },
  setLanguagesData({ commit: e }, t) {
    e("setLanguagesData", t);
  },
  setBonusData({ commit: e }, t) {
    e("setBonusData", t);
  },
  setGamesData({ commit: e }, t) {
    e("setGamesData", t);
  },
  setClickBetValue({ commit: e }, t) {
    e("setClickBetValue", t);
  },
  setFavouriteGames({ commit: e }, t) {
    e("setFavouriteGames", t);
  },
  setGlobalLoader({ commit: e }, t) {
    e("setGlobalLoader", t);
  },
  setCaptchaData({ commit: e }, t) {
    e("setCaptchaData", t);
  },
  setNotification({ commit: e }, t) {
    e("setNotification", t);
  },
  setSport({ commit: e }, t) {
    e("setSport", t);
  },
  showSuccessModal({ commit: e }, t) {
    e("showSuccessModal", t), setTimeout(() => {
      e("showSuccessModal", null);
    }, 2e3);
  },
  showErrorModal({ commit: e }, t) {
    e("showErrorModal", t), setTimeout(() => {
      e("showErrorModal", null);
    }, 2e3);
  },
  setUnderMaintenance({ commit: e }, t) {
    e("setUnderMaintenance", t);
  },
  incrementCount({ commit: e }) {
    e("incrementCount");
  },
  // Userid and offer ------------------------------------
  setLogInData({ commit: e }, t) {
    e("setLogInData", t);
  },
  // -----------------------------------------------------
  // -----------Matka
  setMatkaStakesList({ commit: e }, t) {
    e("setMatkaStakesList", t);
  },
  setSelectedMatkaStake({ commit: e }, t) {
    e("setSelectedMatkaStake", t);
  },
  // side menu sports list (leagues)
  setSideMenuLeagueList({ commit: e }, t) {
    e("setSideMenuLeagueList", t);
  },
  setUserTransactionStakes({ commit: e }, t) {
    e("setUserTransactionStakes", t);
  },
  SetdownloadInfo({ commit: e }, t) {
    e("SetdownloadInfo", t);
  }
}, PS = {
  setSettings(e, t) {
    e.siteSettings = t;
  },
  setLanguagesData(e, t) {
    e.languagesData = t;
  },
  setBonusData(e, t) {
    e.bonusData = t;
  },
  setGamesData(e, t) {
    e.gamesData = t;
  },
  setClickBetValue(e, t) {
    e.clickBetValue = t;
  },
  setFavouriteGames(e, t) {
    e.favouriteGames = t;
  },
  setGlobalLoader(e, t) {
    e.globalLoader = t;
  },
  setCaptchaData(e, t) {
    e.captchaData = t;
  },
  setNotification(e) {
    e.notification = e.notification + 1;
  },
  setSport(e, t) {
    e.sportList = t;
  },
  showSuccessModal(e, t) {
    e.successMsg = t;
  },
  showErrorModal(e, t) {
    e.errorMsg = t;
  },
  setUnderMaintenance(e, t) {
    e.underMaintenance = t;
  },
  incrementCount(e) {
    e.count++;
  },
  // Userid and offer ------------------------------------
  setLogInData(e, t) {
    console.log(t), e.logInData = t;
  },
  // -----------------------------------------------------
  // ---------------Matka draggable chips
  setMatkaStakesList(e, t) {
    e.matkaStakesList = t;
  },
  setSelectedMatkaStake(e, t) {
    e.selectedMatkaStake = t;
  },
  // side menu leagues, sports list
  setSideMenuLeagueList(e, t) {
    e.sideMenuLeagueList = t;
  },
  setUserTransactionStakes(e, t) {
    e.userTransactionStakes = t;
  },
  SetdownloadInfo(e, t) {
    e.downloadInfo = t;
  }
}, kD = {
  state: LS,
  getters: xS,
  actions: kS,
  mutations: PS
}, $S = {
  profitLossItem: null,
  viewBetsItem: null,
  plFilterOption: null
}, FS = {
  profitLossItem: (e) => e == null ? void 0 : e.profitLossItem,
  viewBetsItem: (e) => e == null ? void 0 : e.viewBetsItem,
  plFilterOption: (e) => e == null ? void 0 : e.plFilterOption
}, VS = {
  setProfitLossItem({ commit: e }, t) {
    e("setProfitLossItem", t);
  },
  setViewBetsItem({ commit: e }, t) {
    e("setViewBetsItem", t);
  },
  setPlFilterOption({ commit: e }, t) {
    e("setPlFilterOption", t);
  }
}, BS = {
  setProfitLossItem(e, t) {
    e.profitLossItem = t;
  },
  setViewBetsItem(e, t) {
    e.viewBetsItem = t;
  },
  setPlFilterOption(e, t) {
    e.plFilterOption = t;
  }
}, PD = {
  state: $S,
  getters: FS,
  actions: VS,
  mutations: BS
}, US = {
  userBonus: null
}, HS = {
  userBonus: (e) => e == null ? void 0 : e.userBonus
}, jS = {
  setUserBonus({ commit: e }, t) {
    e("setUserBonus", t);
  }
}, YS = {
  setUserBonus(e, t) {
    e.userBonus = t;
  }
}, $D = {
  state: US,
  getters: HS,
  actions: jS,
  mutations: YS
}, GS = {
  cricFightMatchDetails: null,
  cricFightPlayersList: null,
  tutorials: null,
  teamData: null,
  selectedPlayers: null,
  myContest: null
}, WS = {
  cricFightMatchDetails: (e) => e == null ? void 0 : e.cricFightMatchDetails,
  cricFightPlayersList: (e) => e == null ? void 0 : e.cricFightPlayersList,
  tutorials: (e) => e == null ? void 0 : e.tutorials,
  teamData: (e) => e == null ? void 0 : e.teamData,
  selectedPlayers: (e) => e == null ? void 0 : e.selectedPlayers,
  myContest: (e) => e == null ? void 0 : e.myContest
}, qS = {
  setCricFightMatchDetails({ commit: e }, t) {
    e("setCricFightMatchDetails", t);
  },
  setCricFightPlayersList({ commit: e }, t) {
    e("setCricFightPlayersList", t);
  },
  setTutorials({ commit: e }, t) {
    e("setTutorials", t);
  },
  setTeamData({ commit: e }, t) {
    e("setTeamData", t);
  },
  setSelctedPlayers({ commit: e }, t) {
    e("setSelctedPlayers", t);
  },
  setMyContest({ commit: e }, t) {
    e("setMyContest", t);
  }
}, KS = {
  setCricFightMatchDetails(e, t) {
    e.cricFightMatchDetails = t;
  },
  setCricFightPlayersList(e, t) {
    e.cricFightPlayersList = t;
  },
  setTutorials(e, t) {
    e.tutorials = t;
  },
  setTeamData(e, t) {
    e.teamData = t;
  },
  setSelctedPlayers(e, t) {
    e.selectedPlayers = t;
  },
  setMyContest(e, t) {
    e.myContest = t;
  }
}, FD = {
  state: GS,
  getters: WS,
  actions: qS,
  mutations: KS
}, zS = {
  depositAmount: 0,
  withdrawAmount: 0,
  paymentMethod: null,
  transactionDetails: null
}, JS = {
  depositAmount: (e) => e == null ? void 0 : e.depositAmount,
  withdrawAmount: (e) => e == null ? void 0 : e.withdrawAmount,
  paymentMethod: (e) => e == null ? void 0 : e.paymentMethod,
  transactionDetails: (e) => e == null ? void 0 : e.transactionDetails
}, XS = {
  setDepositAmount({ commit: e }, t) {
    e("setDepositAmount", t);
  },
  setWithdrawAmount({ commit: e }, t) {
    e("setWithdrawAmount", t);
  },
  setPaymentMethodDetails({ commit: e }, t) {
    e("setPaymentMethodDetails", t);
  },
  setTransactionDetails({ commit: e }, t) {
    e("setTransactionDetails", t);
  }
}, QS = {
  setDepositAmount(e, t) {
    e.depositAmount = t;
  },
  setWithdrawAmount(e, t) {
    e.withdrawAmount = t;
  },
  setPaymentMethodDetails(e, t) {
    e.paymentMethod = t;
  },
  setTransactionDetails(e, t) {
    e.transactionDetails = t;
  }
}, VD = {
  state: zS,
  getters: JS,
  actions: XS,
  mutations: QS
}, BD = {
  resetState(e) {
    e.auth.user = null, e.auth.token = null, e.auth = {
      user: null,
      chips: null,
      token: null,
      eventManage: null,
      eventDetailHideSections: [],
      siteVersion: null
    }, e.commonStore.clickBetValue = null;
  }
}, UD = {
  resetAllState({ commit: e }) {
    e("resetState");
  }
}, HD = "AUTH_TOKEN", ZS = [
  {
    id: 1,
    type: "Open Bets"
  },
  {
    id: 2,
    type: "Settled Bets"
  },
  {
    id: 3,
    type: "Statement"
  },
  {
    id: 4,
    type: "Profit & Loss"
  }
], eO = [
  {
    id: 1,
    type: "Sports"
  },
  {
    id: 2,
    type: "Games"
  }
], tO = [
  {
    id: 4,
    type: "Cricket"
  },
  {
    id: 1,
    type: "Football"
  },
  {
    id: 2,
    type: "Tennis"
  }
], rO = [
  {
    id: 999,
    type: "Live Cards"
  },
  {
    id: 4,
    type: "Matka Market"
  },
  {
    id: 2222,
    type: "Sportsbook"
  }
], nO = [
  {
    id: 2,
    type: "Settle Bets"
  },
  {
    id: 4,
    type: "Void"
  },
  {
    id: 5,
    type: "Invalid"
  }
], sO = [
  {
    id: "all",
    type: "All"
  },
  {
    id: "dw",
    type: "Deposit/Withdrawal"
  },
  {
    id: "sport",
    type: "Sports"
  }
], iO = [
  {
    id: "all",
    type: "All"
  },
  {
    id: 4,
    type: "Cricket"
  },
  {
    id: 1,
    type: "Soccer"
  },
  {
    id: 2,
    type: "Tennis"
  }
], oO = [
  {
    id: "all",
    type: "All"
  },
  {
    id: 1,
    type: "Sports"
  },
  {
    id: 2,
    type: "Games"
  }
], aO = [
  {
    id: "worli_matka",
    type: "Matka market"
  },
  {
    id: 2222,
    type: "Sportbook"
  }
];
var lO = [
  {
    id: "all",
    type: "All"
  },
  {
    id: 4,
    type: "Cricket"
  },
  {
    id: 1,
    type: "Football"
  },
  {
    id: 2,
    type: "Tennis"
  },
  {
    id: "dw",
    type: "Deposit/Withdraw"
  },
  {
    id: "sportsbook",
    type: "Sportsbook"
  },
  {
    id: "matka",
    type: "Matka"
  },
  {
    id: "fantasy_cricket",
    type: "Fantasy cricket"
  },
  {
    id: "casino",
    type: "Casino"
  },
  {
    id: "premium",
    type: "Premium"
  },
  {
    id: "virtual_sport",
    type: "Virtual sports"
  }
];
const cO = [
  {
    id: 1,
    type: "open"
  },
  {
    id: 2,
    type: "settled"
  },
  {
    id: 4,
    type: "void"
  },
  {
    id: 5,
    type: "invalid"
  },
  {
    id: 6,
    type: "cancelled"
  }
];
var uO = [
  {
    id: "sport",
    type: "Sports"
  },
  {
    id: "sportsbook",
    type: "Sportsbook"
  },
  {
    id: "matka",
    type: "Matka"
  },
  {
    id: "fantasy_cricket",
    type: "Fantasy Cricket"
  },
  {
    id: "premium",
    type: "Premium"
  },
  {
    id: "casino",
    type: "Casino"
  },
  {
    id: "virtual_sport",
    type: "Virtual Sports"
  }
];
const jD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BETS_STATIC_GAMES: uO,
  BET_STATUS: cO,
  BET_TYPES: nO,
  GAME_SUB_TYPES: rO,
  GAME_TYPES: eO,
  NEW_STATIC_GAMES: lO,
  REPORT_TYPES: sO,
  SPORTS_SUB_TYPES: tO,
  SPORTS_TYPES: iO,
  TYPES: ZS,
  WIN_GAMES_TYPES: aO,
  WIN_LOSS_TYPES: oO
}, Symbol.toStringTag, { value: "Module" }));
export {
  HD as AUTH_TOKEN,
  $D as accountStore,
  UD as actions,
  tN as addAccount,
  lA as addBetCall,
  MC as addMatchRemainder,
  LC as addRemainingTimeToCricketFightMatches,
  pC as affSendOtpServiceCall,
  fC as affSignUpCall,
  dC as affSignUpServiceCall,
  $ as apiCall,
  xD as auth,
  PD as betsStore,
  HC as calculateRemainingTime,
  zC as calculateTeamScores,
  Ai as calculationOfProfitLoss,
  PN as callChangePasswordServiceFunction,
  FN as callChangeStakeValue,
  bA as callForSportsBooksUrl,
  cC as callForvirtualSportsUrl,
  aN as cancelRequest,
  eA as cashout,
  UA as cashoutDisableForBookmaker,
  VA as cashoutDisableForMainMarket,
  jA as cashoutDisableForOtherMarket,
  LO as casinoGamesHandler,
  uA as changeAcceptOdds,
  BA as checkCashoutConditionForBookmaker,
  FA as checkCashoutConditionForMainMarket,
  HA as checkCashoutConditionForOtherMarkets,
  _A as checkClickBetValues,
  VT as checkEventManageForMatka,
  FT as checkEventManageforSingleType,
  Rr as checkEventManageforSports,
  hn as checkForLockedMatches,
  FO as checkForPremiumFancyEvent,
  BT as checkInEventMangeForSection,
  pA as clearStake,
  DD as closeUserId,
  kD as commonStore,
  hC as copyAffUrl,
  JN as copyRefUrl,
  jN as copyRefUrlInAccount,
  CD as copyUserIdRefUrl,
  AN as countdown,
  uC as createComputedPropertiesForAffilliateModule,
  qN as createComputedPropertiesForEditStakes,
  _D as createComputedPropertiesForFooter,
  gD as createComputedPropertiesForLanguageSelection,
  ND as createComputedPropertiesForMaintenance,
  bN as createComputedPropertiesForMatkaDetails,
  iC as createComputedPropertiesForNotifications,
  NA as createComputedPropertiesForOpenBetsInSports,
  AA as createComputedPropertiesForPoolZoneLeaderBoard,
  hD as createComputedPropertiesForPostersAndLogos,
  nC as createComputedPropertiesForReferAndEarn,
  vA as createComputedPropertiesForSportEventDetails,
  LD as createComputedPropertiesForSportSelection,
  lN as createComputedPropertiesForTransactionDetails,
  qO as createSharedComputed,
  XA as createSharedComputedForDepositPayment,
  ZO as createSharedComputedForInplay,
  rD as createSharedComputedForStatements,
  WN as createSharedComputedPropertiesForAccount,
  pD as createSharedComputedPropertiesForCasino,
  zN as createSharedComputedPropertiesForChatbot,
  dN as createSharedComputedPropertiesForMatka,
  XO as createSharedComputedPropertiesForSports,
  Te as dateTime,
  IN as demoUserLoginData,
  LA as disableBookmakerMarketOdds,
  kA as disableFancyMarketOdds,
  IA as disableMainMarketOdds,
  $A as disableOtherMarketOdds,
  TC as downloadOpenBets,
  SC as downloadOpenBetsNotSports,
  AC as downloadProfitLoss,
  _C as downloadQR,
  OC as downloadStatement,
  m as errorToast,
  FD as fantasyCricketStore,
  WO as filterSportsMatchesByKey,
  kN as forgetPasswordCall,
  xN as forgotServiceCall,
  wS as generateGuruSelection,
  Op as getAffOtp,
  NC as getAffProfitLossDetail,
  wC as getAffProfitLossServiceCall,
  bC as getAffStatementServiceCall,
  yC as getAffiliateComReport,
  gC as getAffiliateDashboard,
  EC as getAffiliateRegisterUserCount,
  vC as getAffiliateUsersList,
  OD as getBonusLogs,
  XN as getBonusStatements,
  mN as getBookOfDigit,
  BO as getCasinoGamesServiceCall,
  KC as getContestBetList,
  JC as getContestBetListInMyTeams,
  lC as getEventBookExposures,
  rA as getEventDetails,
  nA as getEventExposuresCall,
  HO as getFantasyMatchList,
  aC as getFavouriteEventIdsServiceCall,
  MN as getId,
  RD as getInplayMatchCounts,
  VO as getInplayMatches,
  TN as getJodiData,
  SA as getLeaderBoardData,
  BN as getLockedEarnedBonus,
  sD as getMarketBetsServiceCall,
  VC as getMatchedBets,
  fN as getMatkaMarkets,
  pN as getMatkaSingleBets,
  cN as getMatkasServiceCall,
  qC as getMyContests,
  oC as getMyMarketsServiceCall,
  sC as getMyNotificationsList,
  kC as getMyStakes,
  aD as getNextMenuItem,
  UO as getNotficationsCount,
  sA as getOpenBets,
  XC as getOpenBetsServiceCall,
  iA as getOpenMarketBets,
  gS as getParentPaymentsMethods,
  mD as getParentWhatsappNumber,
  KA as getPaymentGatewayUrl,
  xC as getPlayersList,
  OA as getPoolOpenBetsServiceCall,
  KT as getPoolWallet,
  oD as getPreviousMenuItem,
  TA as getPreviousPoolWinners,
  nD as getProfitLossDetail,
  mC as getProfitLossEventUsers,
  ZC as getProfitLossServiceCall,
  No as getQueryParam,
  QN as getReferStatements,
  IC as getRememberedMatches,
  ID as getSearch,
  tD as getSearchList,
  DC as getSetUpData,
  RT as getSiteVersion,
  KO as getSportsList,
  QC as getStatementServiceCall,
  $C as getTeamDetails,
  rC as getTotalRolling,
  oN as getTransactionStatus,
  tC as getUsedBonus,
  ES as getUserAccounts,
  CC as getUserMarketBetsServiceCall,
  GA as getWalletAuth,
  iN as getWalletHistory,
  MD as get_sportsList,
  aA as getfancyBookServiceCall,
  WC as handlePlayerSelectionInCricketFight,
  Jd as headers,
  Le as helper,
  vN as isCurrentTimeInRange,
  RA as isSuspendedBookmaker,
  xA as isSuspendedFancy,
  MA as isSuspenedMainMarket,
  PA as isSuspenedOtherMarket,
  wA as joinPool,
  yD as loadMiniGames,
  CN as loginServiceCall,
  $N as logoutServiceCall,
  JO as makeFavouriteCall,
  YC as makePlayerFormation,
  wN as maktaDigits,
  jO as markingFavouriteInMatches,
  BD as mutations,
  qA as ocrCheck,
  fA as oddsMinus,
  dA as oddsPlus,
  TD as onDrag,
  vD as onTouchMove,
  zA as onUploadImage,
  eD as openStatementInfo,
  rN as openWithdrawPasswordModal,
  gA as pinUnpinFancy,
  BC as placeBet,
  tA as poolZone,
  oA as premiumFancyServiceCall,
  GN as redeemBonus,
  YA as redeemPromoBonus,
  eC as redeemRefBonus,
  ZA as removeAccount,
  RC as removeReminder,
  GC as resetTeam,
  sN as resetWithdrawalPassword,
  cA as saveBetsCall,
  mA as saveClickBetValue,
  hN as saveWorliMatkaBetServiceCall,
  iD as scrollActiveElementIntoView,
  yN as selectDigit,
  SN as sendOtpCall,
  ON as sendOtpServiceCall,
  uD as setCasinoGamesList,
  xO as setCurrentLangDataFn,
  DO as setHeaders,
  _N as setMarketList,
  lD as setProviderList,
  hA as setStakeValue,
  MO as setStore,
  RO as setTranslatedDataFn,
  IO as setWalletHeaders,
  WA as setWalletStakeValue,
  PO as setonScroll,
  DA as showIncSuperOverLabelForWhoWillTheMatch,
  DN as signInwithOtp,
  LN as signUpCall,
  RN as signUpServiceCall,
  Np as snapToEdge,
  $O as socketAllEvents,
  yA as socketServiceCall,
  EA as socketServiceOff,
  wD as startDrag,
  AD as startTimer,
  ED as startTouch,
  nN as startWithdrawTimer,
  SD as stopDrag,
  bD as stopTouch,
  JA as submitDepositAmount,
  PC as submitSelectedPlayersTeam,
  _e as successToast,
  VN as switchToWelcomeBonus,
  YO as t1FilteringOutLockedMatches,
  zO as t1FilteringOutSportLockedMatches,
  NN as t1TogglePasswordVisibility,
  GO as t3FilteringOutLockedMatches,
  dD as t5FilterGamesByProviderId,
  EN as t5GetBookOfDigit,
  fD as t5SetUniqueProviders,
  QO as t5setInplayMatches,
  CA as t8CreateComputedPropertiesForOpenBetsInSports,
  KN as toggleChatModal,
  CS as tutorialsList,
  jD as types,
  UN as updateCountdown,
  uN as updateCountdownForMatka,
  cD as updateMenuListForProvider,
  UC as updateMyStakes,
  FC as updateTeamName,
  YN as updateUserName,
  HN as updateWalletType,
  gN as verifySubmitBet,
  jC as viewBetDetails,
  ZN as viewReferedUserLog,
  gv as walletHeaders,
  VD as walletStore,
  QA as withdrawAmountClickValidation,
  eN as withdrawWalletAmount
};
